import ptLocale from '@one/one-vue/dist/locale/pt.mjs'
import { no } from 'element-plus/es/locales.mjs'

export default {
  cmr_draft: {
    new: {
      origin_place: 'Local de origem',
      destination_place: 'Local de destino',
      title: 'Novo rascunho de documento de transporte',
      btn_create: 'Criar',
      cmrNumber: 'Número de documento de transporte',
      cmrNumber_required: 'O número de documento de transporte é obrigatório',
      sendDate: 'Data de envio',
      sendDate_future: 'A data de envio deve ser igual ou posterior à data atual',
      vehiclePlate: 'Matrícula do veículo',
      trailerPlate: 'Matrícula do reboque',
      nameTransportist: 'Empresa transportadora',
      observations: 'Observações',
      save_ok: 'Rascunho criado com sucesso',
      step_header: 'Cabeçalho',
      step_lines: 'Linhas',
      authorization_section: 'Autorização',
      authorizationNumber: 'Número de autorização',
      senderAgency: 'Organismo emissor',
      validityPeriod: 'Período de validade',
      cargo_general_data: 'Dados gerais da carga',
      nature: 'Natureza',
      weight: 'Peso',
      unitOfMeasure: 'Unidade de medida',
      validityDateFrom: 'Período de validade desde',
      validityDateTo: 'Período de validade até',
      validityDateTo_future: 'A data "até" deve ser posterior à data atual',
      origin_place_seller_centres_exclusive: 'Se preencher o local de origem, não pode adicionar centros do vendedor',
      destination_place_seller_centres_exclusive: 'Se preencher o local de destino, não pode adicionar centros do vendedor',
      destination_place_buyer_centres_exclusive: 'Se preencher o local de destino, não pode adicionar centros do comprador'
    },
    stops: {
      title: 'Paradas',
      no_stops: 'Sem paradas',
      add_stop: 'Adicionar parada',
      add_stop_title: 'Adicionar parada',
      delete_stop: 'Excluir parada',
      ship_from: 'Origem',
      final_destination: 'Paragem para destino final',
      stop_place: 'Destino',
      stop_place_destination: 'Destino/Parada',
      stops_required_without_origin_destination: 'Se nao for indicado o local de origem ou o local de destino, e obrigatorio adicionar pelo menos uma parada.',
      final_destination_required: 'Nao foi criada nenhuma parada para o destino final. E obrigatorio criar a parada correspondente a este destino, e o valor deve coincidir exatamente com o dado indicado no campo Local de destino (virgulas, pontos, outros caracteres, etc.). Reveja os dados e adicione a parada para o destino final.',
      lines_required_for_stops: 'Se existir uma ou mais paradas:<br>- Tem de existir obrigatoriamente uma ou mais linhas<br>- Nao pode haver linhas sem referencia a paradas<br>- Tem de existir pelo menos uma linha que faca referencia a cada uma das paradas definidas',
      creation_date: 'Data de criação',
      confirm_delete_stop: 'Deseja deletar esta parada?',
      stop_added: 'Parada adicionada com sucesso',
      stop_deleted: 'Parada deletada com sucesso'
    },
    buttons: {
      delete_draft_tooltip: 'Eliminar rascunho',
      duplicate_tooltip: 'Copiar rascunho'
    },
    messages: {
      duplicate_confirm: 'Deseja copiar este rascunho?',
      duplicate_ok: 'Rascunho copiado com sucesso'
    }
  },
  cmr_lines: {
    table: {
      line_number: 'Número da linha',
      description: 'Descrição/Natureza',
      article_code: 'Código do artigo',
      article_code_seller: 'Código do vendedor',
      quantity: 'Quantidade',
      weight: 'Peso',
      unit_of_measure: 'Unidade de medida'
    },
    form: {
      title: 'Linha do documento de transporte',
      description: 'Descrição/Natureza',
      article_code: 'Código do artigo',
      article_code_seller: 'Código do vendedor',
      quantity: 'Quantidade',
      weight: 'Peso',
      unit_of_measure: 'Unidade de medida'
    },
    buttons: {
      add_line: 'Adicionar linha',
      add_line_tooltip: 'Adicionar uma nova linha ao documento',
      update_line: 'Atualizar linha',
      update_line_tooltip: 'Atualizar a linha selecionada',
      delete: 'Eliminar',
      delete_tooltip: 'Eliminar linhas selecionadas',
      submit_for_acceptance: 'Processar para aceitação',
      delete_draft_tooltip: 'Eliminar o rascunho do documento de transporte'
    },
    confirm_delete_line: 'Tem certeza de que deseja excluir esta linha?',
    confirm_delete_lines: 'Tem certeza de que deseja excluir {count} linhas?',
    line_added: 'Linha adicionada com sucesso',
    line_updated: 'Linha atualizada com sucesso',
    line_deleted: 'Linha eliminada com sucesso',
    lines_deleted: 'Linhas eliminadas com sucesso',
    no_lines_warning: 'Deve adicionar pelo menos uma linha',
    confirm_pending_status: 'O rascunho passará a estar em estado pendente para processamento a partir da tela de Documento de transporte',
    confirm_pending_status_transportist: 'As informações completas sobre o transporte não estão incluídas (dados obrigatórios do transportador e placas). Você pode fornecê-las mais tarde, mas sempre antes do envio. Clique em Confirmar para continuar e você poderá preencher os dados faltantes na tela do Documento de transporte ou Cancelar se preferir adicionar as informações a partir dos rascunhos.'
  },
  new_coacsu: {
    title: 'Novo resumo de conta comercial',
    seller: 'Vendedor',
    buyer: 'Comprador',
    summary_number: 'Número do resumo de conta comercial',
    issue_date: 'Data de emissão',
    delivery_date: 'Data de entrega',
    additional_data: 'Dados adicionais',
    select_seller: 'Selecione o vendedor',
    select_buyer: 'Selecione o comprador',
    payment_method: 'Método de pagamento',
    select_payment_method: 'Selecione o método de pagamento',
    payment_date: 'Data de vencimento',
    currency: 'Moeda',
    registration_date: 'Data de registo',
    code: 'Código',
    role: 'Papel',
    steps: {
      header: 'Cabeçalho',
      lines: 'Linhas'
    },
    seller_code: 'Código do vendedor',
    seller_role: 'Papel do vendedor',
    buyer_code: 'Código do comprador',
    buyer_role: 'Papel do comprador',
    lines: {
      title: 'Linhas',
      insert: 'Carregar',
      insert_tooltip: 'Adicionar linha',
      line_number: 'N.º linha',
      document_number: 'N.º documento',
      issue_date: 'Data de emissão',
      payment_date: 'Data de vencimento',
      total: 'Total',
      currency: 'Moeda',
      status: 'Estado',
      delete_tooltip: 'Eliminar linha',
      back: 'Voltar',
      save: 'Guardar',
      save_tooltip: 'Guardar alterações sem enviar para o Editrack',
      generate: 'Criar',
      generate_tooltip: 'Guardar e enviar COACSU para o Editrack',
      generating: 'A enviar para o Editrack...',
      generate_ok: 'COACSU enviado para o Editrack com sucesso.',
      cancel: 'Cancelar',
      dialog_title: 'Selecionar faturas',
      loading_invoices: 'A carregar faturas...',
      no_invoices: 'Não há faturas disponíveis com os filtros do COACSU atual.',
      add: 'Adicionar ({count})',
      delete_confirm: 'Deseja eliminar esta linha de COACSU?',
      delete_confirm_button: 'Confirmar',
      lines_saved: 'Linhas guardadas com sucesso.'
    },
    duplicate: {
      title: 'Fatura já incluída',
      message: 'A fatura {invoiceNumber} já pertence a um resumo de conta comercial existente (ID: {coacsuId}). Deseja criar um novo mesmo assim?',
      confirm: 'Criar mesmo assim',
      cancel: 'Cancelar'
    },
    errors: {
      summary_number_required: 'O número do resumo de conta comercial é obrigatório',
      issue_date_required: 'A data de emissão é obrigatória',
      payment_date_required: 'A data de vencimento é obrigatória',
      payment_method_required: 'O método de pagamento é obrigatório',
      save_error: 'Não foi possível guardar o COACSU.',
      load_error: 'Não foi possível carregar o detalhe do COACSU.',
      update_error: 'Não foi possível atualizar o COACSU.',
      create_error: 'Não foi possível criar o COACSU.',
      load_invoices: 'Não foi possível carregar a lista de faturas.',
      save_lines: 'Não foi possível guardar as linhas.'
    }
  },
  ...ptLocale,
  label: 'Português',

  date_format: 'DD/MM/YYYY',
  date_format_long: 'DD/MM/YYYY HH:mm:ss',
  date_format_calendar: 'DD/MM/YYYY',
  date_format_month: 'MM/YYYY',
  date_format_long_calendar: '@:date_format_calendar - HH:mm',
  date_format_long_datepicker: '@:date_format_calendar - HH:mm:ss',
  buttons: {
    btnRecovery: 'Restaurar senha',
    btnEnter: 'Entrar',
    btnSend: 'Enviar',
    btnFinish: 'Finalizar',
    btnNext: 'Próximo',
    btnDelete: 'Deletar',
    btnDeleteAll: 'Deletar todos',
    btnDeleteSelected: 'Excluir seleção',
    btnAdd: 'Carregar',
    btnSave: 'Salvar',
    btnBack: 'Voltar',
    btnSaveChanges: 'Salvar',
    btnCancelChanges: 'Reset',
    btnCancelChanges_tooltip: 'Cancelar alterações',
    btnSaveChanges_tooltip: 'Salvar alterações',
    btnSendSaveChanges_tooltip: 'Salvar e enviar',
    btnCancel: 'Cancelar',
    btnCancel_tooltip: 'Cancelar alterações',
    btnOk: 'Aceitar',
    btnConfirm: 'Confirmar',
    btnContinue: 'Continuar',
    btnSign: 'Firmar',
    btnBiometricSign: 'Firma biométrica',
    btnClear: 'Limpar',
    btnDownloadXSL: 'Exibir XSL',
    btnViewMetadata: 'Faça o download de metadados',
    btnDownloadLabels: 'Faça o download de etiquetas',
    btnDownload: 'Download',
    btnDownloadPdf: 'Download PDF',
    btnDownloadOrderRsp: 'Download resposta do pedido',
    btnReSend: 'Reenviar',
    btnCreateInvoice: 'Criar fatura retificativa',
    btnShow: 'Mostrar',
    btnShow_tooltip: 'Mostrar resultados',
    refresh_tooltip: 'Atualizar resultados',
    inicialize_tooltip: 'Recalcular',
    btnChangestatus: 'Alterar status',
    btnCoacsu: 'Coacsu',
    btnCoacsu_error_different_parties: 'Não é possível criar o COACSU: as faturas selecionadas devem ter o mesmo comprador e o mesmo vendedor',
    btnCoacsu_success: 'COACSU criado com sucesso',
    btnClose: 'Fechar',
    btnUpdate: 'Actualizar'
  },

  msg_generics: {
    no: 'Não',
    yes: 'Sim',
    deleting: 'Eliminando...',
    sending: 'Enviando...',
    send_ok: 'Enviado com sucesso',
    request_success: 'Pedido executado com sucesso',
    actual_version: 'Versão Atual',
    error_not_found: 'Ficheiro não encontrado',
    error_download_not_found: 'Erro no download. O(s) ficheiro(s) não foi(foram) encontrado(s)',
    error_download_pdf: 'Não foi possível fazer o download do PDF. Verifique com seu administrador.',
    no_match: 'Sem resultados',
    delveryNoteLines_selected: 'As linhas selecionadas são as linhas que serão enviadas na guia de remessa',
    field_required: 'Campo obrigatório',
    element_selected: 'Selecione um elemento',
    min_three_letters: 'Mínimo 3 letras',
    number_required: 'Deve ser um número',
    min_num_character: 'Mínimo {min} caracteres',
    max_num_character: 'Máximo {max} caracteres',
    max_value: 'Deve ser menor que {max}',
    no_file_selected: 'Não selecionou um ficheiro',
    format_invalid: 'Formato inválido',
    format_invalid_req_csv: 'Formato inválido, deve conter a extensão CSV',
    quantity_exceded: 'A quantidade expedida não pode exceder a quantidade pendente {max}',
    character_invalid: 'Caractere inválido',
    max_decimals: 'Máximo {max} decimais',
    max_numeric: 'Máximo {max} dígitos',
    format_goods_code_invalid: 'O formato deve ser XXXX XX XX (4 dígitos,um espaço,2 dígitos,um espaço e 2 dígitos). ',
    filter_selected: 'Adicionando o filtro selecionado à pesquisa ...',
    filter_no_selected: 'Você não pode excluí-lo. É necessário um intervalo de datas',
    filter_date_required: 'Você deve selecionar',
    filter_date: 'Alterando a data de pesquisa ...',
    filter_delete: 'Eliminando filtro e carregando novos dados ...',
    filter_delete_all: 'Eliminando todos os filtros de pesquisa ...',
    filter_table_menu: 'O que deseja ver na tabela? ',
    order_table: 'Ordenando tabela ...',
    size_table: 'Alterando o tamanho da tabela ...',
    pagination_table: 'Alterando a paginação da tabela ...',
    table_select_rows: 'Tem {num} elementos da tabela selecionados',
    load_init: 'Download de dados ...',
    loading: 'Carregando...',
    no_date: 'Sem data',
    no_quantity: 'Sem quantidade',
    no_price: 'Sem preço',
    information: 'Informação',
    invoiceDetails: 'Detalhes da fatura ',
    download_pdf: 'Download de PDF...',
    download_csv: 'Download de CSV....',
    load_download: 'Descarregando documento...',
    success: 'Sucesso',
    saving: 'Salvando alterações…',
    warning: 'Aviso',
    document_downloaded: 'Documento descarregado',
    download_file_ok: 'O download do ficheiro {filename} foi bem-sucedido',
    download_files_ok: 'O download dos ficheiros foi bem sucedido',
    download_metadata_ok: 'O download do ficheiro de metadados foi bem sucedido',
    success_download: 'O ficheiro {file} foi descarregado com sucesso',
    error_download: 'Erro ao descarregar o ficheiro',
    error_invalid_link: 'O link fornecido não é válido',
    error_load_data: 'Erro ao carregar os dados',
    error_unauthorized: 'Você não tem acesso às informações solicitadas. O link expirou.',
    order_response_ok: 'A resposta foi enviada com sucesso para pedido {order}',
    update_party: 'Atualizando empresas...',
    update_party_ok: 'Atualização de negócios bem sucedida',
    delete_file_ok: 'O ficheiro foi eliminado com sucesso',
    download_ok: 'O download foi executado com sucesso',
    date_required: 'Selecione uma data',
    date_range_required: 'Selecione um período',
    date_diff_error: 'Você não pode selecionar um intervalo maior que um ano',
    date_last_connection: 'Data da última conexão:',
    download_invoice_original: 'Download....',
    processing: 'Em processamento....',
    download_invoice_formatted: 'Download do guardado formatado....',
    download_metadata: 'Download de metadados...',
    upload_invoice: 'Criando ...',
    upload_attachment: 'Upload do Anexo ...',
    upload_parties_massive: 'Empresas de transformação ...',
    upload_centres_massive: 'Processando centros ...',
    upload_centre_approval_flow_massive: 'Processando fluxos de aprovação ...',
    upload_attachment_ok: 'Ficheiro carregado com sucesso',
    upload_issue: 'Criando incidência...',
    upload_issue_ok: 'Problema criado com sucesso.',
    issues_load_delete: 'Eliminando incidência...',
    redigitize: 'Enviando solicitação de redigitalização de fatura...',
    redigitize_ok: 'A solicitação de redigitalização foi enviada com sucesso',
    load_document: 'Carregar',
    upload_attachment_interlocutor: 'Anexo não visível pelo interlocutor',
    add_all_projects: 'Para todos os serviços',
    all_centres: 'Qualquer empresa / centro',
    file_selected: 'Selecione um ficheiro',
    iban: 'O campo Iban é obrigatório',
    ibanKo: 'O Iban introduzido não é correto',
    bic: 'O campo Bic é obrigatório',
    accountTitular: 'O campo Titular da conta é obrigatório',
    email: 'O campo Email é obrigatório',
    emailKo: 'O email digitado não está correto',
    donwloadModelo: 'Faça o download da solicitação de alteração de dados do modelo',
    popover_clean_filters: 'Limpar filtros',
    no_pending_task_status: 'Não foi encontrado nenhum estado configurado para o serviço',
    what_show: 'O que deseja ver na tabela?',
    alter_configuration: 'Este cambio puede alterar las configuraciones del servicio.',
    placeholder: {
      datepicker: 'Selecione uma data'
    },
    date_filter: 'Data',
    date: 'Data de RESOLUÇÃO',
    datepicker: {
      start_placeholder: 'De',
      separator: ' ',
      separator_empty: ' ',
      end_placeholder: 'Até',
      last_week: 'Última semana',
      last_month: 'Último mês',
      last_three_months: 'Últimos três mêses',
      last_year: 'Último ano',
      today: 'Hoje',
      last_two_year: 'Últimos dois anos'

    },
    advanced_search: 'Pesquisa avançada',
    question: {
      yes: 'Sim',
      no: 'Não'
    },
    validating_data: 'Validando os dados',
    all: 'Todos',
    onlyUserAdmin: 'Somente um usuário SuperAdmin pode selecionar todos os serviços.',
    nameDuplicate: 'Nome do perfil duplicado',
    taxDuplicate: 'Imposto duplicado',
    tax_legal_text_used: 'Existem linhas de fatura com o texto legal removido do imposto',
    hostDuplicate: 'Host duplicado',
    detail: 'Detalhe',
    global: 'Global'
  },

  lateral_menu: {
    invoices: {
      title: 'Faturas',
      emitted: 'Emitidas',
      received: 'Recebidas',
      third: 'Terceiros',
      drafts: 'Rascunhos',
      accounting_closes: 'Encerramentos contábeis',
      draft_accounting_closes: 'Rascunhos encerramentos',
      pending_tasks: 'Tarefas pendentes'
    },
    receptions: {
      title: 'Recepções',
      emitted: 'Emitidas',
      received: 'Recebidas'
    },
    carta: {
      title: 'Documento de transporte',
      emitted: 'Documentos de transporte'
    },
    delivery: {
      title: 'Notas de entrega',
      emitted: 'Emitidos',
      received: 'Recebidos'
    },
    orders: {
      title: 'Pedidos',
      emitted: 'Emitidos',
      received: 'Recebidos'
    },
    genrals: {
      title: 'Genrals',
      emitted: 'Emitidos',
      received: 'Recebidos'
    },

    auditory: {
      title: 'Auditoria',
      documents: 'Documentos',
      actions: 'Ações'
    },
    administration: {
      title: 'Administração',
      projects: 'Serviços',
      parties: 'Empresas',
      users: 'Utilizadores',
      plannedProcesses: 'Processos planejados',
      mailTemplates: 'Modelos de correio',
      profiles: 'Perfis',
      taxes: 'Impostos',
      mailServer: 'Servidores de Email',
      communication_method: 'Métodos de comunicação',
      articles: 'Artigos'
    },
    sales_report: {
      title: 'Relatório de vendas',
      view: 'Ver relatório'
    },
    inventory_report: {
      title: 'Relatório de inventário',
      view: 'Ver relatório'
    },
    remadv: {
      title: 'Aviso de liquidação',
      view: 'Ver aviso de liquidação'
    },
    coacsu: {
      title: 'Resumo de conta comercial',
      view: 'Ver resumo de conta comercial'
    }
  },

  breadcrumb: {
    empty: '',
    details: 'Detalhe',

    // PERFIL
    profile_init: 'Perfil',
    profile_general_data: 'Dados gerais',
    profile_password: 'Senha',
    profile_media_contact: 'Contactos',
    profile_parties: 'Empresas',
    profile_signature: 'Delegação de assinatura',

    // FACTURAS
    invoices_init: 'Faturas',
    invoices_emitted: '@:breadcrumb.invoices_init' + ' - Emitidas',
    invoices_received: '@:breadcrumb.invoices_init - Recebidas',
    invoices_third: '@:breadcrumb.invoices_init - Terceiros',
    invoices_drafts: '@:breadcrumb.invoices_init - Rascunhos',
    invoices_ocr: '@:breadcrumb.invoices_init - Aguardando validação',
    invoices_new_invoice: 'Nova fatura',
    invoices_accounting_closes: '@:breadcrumb.invoices_init - Encerramentos contábeis',
    reports_init: 'Relatórios',
    reports_emitted: '@:breadcrumb.reports_init - Emitidos',
    reports_received: '@:breadcrumb.reports_init - Recebidos',
    invoices_draft_accounting_closes: '@:breadcrumb.invoices_init - Rascunhos encerramentos',
    invoices_pending_tasks_title: '@:breadcrumb.invoices_init - Tarefas pendentes',
    invoices_pending_tasks_cover: 'Criação da capa',
    invoices_new_draft_accounting_closes: 'Novo encerramentos contábeis',
    cmr_draft_edit: 'Novo documento de transporte',

    // RECEPCIONES
    receptions_init: 'Recepções',
    receptions_emitted: '@:breadcrumb.receptions_init - Emitidas',
    receptions_received: '@:breadcrumb.receptions_init - Recebidas',
    receptions_new_invoice: 'Nova fatura',

    // ALBARANES
    delivery_notes_init: 'Notas de entrega',
    delivery_notes_emitted: '@:breadcrumb.delivery_notes_init - Emitidos',
    delivery_notes_received: '@:breadcrumb.delivery_notes_init - Recebidos',
    deliverynote_new_invoice: 'Nova fatura',

    // CMR
    cmr_init: 'Notas de remessa',
    cmr_draft_init: 'Rascunho documento de transporte',
    cmr_draft_new: 'Novo rascunho',

    // PEDIDOS
    orders_init: 'Pedidos',
    orders_emitted: '@:breadcrumb.orders_init - Emitidos',
    orders_received: '@:breadcrumb.orders_init - Recebidos',
    orders_new_invoice: 'Nova fatura',
    orders_new_deliveryNote: 'Nova nota de entrega',

    // PEDIDOS
    genrals_init: 'Genral',
    genrals_emitted: '@:breadcrumb.genrals_init - Emitidos',
    genrals_received: '@:breadcrumb.genrals_init - Recebidos',

    // AUDITORIA
    auditory_init: 'Auditoria',
    auditory_documents: '@:breadcrumb.auditory_init - Documentos',
    auditory_actions: '@:breadcrumb.auditory_init - Ações',

    // ADMINISTRACION
    administration_init: 'Administração',
    administration_project_projects: '@:breadcrumb.administration_init - Serviços',
    administration_party_parties: '@:breadcrumb.administration_init - Empresas',
    administration_project_add_project: 'Adicionar serviço',
    administration_project_projectparties: 'Empresas associadas',
    administration_project_add_party: 'Adicionar empresa',
    administration_project_admin_channels: 'Relações comerciais',
    administration_project_admin_channels_detail: 'Detalhe',
    administration_project_admin_centres: 'Centros',
    administration_project_admin_centresOfBuyer: 'Centros de compradores',
    administration_project_admin_centresOfSeller: 'Centros de fornecedores',
    administration_project_admin_centresbuyer: 'Centro do comprador',
    administration_project_admin_centresdelivery: 'Locais de entrega',
    administration_project_admin_centresinvoicee: 'Centro faturado',
    administration_users: '@:breadcrumb.administration_init - Utilizadores',
    administration_users_add_user: 'Adicionar utilizador',
    administration_project_add_centre: 'Adicionar centro',
    administration_plannedProcesses: '@:breadcrumb.administration_init - Processos planejados',
    administration_mailTemplates: '@:breadcrumb.administration_init - Modelos de correio',
    administration_profiles: '@:breadcrumb.administration_init - Perfis',
    administration_taxes: '@:breadcrumb.administration_init - Impostos',
    administration_mailServer: '@:breadcrumb.administration_init - Servidores de Email',
    administration_user_information: '@:breadcrumb.administration_init - Mensagem informativa',
    administration_mailServer_add_new: 'Criar configuração',
    administration_new: 'Novo',
    administration_communication_method: '@:breadcrumb.administration_init - Métodos de comunicação',
    administration_articles: '@:breadcrumb.administration_init - Artigos',

    // ISSUES
    issues_init: 'Problemas',
    issues_issues: '@:breadcrumb.issues_init',
    issues_add_issue: 'Criar problema',

    // DOCUMENTACION
    documentation_init: 'Documentação',
    documentation_documents: '@:breadcrumb.documentation_init',

    // ESTADISTICAS
    statistic_init: 'Estatísticas',
    statistic_emitted: '@:breadcrumb.statistic_init - Volume de faturas emitidas',
    statistic_received: '@:breadcrumb.statistic_init - Volume de faturas recebidas',
    statistic_other: '@:breadcrumb.statistic_init - Faturas geradas a partir de outro documento, pedido, recebimento ou guia de remessa',
    statistic_topseller: '@:breadcrumb.statistic_init - Os 20 principais fornecedores por volume econômico e número de faturas',
    statistic_parties: '@:breadcrumb.statistic_init - Volume de empresas registradas',
    statistic_rejected: '@:breadcrumb.statistic_init - Faturas: Tipos de rejeições e motivos para redigitalização',

    // SALESREPORT
    salesreport_init: 'Relatório de vendas',
    salesreport_view: '@:breadcrumb.salesreport_init - Relatório de vendas',

    // INVENTORYREPORT
    inventoryreport_init: 'Relatório de inventário',
    inventoryreport_view: '@:breadcrumb.inventoryreport_init - Relatório de inventário',

    // REMADV
    remadv_init: 'Remoção de advogados',
    remadv_view: '@:breadcrumb.remadv_init',

    // COACSU
    coacsu_init: 'Resumo da conta comercial',
    coacsu_emitted: '@:breadcrumb.coacsu_init - Emitidos',
    coacsu_received: '@:breadcrumb.coacsu_init - Recebidos',
    coacsu_view: '@:breadcrumb.coacsu_init',
    coacsu_detail: 'Resumo de conta comercial',
    new_coacsu: {
      title: 'Novo resumo de conta comercial'
    }
  },

  nav_header: {
    profile: 'Perfil',
    logout: 'Datar sessão'
  },

  login: {
    welcome: 'Iniciar sessão',
    twoFactorAuth: 'Autenticação de dois fatores',
    cautext: 'TELEFONE SUPORTE AO USUÁRIO',
    cautelephone: '91 191 00 00',
    canalcautext: 'Atendimento ao cliente: 900 365 365',
    titlevocento: 'Portal para envio e consulta de faturas',
    textvocento: 'A Vocento disponibiliza aos seus fornecedores e clientes uma plataforma online que responde às suas necessidades num único espaço.',
    titlevocento2: 'SUPORTE TÉCNICO',
    horariovocento: 'Horário de atendimento ao cliente',
    horario2vocento: 'Segunda a sexta-feira: 9:00 - 19:00',
    horario3vocento: 'Horário de Espanha (UTC/GMT +1).',
    horario4vocento: 'O serviço não é prestado em feriados nacionais',
    avisolegal: 'Aviso legal',
    politica: 'Política de privacidade',
    cookies: 'Política de cookies',
    userLabel: 'Utilizador',
    passLabel: 'Senha',
    codeLabel: 'Digite o código de verificação recebido em seu e-mail',
    contratLabel: 'Ainda não usufrui os benefícios deste serviço?',
    contratLabelRef: 'Consulte-nos...',
    helpLabelRef: 'Precisa de ajuda?',
    labelRef1: 'Informações básicas sobre proteção de dados:',
    labelRef2: 'A Redeia tratará os dados para gerir o registo e utilização da sua conta. Pode exercer os seus direitos de proteção de dados escrevendo um email para o seguinte endereço de email digame@redeia.com e aceder a toda a informação sobre o tratamento na nossa Política de Privacidade.',
    labelRef3: 'Ao pressionar “Enter” você declara que leu e entendeu o ',
    labelRef4: 'Política de Privacidade e Condições Gerais.',
    rules: {
      username: 'Insire o nome de utilizador',
      password: 'Insire a senha',
      email: 'Insire um email',
      code: {
        required: 'Por favor insira o código de 5 dígitos',
        pattern: 'O código deve ter 5 dígitos alfanuméricos'
      }
    },
    logging: 'Iniciando sessão...',
    title_new_pass: 'Restaurar senha',
    message_new_pass: 'Insire um utilizador associado ao produto para continuar',
    emailLabel: 'Email',
    sending: 'Enviando...',
    questionLabel: 'Pergunta',
    answerLabel: 'Resposta',
    passRecovery: 'Restaurar senha',
    backLoginForm: 'Voltar',
    error: {
      invalid_user: 'A combinação utilizador/senha é inválida.',
      user_not_found: 'Utilizador não encontrado.',
      email_without_account: 'Não existe nenhuma conta associada a este utilizador.',
      email_sended: 'Um e-mail foi enviado com a nova senha.',
      bad_final_form: 'Os dados fornecidos não são corretos. Por favor,tente novamente',
      invalid_code: 'O código foi usado ou expirou',
      reeProv_2: 'Erro dnie',
      reeProv_3: 'Erro smartcard',
      reeProv_1: 'Erro. Não existe o utilizador inserido',
      reeProv_4: 'Erro de certificado',
      reeProv_5: 'Utilizador ou senha incorreta. Lembre-se que tem 3 tentativas',
      reeProv_locked: 'Utilizador bloqueado',
      reeProv_renew: 'Credenciais expiradas',
      reeProv_exceptionTranslationFilter: 'ExceptionTranslationFilter',
      reeProv_expired: 'Sessão expirada'
    },
    messageMail: 'Se os dados inseridos estiverem corretos, seu e-mail receberá sua nova senha.',
    reeClientes: 'Acesso e-Fatura clientes',
    reeCliText: 'Se já é um cliente registado,pode aceder ao serviço de faturação eletrônica utilizando o seu nome de utilizador ou senha',
    reeProveedores: 'Acesso e-Fatura fornecedores',
    reeProvText: 'Se já é um fornecedor registado,pode aceder ao serviço de faturação eletrônica utilizando o seu nome de utilizador ou senha',
    logout_correct: 'Sessão terminada com sucesso',
    infoBrowser: 'Otimizado para Firefox v.67/Chrome v.74/Edge v.18'
  },

  // Perfil
  profile: {
    tabs: {
      general_data: 'Dados gerais',
      password: 'Senha',
      contact_data: 'Dados de contacto',
      parties: 'Empresas',
      signature_delegation: 'Delegação de assinatura'
    },

    general_data: {
      username: 'Nome de utilizador',
      profile_form: {
        name: {
          label: 'Nome',
          placeholder: 'Nome'
        },
        first_surname: {
          label: 'Sobrenome',
          placeholder: 'Sobrenome'
        },
        second_surname: {
          label: 'Segundo sobrenome',
          placeholder: 'Sobrenome'
        },
        identification_tax_number: {
          label: 'Nº identificação fiscal',
          placeholder: 'Nº identificação fiscal'
        },
        creation_date: {
          label: 'Data de criação'
        },
        last_connection_date: {
          label: 'Último login'
        },
        departament: {
          label: 'Departamento'
        }
      },
      load: {
        updating: 'Atualização do perfil ...'
      }
    },

    password: {
      change_password: 'Redefinição de senha',
      change_first_password: 'Você deve atualizar sua senha para continuar',
      change_password_form: {
        old_password: {
          label: 'Senha atual',
          placeholder: 'Senha atual'
        },
        new_password: {
          label: 'Nova senha',
          placeholder: 'Nova senha'
        },
        confirm_password: {
          label: 'Confirmação nova senha',
          placeholder: 'Nova senha'
        },
        secret_question: {
          label: 'Pergunta secreta',
          placeholder: 'Pergunta secreta'
        },
        current_secret_answer: {
          label: 'Resposta secreta atual',
          placeholder: 'Resposta secreta atual'
        },
        new_secret_answer: {
          label: 'Nova resposta secreta',
          placeholder: 'Nova resposta secreta'
        },
        confirm_secret_answer: {
          label: 'Confirmação nova resposta secreta',
          placeholder: 'Nova resposta secreta'
        }
      },
      rules_form: {
        pattern: "A senha deve ter pelo menos um dígito, uma maiúscula e um caractere especial (!{'@'}#$%^&*_=+-/).",
        pass_eqaul_newpass: 'A nova senha não pode ser a mesma que a atual.',
        fobidden_words: 'A nova senha contem palavras proibidas.',
        pass_equal_user: 'A nova senha não pode ser igual ao nome de utilizador.',
        newpass_not_equals_confirmation: 'As senhas não coincidem.',
        response_equal_newresponse: 'A nova resposta não pode ser a mesma que a atual.',
        newresponse_not_equals_confirmation: 'As respostas não coincidem.',
        validation_error: 'Erros de validação. Verifique o formulário.'
      }
    },
    error: {
      password: {
        required: {
          atual: 'Campo obrigatório: Senha atual',
          nueva: 'Campo obrigatório: Nova senha',
          repetida: 'Campo obrigatório: Confirmação nova senha',
          pregunta_secreta: 'Campo obrigatório: Pergunta secreta',
          oldSecretAnswer: 'O campo "Resposta secreta atual" é obrigatório.',
          newSecretAnswer: 'O campo "Nova resposta secreta" é obrigatório.',
          renewSecretAnswer: 'O campo "Confirmação nova resposta secreta" é obrigatório.'
        },
        wrongPassword: 'A senha atual inserida não está correta.',
        format_ko: 'Senha incorreta. A nova senha deve ter entre 12 e 64 caracteres e deve conter pelo menos um número,uma letra minúscula,uma letra maiúscula e um tipo de símbolo alternativo %_.@.',
        forbidden_word: 'Altere a senha. Não pode usar esse valor para a senha.',
        sameAsToday: 'A nova senha inserida é a mesma que a atual.',
        sameAsOne: 'A nova palavra-passe introduzida já foi utilizada anteriormente.',
        sameAsUsername: 'A nova senha inserida é a mesma que o nome de utilizador.',
        wrongConfirmation: 'A confirmação da nova senha deve ser a mesma que a nova senha.',
        secretAnswer_wrongSecretAnswer: 'A resposta secreta atual inserida não está correta.',
        secretAnswer_wrongConfirmation: 'A confirmação da resposta secreta não corresponde à resposta inserida anteriormente.',
        maxLength_nueva: 'Comprimento máximo do campo "Nova senha": 64 caracteres',
        minLength_nueva: 'Comprimento mínimo do campo "Nova senha": 12 caracteres',
        maxLength_repetida: 'Comprimento máximo do campo "Confirmação nova senha": 64 caracteres',
        minLength_repetida: 'Comprimento mínimo do campo "Confirmação nova senha": 12 caracteres',
        maxLength_secretQuestion: 'Comprimento máximo do campo "Pergunta secreta": 255 caracteres',
        maxLength_oldAnswer: 'Comprimento máximo do campo "Resposta secreta atual": 64 caracteres',
        maxLength_newSecretAnswer: 'Comprimento máximo do campo "Nova resposta secreta": 64 caracteres',
        maxLength_renewSecretAnswer: 'Comprimento máximo do campo "Confirmação nova resposta secreta": 64 caracteres'
      },
      contact_data: {
        format_email: 'O formato do e-mail não está correto.',
        format_phone: 'O formato do telefone não está correto.',
        user_media_exist: 'O meio selecionado já existe para o utilizador.',
        user_media_not_found: 'O meio selecionado não existe',
        required_id: 'O parâmetro userMediaId é obrigatório',
        required_type: 'O tipo de parâmetro é obrigatório',
        required_value: 'O valor do parâmetro é obrigatório'
      },
      general_data: {
        required: {
          name: 'Campo obrigatório: Nome',
          first_surname: 'Campo obrigatório: Sobrenome'
        },
        validation: {
          maxLength: {
            name: 'Comprimento máximo do campo "Nome": 50 caracteres',
            first_surname: 'Comprimento máximo do campo "Sobrenome": 50 caracteres',
            second_surname: 'Comprimento máximo do campo "Segundo sobrenome": 50 caracteres',
            id_number: 'Comprimento máximo do campo "Número de identificação fiscal": 20 caracteres'
          }
        }
      },
      parties: {
        validation: {
          maxLength_TaxID: 'Comprimento máximo do campo "Número de identificação fiscal": 50 caracteres',
          maxLength_tradeName: 'Comprimento máximo do campo "Nome": 150 caracteres',
          maxLength_gln: 'Comprimento máximo do campo "GLN": 15 caracteres',
          date: "'Data de' deve ser anterior a 'Data até'"
        }
      },
      tamanominimo_name: 'Nome: o tamanho mínimo é 3 caracteres.',
      tamanominimo_id: 'ID: o tamanho mínimo é 3 caracteres.',
      global: 'Ocorreu um erro. Contacte o seu administrador.'
    },
    contact: {
      contact_data_form: {
        type: {
          placeholder: 'Seleciona um tipo...'
        }
      },
      rules_form: {
        phone_format: 'O formato não corresponde a um número de telefone',
        email_format: 'O formato não corresponde a um email',
        contact_media_exist: 'O meio selecionado já existe para o utilizador',
        no_contact_media_exist: 'As informações de contato do tipo de e-mail são necessárias'
      },
      load: {
        add_user_media: 'Adicionando dados de contacto ...'
      }
    },

    signature: {
      presentation_title: 'INFORMAÇÃO',
      presentation_text: 'A autorização de assinatura eletrônica concedida à Indra Soluciones Tecnologías de la Información SL (ESB88018098) permite que você aplique uma assinatura eletrônica às faturas emitidas e geradas pela sua empresa. Essa assinatura eletrônica garante a origem e assegura a integridade do conteúdo para seus clientes, de acordo com o Artigo 2º da Ordem',
      presentation_text2: 'EHA / 962/2007,de 10 de abril.',
      instructions_title: 'INSTRUCTIONS',
      instructions_text1: 'Após o preenchimento dos campos deste formulário manual, será gerado um documento PDF que deverá ser assinado eletronicamente com o certificado da empresa emissora das faturas.',
      instructions_text2: 'Uma vez assinado, você pode fazer upload deste documento PDF neste ',
      instructions_text2_link: 'link',
      instructions_text2_dir: 'https://servicedesk-onesait.atlassian.net/servicedesk/customer/portal/68',
      instructions_text2b: ' ativar a delegação de assinatura sem incorrer em qualquer custo para o emissor.',
      instructions_text4: 'Se as faturas eletrônicas forem entregues a este serviço com uma assinatura eletrônica no formato exigido,essa delegação de assinaturas não será necessária.',
      dialog_add_pdf: {
        title: 'Carregar documento PDF assinado',
        select_file: 'Selecionar documento',
      },
      profile_signature_form: {
        valueNif: {
          placeholder: 'Digite 3 caracteres'
        },
        cargoFir: {
          placeholder: 'Escolha a categoria do signatário'
        },
        valueFechaDD: {
          placeholder: 'Dia - Formato DD'
        },
        valueFechaMM: {
          placeholder: 'Mês - Formato MM'
        },
        valueFechaAAAA: {
          placeholder: 'Ano - Formato AAAA'
        },
        resolucion: {
          placeholder: 'OPCIONAL'
        }
      },
      cFirman: {
        adm: 'Administrador',
        apo: 'Procurador',
        con: 'Conselheiro Delegado',
        dir: 'Diretor',
        ger: 'Gerente',
        rep: 'Representante legal',
        tit: 'Titular (independente)'
      },
      taxIdentificationNumber: {
        label: 'NIF DA EMPRESA',
        placeholder: 'taxIdentificationNumber'
      },
      corporateName: {
        label: 'RAZÃO SOCIAL DA EMPRESA',
        placeholder: 'corporateName'
      },
      cargoFirmante: {
        label: 'CATEGORIA DO SIGNATÁRIO',
        placeholder: 'categoria signatário'
      },
      name: {
        label: 'NOME DO SIGNATÁRIO',
        placeholder: 'Nome'
      },
      first_surname: {
        label: 'SOBRENOME DO SIGNATÁRIO',
        placeholder: 'Sobrenome'
      },
      second_surname: {
        label: 'SEGUNDO SOBRENOME DO SIGNATÁRIO',
        placeholder: 'Sobrenome'
      },
      dni: {
        label: 'ID DO SIGNATÁRIO',
        placeholder: 'id'
      },
      resolucion: {
        label: 'RESOLUÇÃO',
        placeholder: 'resolução'
      },
      fecha: {
        label: 'DATA',
        placeholder: 'data'
      },
      poblacionFirma: {
        label: 'LOCALIDADE ONDE A ASSINATURA TERÁ LUGAR',
        placeholder: 'Localidade assinatura'
      },
      address: {
        label: 'RUA / AVENIDA DA EMPRESA',
        placeholder: 'endereço'
      },
      town: {
        label: 'LOCALIDADE DA EMPRESA',
        placeholder: 'Localidade'
      },
      postcode: {
        label: 'CODIGO POSTAL DA EMPRESA',
        placeholder: 'codigo postal'
      },
      province: {
        label: 'PROVÍNCIA DA EMPRESA',
        placeholder: 'província'
      },
      countryName: {
        label: 'PAÍS DA EMPRESA',
        placeholder: 'nome do país'
      },
      countryNameUser: {
        label: 'PAIS DO SIGNATÁRIO',
        placeholder: 'countryName'
      },
      dniError: 'Dato incorreto,por favor,verifique o CC do signatário'
    },

    parties: {
      filters: {
        country: {
          value: 'País',
          placeholder: 'País'
        },
        enabled: {
          value: 'Ativado/Desativado',
          placeholder: 'Escolha...',
          enabled: 'Ativado',
          disabled: 'Desativado'
        },
        person: {
          value: 'Tipo de pessoa',
          placeholder: 'Tipo',
          physical: 'Física',
          legal: 'Jurídica'
        },
        project: {
          value: 'Serviço',
          placeholder: 'Serviço'
        },
        name: {
          value: 'Nome',
          placeholder: 'Nome'
        },
        tax_identification_number: {
          value: 'ID fiscal',
          placeholder: 'ID fiscal'
        }
      },
      entity_table: {
        name: 'Nome',
        tax_identification_number: 'ID Fiscal',
        gln: 'GLN',
        enabled: 'Ativo',
        country: 'País',
        province: 'Província',
        creation_date: 'Criação',
        business_register: 'R. Comercial',
        project: 'Serviço'
      }
    },
    notify: {
      changes_ok: 'Alterações salvadas com êxito.'
    }
  },
  // Incidencias
  issues: {
    filters: {
      creation_date: {
        value: 'Data-hora do registo',
        placeholder: ''
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      issue_type: {
        value: 'Tipo de problema',
        placeholder: 'Tipo'
      },
      subject: {
        value: 'Cabeçãlho',
        placeholder: 'Cabeçãlho'
      },
      priority: {
        value: 'Prioridade',
        placeholder: 'Prioridade'
      },
      description: {
        value: 'Descrição',
        placeholder: 'Descrição'
      }
    },
    historic: {
      title: 'História do estado',
      no_data: 'Não há estados',
      creationDateTime: 'Date',
      status: 'Status',
      comment: 'Comentário',
      user: 'Usuário',
      addStatus_tooltip: 'Carregar novo status',
      addStatus: 'Upload'
    },
    confirm: {
      title_delete: 'Tem certeza que deseja excluir este problema?',
      confirm_button_delete: 'Excluir',
      title_add_status: 'Criar novo status',
      confirm_button_add_status: 'OK'
    },
    notify: {
      delete_ok: 'O problema foi excluído com sucesso.',
      add_status_ok: 'O estado foi criado com sucesso.'
    },
    load: {
      delete: 'Excluindo incidente ...',
      add_status: 'Criando estado ...'
    },
    dialog_add_issue: {
      title: 'Criar incidente',
      form_add: {
        type: 'Tipo',
        priority: 'Prioridade',
        project: 'Serviço',
        buyer: 'Comprador',
        seller: 'Vendedor',
        subject: 'Assunto',
        description: 'Descrição'
      },
      notify: {
        error_issue_unique: 'Já existe um problema com esses dados'
      },
      button_add: 'Upload',
      button_add_tooltip: 'Problema de upload'
    },
    dialog_add_status: {
      status: 'Status',
      comment: 'Comentário',
      load_status: 'Criar estado'
    }
  },
  // Facturas emitidas y recibidas
  invoices: {
    filters: {
      creation_date: {
        value: 'Data-hora do registo',
        placeholder: ''
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      third: {
        value: 'Terceiro',
        placeholder: 'Insire 3 caracteres'
      },
      issue_date: {
        value: 'Intervalo datas emissão',
        placeholder: 'Data incidências'
      },
      operation_date: {
        value: 'Intervalo datas operação',
        placeholder: 'Data operação'
      },
      modification_date: {
        value: 'Intervalo datas da último estado',
        placeholder: 'Data estado'
      },
      invoice_number: {
        value: 'Nº Fatura',
        placeholder: 'Nº Fatura'
      },
      client_invoice_number: {
        value: 'Nº/Dados da fatura do cliente',
        placeholder: 'Nº/Dados da fatura do cliente'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      document_class: {
        value: 'Tipo de fatura',
        placeholder: 'Tipo de fatura'
      },
      communication_method: {
        send: {
          value: 'Mét. Envio',
          placeholder: 'Método'
        },
        reception: {
          value: 'Met. entrada',
          placeholder: 'Método'
        }
      },
      tax_type: {
        value: 'Tipo de imposto',
        placeholder: 'Imposto'
      },
      currency: {
        value: 'Divisa',
        placeholder: 'Divisa'
      },
      order_number: {
        value: 'Nº encomenda',
        placeholder: 'Encomenda'
      },
      contract_number: {
        value: 'Nº contrato/recepção',
        placeholder: 'Contrato/recepção'
      },
      delivery_note: {
        value: 'Nº nota de entrega',
        placeholder: 'Nota de entrega'
      },
      file_number: {
        value: 'Nº processo',
        placeholder: 'Processo'
      },
      invoice_series_code: {
        value: 'Nº código de série',
        placeholder: 'Código'
      },
      corrective_invoice_number: {
        value: 'Nº fatura corrigida',
        placeholder: 'Nº fatura corrigida'
      },
      channel: {
        value: 'Canal',
        placeholder: 'Canal'
      },
      register_number: {
        value: 'Nº registo',
        placeholder: 'Nº registo'
      },
      id_invoice: {
        value: 'Id interno',
        placeholder: 'Id interno'
      },
      no_error_status: {
        value: 'Estados excluídos',
        placeholder: 'Estados excluídos',
        rejected: 'Estados rejeitados',
        final: 'Estados finais'
      },
      invoice_type: {
        value: 'Subtipo de fatura',
        placeholder: 'Subtipo'
      },
      invoice_type_document: {
        value: 'Tipo de documento de fatura',
        placeholder: 'Tipo'
      },
      total_executable_amount_from: {
        value: 'Montante de',
        placeholder: 'Montante'
      },
      total_executable_amount_to: {
        value: 'Montante a',
        placeholder: 'Montante'
      },
      attachments: {
        value: 'Anexos',
        placeholder: 'Escolha...'
      },
      sent: {
        value: 'Enviada',
        placeholder: 'Escolha...'
      },
      rate: {
        value: 'Taxa',
        placeholder: 'Taxa'
      },
      cancellationRequest: {
        value: 'Pedido de anulação',
        placeholder: 'Escolha...'
      }
    },
    dialog_add_invoice: {
      title: 'Carregar fatura',
      project: {
        label: 'Serviço',
        placeholder: 'Escolha um serviço'
      },
      format: {
        label: 'Formato',
        placeholder: 'Escolha um formato'
      },
      communication_method: {
        label: 'Método de entrega',
        placeholder: 'Escolha método'
      },
      attachments: {
        label: 'Selecione anexo',
        error_attachment_extension: 'Formato de ficheiro não admitido',
        error_attachment_extension_values: 'O formato deve ser: ',
        error_attachment_size: 'Tamanho não permitido. O tamanho máximo é {argumento}',
        error_attachment_empty: 'O anexo está vazio, tem tamanho 0',
        error_attachment_duplicated: 'Já existe um anexo com o mesmo nome'
      },
      button_select_invoice: 'Selecione fatura',
      button_upload: 'Carregar'
    },
    attachment: {
      error_attachment_not_found: 'O anexo não existe.'
    },
    invoices_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      thirdParty: 'Terceiro',
      invoice_class: 'Classe do fatura',
      invoice_number: 'Nº fatura',
      issue_date: 'D. emissão',
      creation_date: 'D. registo',
      amount: 'Montante',
      status: 'Estado',
      reception_method: 'Met. entrada',
      communication_method: 'Mét. envio',
      currency: 'Divisa',
      register_number: 'Nº registo',
      series_code: 'Nº série',
      buyer_generic_centre: 'Centros de compradores',
      buyer_delivery_centre: 'Lugar de entrega',
      buyer_invoicee_centre: 'Centro faturado',
      buyer_centre: 'Centro comprador',
      seller_centre: 'Centros de vendedores',
      cancellation: 'Anulação',
      project: 'Serviço',
      channel: 'Canal',
      id_invoice: 'Id interno',
      accountingDate: 'Data de lançamento',
      paymentDate: 'Data de pagamento prevista',
      paymentMethod: 'Forma de pagamento',
      clientInvoiceNumber: 'Nº/Dados da fatura do cliente',
      csv_title: 'Exportar para CSV. Informação',
      csv_message: 'Não é possível exportar mais de 180.000 registros,restrinja sua pesquisa'
      // csv_message: 'Ao exportar grandes volumes de registros,o tempo e / ou limites de tamanho podem ser excedidos e o arquivo não pode ser gerado. Nesse caso,tente novamente com menos resultados'

    },
    tooltip: {
      attachments: 'Anexos',
      events: 'Eventos',
      detail: 'Detalhe',
      downloadPDF: 'Baixar PDF',
      addBuyerCenter: 'Adicionar centro de comprador',
      original: 'Baixar guardado',
      viewCSV: 'Veja XSL',
      sent: 'Enviada',
      withTaxes: 'Com impostos',
      withoutTaxes: 'Sem impostos liquidados',
      adminApprovalFlow: 'Fluxo de aprovação'
    },
    buttons: {
      upload_invoice: 'Carregar',
      upload_invoice_tooltip: 'Carregar fatura',
      upload_profile_tooltip: 'Criar perfil',
      download_invoices: 'PDF',
      download_invoices_tooltip: 'Baixar visualização em formato PDF',
      download_invoice_signed: 'Guardado',
      download_invoice_signed_tooltip: 'Baixar guardado',
      download_csv_tooltip: 'Baixar CSV',
      download_csv_details_tooltip: 'Baixar detalhe do CSV',
      download_csv_details: 'Detalhe do CSV',
      refresh_invoice: 'Atualizar',
      refresh_tooltip: 'Atualizar faturas'
    },
    loading: {
      download_invoices: 'Baixando Fatura(s) a PDF ...',
      download_invoices_original: 'Baixando Guardado/s ...',
      upload_wait: 'Atualizando ...'
    },
    error: {
      validation: {
        upload_file_formatoinvalido: 'O formato do documento não é válido. O formato permitido é EDI,XML ou XSIG.',
        parametro_obligatorio_invoice: 'O ficheiro fatura é obrigatório.',
        parametro_obligatorio_projectId: 'O ID do projeto é obrigatório.',
        valor_no_en_lista: 'Formato incorreto; possíveis valores: {argumento}',
        parametro_obligatorio_format: 'O formato é obrigatório.',
        proyecto_noexiste_noasociado: 'O projeto cin ID {argumento} não existe ou não está associado ao utilizador.'
      },
      auditoryEventsSearch_event_code_invalidFormat: 'A fatura não corresponde ao formato selecionado.',
      notSupported: 'A versão 1.0 da extensão não é suportada'
    }
  },
  invoice_related_documents_table: {
    date: 'Data de relacionamento',
    destinationDocument: 'Nº documento',
    destinationDocumentType: 'Tipo documento'
  },
  invoice_detail: {
    related_documents_no_data: 'Esta fatura não possui documentos relacionados',
    source_related_documents: 'Documentos relacionados',
    info_message: 'Alguns dos campos dos dados da fatura são editáveis. Lembre-se de clicar no botão \'Salvar\' para aplicar as alterações',
    info_message_download: 'Lembre-se de que é necessário fazer o download do modelo para enviar e / ou salvar as alterações',
    buttons: {
      download_invoice: 'PDF',
      download_labels: 'Etiquetas',
      download_invoice_tooltip: 'Baixar visualização em formato PDF',
      download_original_signed: 'Guardado',
      download_original_signed_tooltip: 'Baixar guardado',
      download_original_formatted: 'Formatado',
      download_original_formatted_tooltip: 'Baixar guardado formatado',
      download_metadata: 'Metadados',
      download_metadata_tooltip: 'Baixar metadados',
      generate_metadata_tooltip: 'Gerar metadatos',
      download_PDF: 'GERAR PDF COM OS DADOS INTRODUZIDOS',
      resend_invoice: 'Reenviar',
      resend_invoice_tooltip: 'Reenviar fatura',
      add_attachment: 'Carregar',
      add_attachment_tooltip: 'Carregar anexo',
      cancel_invoice: 'Cancelar',
      cancel_invoice_tooltip: 'Pedir anulação de fatura',
      visualize_with_xsl: 'XSL',
      visualize_with_xsl_tooltip: 'Visualizar XSL',
      visualize_with_xml: 'Arquivo',
      visualize_with_xml_tooltip: 'Fatura eletronica',
      redigitize_invoice: 'Redigitalizar',
      redigitize_invoice_tooltip: 'Enviar solicitação de redigitalização de fatura',
      check_status: 'Estado',
      check_status_tooltip: 'Consultar estado',
      check_payment_emit: 'Cobrança',
      check_payment_emit_tooltip: 'Detalhes de cobrança',
      check_payment: 'Pagamento',
      check_payment_tooltip: 'Detalhes de pagamento',
      accept_order: 'Aceitar',
      accept_order_tooltip: 'Aceitar pedido',
      error_rules_tooltip: 'Informe de validação'
    },
    dialog_error_rules: {
      title: 'Relatório de Validação',
      code: 'Campo',
      description: 'Descrição',
      location: 'Caminho'
    },
    dialog_add_buyer_center: {
      // 'Añadir centro comprador'
      title: 'Adicionar centro de comprador',
      centres: {
        label: 'Centro',
        // 'Elige centro de comprador'
        placeholder: 'Escolha um centro de comprador',
		required: 'Centro de comprador obrigatório'
      }
    },
    dialog_resend_invoice: {
      title: 'Reenviar fatura',
      communication_method: {
        label: 'Método de envio',
        placeholder: 'Escolha um método de envio'
      },
      get_emails: 'Receber e-mails... ',
      new_emails: 'Novos e-mails para enviar (separados por ;)',
      max_emails: 'Máximo de 5 mensagens electrónicas',
      no_emails: 'Introduzir pelo menos um endereço de correio eletrónico',
      email_format: 'Formato incorreto dos e-mails introduzidos (utilizar ; como separador, o último e-mail não deve terminar com ; )',
      multiple_emails: 'Se não for introduzido nenhum e-mail, será reencaminhado para os e-mails predefinidos associados. Se forem introduzidas mensagens de correio eletrónico, estas serão enviadas para as mensagens de correio eletrónico recentemente introduzidas.'
    },
    dialog_redigitize: {
      title: 'Solicitação de redigitalização de fatura',
      checkboxes: {
        label: 'Motivo do erro',
        field_bad_captured: 'Campo mal capturado',
        field_no_captured: 'Campo não capturado',
        field_incorrect: 'Campo capturado incorreto (tem outra posição no PDF)',
        field_others: 'Outros'
      },
      commentary: 'Comentário para a digitalização'
    },
    dialog_cancel_invoice: {
      title: 'Pedir anulação de fatura',
      motive: 'Motivo do pedido de anulação'
    },
    dialog_status_data: {
      title: 'Informação del estado',
      status: 'Estado',
      motive: 'Motivo',
      description: 'Descrição',
      date: 'Data',
      registrationCode: 'Código de registro'
    },
    error_code: {
      ERROR_PARTY: 'Faltam dados obrigatórios da empresa ou não cumpre a validação prevista.',
      ERROR_LINE_DESCRIPTION: 'Falta a descrição obrigatória em alguma linha.',
      ERROR_DIR_CODE: 'Falta o código DIR3 do organismo destinatário.',
      ERROR_PARTY_ENABLE: 'A empresa está desativada.',
      ERROR_SELLER_ADDRESS: 'O endereço do vendedor não é coerente com o seu país.',
      ERROR_BUYER_ADDRESS: 'O endereço do comprador não é coerente com o seu país.',
      ERROR_PROJECT_PARTY_ENABLE: 'A relação empresa-projeto está desativada.',
      ERROR_COMMERCIAL_RELATION: 'Não existe uma relação comercial válida entre as duas empresas.',
      ERROR_SPONSOR: 'Nenhuma das empresas tem uma configuração sponsor válida.',
      ERROR_CENTRE: 'Falta o centro exigido ou o indicado não é válido.',
      ERROR_UNIQUE_CENTRE: 'Os centros indicados não são únicos.',
      ERROR_DUPLICATE_INVOICE: 'Já existe uma fatura duplicada.',
      ERROR_DUPLICATE_RECADV: 'Já existe uma receção duplicada.',
      ERROR_DUPLICATE_ORDER: 'Já existe um pedido duplicado.',
      ERROR_DUPLICATE_ORDER_RSP: 'Já existe uma resposta de pedido duplicada.',
      ERROR_DUPLICATE_DELIVERY: 'Já existe um documento de transporte duplicado.',
      ERROR_DUPLICATE_CMR: 'Já existe um documento de transporte duplicado.',
      ERROR_DELIVERY_LINE_BATCH: 'Falta o lote em alguma linha de documento de entrega.',
      ERROR_DELIVERY_LINE_SERIAL_NUMBER: 'Falta o número de série em alguma linha de documento de entrega.',
      ERROR_DELIVERY_LINE_EXPIRATION_DATE: 'Falta a data de validade em alguma linha de documento de entrega.',
      ERROR_SEND_DATE: 'A data de envio não pode ser anterior a hoje.',
      ERROR_DELIVERY_LINE_DATES: 'A data de validade não é coerente com a data de entrega.',
      ERROR_DELIVERY_LINE_QUANTITY: 'A quantidade das sublinhas não corresponde à linha pai.',
      ERROR_DELIVERY_LINE_SUBLINE_REQUIRED: 'Cada linha deve ter pelo menos uma sublinha.',
      ERROR_DELIVERY_LINE_PACKAGE_GTIN14: 'As linhas do mesmo embalamento devem partilhar o mesmo GTIN14.',
      ERROR_DOCUMENT_SIGN: 'O documento deve vir assinado ou com assinatura delegada válida.',
      ERROR_ORDER: 'Falta o pedido obrigatório.',
      ERROR_UNIQUE_ORDER: 'O pedido deve ser único.',
      ERROR_ORDER_FORMAT: 'O formato do pedido não é válido.',
      ERROR_ISSUER_ORDER: 'Falta o pedido do emitente.',
      ERROR_ISSUER_UNIQUE_ORDER: 'O pedido do emitente deve ser único.',
      ERROR_ISSUER_ORDER_FORMAT: 'O formato do pedido do emitente não é válido.',
      ERROR_INVOICE_NUMBER_FORMAT: 'O número da fatura não tem um formato válido.',
      ERROR_EXP: 'Falta o processo obrigatório.',
      ERROR_UNIQUE_EXP: 'O processo deve ser único.',
      ERROR_EXP_FORMAT: 'O formato do processo não é válido.',
      ERROR_CONTRACT: 'Falta o contrato obrigatório.',
      ERROR_UNIQUE_CONTRACT: 'O contrato deve ser único.',
      ERROR_CONTRACT_FORMAT: 'O formato do contrato não é válido.',
      ERROR_INVOICE_DATE: 'A data da fatura não é válida.',
      ERROR_OPERATION_DATE: 'A data da operação não cumpre a validação.',
      ERROR_INVOICING_PERIOD: 'O período de faturação não é coerente.',
      ERROR_CORRECTIVE_INVOICE: 'A fatura corretiva não cumpre as condições básicas.',
      ERROR_CORRECTIVE_INVOICE_MANDATORY: 'Falta o bloco corretivo obrigatório.',
      ERROR_ISSUER_TYPE: 'O tipo de emitente não é válido para o documento.',
      ERROR_MODALITY_TYPE: 'A modalidade da fatura não é válida.',
      ERROR_PROJECT: 'Falta o projeto ou o indicado não é válido.',
      ERROR_INVOICE_PROJECT: 'O projeto da fatura não é válido.',
      ERROR_INTRASTAT_REQUIRED: 'Faltam os dados Intrastat obrigatórios.',
      ERROR_INVOICE_COMMUNICATION_METHOD: 'O método de comunicação da fatura não é válido.',
      ERROR_SPANISH_TAX_IDENTIFICATION_NUMBER: 'O NIF ou CIF espanhol não é válido.',
      ERROR_ISSUE_DATE_FUTURE: 'A data de emissão não pode ser posterior à data de registo ou criação.',
      ERROR_ISSUE_DATE_PAST: 'A data de emissão não pode ser anterior à data de registo ou criação.',
      ERROR_SIGN: 'O documento deve estar assinado.',
      ERROR_PROJECT_ATTACHMENT_DIRECTORY: 'Não existe a diretoria de anexos do projeto para a data indicada.',
      ERROR_NUMBER_EXP_FIRST_LINE: 'O número do processo só pode ser indicado na primeira linha ou no cabeçalho.',
      ERROR_NUMBER_CONTRACT_FIRST_LINE: 'O número do contrato só pode ser indicado na primeira linha ou no cabeçalho.',
      ERROR_NUMBER_TRANSACTION_FIRST_LINE: 'O número da transação só pode ser indicado na primeira linha ou no cabeçalho.',
      ERROR_CHANNEL: 'O canal ou documento do canal não é válido.',
      ERROR_TOTAL_LINES_WITHOUT_TAXES: 'O total das linhas sem impostos não bate certo.',
      ERROR_TOTAL_LINES_DISCOUNTS_AND_CHARGES: 'O total das linhas com descontos e encargos não bate certo.',
      ERROR_TOTAL_INVOICE: 'O total da fatura não bate certo.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_AND_CHARGES: 'O total da fatura com descontos e encargos não bate certo.',
      ERROR_TOTAL_INVOICE_WITH_DISCOUNTS_CHARGES_AND_TAXES: 'O total da fatura com descontos, encargos e impostos não bate certo.',
      ERROR_TOTAL_EXECUTABLE_INVOICE: 'O total executável da fatura não bate certo.',
      ERROR_TOTAL_INVOICE_TAXES: 'O total dos impostos da fatura não bate certo.',
      ERROR_CENTRE_ROLE_TYPE: 'A função do centro indicado não é válida.',
      ERROR_CENTRE_ROLE_TYPE_BY_VALUES: 'O centro não cumpre os valores permitidos para a função indicada.',
      ERROR_DRAFT_CENTRE_ROLE_TYPE_BY_VALUES: 'O rascunho do centro não cumpre os valores permitidos para a função indicada.',
      ERROR_CENTRE_ROLE_TYPE_MANDATORY: 'Falta o centro com a função obrigatória.',
      ERROR_LINE: 'O documento deve incluir pelo menos uma linha.',
      ERROR_LINE_CODE: 'Falta o código do artigo ou da linha.',
      ERROR_LINE_ORDER_EXIST: 'Alguma linha não tem pedido associado.',
      ERROR_PERIOD_DATE_INVOICE: 'As datas do período da fatura não são coerentes.',
      ERROR_SIGNATURE: 'A assinatura do documento não é válida ou não existe.',
      ERROR_LINE_TRANSACTION_REFERENCE: 'Falta o número do pedido ou a referência da transação em alguma linha.',
      ERROR_RECEIVER_TRANSACTION_REFERENCE: 'Falta a referência do pedido do destinatário no cabeçalho ou nas linhas.',
      ERROR_CENTRE_VOCENTO_WS: 'Falhou a validação dos centros contra o serviço Vocento.',
      ERROR_CURRENCY_EXCHANGE: 'A taxa de câmbio não é válida ou está em falta.',
      ERROR_IBAN: 'O IBAN não é válido.',
      ERROR_VALID_IBAN: 'O IBAN não supera a validação formal.',
      ERROR_LINE_SEQUENCE_NUMBER: 'O número de sequência da linha não é válido.',
      ERROR_PAYMENT_MEAN: 'O método de pagamento não é permitido.',
      ERROR_FILE_SIZE: 'O tamanho total dos ficheiros excede o máximo permitido.',
      ERROR_REGISTRATION_DATA: 'Os dados de registo não são válidos ou estão incompletos.',
      ERROR_REGISTRATION_DATA_INDRAFE: 'Os dados de registo Indrafe não são válidos ou estão incompletos.',
      ERROR_SEQUENCE_NUMBER: 'O número de sequência não é válido.',
      ERROR_INVOICE_BUYER_CENTRE: 'O centro do comprador não é válido.',
      ERROR_INVOICE_CENTRE_MASK: 'A máscara do centro da fatura não é válida.',
      ERROR_INVOICE_CENTRE_ROL: 'A função do centro da fatura não é válida.',
      ERROR_EIFFAGE_VALIDATION_INVOICE_SERVICE: 'Falhou a chamada ao serviço externo de validação Eiffage.',
      ERROR_INVOICE_BUYER_DIRE: 'Falta ou é inválido o código DIR3 do comprador.',
      ERROR_CORRECTIVE_SIGN: 'A assinatura da fatura corretiva não é válida.',
      ERROR_PARTY_NAME: 'O nome da empresa não é válido ou não cumpre o formato.',
      ERROR_LINE_DOCUMENT_CANAL: 'O documento do canal da linha não é válido.',
      ERROR_INVOICE_CORRECTIVE_METHOD: 'O método de correção da fatura corretiva não é válido.',
      ERROR_NIF_CODPAIS: 'O NIF deve incluir o prefixo do país.',
      ERROR_WITHHOLDING_AMOUNT_WITH_TAXABLE_BASE: 'O valor da retenção não coincide com a base tributável.',
      ERROR_NON_SIMULTANEOUS_TRANSACTION_AND_CONTRACT: 'Não é possível indicar pedido e contrato simultaneamente.',
      ERROR_CONTRACT_AND_TRANSACTION_IN_RECADV: 'O pedido e o contrato não coincidem com a receção registada.',
      ERROR_EUR_CURRENCY: 'A moeda deve ser euros.',
      ERROR_CENTRE_PERMANENT_ESTABLISHMENT: 'O centro permanente não cumpre a configuração territorial.',
      ERROR_IGIC_FROM_CANARY_ISLANDS: 'Falta ou não corresponde o IGIC para as Canárias.',
      ERROR_IPSI_FROM_CEUTA: 'Falta ou não corresponde o IPSI para Ceuta.',
      ERROR_NUMBER_OF_ATTACHED_FILES: 'O número de anexos não é válido.',
      ERROR_ATTACHED_FILES_EXTENSION: 'A extensão dos anexos não está permitida.',
      ERROR_TAXES_IN_PROJECT: 'Os impostos indicados não são permitidos para o projeto.',
      ERROR_FILE_FORMAT: 'O formato do ficheiro não é válido.',
      ERROR_TAX_CERO_LEGAL_TEXT: 'Uma operação com tipo 0 deve incluir texto legal.',
      ERROR_CORRECTIVE_INVOICE_ORDER_OR_CONTRACT: 'A fatura corretiva deve indicar pedido ou contrato.',
      ERROR_CORRECTIVE_REQUIRED: 'Falta o bloco corretivo obrigatório na fatura corretiva.',
      ERROR_PARTY_BUYER_ADDRESS_VALUE: 'O valor do endereço do comprador não é válido.',
      ERROR_SPECIFIC_CANARY: 'A fatura não cumpre as validações específicas das Canárias.',
      ERROR_SPECIFIC_CEUTA: 'A fatura não cumpre as validações específicas de Ceuta.',
      ERROR_PHYSICAL_GLN_REQUIRED: 'Falta o GLN físico obrigatório.',
      ERROR_NO_IGIC_IVA: 'Não é possível indicar IGIC e IVA ao mesmo tempo.',
      ERROR_EXITS_PAYMENT_DETAILS: 'Faltam informações sobre métodos de pagamento.',
      ERROR_LINE_FROM_RECADV_PRICE_QUANTITITY_POSITIVE: 'Em faturas provenientes de receção, a quantidade e o preço têm de ser positivos.',
      ERROR_INVOICE_LINES_NO_NEGATIVE: 'Em faturas manuais, a quantidade e o preço não podem ser negativos.',
      ERROR_LINE_CORRECTIVE_PRICE_NEGATIVE: 'Em faturas corretivas, o preço deve ser negativo.',
      ERROR_LINE_NO_SAME_TAX: 'A mesma linha não pode repetir o mesmo imposto.',
      ERROR_INVOICE_FROM_RECADV: 'Não existe uma receção coincidente para a fatura.',
      ERROR_INVOICE_ADDITIONAL_INFO_FROM_RECADV: 'A fatura não coincide com a informação adicional da receção.',
      ERROR_INVOICE_DOCUMENT_VALUES_FROM_RECADV: 'A fatura não coincide com os valores do documento da receção.',
      ERROR_INVOICE_LINE_DATA_FROM_RECADV: 'A fatura não coincide com os dados da linha da receção.',
      ERROR_INVOICE_ISSUE_DATE_REJECTED: 'A fatura já existe com outra data de emissão.',
      ERROR_GENERIC: 'Erro genérico'
    },
    invoice_detail_edit_form: {
      status: 'Estado da fatura',
      internalStatus: 'Estado interno da fatura',
      invoice_number: 'Número da fatura',
      buyer: 'Comprador',
      issue_date: 'Data de emissão',
      communication_send_method: 'Método de envio',
      change_state: {
        label: 'Redefinição de estado',
        placeholder: 'Escolha um estado de fatura'
      },
      change_internal_state: {
        label: 'Redefinição de estado interno',
        placeholder: 'Escolha um estado interno de fatura'
      },
      change_sent_flag: {
        label: 'Estado de envio',
        placeholder: 'Escolha um estado de envio'
      },
      total_executable_amount: 'Montante',
      seller: 'Vendedor',
      creation_date_time: 'Data de registo',
      communication_reception_method: 'Método de entrada',
      observations: 'Motivo da mudança de estado',
      internal_observations: 'Motivo da mudança de estado interno',
      pending_task: 'Tarefa pendente',
      internal_notes: 'Notas internas',
      registerNumber: 'Número de registro'
    },
    error: {
      validation: {
        id_invoice_empty: 'O identificador de fatura não pode ser null',
        field_bad_captured_empty: 'O campo mal redigitalizado não pode ser null',
        field_category_empty: 'A categoria não pode estar vazia',
        field_category_incorrect: 'Categoria indicada incorreta'
      }
    },
    attachment: 'Anexos',
    no_attachment: 'Não tem anexos associados',
    attachments_table: {
      filename: 'Nome',
      category: 'Categoria',
      size: 'Tamanho',
      compressed_size: 'T. Comp.',
      creation_date: 'Criação',
      author: 'Criador'
    },
    payment_table: {
      remasa: 'Consignação',
      invoice_number: 'N. fatura',
      banco: 'Banco',
      desBanco: 'Descrição do banco',
      viaPago: 'Forma de pagamento',
      desViaPago: 'Descrição da forma de pagamento',
      fechaAcept: 'Data de aceitação',
      fechaVenc: 'Data de validade',
      fechaValor: 'Data de validade',
      moneda: 'Moeda',
      importeDivisa: 'Valor da moeda',
      importeComDivi: 'Valor compensado',
      situacion: 'Estado',
      codigoFianza: 'Código de fiança',
      numeroDocumento: 'Documento',
      importe: 'Valor EUR',
      receptorAlternativo: 'Receptor alternativo',
      detalleCompensacion: 'Detalle de compensación',
      detalleCompensacionPago: 'Documento/s pago',
      detalleCompensacionCobro: 'Documento/s cobro'

    },
    dialog_add_invoice_attachment: {
      title: 'Carregar anexo',
      load_document: 'Carregar',
      file_selected: 'Selecione anexo'
    },
    events: {
      title: 'Eventos',
      code: {
        SIGNED: 'Assinada',
        description: {
          SIGNED: 'Assinada eletrónicamente'
        },
        REJECTED: 'Rejeitada',
        VALIDATE_SIGNATURE: 'Verificação de Assinatura',
        reject: 'Rejeitada',
        DISAGREEMENT: 'Não compatível',
        PENDING_OF_SIGNING: 'Pendente de assinatura',
        PENDING_OF_SEND: 'Pendende de envio',
        UPDATE_STATUS: 'Atualização do estado',
        UPDATE_INTERNAL_STATUS: 'Atualização do estado interno',
        ADD_ATTACHMENT: 'Anexar ficheiro',
        DELETE_ATTACHMENT: 'Eliminação anexo',
        RECEIVED: 'Recebido',
        SEND_INVOICE: 'Envio de fatura',
        SEND_INVOICE_ORIGIN: 'Envio de fatura a origem',
        SEND_STATE: 'Envio do estado',
        SEND_CANCELINVOICE: 'Pedido de anulação',
        PENDING_OF_VERIFYING: 'Pendente de verificação',
        PENDING_OF_GENERATE: 'Geração pendente',
        PENDING_OF_VALIDATION: 'Pendente de validação',
        FORWARD_INVOICE: 'Reenvio de fatura',
        CHECK_STATUS_ONLINE: 'Consulta de estado online',
        NOTIFICATION: 'Notificação',
        RECEPTION_INVOICE: 'Recepção de fatura',
        RECEPTION_ORIGINAL_INVOICE: 'Recepção de fatura original',
        YIELDED: 'Cedido',
        COMPENSATED: 'Compensado',
        PENDING_OF_COMPENSATION: 'Compensação pendente',
        PENDING_OF_CONFIRM: 'A ser confirmado',
        COLLECTED: 'Carregada',
        PENDING: 'Pendente',
        RETAINED_PAYMENT: 'Pagamento retido'
      },
      property: {
        FILE_NAME: 'Nome do ficheiro',
        REASON: 'Razão',
        ORIGINAL_STATUS: 'Estado original',
        FINAL_STATUS: 'Estado final',
        SIGNATURE_DATE: 'Data de assinatura',
        DATE: 'Data pendente de validação',
        DISAGREEMENT: 'Não compatível',
        PENDING_OF_SIGNING_DATE: 'Data pendente de assinatura',
        PENDING_OF_VERIFYING_DATE: 'Data pendente de verificação',
        RECEPTION_DATE: 'Data de recepção',
        REJECT_DATE: 'Data de rejeição',
        MOTIVE: 'Motivo',
        STATUS_BEFORE: 'Estado inicial',
        LAST_STATUS: 'Estado final',
        INTERNAL_MOTIVE: 'Motivo interno',
        INTERNAL_STATUS_BEFORE: 'Estado interno inicial',
        LAST_INTERNAL_STATUS: 'Estado interno final',
        MESSAGE_RESULT: 'Mensagem de resposta',
        ERROR_CODE: 'Código de erro',
        ERROR_DESCRIPTION: 'Descrição da erro',
        ENDPOINT_STATUS: 'Estado cliente',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        DOCUMENT_INTEGRATED: 'Documento integrado',
        INVOICE_ACCEPTED: 'Fatura aceite',
        INVOICE_OPENED: 'Facturaem aberto',
        REJECT_CODE: 'Código de rejeição',
        REJECT_DESCRIPTION: 'Descrição da rejeição',
        REGISTRATION_CODE_PROPERTY: 'Código de registo',
        REGISTRATION_DATE_PROPERTY: 'Data de registo',
        ERROR_DOWNLOAD_PROPERTY: 'Motivo do erro',
        DOWNLOAD_PROPERTY: 'Motivo do download',
        DELETE_DIR: 'Eliminado',
        REJECT: 'Rejeição',
        reject: 'Rejeição',
        USER: 'Utilizador',
        USER_NAME: 'Utilizador',
        signature: {
          no: {
            such: {
              algorithm: {
                exception: {
                  creating: {
                    signature: 'Erro na assinatura'
                  }
                }
              }
            }
          }
        },
        PROPERTY_REJECT_CODE: 'Código de rejeição',
        PROPERTY_ERROR_CODE: 'Código de error',
        PROPERTY_REJECT_DESCRIPTION: 'Descrição da rejeição',
        PROPERTY_ERROR_DESCRIPTION: 'Descrição da erro',
        SIGNATURE_ERROR: 'Erro de assinatura',
        MESSAGE: 'Mensagem',
        RECEPTION_DATE_PLATFORM: 'Data de recepção na plataforma',
        RECEPTION_ORIGINAL_DATE_PLATFORM: 'Data de recepção original na plataforma',
        SEND_DATE: 'Facturaenviada. Data de envio'
      },
      no_events: 'Não tem eventos associados'
    },
    eventsbpm: {
      title: 'Eventos de fluxo de aprovação'
    },
    load: {
      update_invoice: 'Atualização dos dados da fatura ...',
      resend_invoice: 'Reenviando esta fatura ...',
      collecting_buyer_center: 'Recuperando centros de comprador ...',
      add_buyer_center: 'Adicionando centro de comprador ...',
      download_attachment: 'Baixando anexo ...',
      delete_attachment: 'Eliminando anexo ...',
      checking: 'Consultando ...'
    },
    notification: {
      resend_invoice_ok: 'A fatura foi reenviada com sucesso',
      resend_invoice_warn_suffix: ' mas foi obtido um erro durante o envio',
      add_buyer_center_ok: 'Centro de comprador adicionado com sucesso',
      cancel_invoice_ok: 'A fatura foi cancelada com sucesso',
      submit_edit_invoice_ok: 'A fatura foi editada com sucesso',
      resend_invoice_ko_retained: 'A fatura não foi enviada porque estava em estado retido',
      check_status_invoice_ok: 'O estado da fatura foi consultado com sucesso',
      resend_same_project: 'Todas as faturas devem pertencer ao mesmo serviço',
      resend_same_country: 'As faturas devem ter o mesmo país destinatário',
      resend_same_emission: 'Todas as faturas devem ser emitidas ou recebidas',
      resend_invoices_ok: 'As faturas foram encaminhadas com sucesso',
      resend_not_all: 'Algumas das faturas não atendem às condições para reapresentação',
      resend_any: 'Nenhuma das faturas selecionadas atende às condições de encaminhamento',
      submit_edit_invoices_ok: 'Status de fatura atualizados corretamente',
      no_results_payment: 'Nenhum dado encontrado para esta fatura'
    }
  },

  // Documentos OCR
  ocr: {
    filters: {
      creation_date: {
        value: 'Fecha de registro',
        placeholder: ''
      },
      ocr_process_date: {
        value: 'Fecha de procesamiento OCR',
        placeholder: ''
      },
      project: {
        value: 'Servicio',
        placeholder: 'Servicio'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Vendedor'
      },
      document_name: {
        value: 'Documento',
        placeholder: 'Documento'
      },
      document_number: {
        value: 'N° documento',
        placeholder: 'N° documento'
      },
      email: {
        value: 'Email emisor',
        placeholder: 'Email emisor'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      documenttype: {
        value: 'Tipo documento',
        placeholder: 'Tipo documento'
      },
      mail_server: {
        value: 'Email receptor',
        placeholder: 'Email receptor'
      }
    },
    documents_entity_table: {
      locked_icon: 'Bloqueado',
      document_name: 'Documento',
      document_number: 'Nº documento',
      email_from: 'Email',
      status_document: 'Status',
      project: 'Serviço',
      seller: 'Vendedor',
      mail_server: 'Email receptor',
      document_type: 'Tipo documento',
      message_status: 'Mensagem',
      creation_date: 'Data criação',
      ocr_process_date: 'Data processo OCR',
      locked_at: 'Data bloqueio',
      locked_by: 'Bloqueado por',
      attachments: 'Anexos'
    },
    attachments_table: {
      filename: 'Nome',
      size: 'Tamaño',
      compressed_size: 'T. Comp.',
      creation_date: 'D. criação'
    },
    select_placeholder: 'Selecione...',
    title_ocr_document_validation_page: 'Validação de documentos',
    document_block_label_info: 'Está no modo de visualização. Documento bloqueado por outro utilizador.',
    block_tooltip: 'Bloqueado',
    no_ocr_attachment_data: 'Não há anexos associados',
    ocr_attachment: 'Anexos',
    no_ocr_lines_data: 'Não há linhas associadas ao documento',
    ocr_lines: 'Linhas de documento',
    buttons: {
      reject: 'Recusar',
      approve: 'Aprovar',
      permanent_lock: 'Bloquear',
      permanent_unlock: 'Desbloquear'
    },
    permanent_lock: {
      confirm_lock: 'Tem certeza de que deseja ativar o bloqueio permanente neste documento?',
      confirm_unlock: 'Tem certeza de que deseja desativar o bloqueio permanente neste documento?',
      locking: 'Bloqueando documento...',
      unlocking: 'Desbloqueando documento...',
      locked_success: 'Documento bloqueado permanentemente',
      unlocked_success: 'Documento desbloqueado com sucesso'
    },
    // Formulario de pantalla de validación de documentos
    detail_form: {
      // Información de bloques
      general_data: 'Informações do cabeçalho',
      supplier_data: 'Informações do fornecedor',
      receiver_data: 'Informações do cliente',
      total_data: 'Totais',
      taxes: 'Impuestos',
      // Campos información de cabecera
      invoiceNumber: 'Número da fatura',
      invoiceSeriesCode: 'Código de série',
      invoiceDate: 'Data da fatura',
      invoiceType: 'Tipo de fatura',
      invoiceType_ocrValue: 'Valor reconhecido: ',
      correctiveInvoiceId: 'Retificando fatura',
      deliveryDate: 'Data de entrega',
      purchaseOrder: 'Ordem',
      // Campos información del proveedor
      nif_tooltip: 'O id fiscal está normalizado, pode não corresponder ao formato indicado no PDF',
      supplierTaxId: 'Identificador fiscal',
      supplierName: 'Nome',
      supplierAddress: 'Endereço',
      supplierIban: 'Conta bancária',
      supplierEmail: 'E-mail',
      // Campos información del cliente
      receiverTaxId: 'Identificador fiscal',
      receiverName: 'Nome',
      receiverAddress: 'Endereço',
      buyerCentreCode: 'Código do centro comprador',
      // Campos totales
      netAmount: 'Base tributária',
      totalTaxAmount: 'Impostos totais',
      totalAmount: 'Fatura total',
      totalDisbursements: 'Total de despesas reembolsáveis',
      currency: 'Distintivo de moeda'
    },
    taxes_table: {
      // Campos impuestos
      amount: 'Base tributária',
      taxRate: 'Avaliar(%)',
      taxAmount: 'Imposto',
      categoryCode: 'Tipo de imposto'
    },
    lines_table: {
      // Campos líneas
      productCode: 'Código',
      amount: 'Quantia',
      description: 'Descrição',
      quantity: 'Quantia',
      unit: 'Unidade',
      unitPrice: 'Preço unitário',
      purchaseOrder: 'Ordem'
    },
    document_class: {
      ORIGINAL: 'Original',
      RECTIFICATIVA: 'Retificativa'
    },
    send_ocr_document: {
      confirm: {
        params_required: 'Parâmetros necessários não encontrados',
        title_approve: 'Deseja aprovar a fatura?',
        title_reject: 'Deseja rejeitar a fatura?',
        confirm_button_send_document: 'Confirmar',
        approving: 'Aprovando fatura ...',
        rejecting: 'Rejeitando fatura ...',
        nextDocumentInfo: 'O próximo documento foi carregado para validação',
        approve_notification: 'Documento aprovado com sucesso',
        form_notification_error: 'Validar campos de formulário incorretos',
        reject_notification: 'Documento rejeitado com sucesso'
      }
    }
  },

  // Eliminadores
  drafts: {
    filters: {
      creation_date: {
        value: 'Data de registo',
        placeholder: ''
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      buyer_centre: {
        value: 'Centro comprador',
        placeholder: 'Centro'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      seller_centre: {
        value: 'Centro vendedor',
        placeholder: 'Centro'
      },
      invoice_number: {
        value: 'Nº fatura',
        placeholder: 'Nº fatura'
      },
      invoice_series_code: {
        value: 'Nº série',
        placeholder: 'Código'
      },
      currency: {
        value: 'Divisa',
        placeholder: 'Divisa'
      },
      issue_date: {
        value: 'Intervalo datas emissão',
        placeholder: 'Data incidências'
      },
      operation_date: {
        value: 'Intervalo datas operação',
        placeholder: 'Data operação'
      }
    },
    drafts_entity_table: {
      project: 'Serviço',
      buyer: 'Comprador',
      seller: 'Vendedor',
      issue_date: 'D. emissão',
      invoice_number: 'Nº fatura',
      operation_date: 'D. operação',
      creation_date: 'D. registo',
      total_outstanding_amount: 'Total a pagar',
      total_executable_amount: 'Total executável',
      currency: 'Divisa'
    },
    buttons: {
      create_invoice: 'Criar fatura'
    }
  },

  draft_detail: {
    info_draft: 'Informação',
    info_message: 'Alguns dos campos dos dados da fatura são editáveis. Lembre-se de clicar no botão \'Salvar\' para aplicar as alterações',
    copy_draft: 'Copiar',
    copy_draft_tooltip: 'Copiar rascunho da fatura',
    edit_draft: 'Editar',
    edit_draft_tooltip: 'Editar rascunho da fatura',
    delete_draft: 'Eliminar',
    delete_draft_tooltip: 'Eliminar rascunho da fatura',
    csv_title: 'Exportar para CSV. Em formação',
    csv_message: 'Não é possível exportar mais de {argumento} registros, por favor, restrinja sua pesquisa',
    draft_detail_edit_form: {
      invoice_number: 'Número da fatura: ',
      buyer: 'Comprador: ',
      issue_date: 'Data de emissão: ',
      total_executable_amount: 'Montante ({code}): ',
      seller: 'Vendedor: ',
      creation_date_time: 'Data de registo: ',
      invoice_additional_information: 'Observações: ',
      other_additional_information: 'Outras observações: '
    },
    attachment: 'Anexos',
    no_attachment: 'Não tem anexos associados',
    add_attachment: 'Carregar',
    add_attachment_tooltip: 'Carregar documento anexo',

    attachments_table: {
      filename: 'Nome',
      category: 'Categoria',
      size: 'Tamanho',
      compressedSize: 'T. Comp.',
      creationDate: 'Criação',
      author: 'Criador'
    },
    dialog_copy_draft: {
      title: 'Copiar fatura',
      invoice_number: 'Número da fatura',
      issue_date: 'Data de emissão',
      copy_documents: 'Copiar anexos',
      button_copy: 'Copiar fatura'
    },
    dialog_add_attachment: {
      title: 'Carregar anexo',
      form_dialog_add_attachment: {
        select_file: 'SELECIONAR ANEXO'
      },
      button_upload: 'Carregar',
      button_upload_tooltip: 'Carregar anexo'
    },
    confirm: {
      title_delete_draft: 'Tem certeza de que deseja eliminar este rascunho?',
      confirm_button_delete_draft: 'Eliminar',
      title_delete_attachment: 'Tem certeza de que deseja eliminar este anexo?',
      confirm_button_delete_attachment: 'Eliminar',
      delete_draft: 'Eliminando rascunho ...'
    },
    load: {
      init_draft_data: 'Carregamento dos dados do rascunho ...',
      cancel_edit_draft_data: 'Restaurando os dados do rascunho ...',
      copy_draft: 'Copiando rascunho ...',
      delete_draft: 'Eliminando rascunho ...',
      delete_attachment: 'Eliminando anexo ...',
      download_attachment: 'Baixando anexo ...'
    },
    notify: {
      copy_draft_ok: 'O rascunho foi copiado com sucesso.',
      copy_draft_partial_one: 'O rascunho foi copiado, mas 1 anexo não pôde ser copiado.',
      copy_draft_partial_many: 'O rascunho foi copiado, mas {count} anexos não puderam ser copiados.',
      delete_draft_ok: 'O rascunho foi eliminado com sucesso.',
      download_attachment_ok: 'O download do ficheiro: "{filename}" foi bem sucedido.',
      download_attachment_error: 'Não foi possível descarregar o anexo.',
      delete_attachment_ok: 'Anexo eliminado com sucesso.',
      create_cmr_ok: 'O documento de transporte foi criado com sucesso.',
      create_draft_ok: 'O rascunho foi criado com sucesso.',
    }
  },

  new_invoice: {
    title: 'Nova fatura',
    steps: {
      header: 'Cabeçalho',
      extension: 'Extensão',
      lines: 'Linhas',
      totals: 'Totais'
    },
    new_invoice_form: {
      select_placeholder: 'Insire 3 caracteres',
      format: 'Formato',
      document_class: {
        title: 'Tipo de documento',
        COPY: 'Cópia',
        ORIGINAL: 'Original',
        DUPLICATE: 'Cópia',
        ADDITIONAL_TRANSMISSION: 'Adicional',
        REPLACE: 'Retificativa',
        ADDITION: 'Adição'
      },
      seller: 'Vendedor',
      table_centre: {
        code: 'Código',
        role: 'Função'
      },
      invoice_number: 'Número da fatura',
      issue_date: 'Data de emissão',
      invoicing_date_from: 'Data inicial periodo de faturação',
      invoicing_date_from_pickerAll: 'Data do período de cobrança',
      currency: 'Divisa',
      exchange_rate: 'Taxa de câmbio para a moeda do comprador',
      exchange_rate_date: 'Exchange Rate Date',
      extension_type: 'Adicionar extensão',

      document_type: 'Tipo de documento',
      service: 'Serviço',
      buyer: 'Comprador',
      invoice_series_code: 'Número de série',
      operation_date: 'Data de operação',
      invoicing_date_to: 'Data final periodo de faturação',
      communication_method: {
        title: 'Método de envio',
        placeholder: ''
      },

      additional_data: 'Observações',
      other_additional_data: 'Dados do documento anterior',
      place_issue_description: 'Descrição lugar expedição',
      pc_issue: 'CP Lugar Expedição',

      corrective_number: 'Número de fatura corrigida',
      corrective_tax_period_from: 'Data inicial periodo de tributação',
      corrective_tax_period_from_pickerAll: 'Data do período tributação',
      corrective_method: {
        title: 'Método de Retificação',
        '01': 'Retificação íntegra',
        '02': 'Retificação por divergências',
        '03': 'Retificação por desconto por volume de operações durante um periodo',
        '04': 'Autorizadas pela Administração Tributária'
      },

      corrective_series_code: 'Número de série',
      corrective_tax_period_to: 'Data final periodo de tributação',
      corrective_reason: {
        title: 'Motivo de Retificação',
        '01': 'Número de fatura',
        '02': 'Serie da fatura',
        '03': 'Data expedição',
        '04': 'Nome e sobrenomes/Razão Social-Emissor',
        '05': 'Nome e sobrenomes/Razão Social-Recetor',
        '06': 'Identificação fiscal Emissor/obrigado',
        '07': 'Identificação fiscal Recetor',
        '08': 'Domicílio Emissor/Obrigado',
        '09': 'Domicílio Recetor',
        '10': 'Detalhe Operação',
        '11': 'Porcentagem do imposto a aplicar',
        '12': 'Matéria colectável a aplicar',
        '13': 'Data/Periodo a aplicar',
        '14': 'Tipo de fatura',
        '15': 'Alinhas legais',
        '16': 'Base de tributação',
        '80': 'Cálculo de quotas liquidadas',
        '81': 'Cálculo de quotas retidas',
        '82': 'Base de tributação modificada pela devolução de embalagens',
        '83': 'Base de tributação modificada por descontos e bonificações',
        '84': 'Base de tributação modificada por decisão final,judicial ou administrativa',
        '85': 'Base de tributação modificada quotas liquidadas não pagadas. Auto de declaração de insolvência'
      },
      corrective_invoice: 'Fatura Retificativa',
      dialog_add_centre: {
        title: 'Adicionar centro',
        form_add_centre: {
          centre: {
            label: 'Centro',
            placeholder: 'Selecione centro'
          },
          role: {
            label: 'Função',
            placeholder: 'Selecione rol'
          }
        },
        button_add_centre: 'Adicionar centro'
      },
      detail_centre: {
        name: 'Nome',
        country: 'País',
        province: 'Província',
        town: 'Localidade',
        address: 'Endereço',
        postcode: 'C.Postal'
      },
      rules_form: {
        select_project_first: 'Deve selecionar um serviço primeiro',
        select_seller_first: 'Deve selecionar um vendedor primeiro',
        issue_date: 'A data de emissão não pode ser posterior à data atual',
        operation_date_vs_atual_date: 'A data da operação não pode ser posterior à data atual',
        operation_date_lower_issue_date: 'A data da operação deve ser anterior à data de emissão',
        field_required_corrective_invoice: 'Campo obrigatório para faturas retificativas',
        select_cp_first: 'Deve inserir um CP para inserir uma descrição do lugar de expedição',
        select_cpDescription: 'Você deve inserir uma descrição do CP se tiver inserido um CP',
        cp_error: 'O campo "CP local de expedição" não é válido. Deve ser um valor de 5 dígitos'
      },
      load: {
        text_load_data: 'Carregando dados ...',
        text_load_parties: 'Carregando empresas vendedoras e compradoras ...',
        text_load_communications_method: 'Carregando métodos de envio ...',
        text_save_invoice_data: 'Salvando a informação da fatura',
        text_load_init_data: 'Carregando dados iniciais ...'
      },
      error: {
        validation: {
          iban: 'O IBAN não é válido',
          swift: 'O código SWIFT não é válido'
        },
        required: {
          formatDocumentId: 'O parâmetro ID do formato é obrigatório',
          invoiceId: 'O ID da fatura é obrigatório',
          swift_code: 'O código SWIFT é obrigatório.',
          country: 'O país é obrigatório.'
        },
        not_found: {
          invoice: 'Não existe a fatura',
          invoiceExtension: 'Não existe a extensão associada a esta fatura'
        },
        recadv_rejected: 'Não é possível faturar a recepção porque está rejeitada',
        duplicated_invoice_error_recadv: 'Já existe uma fatura para a recepção selecionada',
        duplicated_line_invoice_status_error: 'Uma das linhas está já faturada ou não é possível facturá-la'
      }
    },
    extension: {
      title: 'Adicionar extensão',
      faceb2b: {
        general_data: 'Dados gerais',
        public_sector_information: {
          public_organism_code: 'Código de organismo público - DIR3',
          contract_reference: 'Referência contrato da Administração Pública '
        },
        buyer_data: 'Dados do comprador',
        receiver_administrative_centre: {
          code: 'Código do centro recetor - DIRe',
          name: 'Nome do centro recetor'
        },
        seller_data: 'Dados do vendedor',
        dialog_add_centre: {
          buyer_title: 'Adicionar centro comprador',
          seller_title: 'Adicionar centro vendedor',
          code: {
            label: 'Código',
            placeholder: 'Código'
          },
          name: {
            label: 'Nome',
            placeholder: 'Nome'
          },
          role: {
            label: 'Função',
            placeholder: 'Selecione rol'
          },
          address: {
            label: 'Direção'
          }
        },
        roles: {
          FISCAL: 'Fiscal',
          PAYER: 'Pagador',
          BUYER: 'Comprador',
          COLLECTOR: 'Cobrador',
          SELLER: 'Vendedor',
          PAYMENT_RECEIVER: 'Beneficiário do pagamento',
          COLLECTION_RECEIVER: 'Beneficiário da cobrança',
          ISSUER: 'Emissor'
        },
        validations: {
          public_organism_code_required: 'Este campo é obrigatório se a referência do contrato for dada.'
        },
        add_centre_button: 'Adicionar centro',
        load: {
          saving_data: 'Salvando dados da extensão'
        }
      }
    },
    new_line_invoice: {
      title: 'Nova linha de fatura',
      delivery_title: 'Nova linha de nota de entrega',
      buttons: {
        add_line: 'Carregar',
        update_line: 'Atualizar',
        add_line_tooltip: 'Adicionar linha',
        update_line_tooltip: 'Atualizar linha'
      },
      new_line_invoice_table: {
        concept: 'Descrição conceito',
        article_code: 'Código item',
        article_code_seller: 'Código vendedor',
        article_code_buyer: 'Código comprador',
        quantity: 'Quantidade',
        quantityTradeUnit: 'Quantidade embalagem',
        unitOfMeasure: 'Unidade de medida',
        measureTradeUnit: 'Unidade de medida da embalagem',
        net_price: 'Preço líquido',
        total_cost: 'Custo total',
        batch: 'Lote',
        serial: 'Número série',
        bestbefore: 'Data de validade',
        gtin14: 'Código GTIN14',
        grossAmount: 'Montante bruto',
        grossAmount_tooltip: 'Custo total com encargos e descontos'
      },
      new_line_invoice_form: {
        description: 'Descrição',
        article_code: 'Código item',
        quantity: 'Quantidade',
        quantityShipped: 'Quantidade enviada',
        quantityPending: 'Quantidade pendente',
        net_price: 'Preço líquido',
        unit_of_measure: {
          title: 'Unidade de medida',
          '01': 'Unidades',
          UN: 'Unidades',
          '02': 'Horas',
          '03': 'Quilogramas',
          '04': 'Litros',
          '05': 'Outros',
          '06': 'Caixas',
          '07': 'Bandejas',
          '08': 'Barris',
          '09': 'Bidões',
          '10': 'Sacos',
          '11': 'Botijões',
          '12': 'Garrafas',
          '13': 'Potes',
          '14': 'Tetra Briks',
          '15': 'Centillitros',
          '16': 'Centímetros',
          '17': 'Cubos',
          '18': 'Dúzias',
          '19': 'Estojos',
          '20': 'Bujões',
          '21': 'Gramas',
          '22': 'Quilómetros',
          '23': 'Latas',
          '24': 'Maços',
          '25': 'Medidores',
          '26': 'Milímetros',
          '27': '6-Packs',
          '28': 'Pacotes',
          '29': 'Rações',
          '30': 'Rolos',
          '31': 'Envelopes',
          '32': 'Terrines',
          '33': 'Metro cúbico',
          '34': 'Segundo',
          '35': 'Watt',
          PCE: 'Peças',
          KGM: 'Quilogramas',
          MTR: 'Metro linear',
          TNE: 'Tonelada',
          LTR: 'Litro',
          MTQ: 'Metro cúbico',
          DMQ: 'Dcm. cúbico',
          CENT: 'Centenas',
          MILL: 'Milhares',
          MTK: 'M. quadrados',
          BOX: 'Caixa',
          BOTL: 'Garrafa',
          NTBK: 'Caderno',
          GRM: 'Grama',
          GRSA: 'Grossa',
          SHEE: 'Folha',
          GAME: 'Jogo',
          PAR: 'Par',
          OVLL: 'Novelo',
          CARR: 'Carreto',
          PACK: 'Pacote',
          DOCE: 'Dúzia',
          K: 'K',
          R: 'R',
          B: 'B',
          C62: 'Peça'
        },
        additional_data: 'Observações',
        goods_code: 'Código de mercadoria',
        goods_code_placeholder: 'Insire 3 caracteres',
        weight: 'Peso'
      },
      documents: {
        title: 'Documentos',
        no_documents: 'Não tem documentos associados',
        button_add_document: 'Carregar',
        button_add_document_tooltip: 'Carregar documento relacionado'
      },
      documents_table: {
        name: 'Documentos',
        seller_receiver: 'Emissor/Recetor',
        value: 'Valor',
        date: 'Data',
        line_number: 'Nº linha'
      },
      dialog_add_document: {
        title: 'Carregar documento',
        form_add: {
          invoice_document: {
            label: 'Documento',
            CONTRACT: 'Contrato / recepção',
            TRANSACTION: 'Encomenda',
            DELIVERY_NOTE: 'Nota de entrega',
            FILE: 'Dossier',
            ORDER_LINE: 'Nº de sequência / linha',
            DESADV_LINE: 'Linha de nota de entrega'
          },
          seller: 'Emissor/Recetor',
          value: 'Valor',
          date: 'Data'
        },
        notify: {
          error_type_document_uniqueER: 'O tipo de documento selecionado deve ser único para emissor/recetor',
          error_type_document_unique: 'O tipo de documento selecionado deve ser único'
        },
        button_add: 'Carregar',
        button_add_tooltip: 'Carregar documento'
      },
      taxes: {
        title: 'Impostos',
        no_taxes: 'Não tem impostos associados. Deve adicionar pelo menos um.',
        button_add_tax: 'Carregar',
        button_add_tax_tooltip: 'Carregar imposto',
        no_rate: 'Nenhuma tarifa selecionada'
      },
      chargeDiscount: {
        title: 'Adicionar encargos e descontos',
        table: {
          bi: 'Base tributável',
          type: 'Tipo',
          description: 'Descrição',
          rate: 'Taxa (%)',
          amount: 'Montante'
        },
        form_add: {
          base_amount: 'Base tributável',
          indicator: 'Indicador de encargo ou desconto',
          type: 'Tipo',
          rate: 'Taxa %',
          amount: 'Montante'
        },
        no_chargeDiscount: 'Não tem encargos ou descontos associados.',
        button_add_chargeDiscount: 'Carregar',
        button_add_chargeDiscount_tooltip: 'Carregar encargo ou desconto',
        types: {
          TD: "Desconto comercial",
          DPPROPAGO: "Desconto por pronto pagamento",
          DRAPPEL: "Desconto por volume ou rappel",
          CCANSGAE: "Taxa da sociedade de autores (SGAE)"
        },
        indicator: {
          charge: "Encargo",
          discount: "Desconto"
        }

      },
      taxes_table: {
        tax_type: 'Imposto',
        rate: 'Taxa (em %)',
        bi: 'Base de tributação',
        amount: 'Montante imposto',
        type_exemption: {
          title: 'Tipo de isenção',
          SUBJECT_AND_EXEMPT: 'Sujeito e isento',
          NOT_SUBJECT: 'Não sujeito',
          SUBJECT_AND_NOT_EXEMPT: 'Sujeito e não isento'
        },
        legal_text: 'Motivo'
      },
      dialog_add_tax: {
        title: 'Carregar imposto',
        response: 'As linhas foram atualizadas com sucesso',
        responsewithtax: 'As linhas foram atualizadas com sucesso. Algumas linhas já tiveram o imposto selecionado.',
        form_add: {
          tax: 'Imposto',
          rate: 'Taxa (em %)',
          bi: 'Base de tributação',
          amount: 'Montante imposto',
          type_exemption: 'Tipo de isenção',
          legal_text: 'Motivo',
          motive: 'Motivo',
          legaltextlong: 'Motivo ou texto legal (Campo opcional, selecionar somente para operações isentas, não tributáveis ​​ou em regime especial)'
        },
        validations: {
          no_quantity_no_net_price: 'Deve inserir primeiro quantidade e preço',
          quantity_net_price_incorrect: 'Deve inserir quantidade e preço corretos'
        },
        notify: {
          invoice_line_tax_already_added: 'O imposto selecionado já foi incluído'
        },
        button_add: 'Carregar',
        button_add_tooltip: 'Carregar imposto'
      },
      load: {
        text_go_detail: 'Carregando dados da linha de fatura ...',
        text_go_deliveryNote_detail: 'Carregando dados da linha ...',
        text_add_invoice_line: 'Salvando a nova linha de fatura ...',
        text_update_invoice_line: 'Atualização da linha de fatura  ...',
        text_add_deliveryNote_line: 'Salvando a nova linha ...',
        text_update_deliveryNote_line: 'Atualização da linha ...',
        text_invoice_lines: 'Carregando linhas de fatura ...',
        text_deliveryNote_lines: 'Carregando linhas ...',
        text_delete_invoice_line: 'Eliminando a linha de fatura ...',
        text_delete_deliveryNote_line: 'Eliminando a linha de nota de entrega ...',
        text_add_article: 'Carregando dados do artigo ...'
      },
      notify: {
        no_lines_added: 'A fatura deve ter,pelo menos,uma linha',
        update_deliveryNote_line: 'A quantidade de linha foi atualizada'
      },
      lines: {
        button_delete_tooltip: 'Excluir linhas selecionadas',
        button_delete: 'Excluir'
      },
      confirm: {
        title_delete_invoice_line: 'Deseja eliminar esta/s linha/s de fatura?',
        confirm_button_delete_invoice_line: 'Confirmar',
        title_delete_deliveryNote_line: 'Deseja eliminar esta linha de nota de entrega?',
        confirm_button_delete_deliveryNote_line: 'Confirmar',
        pending_changes_title: 'Confirmação',
        pending_changes_message: 'Existem alterações pendentes de guardar. Deseja continuar sem atualizar?',
        pending_changes_confirm: 'Sim',
        pending_changes_cancel: 'Não'
      }
    },
    invoice_totals: {
      title: 'Totais de fatura',
      invoice_totals_form: {
        total_gross_amount: 'Montante bruto',
        total_gross_amount_invoice: 'Valor bruto total da fatura',
        total_general_discounts: 'Total descontos globais',
        total_general_surcharges: 'Total débitos globais',
        total_gross_amount_before_taxes: 'Montante bruto A.I.',
        total_tax_outputs: 'Total impostos liquidados',
        total_taxes_withheld: 'Total impostos retidos',
        invoice_total: 'Total fatura',
        total_payments_on_account: 'Total adiantamentos',
        irpf: '% IRPF',
        total_irpf: 'Total IRPF',
        payments_on_account_date: 'Data do adiantamento',
        subsidies_total: 'Total subvenções',
        total_outstanding_amount: 'Total a pagar',
        withholding_amount: 'Retenção',
        withholding_amount_tooltip: 'Montantes retidos pelo pagador até a transação estar concluída.',
        withholding_reason: 'Motivo',
        total_reimbursable_expenses: 'Total reembolsos',
        total_financial_expenses: 'Encargos financeiros',
        total_executable_amount: 'Total a executar',
        currency: 'Divisa'
      },
      dialog_global_discounts: {
        title: 'Total de descontos globais',
        add_title: 'Adicionar desconto global',
        button_add: 'Adicionar',
        load: {
          text_add_discount: 'A guardar desconto global ...'
        }
      },
      dialog_global_surcharges: {
        title: 'Total de encargos globais',
        add_title: 'Adicionar encargo global',
        button_add: 'Adicionar',
        text_add_surcharge: 'A guardar encargo global ...'
      },
      dialog_tax_outputs: {
        title: 'Impostos liquidados',
        title_with_held: 'Impostos retidos',
        bi: 'Base de tributação',
        tax_type: 'Tipo de imposto',
        tax_rate: 'Imposto(%)',
        tax_output: 'Imposto liquidado',
        tax_with_held: 'Imposto retido'
      },
      installments: {
        title: 'Dados de vencimento',
        no_installments: 'Não tem dados de vencimento associados.',
        button_add_tax: 'Carregar',
        button_add_tax_tooltip: 'Carregar vencimento'
      },
      table_installments: {
        due_date: 'Data',
        amount: 'Montante',
        payment_means: 'Métodos de pagamento',
        iban: 'IBAN',
        bic: 'SWIFT'
      },
      dialog_add_installment: {
        title: 'Carregar os dados de vencimento',
        form_add_installment: {
          due_date: 'Data',
          amount: 'Montante',
          payment_means: {
            title: 'Métodos de pagamento',
            '01': 'A vista',
            '02': 'Recibo de débito directo',
            '03': 'Recibo',
            '04': 'Transferência',
            '05': 'Letra Aceite',
            '06': 'Crédito documentário',
            '07': 'Contrato de adjudicação',
            '08': 'Letra de câmbio',
            '09': 'Título de crédito à ordem',
            '10': 'Título de crédito não à ordem',
            '11': 'Cheque',
            '12': 'Reabastecimento',
            '13': 'Especiais',
            '14': 'Compensação',
            '15': 'Vale postal',
            '16': 'Cheque conformado',
            '17': 'Cheque bancário',
            '18': 'Pagamento contra-reembolso',
            '19': 'Pagamento por cartão',
            '20': 'Pagaré',
            '21': 'Pago a cuenta bancaria',
            '22': 'Efectivo',
            '23': 'Confirming'
          },
          iban: 'IBAN',
          bic: 'SWIFT'
        },
        load: {
          text_add_installment: 'Salvando dado de vencimento ...',
          text_delete_installment: 'Eliminando vencimento ...'
        },
        notify: {
          error_add_installment: 'O montante selecionado não pode ser maior do que o total a executar',
          error_add_installment_0: 'O montante selecionado não pode ser 0',
          error_add_installment_sepa_no_swift: 'O país do código IBAN não é um país do tipo SEPA,deve inserir o código SWIFT',
          error_add_installment_sepa_no_correct_lenght: 'O país com codigo "{code}" não é um país SEPA cujo código ' +
            'SWIFT deve ter um comprimento de 8 ou de 11',
          error_add_installment_no_correct_country: 'O código de país do IBAN inserido não está correto',
          error_add_installment_incorrect_iban: 'O IBAN inserido não está correto',
          error_character_incorrect_iban: 'O IBAN digitado não está correto. Não são permitidos hífens ou caracteres especiais'
        },
        button_add: 'Carregar',
        button_add_tooltip: 'Carregar vencimento'
      },
      button_finish: 'Enviar',
      button_finish_tooltip: 'Enviar rascunho',
      button_recalculate: 'Recalcular',
      button_recalculate_tooltip: 'Recalcular totais',
      send_invoice: {
        confirm: {
          title_send_invoice: 'Deseja enviar a fatura?',
          confirm_button_send_invoice: 'Confirmar'
        },
        add_attachments: {
          tittle_add_attachments: 'Antes de enviar a fatura,quer adicionar algum anexo?',
          confirm_button_add_attachments: 'Anexar'
        },
        error_no_taxes: 'Não pode continuar se não tiver adicionado pelo menos 1 imposto repercutido a cada uma das linhas de fatura',
        load: {
          sending_invoice: 'Enviando fatura ...'
        },
        sendOK: 'O envio foi bem sucedido'
      },
      send_delivery: {
        confirm: {
          title_send_delivery: 'Deseja enviar nota de entrega?',
          confirm_button_send_delivery: 'Confirmar'
        },
        load: {
          sending_delivery: 'Enviando nota de entrega ...'
        },
        sendOK: 'O envio foi bem sucedido'
      },
      tooltip: {
        tax_output: 'Ver tabela de impostos liquidados',
        tax_with_held: 'Ver tabela de impostos retidos',
        preview_pdf_title: 'Pré-visualização de PDF',
        preview_xsl_title: 'Pré-visualização de XSL',
        preview_xml_title: 'Arquivo de metadados',
        preview_label_title: 'Pré-visualização da etiqueta'
      },
      load: {
        text_invoice_totals: 'Carregando totais da fatura ...',
        text_recalculate_totals: 'Recalculando totais'
      },
      notify: {
        recalculate_totals_ok: 'Foram correctamente recalculados'
      },
      error_no_withholding_amount_when_withholding_reason: 'Este campo é obrigatório se a retenção for aplicada',
      error_no_payments_on_account_date: 'Este campo é obrigatório se um adiantamento for aplicado'
    }
  },
  new_deliveryNote: {
    title: 'Nova nota de entrega',
    generate_line: 'Gerar linha',
    delete_line: 'Excluir linha',
    steps: {
      header: 'Cabeçalho',
      extension: 'Extensão',
      lines: 'Linhas',
      totals: 'Totais'
    },
    new_deliveryNote_form: {
      select_placeholder: 'Insire 3 caracteres',
      format: 'Formato',
      document_class: {
        title: 'Tipo de documento',
        COPY: 'Cópia',
        ORIGINAL: 'Original',
        DUPLICATE: 'Cópia',
        ADDITIONAL_TRANSMISSION: 'Adicional',
        REPLACE: 'Retificativa',
        ADDITION: 'Adição'
      },
      seller: 'Vendedor',
      table_centre: {
        code: 'Código',
        role: 'Função'
      },
      deliveryNote_number: 'Número da nota de entrega',
      issue_date: 'Data de emissão',
      delivery_date: 'Data de entrega',
      invoicing_date_from: 'Data inicial periodo de faturação',
      invoicing_date_from_pickerAll: 'Data do período de cobrança',
      currency: 'Divisa',
      exchange_rate: 'Taxa de câmbio para a moeda do comprador',
      exchange_rate_date: 'Exchange Rate Date',
      extension_type: 'Adicionar extensão',

      document_type: 'Tipo de documento',
      deliveryNote_type: 'Tipo de Albarão',
      service: 'Serviço',
      buyer: 'Comprador',
      deliveryNote_series_code: 'Número de série',
      operation_date: 'Data de operação',
      invoicing_date_to: 'Data final periodo de faturação',
      communication_method: {
        title: 'Método de envio',
        placeholder: ''
      },

      additional_data: 'Observações',
      other_additional_data: 'Outras observações',
      place_issue_description: 'Descrição lugar expedição',
      pc_issue: 'CP Lugar Expedição',
      buttons: {
        add_package_tooltip: 'Adicionar nova embalagem',
        delete_package_tooltip: 'Remova embalagem',
        show_package_lines_tooltip: 'Mostre linhas associadas à embalagem',
        show_all_lines: {
          label: 'Mostrar linhas',
          tooltip: 'Mostrar todas as linhas da nota de entrega'
        }
      },
      dialog_add_package: {
        title: 'Adicionar embalagem',
        load_registration: 'Geração de código SSCC',
        form_add_package: {
          package_type: {
            label: 'Tipo de embalagem',
            placeholder: 'Selezioni tipo'
          },
          sscc: {
            label: {
              seller: 'Código SSCC gerado pelo provedor. Opcional',
              auto: 'Código SSCC gerado pela plataforma'
            },
            placeholder: 'SSCC',
            noexist: 'Não é possível adicionar um novo pacote porque o código da empresa e o número do pacote inicial não foram configurados. Consulte o administrador.'
          }
        }
      },
      dialog_add_centre: {
        title: 'Adicionar centro',
        form_add_centre: {
          centre: {
            label: 'Centro',
            placeholder: 'Selecione centro'
          },
          role: {
            label: 'Função',
            placeholder: 'Selecione rol'
          }
        },
        button_add_centre: 'Adicionar centro'
      },
      detail_centre: {
        name: 'Nome',
        country: 'País',
        province: 'Província',
        town: 'Localidade',
        address: 'Endereço',
        postcode: 'C.Postal'
      },
      rules_form: {
        select_project_first: 'Deve selecionar um serviço primeiro',
        select_seller_first: 'Deve selecionar um vendedor primeiro',
        issue_date: 'A data de emissão não pode ser posterior à data atual',
        operation_date_vs_atual_date: 'A data da operação não pode ser posterior à data atual',
        operation_date_lower_issue_date: 'A data da operação deve ser anterior à data de emissão',
        select_cp_first: 'Deve inserir um CP para inserir uma descrição do lugar de expedição',
        select_cpDescription: 'Você deve inserir uma descrição do CP se tiver inserido um CP',
        cp_error: 'O campo "CP local de expedição" não é válido. Deve ser um valor de 5 dígitos',
        select_centre_delivery_point: 'É necessário selecionar um ponto de entrega para visualizar as linhas'
      },
      load: {
        text_load_data: 'Carregando dados ...',
        text_load_parties: 'Carregando empresas vendedoras e compradoras ...',
        text_load_communications_method: 'Carregando métodos de envio ...',
        text_save_deliveryNote_data: 'Salvando a informação da nota de entrega',
        text_load_init_data: 'Carregando dados iniciais ...',
        delete_load_deliveryNote: 'Excluindo nota de entrega...'
      },
      notify: {
        deliverynote_data_saved: 'Os dados da nota de entrega foram salvos corretamente',
        delete_deliveryNote: 'Excluir nota de entrega?',
        delete_tooltip: 'Excluir nota de entrega',
        confirm_delete_deliveryNote: 'Excluir',
        delete_deliveryNote_ok: 'Excluir rascunho com sucesso.'
      },
      error: {
        validation: {
          iban: 'O IBAN não é válido',
          swift: 'O código SWIFT não é válido'
        },
        required: {
          formatDocumentId: 'O parâmetro ID do formato é obrigatório',
          deliveryNoteId: 'O ID da nota de entrega é obrigatório',
          swift_code: 'O código SWIFT é obrigatório.',
          country: 'O país é obrigatório.'
        },
        not_found: {
          deliveryNote: 'Não existe a nota de entrega',
          deliveryNoteExtension: 'Não existe a extensão associada a esta nota de entrega'
        },
        recadv_rejected: 'Não é possível faturar a recepção porque está rejeitada',
        duplicated_invoice_error_recadv: 'Já existe uma nota de entrega para a recepção selecionada',
        duplicated_line_deliveryNote_error_recadv: 'Uma das linhas está já faturada ou não é possível facturá-la'
      }
    },
    deliveryNote_package: {
      title: 'Embalagens',
      form_package: 'Embalagem',
      popover: {
        all_packages_has_subpackages: 'Todas as embalagens de segundo nível devem ter embalagem interna',
        all_packages_has_lines: 'Todas as embalagens de último nível deverão ter pelo menos uma linha associada',
        all_lines_has_package: 'Todas as linhas deverão ter embalagens atribuídas'
      },
      dialog_move_line_package: {
        title: 'Atribua embalagens às linhas',
        buttons: {
          move_line_package: {
            label: 'Atribuir embalagem',
            tooltip: 'Atribua embalagens às linhas'
          }
        }
      },
      load: {
        get_all_lines: 'Carregando todas as linhas ...',
        remove_package: 'Excluindo embalagem ...',
        get_package_lines: 'Carregando as linhas de embalagem ...',
        new_package: 'Adicionando embalagem ...',
        move_line_package: 'Atribuindo embalagens às linhas ...'
      },
      notify: {
        remove_package: 'Excluir a embalagem?'
      }
    }
  },

  // Cierres contables y borradores de cierres contables
  accounting_closes: {
    filters: {
      close_date: {
        value: 'Data de encerramento'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      invoice_number: {
        value: 'Nº fatura',
        placeholder: 'Nº fatura'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      accounting_close_name: {
        value: 'Nome encerramento dependente',
        placeholder: 'Nome encerramento '
      },
      start_date: {
        value: 'Data de início',
        placeholder: 'Data'
      },
      end_date: {
        value: 'Data final',
        placeholder: 'Data'
      }
    },
    entity_table: {
      project: 'Serviço',
      buyer: 'Comprador',
      name: 'Nome',
      close_date_time: 'Data encerramento ',
      status: 'Estado',
      start_date: 'Data início',
      end_date: 'Data final',
      child_accounting_close_name: 'Encerramento dependente',
      date_info: 'Data de divulgação',
      description: 'Descrição',
      add: 'Carregar encerramento',
      close_accounting: 'Fechar contabilidade fechar'
    },
    notify: {
      save_changes: 'O fechamento contábil foi criado com sucesso',
      update_changes: 'O fechamento contábil foi atualizado com sucesso',
      invoices_added: 'Faturas adicionadas corretamente',
      verification_ok: 'A assinatura de fechamento está correta',
      verification_ko: 'A assinatura de fechamento não está correta',
      result_exceded: 'Não permitido. Você deve restringir a pesquisa a pelo menos 1000 resultados'
    },
    add_invoices: 'Adicionar faturas',
    add_selected: 'Adicionar seleção',
    add_all_invoices: 'Adicionar todas as faturas',
    new_accounting: 'Novo encerramento',
    new_accounting_tooltip: 'Criar novo encerramento contábil',
    validate_signature: 'Verificação de Assinatura'
  },
  accounting_closes_detail: {
    invoices: {
      title: 'Lista de faturas',
      no_data: 'Não existem faturas associadas a este encerramento contábil',
      buyer: 'Comprador',
      seller: 'Vendedor',
      invoice_number: 'Nº fatura',
      issue_date: 'D. emissão',
      creation_date_time: 'D. registo',
      total_executable_amount: 'Montante',
      currency: 'Divisa',
      status: 'Estado',
      project: 'Serviço',
      reception_method: 'Método recepção'
    },
    confirm: {
      title_delete_draft: 'Tem certeza de que deseja eliminar este rascunho de encerramento contábil?',
      title_close_draft: 'você tem certeza de fechar o fechamento contábil?',
      close_ok: 'Rascunho fechado corretamente',
      close_ko: 'O rascunho não pôde ser fechado. Entre em contato com seu administrador'
    },
    notify: {
      delete_draft_ok: 'Rascunho eliminado'
    }
  },
  issue: {
    type: {
      ERROR_PORTAL: 'Erro do portal',
      PRICE_ERROR: 'Erro de preço',
      QUANTITY_ERROR: 'Erro de quantidade'
    },
    status: {
      OPEN: 'Abrir',
      IN_PROGRESS: 'Em processo',
      RESOLVED: 'Resolvido'
    },
    priority: {
      value_0: 'Nenhum',
      value_1: 'Baixo',
      value_2: 'Média',
      value_3: 'Alto'
    }
  },
  // Tareas pendientes
  pendingtask: {
    error: {
      reject_action: 'Não é possível rejeitar a fatura ao fornecedor se esta não tiver sido previamente rejeitada no sistema de gestão.'
    },
    filters: {
      creation_date: {
        value: 'Data-hora do registo'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      invoice_number: {
        value: 'Nº fatura',
        placeholder: 'Nº fatura'
      },
      invoice_series_code: {
        value: 'Nº código de série',
        placeholder: 'Código'
      },
      corrective_invoice_number: {
        value: 'Nº fatura corrigida',
        placeholder: 'Nº fatura corrigida'
      },
      total_executable_amount_from: {
        value: 'Montante de',
        placeholder: 'Montante'
      },
      total_executable_amount_to: {
        value: 'Montante até',
        placeholder: 'Montante'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      document_class: {
        value: 'Tipo de fatura',
        placeholder: 'Tipo de fatura'
      },
      registration_number: {
        value: 'Nº registo',
        placeholder: 'Registo'
      },
      reception_method: {
        value: 'Met. entrada',
        placeholder: 'Método'
      },
      attachments: {
        value: 'Anexos',
        placeholder: 'Escolha...'
      },
      internal_status: {
        value: 'Estado interno',
        placeholder: 'Estado'
      },
      pending_task: {
        value: 'Tarefa pendente',
        placeholder: 'Escolha...'
      },
      invoice_type: {
        value: 'Tipo de fatura',
        placeholder: 'Tipo'
      },
      tax_type: {
        value: 'Tipo de imposto',
        placeholder: 'Imposto'
      },
      rate: {
        value: 'Taxa',
        placeholder: 'Taxa'
      },
      currency_type: {
        value: 'Divisa',
        placeholder: 'Divisa'
      },
      order_number: {
        value: 'Nº encomenda',
        placeholder: 'Encomenda'
      },
      contract_number: {
        value: 'Nº contrato/recepção',
        placeholder: 'Contrato/recepção'
      },
      delivery_note: {
        value: 'Nº nota de entrega',
        placeholder: 'Nota de entrega'
      },
      file_number: {
        value: 'Nº processo',
        placeholder: 'Processo'
      },
      issue_date: {
        value: 'Intervalo datas emissão',
        placeholder: 'Intervalo datas'
      },
      operation_date: {
        value: 'Intervalo datas operação',
        placeholder: 'Intervalo datas'
      }
    },

    buttons: {
      btnDownloadPdf: 'PDF',
      btnDownloadPdf_tooltip: 'Baixar visualização em formato PDF',
      btnDownloadOriginal: 'Guardado',
      btnDownloadOriginal_tooltip: 'Baixar guardado',
      btnDownloadMetadata: 'Metadados',
      btnDownloadMetadata_tooltip: 'Baixar metadados',
      btnSendInvoice: 'Enviar fatura',
      btnSendInvoice_tooltip: 'Enviar fatura',
      btnPaymentProposal: 'Enviar proposta',
      btnPaymentProposal_tooltip: 'Enviar status da proposta de pagamento',
      btnApprove: 'Aprovar',
      btnSend: 'Enviar',
      btnCreate: 'Criar/Reiniciar',
      btnRejected: 'Rejeitar'
    },

    createcover: {
      noCoverPP: 'Não há capa para a proposta de pagamento da fatura ',
      noSendCoverPP: '. Não foi possível enviar o status da proposta de pagamento.',
      createcover_multiple_ko: 'As seguintes faturas devem estar pendentes: ',
      title: ' Fluxo de aprovação de documentos ',
      rbInvoice: 'Capa Fatura',
      rbPaymentProposal: 'Capa proposta pagamento',
      cover: {
        steps: {
          creation: 'Criação',
          send: 'Envio'
        },
        titleaux: '1. Selecione Documento: ',
        title: '1. Documento: ',
        create_ok: 'A(s) capa(s) foi(foram) criada(s) com sucesso',
        create: 'Criando capa',
        btnCover: 'Criar capa',
        send_ok: ' A(s) fatura(s) foram enviadas com sucesso ',
        send_multiple_ko: 'Se ha enviado correctamente el estado de la propuesta de pago ',
        send_multiple_ko_all: 'No se ha enviado el estado de las propuesta de pago. Revise los errores',

        aprroval: {
          btnAprroval: 'Enviar para aprovação',
          notify: 'Enviando para aprovação'
        },

        signature: {
          btnSignature: 'Enviar para assinatura',
          notify: 'Enviando para assinatura'
        },
        user: {
          title: '2. Utilizador: ',
          placeholder: 'Insire um utilizador',
          user_required: 'Selecione utilizador'
        }
      }
    },

    pendingtask_entity_table: {
      buyer: 'Comprador',
      buyer_centres: 'Centros comprador',
      seller: 'Vendedor',
      num_pendingtask: 'N.Fatura',
      issue_date: 'D.Emissão',
      creation_date: 'D.Registo',
      import: 'Montante',
      divisa: 'Divisa',
      status: 'Estado',
      reception_method: 'Met. entrada',
      pendingtask: 'Tarefa pendente',
      internal_status: 'Estado interno',
      internal_notes: 'Notas Internas',
      register_number: 'Nº registo',
      level_approval: 'Nível de aprovação'
    },

    pendingtask_entity_table_detail: {
      code: 'Código item',
      description: 'Descrição',
      order: 'Encomenda',
      despatch_quantity: 'Quantidade anunciada',
      received_quantity: 'Quantidade recebida',
      accepted_quantity: 'Quantidade aceite',
      measure: 'Unidade de medida',
      price: 'Preço unitário',
      currency: 'Divisa',
      status: 'Estado'
    },
    pendingtask_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF',
      download_pdfmultiple_buttons: 'PDF/S',
      download_originalmultiple_buttons: 'Guardado/s',
      download_createrestar_buttons: 'Criar/Reiniciar',
      download_sendinvoice_buttons: 'Enviar',
      download_sendstatus_buttons: 'Enviar proposta',

      event_table: {
        events: 'Eventos',
        action: 'Ação',
        date: 'Data evento',
        category: 'Categoria',
        user_origin: 'Utilizador origem',
        user_destiny: 'Utilizador destino',
        observations: 'Observações',
        no_date: 'Esta fatura não tem eventos'
      },

      attachments_table: {
        attachments: 'Anexos',
        fiename: 'Nome',
        category: 'Categoria',
        size: 'Tamanho',
        compressedSize: 'T.compactado',
        hidden: 'Oculto',
        creationDate: 'D.Criação',
        author: 'Criador',
        no_date: 'Esta fatura não tem nenhum documento anexo',
        load: 'Carregar',
        load_tooltip: 'Carregar anexo',
        download: 'Baixando Documento Anexo da Fatura ...',
        delete: 'Eliminando Documento Anexo da Fatura ...',
        delete_ok: 'O ficheiro foi eliminado com sucesso.',
        fileselected: 'Selecione ficheiro.'
      },

      sap: {
        send: 'Enviando fatura',
        send_ok: 'Facturaenviada',
        send_multiple_ko: 'La factura {fact} debe estar en estado pendiente y no haber sido enviadas previamente.',
        send_multiple_ko_all: 'No se han enviado las facturas. Revise los errores',
        maxselected: 'No puede realizar el envío de más de 10 facturas a la vez.'

      },

      paymentproposal: {
        send: 'Enviando estado proposta de pagamento',
        send_ok: 'Facturaenviada a proposta de pagamento',
        name: 'Nome proposta pagamento',
        invoicenumber: 'Número de fatura',
        status: 'Estado',
        description: 'Descrição',
        title: 'Proposta de pagamento',
        btnsend: 'Enviar'
      },

      rejectedinvoice: {
        title: 'Rejeitar fatura',
        status: 'Estado atual',
        statusnext: 'Estado seguinte',
        category: 'Categoria',
        motive: 'Motivo da rejeição',
        motive_required: ' Motivo obrigatório ',
        categoryselected: 'Selecione .',
        rejected: 'Rejeitando a fatura',
        rejected_ok: 'A fatura foi rejeitada com sucesso ',
        statusrejected: 'Rejeitada'
      },

      approveinvoice: {
        title1: 'Aprovar fatura',
        title2: 'Enviar fatura',
        status: 'Nível atual',
        statusnext: 'Próximo nível',
        category: 'Categoría',
        motive: 'Comentário',
        motive_required: 'Comentário obrigatório',
        categoryselected: 'Selecione .',
        approved: 'Aprovando a fatura',
        approved_ok: 'A fatura foi aprovada com sucesso',
        send: 'Envio da faturaa',
        send_ok: 'A fatura foi enviada com sucesso',
        field: 'Campo',
        value: 'Valor'
      },

      internal_notes: {
        title: 'Notas internas'
      },

      notify: {
        save: 'Atualização dos dados da fatura',
        download: 'O download do ficheiro {file} foi bem sucedido.',
        download_multiple: '"O download foi executado com sucesso.',
        selected_service: 'Selecione um serviço',
        save_field: 'Guardar campos...',
        save_field_ok: 'Campos guardados com sucesso.',
        delete_fields: 'Apagar campos...',
        delete_fields_ok: 'Os campos foram removidos com sucesso.'
      }
    }
  },

  auditory: {
    filters: {
      input_date: {
        value: 'Data-hora de entrada'
      },
      sender: {
        value: 'Emissor',
        placeholder: 'Emissor'
      },
      receiver: {
        value: 'Recetor',
        placeholder: 'Recetor'
      },
      filename: {
        value: 'Nome de ficheiro',
        placeholder: 'Ficheiro'
      },
      document_number: {
        value: 'Nº documento',
        placeholder: 'Documento'
      },
      document_type: {
        value: 'Tipo de documento',
        placeholder: 'Tipo'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      batch: {
        value: 'Lote',
        placeholder: 'Escolha...'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      inFormat: {
        value: 'Formato Entrada',
        placeholder: 'Formato Entrada'
      },
      outFormat: {
        value: 'Formato Saída',
        placeholder: 'Formato Saída'
      },
      visible: {
        value: 'Visível',
        placeholder: 'Escolha...'
      },
      sonFrom: {
        value: 'N. docs. filhos de',
        placeholder: 'N. docs. filhos de'
      },
      sonTo: {
        value: 'N. docs. filhos até',
        placeholder: 'N. docs. filhos até'
      },
      processingTimeFrom: {
        value: 'Tempo de processamento a partir de',
        placeholder: 'Tempo de processamento a partir de'
      },
      processingTimeTo: {
        value: 'Tempo de processamento até',
        placeholder: 'Tempo de processamento até'
      },
      communication_protocol: {
        value: 'Protocolo de comunicação',
        placeholder: 'Protocolo'
      },
      audit_document_module: {
        value: 'Módulo',
        placeholder: 'Módulo'
      },
      user: {
        value: 'Usuário',
        placeholder: 'Usuário'
      },
      action: {
        value: 'Ação',
        placeholder: 'Ação'
      },
      group: {
        value: 'Grupo funcional',
        placeholder: 'Grupo funcional'
      },
      value: {
        value: 'Valor',
        placeholder: 'Valor'
      }
    },
    parent: 'Acessar o arquivo principal',
    son: 'Acessar arquivos gerados',
    auditory_entity_table: {
      project: 'Serviço',
      sender: 'Emissor',
      receiver: 'Recetor',
      date: 'Data',
      filename: 'Nome ficheiro',
      document_number: 'Nº documento',
      document_type: 'T. documento',
      status: 'Estado',
      communication_protocol: 'Comunicação',
      audit_document_module: 'Módulo',
      batch: 'Lote',
      processingTime: 'Tempo de processamento',
      group: 'Grupo',
      user: 'Usuário',
      action: 'Ação',
      value: 'Valor',
      csv_title: 'Exportar para CSV. Em formação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, por favor, restrinja sua pesquisa'
    },
    download_multiple: {
      multiple_ko: ' As seguintes auditorias não podem ser baixadas'
    },

    load: {
      download_request_file: 'Baixando ficheiros de entrada ...',
      download_response_file: 'Baixando ficheiros de saída ...',
      download_incoming_file: 'Baixando ficheiros de entrada ...',
      download_integrated_file: 'Baixando ficheiros integrados ...'
    },

    buttons: {
      btn_request: 'Pedido/s',
      btn_response: 'Resposta/s',
      btn_incoming_file: 'Ficheiro/s de entrada',
      btn_integrated_file: 'Ficheiro/s intregado/s',
      btn_request_tooltip: 'Baixar pedido/s',
      btn_response_tooltip: 'Baixar resposta/s',
      btn_incoming_file_tooltip: 'Baixar ficheiro/s de entrada',
      btn_integrated_file_tooltip: 'Baixar ficheiro/s intregado/s'
    }
  },

  auditory_detail: {
    info_auditory: 'Eventos',

    buttons: {
      request: 'Pedido',
      response: 'Resposta',
      incoming_file: 'Ficheiro de entrada',
      integrated_file: 'Ficheiro integrado',
      request_tooltip: 'Baixar pedido',
      response_tooltip: 'Baixar resposta',
      incoming_file_tooltip: 'Baixar ficheiro de entrada',
      integrated_file_tooltip: 'Baixar ficheiro integrado'
    },

    load: {
      download_request_file: 'Baixando pedido de entrada ...',
      download_response_file: ' Baixando pedido de saída ...',
      download_original_file: 'Baixando ficheiro guardado ...',
      download_incoming_file: 'Baixando ficheiros de entrada ...',
      download_integrated_file: 'Baixando ficheiros integrados ...'
    },

    notify: {
      error_download_not_found: 'Erro no download. O ficheiro não foi encontrado'
    },

    events: {
      code: {
        RECEPTION_INVOICE: 'Recepção de fatura',
        RECEPTION_ORIGINAL_INVOICE: 'Recepção de fatura original',
        SUMMARY_ALTCLI: 'Resumo registo clientes',
        SUMMARY_ALTPRO: 'Resumo registo fornecedores',
        ERROR_LINE_LENGTH: 'Linha mal formada',
        DELETE_DIR: 'Eliminado',
        invalidFormat: 'A fatura não segue o formato de fatura selecionado',
        FILE_BASE64_ERROR: 'Erro inesperado no formato da fatura',
        'VALIDATION.DUPLICATION': 'Não passou a validação de fatura duplicada',
        'VALIDATION.DUPLICATION.ISSUEYEAR': 'Não passou a validação de fatura duplicada no ano em curso',
        SIGNED: 'Assinada',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        DISAGREEMENT: 'Não compatível',
        PENDING_OF_SIGNING: 'Pendente de assinatura',
        PENDING_OF_SEND: 'Pendende de envio',
        UPDATE_STATUS: 'Atualização estado',
        UPDATE_INTERNAL_STATUS: 'Atualização estado interno',
        CHECK_STATUS_ONLINE: 'Consulta de estado online',
        DOCUMENT_INTEGRATED: 'Documento integrado',
        INVOICE_INTEGRATED: 'Fatura integrada com sucesso',
        INVOICE_INTEGRATED_WS: 'Fatura integrada no Web Service',
        INVOICE_INTEGRATED_REST: 'Fatura integrada no Rest',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Fatura digitalizada validada no Web Service',
        RECOGNITION: 'Reconhecimento',
        VALIDATE_SIGNATURE: 'Verificação de Assinatura',
        TRANSFORMATION: ' Transformação',
        SIGNATURE: 'Assinatura',
        DELIVERY: 'Entrega',
        CHANGE_STATUS_RECADV_WS: 'Redefinição de recepções WS',
        CHECK_STATUS_RECADV_WS: 'Verificar estado de recepções WS',
        INTEGRATION_RECADV_WS: 'Integração de recepções WS',
        ERROR: 'Erro',
        FACTURAE_INVALID: 'Fatura mal formada',
        PARTY_SENDER_NOTFOUND: 'Empresa emissora não encontrada',
        CENTRE_SELLER_NOTFOUND: 'Centro da empresa fornecedora não encontrado',
        PARTY_RECEIVER_NOTFOUND: 'Empresa recetora não encontrada',
        CENTRE_BUYER_NOTFOUND: 'Centro da empresa cliente não encontrado',
        CURRENCY_NOTFOUND: 'Divisa não encontrada',
        TAXTYPE_NOTFOUND: 'Tipo de imposto não encontrado',
        COUNTRY_BUYER_NOTFOUND: 'País da empresa cliente não encontrado',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'O país indicado no prefixo do CIF não existe ',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefixo de cif fornecedor não encontrado',
        COUNTRY_CENTRE_NOTFOUND: 'País do centro não encontrado',
        MEDIA_TYPE_NOTFOUND: 'Media type não encontrado',
        CONTRACT_BUYER_ERROR: 'Erro inesperado na contratação da empresa cliente',
        CONTRACT_PARTYMEDIA_ERROR: 'Erro na contratação de party_media',
        DB_ERROR: 'Erro inesperado na conexão à bbdd',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Erro ao copiar ficheiro no repositório fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Erro ao descompactar anexos em temporários',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Erro ao copiar o ficheiro recebido no repositório fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Erro ocorrido ao obter ou descompactar o ficheiro do repositório de editrack',
        NOTE_INVOICE_ERROR: 'Erro inesperado ao criar a linha de fatura',
        AUDIT_DOCUMENT_ERROR: 'Erro inesperado ao insertar dados em auditoria',
        GETFORMAT_ERROR: 'Erro inesperado ao determinar o formato do documento a integrar',
        SEND_MAIL_ERROR: 'Erro ocorrido durante o envio de correio',
        RETRY_MAIL_ERROR: 'Erro ao salvar dados para uma nova tentativa de envio de email',
        UNEXPECTED_ERROR: 'Erro inesperado',
        REQUEST_EMPTY: 'Pedido vazio',
        DOCUMENT_CLASS_NOTFOUND: 'Tipo de documento não encontrado',
        STATUS_DOCUMENT_NOTFOUND: 'Estado de documento não encontrado',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento de fatura não encontrado',
        INVOICE_TYPE_NOTFOUND: 'Tipo de fatura não encontrado',
        INSTANCES_REQUEST_EMPTY: 'As instâncias de documento não podem ester vazias',
        DOCUMENT_FORMAT_EMPTY: 'O elemento Documentformat não pode estar vazio ou nulo',
        DOCUMENT_FORMAT_UNRECOGNIZED: 'Formato de documento não reconhecido',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'O elemento Repositorylocator da instância ATTACHMENT não pode ser nulo ou estar vazio',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'O elemento originalfilename da instância ATTACHMENT não pode ser nulo ou estar vazio',
        DOCUMENT_FORMAT_ERROR: 'O formato do documento a integrar (contido no pedido) não está correto',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Sponsor não encontrado entre as empresas da fatura',
        PROJECT_PARTY_SPONSOR_ERROR: 'Erro inesperado ao pesquisar o sponsor entre as empresas fornecedor/cliente da fatura',
        VALIDITY_DOCUMENT_NOTFOUND: 'Não existe vigência de documento para o tipo de documento e o país da fatura',
        STATUS_AUDIT_NOTFOUND: 'Estado de auditoria não encontrado',
        SEMANTICDOCUMENTID_EMPTY: 'O elemento semanticdocumentid não pode ser nulo ou estar vazio',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'O elemento Repositorylocator da instância RECEIVED não pode ser nulo ou estar vazio',
        INCOMINGDATETIME_EMPTY: 'O elemento incomingdatetime não pode ser nulo ou estar vazio',
        RECEIVERID_NOTFOUND: 'Empresa cujo código é indicado no elemento receiverid não existe',
        SENDERID_NOTFOUND: 'Empresa cujo código é indicado no elemento senderid não existe',
        DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento não encontrado',
        DOCUMENT_PARENT_NOTFOUND: 'Documento padre não encontrado',
        COMMUNICATION_PROTOCOL_EMPTY: 'Protocolo de comunicação não pode ser nulo ou estar vazio',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Protocolo de comunicação não encontrado',
        REPOSITORY_ERROR: 'Erro ao obter o ficheiro do repositório',
        CONNECTION_ERROR: 'Erro inesperado de conexão à bd',
        PROJECT_COMMUNITYID_NOTFOUND: 'Serviço com codigo communityid não encontrado',
        DOCUMENT_FORMAT_NOTFOUND: 'Formato de documento não encontrado',
        INPUTDATETIME_EMPTY: 'O elemento inputdatetime não pode ser nulo ou estar vazio',
        DELIVERYCHECK: 'Confirmação de entrega',
        DUPLICATED_INVOICE_ERROR: 'Erro de fatura duplicada',
        CORRECTIVE_NUMBER_REQUIRED: 'O número de fatura retificativa é obrigatório para método de Retificação 01 ou 02',
        DIR_ATTACHMENT_NOTFOUND: ' Não existe o diretório de anexos da fatura a ser integrada',
        996: '996',
        CIF_REQUIRED: 'O cif é um Campo obrigatório',
        ACTION_REQUIRED: 'A ação é um campo obrigatório',
        DESCRIPTION_REQUIRED: 'A descrição é um campo obrigatório',
        CANAL_REQUIRED: 'O canal é um campo obrigatório',
        EMAIL_REQUIRED: 'O email é um campo obrigatório',
        PARTY_BUYER_NOTFOUND: 'A empresa cliente não existe',
        PROJECT_PARTY_DISABLED: 'A empresa está desativada para o serviço indicado',
        PROJECT_PARTY_BUYER_NOTFOUND: 'A empresa cliente não está associada ou está desativada para o serviço indicado',
        PROJECT_PARTY_SELLER_NOTFOUND: 'A empresa vendedora não está associada ou está desativada para o serviço indicado',
        COMMUNICATION_METHOD_NOTFOUND: 'O método de comunicação não existe',
        EMAIL_INVALID: 'O email é incorreto',
        ACTION_UNEXPECTED: 'A ação é incorreta',
        READ_FILE_BUYERS_ERROR: 'Erro inesperado ao ler o ficheiro de contratação de empresas clientes',
        UPDATE_PARTY_ERROR: 'Erro ao atualizar os dados da empresa',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Erro ao criar o método de entrega associado à empresa',
        CREATE_PARTY_MEDIA_ERROR: 'Erro ao criar o email associado à empresa cliente',
        CREATE_USER_PARTY_ERROR: 'Erro ao criar o utilizador associado à empresa cliente',
        CREATE_USER_ERROR: 'Erro ao criar o utilizador',
        CREATE_PARTY_ERROR: 'Erro ao criar a empresa',
        CREATE_PROJECT_PARTY_ERROR: 'Erro ao criar a relação entre o projeto e a empresa',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Erro ao criar a relação comercial entre a empresa sponsor e a empresa cliente',
        CREATION_PARTY_WS: 'Criação de empresas',
        UPDATE_PARTY_WS: 'Atualização de empresas',
        CREATION_USER_WS: 'Criação de utilizadores',
        REMOVE_USER_WS: 'Eliminado de utilizadores',
        UPDATE_USER_WS: 'Atualização de utilizadores',
        UNLOCK_USER_WS: 'Desbloqueio de utilizadores',
        RESET_USER_WS: 'Reset de utilizadores',
        PROJECT_NOSENDER: 'Método de envio incorreto. O projeto não é de emissão',
        SELLER_NOSPONSOR: 'Método de envio incorreto. A empresa não é sponsor.',
        PROJECT_NO_DELIVERY_METHOD: 'Método de envio não encontrado para o projeto.',
        NO_LINES: 'Recepção sem linhas',
        ITEM_PRICE_NOTFOUND: 'A linha não tem preço',
        ITEM_NOTFOUND: 'Falta o item',
        INVALID_MEASURE: 'Unidade de medida errada',
        RECADV_ERROR: 'Erro',
        DUPLICATED_RECADV: 'Recepção duplicada',
        INVOICE_VALIDATION: 'Erro durante a validação da fatura',
        UPDATE_PARTY: 'Atualização empresa',
        SIGN: 'Signature',
        hermes: {
          integration: {
            invoice: 'Fatura integrada bemsucedida'
          },
          download: {
            invoice: 'Fatura descarregada'
          }
        },

        // Categorías

        CARATULA_FACTURA: 'Capa de fatura',
        CARATULA_PROPUESTA_PAGO: 'Capa de proposta de pagamento',
        PROPUESTA_PAGO: 'Proposta de pagamento',
        DISPLAY_INVOICE: 'PDF da fatura',
        APPROVAL_FLOW: 'Fluxo de aprovação',

        // Acciones

        SEND_SIGNED: 'Envio para assinatura',
        SEND_APPROVAL: 'Envio para aprovação',
        CREATE_COVER: 'Criação de capa',
        RESTART_CREATE_COVER: 'Reinício de capa',
        ACCEPTED: 'Aceite',
        REJECTED: 'Rejeitada',
        SEND_INVOICE: 'Envio de fatura',
        SEND_INVOICE_ORIGIN: 'Envio de fatura a origem',
        SEND_STATE: 'Envio do estado',
        SEND_PROPOSED_STATE: 'Enviado estado proposta',
        INVOICE_SIGNATURE: 'Facturaem assinatura',
        PROPOSALS_SIGNATURE: 'Propuesta em assinatura',

        // Códigos para eventos de auditorías de webservices
        unexpected: {
          error: 'Erro inesperado ao processar o pedido ou seu documento'
        },
        document: {
          integration: {
            error: 'Erro de integração do documento do pedido'
          }
        },
        repository: {
          error: 'Erro ao pesquisar ou salvar o documento do pedido num repositório'
        },
        validation: {
          error: 'Erro ao validar o documento do pedido',
          retry: 'Nova tentativa de validação'
        },
        invoice: {
          integrated: {
            b2bintegration: 'Fatura B2B integrada com sucesso',
            ws: 'Fatura no Webservice integrada com sucesso',
            upload: 'Fatura integrada com sucesso'
          },
          format: {
            error: 'Erro no formato da fatura'
          },
          schema: {
            error: 'Erro no esquema XML da fatura'
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Fatura B2B integrada com sucesso'
          },
          format: {
            error: 'Erro no formato da recepção'
          },
          schema: {
            error: 'Erro no esquema XML da recepção'
          }
        },
        csvparties: {
          integrated: {
            b2bintegration: 'CSV de empresas integradas com sucesso'
          },
          format: {
            error: 'Erro no formato do CSV das empresas'
          },
          schema: {
            error: 'Erro no conteúdo do CSV das empresas'
          }
        }
      },

      property: {
        NUMLINES_TOTAL: 'Número de linhas contidas',
        NUMLINES_ERROR: 'Número de linhas com erro',
        NUMLINES_OK: 'Número de linhas corretas',
        UPDATE_PARTY: 'Atualização empresa',
        UPDATED_PARTY: 'Atualizado',
        SEND_FILE: 'Documento de envio',
        ERROR_LINE_LENGTH: 'Linha mal formada',
        DELETE_DIR: 'Eliminado',
        REASON: 'Razão',
        ORIGINAL_STATUS: 'Estado original',
        FINAL_STATUS: 'Estado final',
        SEND_MAIL_ERROR: 'Erro ocorrido durante o envio de correio',
        NOTE_INVOICE_ERROR: 'Erro inesperado ao criar a linha de fatura',
        DOCUMENT_INTEGRATED: 'Número de documento integrado',
        DIGITIZEDINVOICE_VALIDATED: 'Fatura validada',
        ATTACHMENT_INTEGRATED: 'Nome de ficheiro de anexos',
        INVOICE_INTEGRATED_WS: 'Número de fatura integrada',
        INVOICE_INTEGRATED: 'Número de fatura integrada',
        VALIDATION_INVOICE_DIGITIZED_WS: 'Número de fatura digitalizada validada',
        documentinstance: {
          filename: 'Nome do ficheiro'
        },
        MOTIVE: 'Motivo',
        STATUS_BEFORE: 'Estado inicial',
        LAST_STATUS: 'Estado final',
        USER_NAME: 'Utilizador',
        INTERNAL_MOTIVE: 'Motivo interno',
        INTERNAL_STATUS_BEFORE: 'Estado interno inicial',
        LAST_INTERNAL_STATUS: 'Estado interno final',
        MESSAGE_RESULT: 'Mensagem de resposta',
        CHANGE_STATUS_RECADV_WS: 'Mudança de status',
        FACTURAE_INVALID: 'Facturae mal formado',
        PARTY_SENDER_NOTFOUND: 'Empresa emissora não encontrada',
        CENTRE_SELLER_NOTFOUND: 'Centro da empresa fornecedora não encontrado',
        PARTY_RECEIVER_NOTFOUND: 'Empresa recetora não encontrada',
        CENTRE_BUYER_NOTFOUND: 'Centro da empresa cliente não encontrado',
        CURRENCY_NOTFOUND: 'Divisa não encontrada',
        TAXTYPE_NOTFOUND: 'Tipo de imposto não encontrado',
        COUNTRY_BUYER_NOTFOUND: 'País da empresa cliente não encontrado',
        COUNTRY_BUYER_CIFPREFIX_NOTFOUND: 'Prefixo de cif cliente não encontrado',
        COUNTRY_SELLER_CIFPREFIX_NOTFOUND: 'Prefixo de cif fornecedor não encontrado',
        COUNTRY_CENTRE_NOTFOUND: 'País do centro não encontrado',
        MEDIA_TYPE_NOTFOUND: 'Media type não encontrado',
        CONTRACT_BUYER_ERROR: 'Erro inesperado na contratação da empresa cliente',
        CONTRACT_PARTYMEDIA_ERROR: 'Erro na contratação de party_media',
        DB_ERROR: 'Erro inesperado na conexão à bbdd',
        REPOSITORY_FENIX_INVOICE_ERROR: 'Erro ao copiar ficheiro no repositório fenix',
        REPOSITORY_FENIX_ATTACHMENT_ERROR: 'Erro ao descompactar anexos em temporários',
        REPOSITORY_FENIX_RECEIVED_INVOICE_ERROR: 'Erro ao copiar o ficheiro recebido no repositório fenix',
        REPOSITORY_UNZIP_FILE_ERROR: 'Erro ocorrido ao obter ou descompactar o ficheiro do repositório de editrack',
        AUDIT_DOCUMENT_ERROR: 'Erro inesperado ao insertar dados em auditoria',
        RETRY_MAIL_ERROR: 'Erro ao salvar dados para uma nova tentativa de envio de email',
        UNEXPECTED_ERROR: 'Erro inesperado',
        REQUEST_EMPTY: 'Pedido vazio',
        CORRECTIVE_NUMBER_REQUIRED: 'O número de fatura retificativa é obrigatório para método de Retificação 01 ou 02',
        DOCUMENT_CLASS_NOTFOUND: 'Tipo de documento não encontrado',
        STATUS_DOCUMENT_NOTFOUND: 'Estado de documento não encontrado',
        INVOICE_DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento de fatura não encontrado',
        INVOICE_TYPE_NOTFOUND: 'Tipo de fatura não encontrado',
        INSTANCES_REQUEST_EMPTY: 'As instâncias de documento não podem estar vazias',
        DOCUMENT_FORMAT_EMPTY: 'O elemento Documentformat não pode estar vazio o nulo',
        REPOSITORYLOCATOR_ATTACHMENT_EMPTY: 'O elemento Repositorylocator da instância ATTACHMENT não pode ser nulo ou estar vazio',
        ORIGINALFILENAME_ATTACHMENT_EMPTY: 'O elemento originalfilename da instância ATTACHMENT não pode ser nulo ou estar vazio',
        DOCUMENT_FORMAT_ERROR: 'Formato de documento não reconhecido',
        PROJECT_PARTY_SPONSOR_NOTFOUND: 'Sponsor não encontrado entre as empresas da fatura',
        PROJECT_PARTY_SPONSOR_ERROR: 'Erro inesperado ao pesquisar o sponsor entre as empresas fornecedor/cliente da fatura',
        VALIDITY_DOCUMENT_NOTFOUND: 'Não existe vigência de documento para o tipo de documento e o país da fatura',
        STATUS_AUDIT_NOTFOUND: 'Estado de auditoria não encontrado',
        SEMANTICDOCUMENTID_EMPTY: 'O elemento semanticdocumentid não pode ser nulo ou estar vazio',
        REPOSITORYLOCATOR_RECEIVED_EMPTY: 'O elemento Repositorylocator da instância RECEIVED não pode ser nulo ou estar vazio',
        INCOMINGDATETIME_EMPTY: 'O elemento incomingdatetime não pode ser nulo ou estar vazio',
        RECEIVERID_NOTFOUND: 'Empresa cujo código é indicado no elemento receiverid não existe',
        SENDERID_NOTFOUND: 'Empresa cujo código é indicado no elemento senderid não existe',
        DOCUMENT_TYPE_NOTFOUND: 'Tipo de documento não encontrado',
        DOCUMENT_PARENT_NOTFOUND: 'Documento padre não encontrado',
        COMMUNICATION_PROTOCOL_EMPTY: 'Protocolo de comunicação não pode ser nulo ou estar vazio',
        COMMUNICATION_PROTOCOL_NOTFOUND: 'Protocolo de comunicação não encontrado',
        REPOSITORY_ERROR: 'Erro ao obter o ficheiro do repositório',
        CONNECTION_ERROR: 'Erro inesperado de conexão à bd ',
        PROJECT_COMMUNITYID_NOTFOUND: 'Serviço com código communityid não encontrado',
        DOCUMENT_FORMAT_NOTFOUND: 'Formato de documento não encontrado',
        INPUTDATETIME_EMPTY: 'O elemento inputdatetime não pode ser nulo ou estar vazio',
        TRANSFORMATION: 'Fase de transformação da fatura',
        EXTRACTION: 'Fase de extração da fatura',
        ATTACHMENT: 'Fase de extração dos anexos da fatura',
        DELIVERY: 'Fase de entrega do ficheiro',
        DIR_ATTACHMENT_NOTFOUND: 'Não existe o diretório de anexos da fatura a ser integrada',
        VALIDATION_ERROR: 'Erro de validação',
        translation: {
          instances: {
            added: 'Tradução de instâncias adicionada'
          },
          processingtime: 'Duração na conclusão da tradução'
        },
        error: {
          document: {
            entrieszip: {
              '': 'Erro ao descompactar o zip',
              format: {
                invalid: 'Estrutura/Formato do ficheiro de entrada incorreta'
              }
            },
            attachments: {
              directory: {
                name: {
                  invalid: 'O nome do diretório de anexos é inválido'
                }
              }
            },
            file: {
              name: {
                invalid: 'O nome de qualquer um dos ficheiros de entrada é inválido'
              },
              format: 'Erro no formato do ficheiro de entrada'
            },
            read: {
              country: 'Erro durante a letura do ficheiro,não é possível determinar o país'
            }
          },
          ai: {
            translationfail: 'Erro durante a tradução AI do ficheiro'
          },
          ruleinformation: {
            notfound: 'Regra não encontrada'
          }
        },
        EXTRACTION_INVOICE: {
          ERROR: 'Erro ocorrido ao extrair a fatura do ficheiro compactado'
        },
        EXTRACTION_ATTACHMENT: {
          ERROR: 'Erro ocorrido ao extrair os anexos do ficheiro compactado'
        },
        TRANSLATION_MAP: {
          ERROR: 'Erro ocorrido ao aplicar o mapa à fatura'
        },
        SIGNATURE: {
          '': 'Fase de assinatura do ficheiro',
          ERROR: 'Erro ocorrido durante a assinatura da fatura'
        },
        signature: {
          sax: {
            exception: {
              parsing: {
                document: 'Erro ocorrido durante a assinatura da fatura,formato incorreto'
              }
            }
          },
          signature: {
            exception: {
              signing: 'Erro ao assinar a fatura'
            }
          }
        },
        RECOGNITION: {
          '': 'Fase de reconhecimento do ficheiro de entrada',
          ERROR: 'Erro ocorrido durante o reconhecimento do ficheiro'
        },
        vltrader: {
          senddt: 'Data envio',
          sender: {
            host: 'Host',
            mailbox: 'Caixa de correio'
          },
          sendid: 'Identificador envio',
          totalattempts: 'Número de tentativas',
          transfer: {
            enddt: 'Data final envio',
            resulttext: 'Resultado do envio',
            startdt: 'Data início envio',
            status: 'Estado resultado de envio',
            transferid: 'Identificador de entrega'
          }
        },
        wsserver: {
          profile: 'Perfil',
          requestid: 'Identificador do pedido'
        },
        DUPLICATED_INVOICE_ERROR: 'Erro devido a fatura duplicada',
        EDICOM_CDR_NEGATIVE: 'CDR negativo',
        996: '996',
        CIF_REQUIRED: 'O cif é um campo obrigatório',
        ACTION_REQUIRED: 'A ação é um campo obrigatório',
        DESCRIPTION_REQUIRED: 'A descrição é um campo obrigatório',
        CANAL_REQUIRED: 'O canal é um campo obrigatório',
        EMAIL_REQUIRED: 'O email é um campo obrigatório',
        PARTY_BUYER_NOTFOUND: 'A empresa cliente não existe',
        PROJECT_PARTY_DISABLED: 'A empresa está desativada para o serviço indicado',
        PARTY_DISABLED: 'A empresa está desativada',
        COMMUNICATION_METHOD_NOTFOUND: 'O método de comunicação não existe',
        EMAIL_INVALID: 'O email é incorreto',
        ACTION_UNEXPECTED: 'A ação é incorreta',
        READ_FILE_BUYERS_ERROR: 'Erro inesperado ao ler o ficheiro de contratação de empresas clientes',
        UPDATE_PARTY_ERROR: 'Erro ao atualizar os dados da empresa',
        CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Erro ao criar o método de entrega associado à empresa',
        CREATE_PARTY_MEDIA_ERROR: 'Erro ao criar o email associado à empresa cliente',
        CREATE_USER_PARTY_ERROR: 'Erro ao criar o utilizador associado à empresa cliente',
        CREATE_PARTY_ERROR: 'Erro ao criar a empresa cliente',
        CREATE_USER_ERROR: 'Erro ao criar o utilizador',
        CREATE_PROJECT_PARTY_ERROR: 'Erro ao criar a relação entre o projeto e a empresa',
        CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Erro ao criar a relação comercial entre a empresa sponsor e a empresa cliente',
        EDICOM_ACK_NEGATIVE: 'ACK negativo',
        NO_PERSON_CODE_VALID: 'Código de persona inválido',
        PARTY_NIF_EXIST: 'O NIF de empresa já existe',
        PARTY_GLN_EXIST: 'O GLN de empresa já existe',
        WITHOUT_DATA_REQUIRED: 'Faltam dados obrigatórios',
        LOGO_ERROR: 'Erro com o logo',
        MIME_TYPE_LOGO_ERROR: 'Erro de formato de logo',
        FILE_BASE64_ERROR: 'Erro de ficheiro em Base64',
        NO_COUNTRY_CODE_VALID: 'Código de país inválido',
        CENTRE_ERROR: 'Erro de centro',
        COMMUNICATION_METHOD_ERROR: 'Erro de método de comunicação',
        EMAIL_ERROR: 'Erro de Email',
        PARTY_USER_ERROR: 'Erro ao alocar a entidade ao utilizador',
        PROJECT_PARTY_NIF_NOT_EXIST: 'Não existe empresa com esse NIF',
        CREATED: 'Criado',
        DELETED: 'Eliminado',
        UPDATED: 'Atualizado',
        EDICOM_CDR_POSITIVE: 'CDR positivo',
        CENTRE_NOT_EXIST: 'Não existe o centro',
        USER_EXIST: 'O utilizador já existe',
        USER_NOT_EXIST: 'O utilizador não existe',
        USER_NOT_LOCKED: 'Utilizador não bloqueado',
        USER_NOT_REMOVED: 'Utilizador não eliminado',
        USER_NOT_PROJECT: 'O utilizador não é do serviço',
        USER_NIF_EXIST: 'Já existe um utilizador com esse NIF',
        PROJECT_NOSENDER: 'Método de envio incorreto. O projeto não é de emissão',
        SELLER_NOSPONSOR: 'Método de envio incorreto. A empresa não é sponsor.',
        PROJECT_NO_DELIVERY_METHOD: 'Método de envio não encontrado para o projeto.',
        REGISTRATION_CODE_PROPERTY: 'Código de registo',
        REGISTRATION_DATE_PROPERTY: 'Data de registo',
        CHANGE_STATUS: 'Mudança de estado',
        CHANGE_STATUS_PROPERTY: 'Mudança de estado',
        DOWNLOAD_PROPERTY: 'Descarga',

        // Códigos para propiedades de auditorías
        invoice: {
          integrated: {
            b2bintegration: 'Número de fatura B2B integrada com sucesso',
            ws: 'Número de fatura no Webservice integrada com sucesso',
            upload: 'Número de fatura integrada com sucesso'
          },
          note: {
            media: {
              type: {
                not: {
                  found: 'O canal de comunicação especificado para os dados de contacto da entrada de fatura não foi encontrado'
                }
              },
              invalid: {
                email: {
                  format: 'O endereço de e-mail dos dados de contacto da entrada de fatura é inválido'
                }
              }
            },
            document: {
              not: {
                found: 'O documento de fatura indicado não foi encontrado. Não existe ou os seus dados estão errados'
              }
            },
            recadv: {
              not: {
                found: 'O recibo indicado para as notas fiscais não foi encontrado. Não existe ou os seus dados estão incorretos'
              }
            },
            attachment: {
              category: {
                not: {
                  found: 'A categoria indicada do anexo da entrada de fatura  não foi encontrada'
                }
              },
              user: {
                not: {
                  found: 'O utilizador indicado do anexo da entrada de fatura não foi encontrado'
                }
              }
            }
          },
          project: {
            not: {
              found: 'O projeto indicado para a fatura não foi encontrado. Não existe ou es erroneo'
            },
            category: {
              not: {
                found: 'A categoria de projeto indicada para a fatura não foi encontrada. Não existe ou es erronea'
              }
            }
          },
          sender: {
            not: {
              found: 'A empresa emissora indicada para a fatura não foi encontrada. Não existe ou os seus dados estão incorretos'
            }
          },
          receiver: {
            not: {
              found: 'A empresa recetora indicada para a fatura não foi encontrada. Não existe ou os seus dados estão incorretos'
            }
          },
          thirdparty: {
            not: {
              found: 'A terceira empresa indicada para a fatura não foi encontrada. Não existe,está desativada para o projeto ou os seus dados estão incorretos'
            }
          },
          status: {
            not: {
              found: 'O estado indicado para a fatura não foi encontrado. Não existe ou es erroneo'
            }
          },
          currency: {
            not: {
              found: 'A divisa indicada para a fatura não foi encontrada. Não existe ou es erronea'
            }
          },
          document: {
            format: {
              not: {
                found: 'O formato de documento indicado para a fatura não foi encontrado. Não existe ou es erroneo'
              }
            },
            class: {
              not: {
                found: 'O tipo de documento indicado para a fatura não foi encontrado. Não existe ou es erroneo'
              }
            },
            type: {
              not: {
                found: 'O tipo de documento indicado para a fatura não foi encontrado. Não existe ou es erroneo'
              }
            }
          },
          type: {
            not: {
              found: 'O tipo de fatura indicado não foi encontrado. Não existe ou es erroneo'
            }
          },
          validity: {
            document: {
              not: {
                found: 'O documento de vigência indicado para a fatura não foi encontrado. Não existe ou es erroneo'
              }
            }
          },
          communication: {
            method: {
              not: {
                found: 'O método de comunicação indicado para a fatura não foi encontrado. Não existe ou es erroneo'
              }
            }
          },
          auditdocument: {
            not: {
              found: 'O documento de auditoria indicado para a fatura não foi encontrado. Não existe ou es erroneo'
            }
          },
          accounting: {
            close: {
              not: {
                found: 'O encerramento contábil indicado para a fatura não foi encontrado. Não existe ou es erroneo'
              }
            }
          },
          recept: {
            comm: {
              method: {
                not: {
                  found: 'O método de comunicação de recepção indicado para a fatura não foi encontrado. Não existe ou es erroneo'
                }
              }
            }
          },
          internal: {
            status: {
              not: {
                found: 'O estado interno indicado para a fatura. Não existe ou es erroneo'
              }
            }
          },
          batch: {
            not: {
              found: 'O lote indicado para a fatura não foi encontrado. Não existe ou es erroneo'
            }
          },
          channel: {
            not: {
              found: 'O canal indicado para a fatura não foi encontrado. Não existe ou es erroneo'
            }
          },
          seller: {
            centre: {
              not: {
                found: 'Um dos centros vendedores da fatura não foi encontrado. Não existe ou os seus dados estão incorretos'
              },
              roletype: {
                not: {
                  found: 'O tipo de função específica do centro vendedor da fatura. Não existe ou os seus dados estão incorretos'
                }
              }
            }
          },
          buyer: {
            centre: {
              not: {
                found: 'Um dos centros compradores da fatura não foi encontrado. Não existe ou os seus dados estão incorretos'
              },
              roletype: {
                not: {
                  found: 'O tipo de função específica do centro comprador da fatura não foi encontrado. Não existe ou os seus dados estão incorretos'
                }
              }
            }
          },
          tax: {
            type: {
              not: {
                found: 'O tipo de imposto indicado para a fatura não foi encontrado. Não existe ou os seus dados estão incorretos'
              }
            },
            currency: {
              not: {
                found: 'A divisa indicada para o imposto da fatura não foi encontrada. Não existe ou os seus dados estão incorretos'
              }
            }
          },
          user: {
            does: {
              not: {
                belong: {
                  to: {
                    party: 'O utilizador do pedido não pertence à parte do número de identificação fiscal do vendedor'
                  }
                }
              }
            }
          }
        },
        recadv: {
          integrated: {
            b2bintegration: 'Número de recepção B2B integrada com sucesso'
          },
          status: {
            not: {
              found: 'O estado indicado para a recepção não foi encontrado. Não existe ou es erroneo'
            }
          },
          validity: {
            document: {
              not: {
                found: 'O documento de vigência indicado para a recepção não foi encontrado. Não existe ou es erroneo'
              }
            }
          },
          document: {
            format: {
              not: {
                found: 'O formato de documento indicado para a recepção não foi encontrado. Não existe ou es erroneo'
              }
            }
          },
          centre: {
            not: {
              found: 'O centro do comprador do documento de recepção não foi encontrado '
            }
          }
        },
        unexpected: {
          error: 'Erro inesperado ao processar o pedido ou seu documento'
        },
        validation: {
          noDocumentType: 'Nenhum tipo de documento foi incluído',
          retry: 'As validações se devem tentar novamente',
          invoicePeriodDates: 'A data de início do período de cobrança deve ser anterior à data de término',
          invoiceCorrectivePeriodDates: 'A data de início do período de retificação deve ser anterior à data de término',
          signature: 'A fatura não está assinada',
          nif: 'O número NIF ou CIF não é válido',
          attachmentformat: 'Tipo de anexo não permitido,apenas extensões são suportadas: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
          attachmentformat321: 'Tipo de anexo não permitido,apenas extensões são suportadas: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
          error: 'Formato de arquivo incorreto',
          party: {
            noTaxId: 'Nenhuma identificação fiscal foi incluído',
            noProject: 'Nenhum projeto foi incluído',
            buyer: {
              notInProject: 'A empresa compradora não existe para o projeto ou está desativada'
            },
            seller: {
              notInProject: 'A empresa vendedora não existe para o projeto ou está desativada'
            },
            noSeller: 'Nenhuma identificação fiscal do vendedor foi incluída',
            noBuyer: 'Nenhuma identificação fiscal do comprador foi incluída',
            noRelation: 'Não existe uma relação comercial entre a empresa compradora e vendedora para este serviço',
            noSponsor: 'A empresa não é sponsor para o projeto',
            disabled: 'A empresa está desativada',
            disabledInProject: 'A empresa está desativada para o projeto'
          },
          parties: {
            noSponsor: 'Nenhuma das empresas é sponsor do projeto'
          },
          centre: {
            role: {
              type: 'A função do centro não é válida para o formato da fatura'
            },
            noCentreCode: 'Nenhum código de centro foi incluído',
            noParty: 'Nenhuma empresa foi incluída',
            buyer: {
              notInParty: 'Um ou mais dos centros compradores não existem para a empresa ou estão desativados'
            },
            seller: {
              notInParty: 'Um ou mais dos centros vendedores não existem para a empresa ou estão desativados'
            },
            noCentreUnique: 'Os centros devem ser únicos'
          },
          document: {
            noDocument: 'Nenhum documento inclu\u00EDda'
          },
          invoice: {
            currency: 'Moeda não incluída',
            currencyExchange: 'A taxa de câmbio não foi incluída',
            currencyExchangeDate: 'A data da taxa de câmbio não foi incluída',
            iban: 'O formato do IBAN não está correto.',
            ibanNull: 'IBAN não relatado',
            registrationData: 'Os dados do cadastro comercial incluídos na fatura não correspondem aos dados cadastrados no B2B',
            sequenceNumber: 'A posição do pedido é obrigatória para o pedido indicado',
            correctiveSign01pos: 'Factura rectificativa de tipo Rectificación Integra deben ser positivas',
            correctiveSign02pos: 'Factura rectificativa de tipo Rectificación por diferencias deben ser positivas',
            correctiveSign03pos: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser positivas',
            correctiveSign04pos: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser positivas',
            correctiveSign01neg: 'Factura rectificativa de tipo Rectificación Integra deben ser negativas',
            correctiveSign02neg: 'Factura rectificativa de tipo Rectificación por diferencias deben ser negativas',
            correctiveSign03neg: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser negativas',
            correctiveSign04neg: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser negativas',
            noInvoice: 'Nenhuma fatura foi incluída',
            noInvoiceLine: 'Nenhuma linha de fatura foi incluída ou uma ou mais são nulas',
            noInvoiceNumber: 'Nenhum número de fatura foi incluído',
            noParty: 'Nenhuma empresa foi incluída',
            noProject: 'Nenhum projeto foi incluído',
            duplicate: 'Já existe uma fatura com o número de fatura em estado correto',
            issuedate: 'A data da fatura não corresponde à fatura anterior recebida com a data de emissão {argumento}',
            dates: 'A data de operação deve ser menor ou igual à data de emissão',
            noIssueDate: 'Nenhuma data de emissão foi incluída',
            noOperationDate: 'Nenhuma data de operação foi incluída',
            noIssuerType: 'Nenhum tipo de emissor foi incluído',
            issuerType: 'O tipo emissor fatura não é válido',
            issuerTypeErro: 'Os dados necessários para realizar a validação não foram incluídos',
            noModalityType: 'A modalidade da fatura não corresponde a um dos valores aceitos',
            modalityType: 'O tipo de fatura deve ser individual',
            modalityTypeErro: 'Os dados necessários para realizar a validação não foram incluídos',
            project: {
              notSender: 'O projeto não tem ativado a função de emissão indicada para a fatura',
              notReceiver: 'O projeto não tem ativado a função de recepção indicada para a fatura'
            },
            noRole: 'A função da fatura (emissora ou recetora) deve ser estabelecida',
            communication: {
              method: 'O método de comunicação da fatura não está contratado para o seu projeto'
            },
            lines: {
              total: {
                error: 'O total de linha sem impostos não corresponde ao produto da quantidade por preço unitário',
                discountscharges: {
                  error: 'O total de linha com taxas e descontos não corresponde ao montante bruto da linha'
                }
              }
            },
            total: {
              error: 'O total da fatura sem taxas ou descontos gerais não corresponde à soma do total das linhas com descontos e taxas',
              discountscharges: {
                error: 'O total da fatura com taxas e descontos gerais não corresponde ao total da fatura antes dos impostos',
                taxes: {
                  error: 'O total da fatura não corresponde ao total da fatura antes dos impostos mais o total de impostos liquidados e menos o total de impostos retidos'
                }
              }
            },
            totalexecutable: {
              error: 'O total executável da fatura não corresponde ao total a pagar menos subvenções,adiantamentos e retenções mais fornecimentos e encargos financeiros'
            },
            accounting: {
              error: 'A fatura não cumpre com alguma das validações contábeis'
            }
          },
          recadv: {
            noRecadv: 'Nenhuma recepção foi incluída',
            noRecadvNumber: 'Nenhum número de recepção foi incluído',
            noSeller: 'Nenhuma empresa vendedora foi incluída',
            noBuyer: 'Nenhuma empresa compradora foi incluída',
            duplicate: 'Já existe uma recepção com número em estado correto'
          },
          cmr: {
            noCmr: 'Nenhum documento de transporte foi incluído',
            noCmrNumber: 'Nenhum número de documento de transporte foi incluído',
            noSeller: 'Nenhuma empresa vendedora foi incluída',
            noBuyer: 'Nenhuma empresa compradora foi incluída',
            noshipfrom: 'O local de origem deve ser definido',
            noshipto: 'O local de destino deve ser definido',
            duplicate: {
              '': 'Já existe um documento de transporte com o mesmo número em estado correto',
              issueyear: 'Já existe um documento de transporte com o mesmo número em estado correto no ano em curso'
            },
          },
          sign: {
            noParty: 'Nenhuma empresa foi incluída',
            noSign: 'A empresa emissora não tem assinatura delegada'
          },
          order: {
            noOrder: 'O número de encomenda é obrigatório',
            noUnique: 'O número de encomenda deve ser único na fatura',
            noOrderIssuer: 'O número do emissor do pedido é obrigatório',
            noUniqueIssuer: 'O número do pedido do emissor deve ser único na fatura',
            invalidPatternIssuer: 'O formato do número do pedido do emissor é inválido',
            noPattern: 'O padrão a ser verificado não foi configurado',
            invalidPattern: 'O número de encomenda incluído não está em conformidade com o formato exigido pelo destinatário',
            error: 'Os dados necessários para realizar a validação não foram incluídos'
          },
          processo: {
            noExp: 'O número de dossier é obrigatório',
            noUnique: 'O número de dossier deve ser único na fatura',
            noPattern: 'O padrão a ser verificado não foi configurado',
            invalidPattern: 'O número de dossier incluido não cumpre com o formato exigido pelo destinatário',
            error: 'Os dados necessários para realizar a validação não foram incluídos'
          },
          contract: {
            noContract: 'O número de contrato é obrigatório',
            invalidPattern: 'O número de contrato incluido não cumpre com o formato exigido pelo destinatário',
            noUnique: 'O número de contrato deve ser único na fatura',
            noPattern: 'O padrão a ser verificado não foi configurado',
            error: 'Os dados necessários para realizar a validação não foram incluídos'
          },
          transaction: {
            noTransaction: 'O número da transação é obrigatório'
          },

          invoiceCorrective: {
            dates: 'A data inicial e final do periodo de tributação não são válidas',
            number: 'O número de fatura é obrigatório para as faturas de tipo Retificação íntegra e Retificação por divergências',
            noNumber: 'O número de fatura é obrigatório para as faturas de tipo retificativas',
            invalidPattern: 'O formato do número da fatura retificada não é válido',
            noValue: 'Nenhum documento com algum valor foi anexado',
            noOrderValue: 'Deve indicar o pedido do destinatário',
			required: 'O bloco corretivo é obrigatório para uma fatura retificativa'
          },

          project: {
            disabled: 'O projeto não existe ou está desativado',
            noProject: 'Nenhum projeto foi incluído',
            attachment: {
              notfound: 'Não existe o diretório de anexos do projeto da fatura a ser integrada'
            }
          },
          issue: {
            date: {
              future: 'A data de emissão é posterior à data de registo',
              past: 'A data de emissão é anterior à data de registo'
            }
          },
          commercial: {
            relation: {
              channel: 'Não existe a relação comercial entre o vendedor,o comprador e o canal'
            }
          },
          channel: {
            not: {
              found: 'Não existe o canal'
            }
          },
          invoiceNumber: {
            error: 'Os dados necessários para realizar a validação do Número de Fatura não foram incluídos',
            noPattern: 'O padrão do Número de Fatura não foi configurado',
            invalidPattern: 'O formato do Número de Fatura não é válido'
          },
          b2bvalidationws: {
            nourl: 'Não existe uma URL associada ao WS ou é inválida',
            metadataerror: 'Aconteceu um erro ao intentar obter o ficheiro de metadados.',
            connectionerror: 'Aconteceu um erro durante a conexão com o serviço do cliente.',
            wrongresponse: 'O WS cliente retornou uma resposta incorreta.',
            errorresponse: 'O WS cliente retornou uma resposta de ERRO.'
          }
        },
        invalid: {
          validation: {
            code: {
              exception: 'Um ou mais códigos de validação não têm um método de validação'
            }
          },
          persontypecode: 'O código de tipo de pessoa especificado não é válido. Só pode ser jurídica (j) ou física (f)',
          name: {
            format: 'O nome ou sobrenome têm caracteres não permitidos no formato utf-8'
          },
          facturae32: {
            xml: {
              format: 'O formato do ficheiro da Facturae 3.2 é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo Facturae 3.2 tem campos que não passam a validação do seu esquema: '
          },
          facturae321: {
            xml: {
              format: 'O formato do ficheiro de Facturae 3.2.1 é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo Facturae 3.2.1 tem campos que não passam a validação do seu esquema: '
          },
          facturae322: {
            xml: {
              format: 'O formato do ficheiro da Facturae 3.2.2 é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo Facturae 3.2.2 tem campos que não passam a validação do seu esquema: '
          },
          facturapdf: {
            xml: {
              format: 'O formato da fatura PDF é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo fatura PDF tem campos que não passam a validação do seu esquema: '
          },
          edi: {
            date: {
              format: 'El formato de la fecha no es correcto'
            }
          },
          facturad01b: {
            edi: {
              format: 'O formato do ficheiro da InvoicD01b é incorreto ou .edi'
            }
          },
          facturad93a: {
            edi: {
              format: 'O formato do ficheiro da InvoicD93A é incorreto ou .edi'
            }
          },
          facturad96a: {
            edi: {
              format: 'O formato do ficheiro da InvoicD96A é incorreto ou .edi'
            }
          },
          facturad97a: {
            edi: {
              format: 'O formato do ficheiro da InvoicD97A é incorreto ou .edi'
            }
          },
          fatturapa12: {
            xml: {
              format: 'O formato do ficheiro do fatturapa12 é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo fatturapa12 tem campos que não passam a validação do seu esquema: '
          },
          recadv: {
            xml: {
              format: 'O formato do ficheiro do documento de recepção é incorreto ou não é .xml'
            },
            schema: 'A fatura da recepção tem campos que não passam a validação do seu esquema: {0}'
          },
          fatturapaSemplificata1: {
            xml: {
              format: 'O formato do ficheiro do fatturapa simplificado é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo fatturapa simplificado tem campos que não passam a validação do seu esquema: {0}'
          },
          fatturapa12cades: {
            xml: {
              format: 'O formato do ficheiro do fatturapa 1.2 cades é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo fatturapa 1.2 cades tem campos que não passam a validação do seu esquema: {0}'
          },
          fatturapaSemplificatacades: {
            xml: {
              format: 'O formato do ficheiro do fatturapa simplificado cades é incorreto ou não é .xml'
            },
            schema: 'A fatura de tipo fatturapa simplificado cades tem campos que não passam a validação do seu esquema: {0}'
          }
        },
        unable: {
          to: {
            save: {
              file: {
                in: {
                  repository: 'Não foi possível salvar o ficheiro no endereço do repositório. es erroneo ou há um problema com o ficheiro'
                }
              }
            },
            get: {
              repository: {
                file: 'Não foi possível recuperar o ficheiro com o endereço do repositório indicado. es erroneo ou há um problema com o ficheiro'
              }
            },
            delete: {
              repository: {
                file: 'Não foi possível eliminar o ficheiro do endereço do repositório indicado. es erroneo ou o ficheiro está bloqueado'
              }
            }
          }
        },
        no: {
          repository: {
            date: 'Nenhuma data foi incluída. É nécessaria para o tipo de ficheiro',
            project: {
              name: 'Nenhum nome de projeto exigido para o tipo de ficheiro a salvar foi incluído'
            },
            file: 'Nenhum ficheiro a salvar foi incluído',
            subpath: 'O caminho secundário do ficheiro não foi incluído'
          },
          file: {
            to: {
              save: {
                extension: 'A extensão do ficheiro a salvar não foi indicada'
              }
            }
          },
          pathcomplete: {
            flag: 'Não foi indicado se o caminho incluído no objeto é completo ou parcial'
          }
        },
        repository: {
          path: {
            not: {
              found: 'Não se encontrou um caminho de repositório na base de dados para o tipo de ficheiro a salvar. Não existe ou é inválido'
            }
          }
        },
        missing: {
          required: {
            party: {
              data: 'Um ou mais dos dados obrigatórios da empresa (nif,nomes e estado de ativação) não foi incluído',
              commercial: {
                relation: {
                  data: 'Um ou mais dos dados obrigatórios da relação comercial da empresa (empresa emissora/vendedora e empresa recetora/compradora) não foi incluído'
                }
              },
              media: {
                value: 'deve especificar um valor para o meio de contacto da empresa',
                type: 'O canal dos dados de contacto não foi indicado',
                to: {
                  delete: 'Os dados de contacto da empresa a ser eliminada não foram indicados'
                }
              }
            },
            partyproject: 'É necessário indicar um projeto da empresa para poder criar os dados de contacto e as relações comerciais',
            projectparty: {
              data: 'Um ou mais dados obrigatórios (projeto,empresa e data de criação da relação) da relação projeto-empresa não foi incluído',
              role: 'As funções (vendedor, comprador ou terceiro) para a empresa não foram indicadas no seu projeto',
              role_required: 'É obrigatório indicar uma função (vendedor, comprador ou terceiro) para a empresa no seu projeto',
              enable: 'O estado de ativação da empresa com o projeto não foi indicado'
            },
            communicationmethod: {
              data: 'Um ou mais dados obrigatórios (empresa e metodo de comunicação) do método de comunicação da empresa não foi incluído'
            },
            partycentre: {
              roletype: {
                data: 'Um ou mais dados obrigatórios do tipo de função do centro não foi incluído'
              }
            },
            centre: {
              role: 'As funções (vendedor ou comprador) para o centro não foram indicadas',
              data: 'Um ou mais dos dados obrigatórios (nif ou id de empresa,código e estado de ativação) do centro não foi incluído',
              media: {
                value: 'Deve especificar um valor para o meio de contacto do centro',
                type: 'O canal dos dados de contacto do centro não foi indicado',
                to: {
                  delete: 'Os dados de contacto do centro a ser eliminado não foram indicados'
                }
              }
            },
            invoice: {
              note: {
                media: {
                  value: 'Deve especificar um valor para o meio de contacto da entrada de fatura',
                  type: 'O canal dos dados de contacto da entrada de fatura não foi indicado',
                  default: {
                    flag: 'O flag de contacto por defeito dos dados de contacto da entrada de fatura não foi indicado'
                  },
                  role: 'A função (vendedor ou comprador) dos dados de contacto da fatura não foi indicada'
                },
                issue: {
                  date: 'A data de emissão para a entrada de fatura não foi indicada'
                },
                document: {
                  name: 'O nome do documento da entrada de fatura ou o seu Id não foi indicado',
                  format: 'O formato para o documento da entrada de fatura não foi indicado',
                  type: 'O tipo de documento para a entrada de fatura não foi indicado'
                },
                recadv: {
                  data: 'O recibo (seu ID ou número) associado à entrada de fatura não foi indicado'
                }
              },
              integration: {
                file: {
                  '': 'O ficheiro da fatura não foi incluído',
                  extension: 'A extensão do ficheiro da fatura não foi indicada',
                  size: 'O tamanho original do ficheiro da fatura não foi indicado'
                }
              },
              project: 'O projeto da fatura não foi indicado',
              seller: {
                '': 'A empresa vendedora da fatura não foi indicada',
                centre: {
                  code: 'O código de um ou mais centros vendedores da fatura não foi incluído'
                }
              },
              buyer: {
                '': 'A empresa compradora da fatura não foi indicada',
                centre: {
                  code: 'O código de um ou mais centros compradores da fatura não foi incluído'
                }
              },
              number: 'O número da fatura não foi indicado',
              sender: 'A empresa emissora da linha de fatura não foi indicada',
              receiver: 'A empresa recetora da linha de fatura não foi indicada',
              status: 'O estado para a fatura não foi indicado',
              document: {
                format: 'O formato de documento para a fatura não foi indicado',
                class: 'A categoria de documento para a fatura não foi indicada',
                type: 'O tipo de documento para a fatura não foi indicado'
              },
              validity: {
                document: 'O documento de vigência da fatura não foi indicado'
              },
              correctedflag: 'O flag de fatura corretiva (true: a fatura é corretiva,false: não o è) não foi indicado',
              metadata: {
                file: {
                  extension: 'A extensão do ficheiro de metadados da fatura não foi indicada'
                }
              },
              attachment: {
                extension: 'A extensão de um ou mais anexos da fatura não foi indicada'
              },
              tax: {
                type: 'O tipo de um ou mais impostos da entrada de fatura não foi indicado',
                baseamount: 'O valor base de um ou mais impostos da entrada de fatura não foi indicado',
                currency: 'A divisa de um ou mais impostos da entrada de fatura não foi indicada'
              },
              event: 'O nome para o evento da fatura não foi indicado',
              property: {
                '': 'A propriedade do evento da fatura não foi indicada',
                value: 'O valor para a propriedade do evento da fatura não foi indicado'
              },
              outstanding: {
                amount: 'O montante pendente da fatura não foi indicado'
              },
              executable: {
                amount: 'O executável da fatura não foi indicado'
              },
              communication: {
                reception: {
                  name: 'O nome da comunicação de recepção usada para a integração da fatura não foi indicado'
                }
              }
            },
            media: {
              type: 'O canal dos dados de contacto da empresa não foi indicado'
            },
            centremedia: {
              project: 'É necessário indicar um projeto do centro para poder criar os dados de contacto',
              role: 'As funções (vendedor ou comprador) para os dados de contacto do centro não foram indicadas'
            },
            partymedia: {
              role: ' As funções (vendedor ou comprador) para os dados de contacto da empresa não foram indicadas'
            },
            request: {
              compressed: {
                invoice: {
                  flag: 'O ficheiro da fatura do pedido está compactado ou não foi indicado'
                }
              },
              invoice: {
                file: 'O ficheiro da fatura na encomenda não foi incluído'
              }
            }
          },
          update: {
            party: {
              taxid: 'O identificador fiscal da empresa a ser atualizada ou modificada não foi especificado'
            }
          },
          search: {
            party: {
              taxid: 'Um ou mais identificadores fiscais das empresas a serem procuradas não foram identificados'
            }
          },
          commercial: {
            relation: {
              partytaxid: 'O identificador fiscal da empresa da relação comercial não foi incluído',
              role: 'A função da empresa criada/atualizada na relação comercial não foi indicada'
            }
          },
          recadv: {
            integration: {
              file: {
                '': 'O ficheiro da recepção não foi incluído',
                extension: 'A extensão do ficheiro da recepção não foi indicada'
              }
            },
            status: 'O estado para a recepção não foi indicado',
            number: {
              exception: 'O número da recepção não foi indicado'
            },
            receiving: {
              date: {
                time: {
                  extension: 'A data da última recepção do recibo não foi indicada'
                }
              }
            },
            validity: {
              document: 'O documento de vigência da fatura não foi indicado'
            },
            document: {
              format: 'O formato de documento para a recepção não foi indicado'
            },
            centre: 'O centro do comprador do documento de recepção não foi indicado'
          }
        },
        party: {
          not: {
            found: 'Não foi encontrada nenhuma empresa com o número de identificação fiscal indicado'
          },
          project: {
            not: {
              found: 'Não foi encontrado nenhum projeto especificado para a empresa. Não existe ou está desativado'
            }
          },
          to: {
            delete: {
              not: {
                found: 'A empresa a ser eliminada não foi encontrada. O identificador fiscal não foi indicado ou não existe'
              }
            }
          },
          commercial: {
            relation: {
              channel: {
                not: {
                  found: 'Não foi encontrado o canal para a relação comercial. Não existe ou es erroneo'
                }
              }
            }
          },
          deletion: 'Erro ao eliminar a empresa',
          country: {
            not: {
              found: 'Não foi encontrado o país indicado para a empresa. Não existe ou os seus dados estão errados'
            }
          },
          media: {
            type: {
              not: {
                found: 'Não foi encontrado o canal de comunicação especificado para os dados de contacto de empresa'
              }
            },
            deletion: 'Erro ao eliminar os dados de contacto da empresa',
            to: {
              delete: {
                not: {
                  found: 'Não foram encontrados os dados de contacto da empresa a serem eliminados. Não foram indicados ou não existem'
                }
              }
            },
            invalid: {
              email: {
                format: 'O endereço de e-mail dos dados de contacto da empresa é inválido'
              }
            }
          }
        },
        commercial: {
          relation: {
            party: {
              not: {
                found: 'Não foi encontrada a empresa indicada para a relação comercial dentro da função especificada. Também é possível que não exista ou esteja desativada'
              }
            }
          }
        },
        incompatible: {
          integrated: {
            party: {
              for: {
                commercial: {
                  relation: 'A empresa integrada não tem ativada a função (vendedor ou comprador) estabelecida para a sua relação comercial ou está desativada'
                }
              }
            }
          },
          centre: {
            role: 'O centro não tem uma função compatível com a de sua empresa dentro da sua relação de projeto',
            media: {
              data: {
                role: 'O centro não tem a função atribuída (vendedor ou comprador) para os dados de contacto,ou essa função é incompatível com as atribuídas para a sua empresa no projeto determinado'
              }
            }
          },
          party: {
            media: {
              data: {
                role: 'A empresa não tem a função atribuída (vendedor ou comprador) para os dados de contacto dentro do seu projeto'
              }
            }
          }
        },
        communication: {
          method: {
            not: {
              found: 'Não foi encontrado o método de comunicação especificado para a empresa'
            }
          }
        },
        centre: {
          role: {
            type: {
              not: {
                found: 'Não foi encontrado o tipo de função especificado para o centro'
              }
            }
          },
          to: {
            delete: {
              not: {
                found: 'Não foi encontrado o centro a ser eliminado. Não foi indicado nenhum dos dados obrigatórios (empresa e código do centro) ou o centro não existe'
              }
            }
          },
          deletion: 'Erro ao eliminar o centro',
          party: {
            not: {
              found: 'Não foi encontrada a empresa do centro com os dados estabelecidos'
            }
          },
          not: {
            found: 'Não foi encontrado um centro que corresponda à empresa e código indicados'
          },
          country: {
            not: {
              found: 'Não foi encontrado o país indicado para o centro. Não existe ou os seus dados estão errados'
            }
          },
          media: {
            type: {
              not: {
                found: 'Não foi encontrado o canal de comunicação especificado para os dados de contacto do centro'
              }
            },
            deletion: 'Erro ao eliminar os dados de contacto do centro',
            to: {
              delete: {
                not: {
                  found: 'Os dados de contacto do centro a serem eliminados não foram encontrados. Não foram indicados ou não existem'
                }
              }
            },
            invalid: {
              email: {
                format: 'O endereço de e-mail dos dados de contacto do centro é inválido'
              }
            }
          }
        },
        media: {
          type: {
            not: {
              found: 'O canal de contacto especificado não foi encontrado'
            }
          }
        },
        centremedia: {
          project: {
            not: {
              found: 'Não foi encontrado o projeto para os dados de contacto do centro. Não existe ou os seus dados estão errados'
            }
          }
        },
        duplicate: {
          partymedia: {
            value: 'já existem dados de contacto da empresa com o mesmo valor para o projeto ao qual está atribuído'
          },
          centremedia: {
            value: 'já existem dados de contacto do centro com o mesmo valor para o projeto ao qual está atribuído'
          }
        },
        recadvLine: {
          currency: {
            not: {
              found: 'A divisa indicada para a recepção. Não existe ou es erronea'
            }
          },
          unitOfMeasure: {
            notFound: 'Não foi encontrada a unidade de medida indicada para a linha de recepção'
          }
        },
        document: {
          generation: {
            format: {
              class: {
                not: {
                  found: 'Não foi encontrado o tipo de mapeamento do formato do documento. Não existe ou es erroneo'
                }
              }
            }
          }
        },
        unzipped: {
          request: {
            invoice: {
              file: 'O pedido da fatura está configurado para conter ficheiros de fatura compactados,mas o seu su ficheiro não está compactado'
            },
            attachments: 'O pedido da fatura está configurado para conter anexos compactados,mas só tem um não compactado'
          }
        },
        zipped: {
          request: {
            invoice: {
              file: 'O pedido da fatura está configurado para conter ficheiros de fatura não compactados,mas o ficheiro está compactado'
            },
            attachments: 'O pedido da fatura está configurado para conter só um anexo não compactado,mas tem um ficheiro compactado com um ou mais'
          }
        },
        different: {
          invoice: {
            number: 'O número de fatura do pedido é diferente do extraído do ficheiro de fatura anexo'
          },
          seller: {
            tax: {
              identification: {
                number: 'A identificação fiscal do vendedor do pedido é diferente da extraída do ficheiro de fatura anexo'
              }
            }
          }
        }
      }
    }
  },
  // Errores/mensajes en Integración de factura

  translation: {
    instances: {
      added: 'Tradução de instâncias adicionada'
    },
    processingtime: 'Duração na conclusão da tradução'
  },
  error_code: {
    document: {
      entrieszip: {
        '': 'Erro ao descompactar o zip',
        format: {
          invalid: 'Estrutura/Formato do ficheiro de entrada incorreta'
        }
      },
      attachments: {
        directory: {
          name: {
            invalid: 'O nome do diretório de anexos é inválido'
          }
        }
      },
      file: {
        name: {
          invalid: 'O nome de qualquer um dos ficheiros de entrada é inválido'
        },
        format: 'Erro no formato do ficheiro de entrada'
      },
      read: {
        country: 'Erro durante a letura do ficheiro,não é possível determinar o país'
      }
    },
    ai: {
      translationfail: 'Erro durante a tradução AI do ficheiro'
    },
    ruleinformation: {
      notfound: 'Regra não encontrada'
    }
  },
  EXTRACTION_INVOICE: {
    ERROR: 'Erro ocorrido ao extrair a fatura do ficheiro compactado'
  },
  EXTRACTION_ATTACHMENT: {
    ERROR: 'Erro ocorrido ao extrair os anexos do ficheiro compactado'
  },
  TRANSLATION_MAP: {
    ERROR: 'Erro ocorrido ao aplicar o mapa à fatura'
  },
  SIGNATURE: {
    '': 'Fase de assinatura do ficheiro',
    ERROR: 'Erro ocorrido durante a assinatura da fatura'
  },
  signature: {
    sax: {
      exception: {
        parsing: {
          document: 'Erro ocorrido durante a assinatura da fatura,formato incorreto'
        }
      }
    },
    signature: {
      exception: {
        signing: 'Erro ao assinar a fatura'
      }
    }
  },
  RECOGNITION: {
    '': 'Fase de reconhecimento do ficheiro de entrada',
    ERROR: 'Erro ocorrido durante o reconhecimento do ficheiro'
  },
  vltrader: {
    senddt: 'Data envio',
    sender: {
      host: 'Host',
      mailbox: 'Caixa de correio'
    },
    sendid: 'Identificador envio',
    totalattempts: 'Número de tentativas',
    transfer: {
      enddt: 'Data final envio',
      resulttext: 'Resultado do envio',
      startdt: 'Data início envio',
      status: 'Estado resultado do envio',
      transferid: 'Identificador de entrega'
    }
  },
  wsserver: {
    profile: 'Perfil',
    requestid: 'Identificador do pedido'
  },
  DUPLICATED_INVOICE_ERROR: 'Erro devido a fatura duplicada',
  EDICOM_CDR_NEGATIVE: 'CDR negativo',
  996: '996',
  CIF_REQUIRED: 'O cif é um campo obrigatório',
  ACTION_REQUIRED: 'A ação é um campo obrigatório',
  DESCRIPTION_REQUIRED: 'A descrição é um campo obrigatório',
  CANAL_REQUIRED: 'O canal é um campo obrigatório',
  EMAIL_REQUIRED: 'O email é um campo obrigatório',
  PARTY_BUYER_NOTFOUND: 'A empresa cliente não existe',
  PROJECT_PARTY_DISABLED: 'A empresa está desativada para o serviço indicado',
  PARTY_DISABLED: 'A empresa está desativada',
  COMMUNICATION_METHOD_NOTFOUND: 'O método de comunicação não existe',
  EMAIL_INVALID: 'O email é incorreto',
  ACTION_UNEXPECTED: 'A ação é incorreta',
  READ_FILE_BUYERS_ERROR: 'Erro inesperado ao ler o ficheiro de contratação de empresas clientes',
  UPDATE_PARTY_ERROR: 'Erro ao atualizar os dados da empresa',
  CREATE_COMMUNICATIONMETHOD_PARTY_ERROR: 'Erro ao criar o método de entrega associado à empresa',
  CREATE_PARTY_MEDIA_ERROR: 'Erro ao criar o email associado à empresa cliente',
  CREATE_USER_PARTY_ERROR: 'Erro ao criar o utilizador associado à empresa cliente',
  CREATE_PARTY_ERROR: 'Erro ao criar a empresa cliente',
  CREATE_USER_ERROR: 'Erro ao criar o utilizador',
  CREATE_PROJECT_PARTY_ERROR: 'Erro ao criar a relação entre o projeto e a empresa',
  CREATE_PARTY_COMMERCIALRELATION_ERROR: 'Erro ao criar a relação comercial entre a empresa sponsor e a empresa cliente',
  EDICOM_ACK_NEGATIVE: 'ACK negativo',
  NO_PERSON_CODE_VALID: 'Código de persona inválido',
  PARTY_NIF_EXIST: 'O NIF de empresa já existe',
  PARTY_GLN_EXIST: 'O GLN de empresa já existe',
  WITHOUT_DATA_REQUIRED: 'Faltam dados obrigatórios',
  WITHOUT_DATA_REQUIRED_INVALID: 'Faltam dados obrigatórios ou são inválidos',
  LOGO_ERROR: 'Erro com o logo',
  MIME_TYPE_LOGO_ERROR: 'Erro de formato de logo',
  FILE_BASE64_ERROR: 'Erro de ficheiro em Base64',
  NO_COUNTRY_CODE_VALID: 'Código de país inválido',
  CENTRE_ERROR: 'Erro de centro',
  COMMUNICATION_METHOD_ERROR: 'Erro de método de comunicação',
  EMAIL_ERROR: 'Erro de Email',
  PARTY_USER_ERROR: 'Erro ao alocar a entidade ao utilizador',
  PROJECT_PARTY_NIF_NOT_EXIST: 'Não existe empresa com esse NIF',
  CREATED: 'Criado',
  DELETED: 'Eliminado',
  UPDATED: 'Atualizado',
  EDICOM_CDR_POSITIVE: 'CDR positivo',
  CENTRE_NOT_EXIST: 'Não existe o centro',
  USER_EXIST: 'O utilizador já existe',
  USER_NOT_EXIST: 'O utilizador não existe',
  USER_NOT_LOCKED: 'Utilizador não bloqueado',
  USER_NOT_REMOVED: 'Utilizador não eliminado',
  USER_NOT_PROJECT: 'O utilizador não é do serviço',
  USER_NIF_EXIST: 'Já existe um utilizador com esse NIF',
  PROJECT_NOSENDER: 'Método de envio incorreto. O projeto não é para emissão',
  SELLER_NOSPONSOR: 'Método de envio incorreto. A empresa não é sponsor.',
  PROJECT_NO_DELIVERY_METHOD: 'Método de envio não encontrado para o projeto.',

  // Códigos para propiedades de auditorías
  invoice: {
    integrated: {
      b2bintegration: 'Número de fatura B2B integrada com sucesso',
      ws: 'Número de fatura no Webservice integrada com sucesso',
      upload: 'Número de fatura integrada com sucesso'
    },
    note: {
      media: {
        type: {
          not: {
            found: 'O canal de comunicação especificado para os dados de contacto da entrada de fatura não foi encontrado'
          }
        },
        invalid: {
          email: {
            format: 'O endereço de e-mail dos dados de contacto da entrada de fatura é inválido'
          }
        }
      },
      document: {
        not: {
          found: 'O documento de fatura indicado não foi encontrado. Não existe ou os seus dados estão errados'
        }
      },
      recadv: {
        not: {
          found: 'Não foi encontrado o recibo indicado para as notas fiscais. Não existe ou os seus dados estão incorretos'
        }
      },
      attachment: {
        category: {
          not: {
            found: 'Não foi encontrada a categoria indicada do anexo da entrada de fatura '
          }
        },
        user: {
          not: {
            found: 'Não foi encontrado o utilizador indicado do anexo da entrada de fatura '
          }
        }
      }
    },
    project: {
      not: {
        found: 'Não foi encontrado o projeto indicado para a fatura. Não existe ou es erroneo'
      },
      category: {
        not: {
          found: 'Não foi encontrada a categoria de projeto indicada para a fatura. Não existe ou es erronea'
        }
      }
    },
    sender: {
      not: {
        found: ' Não foi encontrada a empresa emissora indicada para a fatura. Não existe ou os seus dados estão incorretos'
      }
    },
    receiver: {
      not: {
        found: 'Não foi encontrada a empresa recetora indicada para a fatura. Não existe ou os seus dados estão incorretos'
      }
    },
    thirdparty: {
      not: {
        found: 'Não foi encontrada a terceira empresa indicada para a fatura. Não existe,está desativada para o projeto ou os seus dados estão incorretos'
      }
    },
    status: {
      not: {
        found: 'Não foi encontrado o estado indicado para a fatura. Não existe ou es erroneo'
      }
    },
    currency: {
      not: {
        found: 'Não foi encontrada a divisa indicada para a fatura. Não existe ou es erronea'
      }
    },
    document: {
      format: {
        not: {
          found: 'Não foi encontrado o formato de documento indicado para a fatura. Não existe ou es erroneo'
        }
      },
      class: {
        not: {
          found: 'Não foi encontrado o tipo de documento indicado para a fatura. Não existe ou es erronea'
        }
      },
      type: {
        not: {
          found: 'Não foi encontrado o tipo de documento para a fatura indicado. Não existe ou es erroneo'
        }
      }
    },
    type: {
      not: {
        found: 'Não foi encontrado o tipo de fatura indicado. Não existe ou es erroneo'
      }
    },
    validity: {
      document: {
        not: {
          found: 'Não foi encontrado o documento de vigência indicado para a fatura. Não existe ou es erroneo'
        }
      }
    },
    communication: {
      method: {
        not: {
          found: 'Não foi encontrado o método de comunicação indicado para a fatura. Não existe ou es erroneo'
        }
      }
    },
    auditdocument: {
      not: {
        found: 'Não foi encontrado o documento de auditoria indicado para a fatura. Não existe ou es erroneo'
      }
    },
    accounting: {
      close: {
        not: {
          found: 'Não foi encontrado o encerramento contábil indicado para a fatura. Não existe ou es erroneo'
        }
      }
    },
    recept: {
      comm: {
        method: {
          not: {
            found: 'Não foi encontrado o método de comunicação de recepção indicado para a fatura. Não existe ou es erroneo'
          }
        }
      }
    },
    internal: {
      status: {
        not: {
          found: 'Não foi encontrado o estado interno indicado para a fatura. Não existe ou es erroneo'
        }
      }
    },
    batch: {
      not: {
        found: 'Não foi encontrado o lote indicado para a fatura. Não existe ou es erroneo'
      }
    },
    channel: {
      not: {
        found: 'Não foi encontrado o canal indicado para a fatura. Não existe ou es erroneo'
      }
    },
    seller: {
      centre: {
        not: {
          found: 'Um dos centros vendedores da fatura não foi encontrado. Não existe ou os seus dados estão incorretos'
        },
        roletype: {
          not: {
            found: 'Não foi encontrado o tipo de função específica do centro vendedor da fatura. Não existe ou os seus dados estão incorretos'
          }
        }
      }
    },
    buyer: {
      centre: {
        not: {
          found: 'Um dos centros compradores da fatura não foi encontrado. Não existe ou os seus dados estão incorretos'
        },
        roletype: {
          not: {
            found: 'Não foi encontrado o tipo de função específica do centro comprador da fatura. Não existe ou os seus dados estão incorretos'
          }
        }
      }
    },
    tax: {
      type: {
        not: {
          found: 'Não foi encontrado o tipo de imposto indicado para a fatura. Não existe ou os seus dados estão incorretos'
        }
      },
      currency: {
        not: {
          found: 'Não foi encontrada a divisa indicada para o imposto da fatura. Não existe ou os seus dados estão incorretos'
        }
      }
    },
    user: {
      does: {
        not: {
          belong: {
            to: {
              party: 'O utilizador do pedido não pertence à parte do id fiscal do vendedor'
            }
          }
        }
      }
    }
  },
  recadv_code: {
    integrated: {
      b2bintegration: 'Número de recepção B2B integrada com sucesso'
    },
    status: {
      not: {
        found: 'Não foi encontrado o estado indicado para a recepção. Não existe ou es erroneo'
      }
    },
    validity: {
      document: {
        not: {
          found: 'Não foi encontrado o documento de vigência indicado para a recepção. Não existe ou es erroneo'
        }
      }
    },
    document: {
      format: {
        not: {
          found: 'Não foi encontrado o formato de documento indicado para a recepção. Não existe ou es erroneo'
        }
      }
    },
    centre: {
      not: {
        found: 'Não foi encontrado o centro do comprador do documento de recepção'
      }
    }
  },
  unexpected: {
    error: 'Erro inesperado ao processar a encomenda ou o seu documento'
  },
  FACTURAE_INVALID: 'Fatura mal formada',
  validation: {
    noDocumentType: 'Não foi incluído nenhum tipo de documento',
    retry: 'As validações se devem tentar novamente',
    invoicePeriodDates: 'A data de início do período de cobrança deve ser anterior à data de término',
    invoiceCorrectivePeriodDates: 'A data de início do período de retificação deve ser anterior à data de término',
    signature: 'A fatura não está assinada',
    nif: 'O número NIF não é válido',
    attachmentformat: 'Tipo de anexo não permitido,apenas extensões são suportadas: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx, .zip, .msg',
    attachmentformat321: 'Tipo de anexo não permitido,apenas extensões são suportadas: .pdf, .xlsx, .csv, .xls, .jpg, .jpeg, .xml, .txt, .doc, .docx',
    error: 'Formato de arquivo incorreto',
    invoicedocument: 'O campo "valor" do tipo de documento "Número de sequência / linha" deve ser do tipo numérico',
    ep: {
      errorclientnoepcanarias: 'Para facturar serviços nas Canárias, verifique ambos os indicadores de estabelecimento estável.',
      errorclientnoepceuta: 'Para facturar serviços na Ceuta, verifique ambos os indicadores de estabelecimento estável.',
      clientepproveedorpencanarias: 'Para faturar serviços na Península, desmarque o indicador do seu estabelecimento estável nas Ilhas Canárias.',
      clientepproveedorpenceuta: 'Para faturar serviços na Península, desmarque o indicador do seu estabelecimento estável em Ceuta.',
      clientepproveedornocanarias: 'Para faturar serviços nas Ilhas Canárias consulte o indicador do seu estabelecimento estável.',
      clientepproveedornoceuta: 'Para faturar serviços na Ceuta consulte o indicador do seu estabelecimento estável.',
      clientecanariasceuta: 'Para faturar serviços nas Ilhas Canárias, desmarque a caixa referente ao seu estabelecimento permanente em Ceuta.',
      errorclientnoepceutacanarias: 'Para faturar serviços em Ceuta, desmarque a caixa referente ao seu estabelecimento permanente nas Ilhas Canárias.'
    },
    buyer: {
      address: 'A identificação do tipo de residência não é correta para a empresa compradora.',
      noAddress: 'Não há endereço para a empresa compradora',
      noCountry: 'Não há país para a empresa compradora',
      noPostCode: 'Não há código postal para a empresa compradora',
      invalidPostCode: 'O código postal atribuído à empresa compradora não deve ter menos de 5 dígitos',
      noProvince: 'Não há província para a empresa compradora',
      noTown: 'Não há ciudade para a empresa compradora',
      centres: {
        rol: 'Nenhum centro da empresa compradora foi incluído para o tipo de função necessário: {argumento}.',
        rolbyvalues: 'Nenhum centro da empresa compradora foi incluído para o tipo de função necessário: {argumento}.',
        roletype: {
          notfound: 'O tipo de função de centro a validar para a empresa compradora não existe: {argumento}'
        }
      }
    },
    buyerCentre: {
      noAddress: 'Não há endereço para ao centro de compras',
      noCountry: 'Não há país para ao centro de compras',
      noPostCode: 'Não há código postal para ao centro de compras',
      invalidPostCode: 'O código postal atribuído ao centro de compras não deve ter menos de 5 dígitos',
      noProvince: 'Não há província para ao centro de compras',
      noTown: 'Não há ciudade para ao centro de compras'
    },
    seller: {
      address: 'A identificação do tipo de residência não é correta para a empresa vendedora.',
      noAddress: 'Não há endereço para a empresa vendedora',
      noCountry: 'Não há país para a empresa vendedora',
      noPostCode: 'Não há código postal para a empresa vendedora',
      invalidPostCode: 'O código postal atribuído à empresa vendedora não deve ter menos de 5 dígitos',
      noProvince: 'Não há província para a empresa vendedora',
      noTown: 'Não há ciudade para a empresa vendedora',
      centres: {
        rol: 'Nenhum centro da empresa vendedora foi incluído para o tipo de função necessário: {argumento}.',
        rolbyvalues: 'Nenhum centro da empresa vendedora foi incluído para o tipo de função necessário: {argumento}.',
        roletype: {
          notfound: 'O tipo de função de centro a validar para a empresa vendedora não existe: {argumento}'
        }
      }
    },
    sellerCentre: {
      noAddress: 'Não há endereço para ao centro de vendas',
      noCountry: 'Não há país para ao centro de vendas',
      noPostCode: 'Não há código postal para ao centro de vendas',
      invalidPostCode: 'O código postal atribuído ao centro de vendas não deve ter menos de 5 dígitos',
      noProvince: 'Não há província para ao centro de vendas',
      noTown: 'Não há ciudade para ao centro de vendas'
    },
    party: {
      noTaxId: 'Não foi incluído nenhum identificador fiscal',
      noProject: 'Nenhum projeto foi incluído',
      buyer: {
        notInProject: 'A empresa compradora não existe para o projeto ou está desativada',
        invalidName: 'O nome da empresa compradora está incorreto, deve corresponder à expressão regular {argumento}\nDeveria ser {argumento1}.',
        addressvalue: 'O endereço do destinatário da fatura não é válido, deve ser Paseo Conde de los Gaitanes n 177 para faturas da península, ou Calle Juan de Quesada n 9 para faturas das Ilhas Canárias.'
      },
      seller: {
        notInProject: 'A empresa vendedora não existe para o projeto ou está desativada',
        invalidName: 'O nome da empresa vendedora está incorreto, deve corresponder à expressão regular {argumento}\nDeveria ser {argumento1}.'
      },
      noSeller: 'Não foi incluída nenhuma identificação fiscal do vendedor',
      noBuyer: ' Não foi incluída nenhuma identificação fiscal do comprador',
      noRelation: 'Não existe uma relação comercial entre a empresa compradora e vendedora para este serviço',
      noSponsor: 'A empresa não é sponsor para o projeto',
      disabled: 'A empresa está desativada',
      disabledInProject: 'A empresa está desativada para o projeto',
      invalidExpression: 'A expressão regular para validar o nome da empresa com NIF {argumento} não está correcta'
    },
    parties: {
      noSponsor: 'Nenhuma das empresas é sponsor do projeto'
    },
    centre: {
      role: {
        type: 'A função do centro não é válida para o formato'
      },
      roletype: {
        notfound: 'O tipo de função de centro central indicado não existe'
      },
      noCentreCode: 'Nenhum código de centro foi incluído',
      noParty: 'Nenhuma empresa foi incluída',
      buyer: {
        notInParty: 'Um ou mais centros compradores não existem para a empresa ou estão desativados'
      },
      seller: {
        notInParty: 'Um ou mais dos centros vendedores não existen para a empresa o estão desativados'
      },
      noCentreUnique: 'Os centros devem ser únicos'
    },
    document: {
      noDocument: 'Nenhum documento inclu\u00EDda'
    },
    phisical: {
      gln: 'Caixa de correio física obrigatória'
    },
    schematron: {
      error: 'Erro na validação da fatura: {argumento}'
    },
    kosit: {
      error: 'Erro na validação da fatura: {argumento}'
    },
    invoice: {
      currency: 'Moeda não incluída',
      currencyExchange: 'A taxa de câmbio não foi incluída',
      currencyExchangeDate: 'A data da taxa de câmbio não foi incluída',
      iban: 'O formato do IBAN não está correto.',
      ibanNull: 'IBAN não relatado',
      registrationData: 'Os dados do cadastro comercial incluídos na fatura não correspondem aos dados cadastrados no B2B',
      sequenceNumber: 'A posição do pedido é obrigatória para o pedido indicado{argumento}',
      correctiveSign01pos: 'Factura rectificativa de tipo Rectificación Integra deben ser positivas',
      correctiveSign02pos: 'Factura rectificativa de tipo Rectificación por diferencias deben ser positivas',
      correctiveSign03pos: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser positivas',
      correctiveSign04pos: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser positivas',
      correctiveSign01neg: 'Factura rectificativa de tipo Rectificación Integra deben ser negativas',
      correctiveSign02neg: 'Factura rectificativa de tipo Rectificación por diferencias deben ser negativas',
      correctiveSign03neg: 'Factura rectificativa de tipo Rectificación parcial por descuento por volumen de operaciones deben ser negativas',
      correctiveSign04neg: 'Factura rectificativa de tipo Rectificación autorizada por la Agencia Tributaria deben ser negativas',
      noInvoice: 'Nenhuma fatura foi incluída',
      noInvoiceLine: 'Nenhuma entrada de fatura foi incluída ou uma ou mais são nulas',
      noInvoiceNumber: 'Nenhum número de fatura foi incluído',
      noParty: 'Nenhuma empresa foi incluída',
      noProject: 'Nenhum projeto foi incluído',
      duplicate: 'Já existe uma fatura com o número de fatura em estado correto {argumento}',
      issuedate: 'A data da fatura não coincide com a fatura anterior recebida com a data de emissão {argumento}',
      dates: 'A data de operação deve ser menor ou igual à data de emissão',
      invalidOperationDate: 'A data da operação não pode ser posterior ao dia {argumento} ({argumento1} día e {argumento2} meses a partir da data de emissão)',
      invalidOperationDateEnd: 'A data da operação não pode ser posterior ao dia {argumento} (Último dia do mês {argumento2} a partir da data de emissão)',
      invalidInvoicingPeriod: 'A data final do período de faturamento não pode ser posterior ao {argumento} ({argumento1} día e {argumento2} meses a partir da data de emissão)',
      invalidInvoicingPeriodEnd: 'A data final do período de faturamento não pode ser posterior ao {argumento} (Último dia do mês {argumento2} a partir da data de emissão)',
      invalidWithholdingAmount: 'A retenção em garantia deve ser {argumento}',
      invalidNegativeWithholdingAmount: 'A retenção em garantia deve ser positiva',
      simultaneousTransactionAndContract: 'A fatura não pode indicar contrato e pedido ao mesmo tempo; deve indicar exatamente um dos dois',
      contractNotFoundRecadv: 'Nenhuma certificação/recibo com número foi encontrada {argumento}, status {argumento1} para fornecedor, cliente e pedido especificado na fatura',
      recadvNotFound: 'A receção {argumento} da linha {argumento1} não está publicada pelo comprador, ou não está em um estado faturável.',
      contractNotFound: 'Debe indicar certificação/recepção, line {argumento}',
      duplicateContractFoundRecadv: 'Foi encontrada mais de uma recepção',
      orderNotFound: 'Debe indicar a ordem, line {argumento}',
      orderContractNotFound: 'Debe indicar pedido e certificação/recibo, line {argumento}',
      differentOrder: 'O pedido indicado no arquivo ({argumento}) não corresponde ao registrado ({argumento1})',
      currencyNotEur: 'Apenas são aceitas faturas em euros',
      igicNotInCanary: 'A fatura inclui imposto IGIC: \n {argumento} \n {argumento1}',
      ipsiNotInCeuta: 'A fatura inclui imposto IPSI: \n {argumento} \n {argumento1}',
      tooMuchAttachments: 'A fatura excede o máximo de arquivos anexados configurados ({argumento} arquivo/s)',
      notAllowedAttachedExtension: 'A extensão do anexo não é permitida. Permitido: {argumento}',
      taxesNotInProject: 'Os seguintes impostos não estão incluídos no projeto: {argumento}',
      taxRateNotRegistered: 'Para o imposto {argumento}, apenas as taxas (%) {argumento1} são permitidas',
      notAllowedFileFormat: 'O formato do arquivo ({argumento}) não é permitido. Formatos permitidos: {argumento1}',
      noIssueDate: 'Nenhuma data de emissão foi incluída',
      noOperationDate: 'Nenhuma data de operação foi incluída',
      noIssuerType: 'Nenhum tipo de emissor foi incluído',
      issuerType: 'O tipo emissor fatura não é válido',
      issuerTypeErro: 'Os dados necessários para realizar a validação não foram incluídos',
      noModalityType: 'A modalidade da fatura não corresponde a um dos valores aceitos',
      modalityType: 'O tipo de fatura deve ser individual',
      modalityTypeErro: ' Os dados necessários para realizar a validação não foram incluídos',
      taxCeroLegalText: 'Para imposto 0 deverá informar texto legal',
      specificCanary: 'Validação específica das Ilhas Canárias, IVA positivo',
      specificCeuta: 'Validação específica do Ceuta, IVA positivo',
      noIgicIva: 'A fatura não pode ter IGIC e IVA como impostos ao mesmo tempo',
      exitsPaymentDetails: 'A fatura não contém uma forma de pagamento',
      receiverTransactionReferenceNotFound: 'A fatura {argumento} não contém número de pedido nem no cabeçalho nem nas linhas',
      documentValuesRecadv: 'Linha {argumento}. O {argumento1} \'{argumento2}\' não corresponde ao indicado na receção',
      documentValuesRecadvDeliveryNote: 'Linha {argumento}. O {argumento1} \‘{argumento2}\’  da receção não coincide com os indicados na fatura',
      lineDataFromRecadv: 'Linha {argumento}. A linha do pedido: {argumento1} não corresponde a nenhuma linha da receção',
      lineDataFromRecadvValue: 'Linha {argumento}. {argumento1} : {argumento2}, não corresponde à linha da recepção',
      lineDataFromRecadvTax: 'Linha {argumento}. O imposto com tipo {argumento1} e com percentual {argumento2} não corresponde à linha da recepção',
      project: {
        notSender: 'O projeto não tem ativada a função de emissão indicada para a fatura',
        notReceiver: 'O projeto não tem ativada a função de recepção indicada para a fatura'
      },
      noRole: 'A função da fatura (emissora ou recetora) deve ser estabelecida',
      communication: {
        method: 'O método de comunicação da fatura não está contratado para o seu projeto'
      },
      lines: {
        invalidOperationDate: 'Número da linha {argumento3}. A data da operação não pode ser posterior ao dia {argumento} ({argumento1} día e {argumento2} meses a partir da data de emissão)',
        invalidOperationDateEnd: 'Número da linha {argumento3}. A data da operação não pode ser posterior ao dia {argumento} (Último dia do mês {argumento2} a partir da data de emissão)',
        invalidInvoicingPeriod: 'Número da linha {argumento3}. A data final do período de faturamento não pode ser posterior ao {argumento} ({argumento1} día e {argumento2} meses a partir da data de emissão)',
        invalidInvoicingPeriodEnd: 'Número da linha {argumento3}. A data final do período de faturamento não pode ser posterior ao {argumento} (Último dia do mês {argumento2} a partir da data de emissão)',
        total: {
          error: 'O total de linha sem impostos não corresponde ao produto da quantidade por preço unitário',
          discountscharges: {
            error: 'O total de linha com taxas e descontos não corresponde ao montante bruto da linha'
          }
        },
        positive: 'Preços e quantidades devem ser positivos',
        negative: 'Todos os preços devem ser negativos e as quantidades positivas',
        sametax: 'La factura no puede contener el mismo impuesto en la misma linea',
        totalPositive: 'O montante total da fatura deve ser positivo'
      },
      total: {
        error: 'O total da fatura sem taxas ou descontos gerais não corresponde à soma do total das linhas com descontos e taxas',
        discountscharges: {
          error: 'O total da fatura com taxas e descontos gerais não corresponde ao total da fatura antes dos impostos',
          taxes: {
            error: 'O total da fatura não corresponde ao total da fatura antes dos impostos mais o total de impostos liquidados menos o total de impostos retidos'
          }
        },
        taxes: {
          error: 'O total de impostos informados não corresponde à soma dos impostos'
        }
      },
      totalexecutable: {
        error: 'O total executável da fatura não corresponde ao total a pagar menos subvenções,adiantamentos e retenções mais fornecimentos e encargos financeiros'
      },
      accounting: {
        error: 'A fatura não cumpre com alguma das validações contábeis'
      },
      centre: {
        mask: 'Máscara central inválida',
        rol: 'Função central inválida'
      },
      corrective: {
        method: 'Método de correção {argumento} não suportado pelo destinatário da fatura corretiva'
      },
      buyer: {
        centre: 'Centro do comprador não informado'
      },
      noOrder: 'Nenhuma encomenda foi incluída na linha de recepção',
      order: {
        noLine: 'A encomenda {argumento} incluída na linha de recepção não foi encontrada',
        missingData: 'Faltam dados obrigatórios em uma ou mais linhas de encomenda {argumento}'
      },
      recadv: {
        additionalInfo: 'O valor {argumento} da propriedade {argumento1} não se encontra nas informações adicionais da fatura.',
        noAdditionalInfo: 'A fatura não contém as informações adicionais da receção {argumento}',
        additionalInfoNoProperty: 'A propriedade {argumento1} não foi incluída nas informações adicionais da receção {argumento}.',
        noData: 'Não foi incluída informação na receção {argumento}'
      }
    },
    recadv: {
      noRecadv: 'Nenhuma recepção foi incluída',
      noRecadvNumber: 'Nenhum número de recepção foi incluído',
      noSeller: 'Nenhuma empresa vendedora foi incluída',
      noBuyer: 'Nenhuma empresa compradora foi incluída',
      duplicate: 'Já existe uma recepção com número em estado correto'
    },
    sign: {
      noParty: 'Nenhuma empresa foi incluída',
      noSign: 'A empresa emissora não tem assinatura delegada'
    },
    order: {
      noOrder: 'O número de encomenda é obrigatório',
      noUnique: 'O número de encomenda deve ser único na fatura',
      noOrderIssuer: 'O número do emissor do pedido é obrigatório',
      noUniqueIssuer: 'O número do pedido do emissor deve ser único na fatura',
      invalidPatternIssuer: 'O formato do número do pedido do emissor é inválido',
      noPattern: 'O padrão a ser verificado não foi configurado',
      invalidPattern: 'O número de encomenda incluído não está em conformidade com o formato exigido pelo destinatário',
      error: ' Os dados necessários para realizar a validação não foram incluídos'
    },
    documentCycle: {
      noOrder: 'Não foram incluídas informações suficientes do pedido',
      orderResponseRequired: 'Não é possível gerar a nota de entrega se o pedido não for aceito anteriormente',
      order: {
        type: {
          noParams: 'A classe do ciclo está incorreta, você deve indicar parâmetros adicionais indicando o tipo e subtipo a serem validados'
        },
        invalid: {
          type: 'Não é possível criar uma fatura para este pedido, deve ter o tipo "{argumento}"',
          subtype: 'Não é possível criar uma fatura para este pedido, deve ter o subtipo "{argumento}"'
        }
      }
    },
    expediente: {
      noExp: 'O número de dossier é obrigatório',
      noUnique: 'O número de dossier deve ser único na fatura',
      noPattern: 'O padrão a ser verificado não foi configurado',
      invalidPattern: 'O número de dossier incluido não cumpre com o formato exigido pelo destinatário',
      error: ' Os dados necessários para realizar a validação não foram incluídos'
    },
    contract: {
      noContract: 'O número de contrato é obrigatório',
      invalidPattern: 'O número de contrato incluido não cumpre com o formato exigido pelo destinatário',
      noUnique: 'O número de contrato deve ser único na fatura',
      noPattern: 'O padrão a ser verificado não foi configurado',
      error: ' Os dados necessários para realizar a validação não foram incluídos'
    },
    transaction: {
      noTransaction: 'O número da transação é obrigatório'
    },
    invoiceCorrective: {
      dates: 'A data inicial e final do periodo de tributação não são válidas',
      number: 'O número de fatura é obrigatório para as faturas de tipo Retificação íntegra e Retificação por divergências',
      noNumber: 'O número de fatura é obrigatório para as faturas de tipo retificativas',
      invalidPattern: 'O formato do número da fatura retificada não é válido',
      noValue: 'Nenhum documento com algum valor foi anexado',
      noOrderValue: 'Deve indicar o pedido do destinatário',
	  required: 'O bloco corretivo é obrigatório para uma fatura retificativa'
    },

    project: {
      disabled: 'O projeto não existe ou está desativado',
      noProject: 'Nenhum projeto foi incluído',
      attachment: {
        notfound: 'Não existe o diretório de anexos do projeto da fatura a ser integrada'
      }
    },
    issue: {
      date: {
        future: 'A data de emissão é posterior à data de registo em {argumento} dias. A data máxima permitida de emissão é: {argumento1}',
        past: 'A data de emissão é anterior à data de registo em {argumento} dias. A data mínima permitida de emissão é: {argumento1}'
      }
    },
    commercial: {
      relation: {
        channel: 'Não existe a relação comercial entre o vendedor,o comprador e o canal'
      }
    },
    channel: {
      not: {
        found: 'Não existe o canal'
      }
    },
    invoiceNumber: {
      error: 'Os dados necessários para realizar a validação do número de fatura não foram incluídos',
      noPattern: 'O padrão do Número de Fatura não foi configurado',
      invalidPattern: 'O formato do Número de Fatura não é válido'
    },
    b2bvalidationws: {
      nourl: 'Não existe uma URL associada ao WS ou é inválida',
      metadataerror: 'Aconteceu um erro ao intentar obter o ficheiro de metadados.',
      connectionerror: 'Aconteceu um erro durante a conexão com o serviço do cliente.',
      wrongresponse: 'O WS cliente retornou uma resposta incorreta.',
      errorresponse: 'O WS cliente retornou uma resposta de ERRO.'
    },
    valid: {
      iban: 'Erro de validação de IBAN.'
    },
    payment: {
      mean: 'Erro: a fatura não contém métodos de pagamento suportados.'
    },
    file: {
      size: 'Erro: fatura e anexos excedem o tamanho máximo permitido.'
    },
    nif: {
      codpais: 'Erro na validação do código do país no NIF {argumento}. O país deve ser indicado antes do NIF.'
    },
    line: {
      noDescription: 'Alguma das linhas não tem descrição',
      transactionReference: 'Todas as linhas devem conter IssuerTransactionReference e/ou ReceiverTransactionReference',
      sequence: {
        number: 'Todas as linhas devem ter o mesmo sequence number'
      }
    },
    noPublicOrganismCode: 'O Órgão Público Proponente não foi informado– DIR3',
    delivery: {
      noDeliveryDate: 'A data de entrega é obrigatória',
      duplicate: {
        '': 'Já existe uma nota de entrega correta com o número da nota de entrega',
        issueyear: 'Já existe uma nota de entrega correta no ano atual com o número da nota de entrega'
      },
      lines: {
        noBatch: 'Alguma das linhas não tem número do lote',
        noSerialNumber: 'Alguma das linhas não tem número de série',
        noExpirationDate: 'Alguma das linhas não tem data de validade',
        invalidDate: 'Alguma das linhas não tem data de validade é posterior à data de entrega',
        noQuantity: 'A soma dos valores das sublinhas não é igual ao valor da linha pai',
        noSubline: 'Algumas das linhas da nota de entrega não têm sublinhas',
        package: {
          invalidGtin14: 'Não é possível associar linhas com códigos GTIN14 diferentes à mesma embalagem. As linhas associadas à embalagem com SSCC {argumento} têm códigos GTIN14 diferentes.'
        }
      }
    }
  },
  invalid: {
    validation: {
      code: {
        exception: 'Um ou mais códigos de validação não têm um método de validação'
      }
    },
    persontypecode: 'O código de tipo de pessoa especificado não é válido. Só pode ser jurídica (j) ou física (f)',
    name: {
      format: 'O nome ou sobrenome têm caracteres não permitidos no formato utf-8'
    },
    facturae32: {
      xml: {
        format: 'O formato do ficheiro da Facturae 3.2 é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo Facturae 3.2 tem campos que não passam a validação do seu esquema: '
    },
    facturae321: {
      xml: {
        format: 'O formato do ficheiro da Facturae 3.2.1 é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo Facturae 3.2.1 tem campos que não passam a validação do seu esquema: '
    },
    facturae322: {
      xml: {
        format: 'O formato do ficheiro da Facturae 3.2.2 é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo Facturae 3.2.2 tem campos que não passam a validação do seu esquema: '
    },
    facturapdf: {
      xml: {
        format: 'O formato da fatura PDF é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo fatura PDF tem campos que não passam a validação do seu esquema: '
    },
    edi: {
      date: {
        format: 'El formato de la fecha no es correcto'
      }
    },
    facturad01b: {
      edi: {
        format: 'O formato do ficheiro da InvoicD01b é incorreto ou .edi'
      }
    },
    facturad93a: {
      edi: {
        format: 'O formato do ficheiro da InvoicD93A é incorreto ou .edi'
      }
    },
    facturad96a: {
      edi: {
        format: 'O formato do ficheiro da InvoicD96A é incorreto ou .edi'
      }
    },
    facturad97a: {
      edi: {
        format: 'O formato do ficheiro da InvoicD97A é incorreto ou .edi'
      }
    },
    fatturapa12: {
      xml: {
        format: 'O formato do ficheiro do fatturapa12 é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo fatturapa12 tem campos que não passam a validação do seu esquema: '
    },
    recadv: {
      xml: {
        format: 'O formato do ficheiro do documento de recepção é incorreto ou não é .xml'
      },
      schema: 'A fatura da recepção tem campos que não passam a validação do seu esquema: {argumento}'
    },
    fatturapaSemplificata1: {
      xml: {
        format: 'O formato do ficheiro do fatturapa simplificado é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo fatturapa simplificado tem campos que não passam a validação do seu esquema: {argumento}'
    },
    fatturapa12cades: {
      xml: {
        format: 'O formato do ficheiro do fatturapa 1.2 cades é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo fatturapa 1.2 cades tem campos que não passam a validação do seu esquema: {argumento}'
    },
    fatturapaSemplificatacades: {
      xml: {
        format: 'O formato do ficheiro do fatturapa simplificado cades é incorreto ou não é .xml'
      },
      schema: 'A fatura de tipo fatturapa simplificado cades tem campos que não passam a validação do seu esquema: {argumento}'
    }
  },
  unable: {
    to: {
      save: {
        file: {
          in: {
            repository: 'Não foi possível salvar o ficheiro no endereço do repositório. es erroneo ou há um problema com o ficheiro'
          }
        }
      },
      get: {
        repository: {
          file: 'Não foi possível recuperar o ficheiro com o endereço do repositório indicado. es erroneo ou há um problema com o ficheiro'
        }
      },
      delete: {
        repository: {
          file: 'Não foi possível eliminar o ficheiro do endereço do repositório indicado. es erroneo ou o ficheiro está bloqueado'
        }
      }
    }
  },
  no: {
    repository: {
      date: 'Nenhuma data foi incluída. É nécessaria para o tipo de ficheiro',
      project: {
        name: 'Nenhum nome de projeto exigido para o tipo de ficheiro a salvar foi incluído'
      },
      file: 'Nenhum ficheiro a salvar foi incluído',
      subpath: 'O caminho secundário do ficheiro não foi incluído'
    },
    file: {
      to: {
        save: {
          extension: 'A extensão do ficheiro a salvar não foi indicada'
        }
      }
    },
    pathcomplete: {
      flag: 'Não foi indicado se o caminho incluído no objeto é completo ou parcial'
    }
  },
  repository: {
    path: {
      not: {
        found: 'Não se encontrou um caminho de repositório na base de dados para o tipo de ficheiro a salvar. Não existe ou é inválido'
      }
    }
  },
  missing: {
    required: {
      party: {
        data: 'Um ou mais dos dados obrigatórios da empresa (nif,nomes e estado de ativação) não foi incluído',
        commercial: {
          relation: {
            data: 'Um ou mais dos dados obrigatórios da relação comercial da empresa (empresa emissora/vendedora e empresa recetora/compradora) não foi incluído'
          }
        },
        media: {
          value: 'Deve especificar um valor para o meio de contacto da empresa',
          type: 'O canal dos dados de contacto não foi indicado',
          to: {
            delete: 'Os dados de contacto da empresa a ser eliminada não foram indicados'
          }
        },
        documentcycle: {
          buyer: 'Falta o comprador do ciclo do documento',
          sourcetype: 'Falta o tipo de documento de origem do ciclo do documento',
          destinationtype: 'Falta o tipo de documento de destino do ciclo do documento',
          class: {
            source: 'Falta o sentido da classe do ciclo do documento'
          }
        }
      },
      partyproject: 'É necessário indicar um projeto da empresa para poder criar os dados de contacto e as relações comerciais',
      projectparty: {
        data: 'Um ou mais dados obrigatórios (projeto,empresa e data de criação da relação) da relação projeto-empresa não foi incluído',
        role: 'As funções (vendedor ou comprador) para a empresa não foram indicadas no seu projeto',
        enable: 'O estado de ativação da empresa com o projeto não foi indicado'
      },
      communicationmethod: {
        data: 'Um ou mais dados obrigatórios (empresa e metodo de comunicação) do método de comunicação da empresa não foi incluído'
      },
      partycentre: {
        roletype: {
          data: 'Um ou mais dados obrigatórios do tipo de função do centro não foi incluído'
        }
      },
      centre: {
        role: 'As funções (vendedor ou comprador) para o centro não foram indicadas',
        data: 'Um ou mais dos dados obrigatórios (nif ou id de empresa,código e estado de ativação) do centro não foi incluído',
        media: {
          value: 'deve especificar um valor para o meio de contacto do centro',
          type: 'O canal dos dados de contacto do centro não foi indicado',
          to: {
            delete: 'Os dados de contacto do centro a ser eliminado não foram indicados'
          }
        }
      },
      invoice: {
        note: {
          media: {
            value: 'deve especificar um valor para o meio de contacto da entrada de fatura ',
            type: 'O canal dos dados de contacto da entrada de fatura não foi indicado',
            default: {
              flag: 'O flag de contacto por defeito dos dados de contacto da entrada de fatura não foi indicado'
            },
            role: 'A função (vendedor ou comprador) dos dados de contacto da fatura não foi indicada'
          },
          issue: {
            date: 'A data de emissão para as notas fiscais não foi indicada'
          },
          document: {
            name: 'O nome do documento da entrada de fatura ou o seu Id não foi indicado',
            format: 'O formato para o documento da entrada de fatura não foi indicado',
            type: 'O tipo de documento para as notas fiscais não foi indicado'
          },
          recadv: {
            data: 'O recibo (o seu ID ou número) associado à entrada de fatura não foi indicado'
          }
        },
        integration: {
          file: {
            '': 'O ficheiro da fatura não foi incluído',
            extension: 'A extensão do ficheiro da fatura não foi indicada',
            size: 'O tamanho original do ficheiro da fatura não foi indicado'
          }
        },
        project: 'O projeto da fatura não foi indicado',
        seller: {
          '': 'A empresa vendedora da fatura não foi indicada',
          centre: {
            code: 'O código de um ou mais centros vendedores da fatura não foi incluído'
          }
        },
        buyer: {
          '': 'A empresa compradora da fatura não foi indicada',
          centre: {
            code: 'O código de um ou mais centros compradores da fatura não foi incluído'
          }
        },
        number: 'O número da fatura não foi indicado',
        sender: 'A empresa emissora da entrada de fatura não foi indicada',
        receiver: 'A empresa recetora da entrada de fatura não foi indicada',
        status: 'O status para a fatura não foi indicado',
        document: {
          format: 'O formato de documento para a fatura não foi indicado',
          class: 'A categoría do documento para a fatura não foi indicada',
          type: 'O tipo de documento para a fatura não foi indicado'
        },
        validity: {
          document: 'O documento de vigência da fatura não foi indicado'
        },
        correctedflag: 'O flag de fatura corretiva não foi indicado (true: a fatura é corretiva,false: não o é)',
        metadata: {
          file: {
            extension: 'A extensão do ficheiro de metadados da fatura não foi indicada'
          }
        },
        attachment: {
          extension: 'A extensão de um ou mais anexos da fatura não foi indicada'
        },
        tax: {
          type: 'O tipo de um ou mais impostos da entrada de fatura não foi indicado',
          baseamount: 'O valor base de um ou mais impostos da entrada de fatura não foi indicado',
          currency: 'A divisa de um ou mais impostos da entrada de fatura não foi indicado'
        },
        event: 'O nome do evento da entrada de fatura não foi indicado',
        property: {
          '': 'Não foi indicado um nome para a propriedade do evento da fatura',
          value: 'O valor para a propriedade do evento da fatura não foi indicado'
        },
        outstanding: {
          amount: 'O montante pendente da fatura não foi indicado'
        },
        executable: {
          amount: 'O montante executável da fatura não foi indicado'
        },
        communication: {
          reception: {
            name: 'O nome da comunicação de recepção usada para a integração da fatura não foi indicado'
          }
        }
      },
      media: {
        type: 'O canal dos dados de contacto de empresa não foi indicado'
      },
      centremedia: {
        project: 'é necessário indicar um projeto do centro para poder criar os dados de contacto',
        role: 'As funções (vendedor ou comprador) para os dados de contacto do centro não foram indicadas'
      },
      partymedia: {
        role: 'As funções (vendedor ou comprador) para os dados de contacto da empresa não foram indicadas'
      },
      request: {
        compressed: {
          invoice: {
            flag: 'Não foi indicado se o ficheiro da fatura do pedido está compactado ou não'
          }
        },
        invoice: {
          file: 'O ficheiro de fatura não foi incluído no pedido'
        }
      }
    },
    update: {
      party: {
        taxid: 'O identificador fiscal da empresa a ser atualizada ou modificada não foi especificado'
      }
    },
    search: {
      party: {
        taxid: 'Um ou mais identificadores fiscais das empresas a serem pesquisadas não foram especificados'
      }
    },
    commercial: {
      relation: {
        partytaxid: 'O identificador fiscal da empresa da relação comercial não foi incluído',
        role: 'A função da empresa criada/atualizada na relação comercial não foi indicada'
      }
    },
    recadv: {
      integration: {
        file: {
          '': 'O ficheiro da recepção não foi incluído',
          extension: 'A extensão do ficheiro da recepção não foi indicada'
        }
      },
      status: 'O estado para a recepção não foi indicado',
      number: {
        exception: 'O número de recepção não foi indicado'
      },
      receiving: {
        date: {
          time: {
            extension: 'A data da última recepção do recibo não foi indicada'
          }
        }
      },
      validity: {
        document: 'O documento de vigência da fatura não foi indicado'
      },
      document: {
        format: 'O formato de documento para a recepção não foi indicado'
      },
      centre: 'O centro do comprador do documento de recepção não foi indicado'
    }
  },
  party: {
    not: {
      found: 'A empresa com o número de identificação fiscal indicado não foi encontrada'
    },
    project: {
      not: {
        found: 'O projeto especificado para a empresa não foi encontrado. Não existe ou está desativado'
      }
    },
    to: {
      delete: {
        not: {
          found: 'A empresa a ser eliminada não foi encontrada. O seu identificador fiscal não foi indicado ou não existe'
        }
      }
    },
    commercial: {
      relation: {
        channel: {
          not: {
            found: 'O canal para a relação comercial não foi encontrado. Não existe ou es erroneo'
          }
        }
      }
    },
    deletion: 'Erro ao eliminar a empresa',
    country: {
      not: {
        found: 'O país indicado para a empresa não foi encontrado. Não existe ou os seus dados estão errados'
      }
    },
    media: {
      type: {
        not: {
          found: 'O canal de comunicação especificado para os dados de contacto de empresa não foi encontrado'
        }
      },
      deletion: 'Erro ao eliminar os dados de contacto da empresa',
      to: {
        delete: {
          not: {
            found: 'Os dados de contacto da empresa a serem eliminados não foram encontrados. Não foram indicados ou não existem'
          }
        }
      },
      invalid: {
        email: {
          format: 'O endereço de e-mail dos dados de contacto da empresa é inválido'
        }
      }
    }
  },
  commercial: {
    relation: {
      party: {
        not: {
          found: 'A empresa indicada para a relação comercial dentro da função especificada não foi encontrada. Também é possível que não exista ou esteja desativada'
        }
      }
    }
  },
  incompatible: {
    integrated: {
      party: {
        for: {
          commercial: {
            relation: 'A empresa integrada não tem ativada a função (vendedor ou comprador) estabelecida para a sua relação comercial ou está desativada'
          }
        }
      }
    },
    centre: {
      role: 'O centro não tem uma função compatível com a da sua empresa dentro da sua relação de projeto',
      media: {
        data: {
          role: 'O centro não tem a função atribuída (vendedor ou comprador) para os dados de contacto,ou esta função é incompatível com os atribuídos para à sua empresa no projeto determinado'
        }
      }
    },
    party: {
      media: {
        data: {
          role: 'A empresa não tem a função atribuída (vendedor ou comprador) para os dados de contacto dentro do seu projeto'
        }
      }
    }
  },
  communication: {
    method: {
      not: {
        found: 'O método de comunicação especificado para a empresa não foi encontrado'
      }
    }
  },
  centre: {
    role: {
      type: {
        not: {
          found: 'O tipo de função especificado para o centro não foi encontrado'
        }
      }
    },
    to: {
      delete: {
        not: {
          found: 'O centro a ser eliminado não foi encontrado. Não foi indicado nenhum dos dados obrigatórios (empresa e código do centro) ou o centro não existe'
        }
      }
    },
    deletion: 'Erro ao eliminar o centro',
    party: {
      not: {
        found: 'A empresa do centro com os dados estabelecidos não foi encontrada'
      }
    },
    not: {
      found: 'Um centro que corresponda à empresa e ao código indicados não foi indicado'
    },
    country: {
      not: {
        found: 'O país indicado para o centro não foi indicado. Não existe ou os seus dados estão errados'
      }
    },
    media: {
      type: {
        not: {
          found: 'O canal de comunicação especificado para os dados de contacto do centro não foi indicado'
        }
      },
      deletion: 'Erro ao eliminar os dados de contacto do centro',
      to: {
        delete: {
          not: {
            found: 'Os dados de contacto encontrados a serem eliminados do centro não foram encontrados. Não foram indicados ou não existem'
          }
        }
      },
      invalid: {
        email: {
          format: 'O endereço de e-mail dos dados de contacto do centro é inválido'
        }
      }
    }
  },
  media: {
    type: {
      not: {
        found: 'O canal de contacto especificado não foi encontrado'
      }
    }
  },
  centremedia: {
    project: {
      not: {
        found: 'O projeto para os dados de contacto do centro não foi encontrado. Não existe ou os seus dados estão errados'
      }
    }
  },
  duplicate: {
    partymedia: {
      value: 'já existem dados de contacto da empresa com o mesmo valor para o projeto ao qual está atribuído'
    },
    centremedia: {
      value: 'já existem dados de contacto do centro com o mesmo valor para o projeto ao qual está atribuído'
    }
  },
  recadvLine: {
    currency: {
      not: {
        found: 'A divisa indicada para a recepção não foi encontrada. Não existe ou es erronea'
      }
    },
    unitOfMeasure: {
      notFound: 'A unidade de medida indicada para a linha de recepção não foi encontrada'
    }
  },
  document_code: {
    generation: {
      format: {
        class: {
          not: {
            found: 'O tipo de mapeamento do formato do documento não foi encontrado. Não existe ou es erroneo'
          }
        }
      }
    }
  },
  unzipped: {
    request: {
      invoice: {
        file: 'O pedido da fatura está configurado para conter ficheiros de fatura compactados,mas o seu ficheiro não está compactado'
      },
      attachments: 'O pedido da fatura está configurado para conter anexos compactados,mas tem só um descompactado'
    }
  },
  zipped: {
    request: {
      invoice: {
        file: 'O pedido da fatura está configurado para conter ficheiros de fatura descompactados,mas o seu ficheiro está compactado'
      },
      attachments: 'O pedido da fatura está configurado para conter um único anexo descompactado,mas tem um ficheiro compactado com um ou mais'
    }
  },
  different: {
    invoice: {
      number: 'O número de fatura do pedido é diferente ao extraído do ficheiro de fatura anexado'
    },
    seller: {
      tax: {
        identification: {
          number: 'A identificação fiscal do vendedor do pedido é diferente à identificação extraída do ficheiro de fatura anexado'
        }
      }
    }
  },
  // Fin errores/mensajes en Integración de factura
  projects: {
    filters: {
      creation_date: {
        value: 'Data de criação'
      },
      name: {
        value: 'Nome do serviço',
        placeholder: 'Nome'
      },
      code: {
        value: 'Código do serviço',
        placeholder: 'Código'
      },
      security_code: {
        value: 'Código de segurança',
        placeholder: 'Código'
      },
      enabled: {
        value: 'Ativo',
        placeholder: 'Escolha...'
      },
      issuing: {
        value: 'Emissão',
        placeholder: 'Escolha...'
      },
      reception: {
        value: 'Recepção',
        placeholder: 'Escolha...'
      },
      party_nif: {
        value: 'NIF empresa',
        placeholder: 'NIF'
      },
      party_name: {
        value: 'Nome empresa',
        placeholder: 'Nome'
      }
    },
    entity_table: {
      name: 'Serviço',
      code: 'Código',
      security_code: 'Código de segurança',
      issuing: 'Emissão',
      reception: 'Recepção',
      creation_date: 'Data',
      enabled: 'Ativo'
    },
    buttons: {
      new_project: 'Novo serviço'
    },
    error: {
      tamanomaximo: {
        code: "Tamanho máximo do campo 'Código de Serviço': 50 caracteres",
        name: "Tamanho máximo do campo 'Nome de Serviço': 40 caracteres",
        security_code: "Tamanho máximo do campo 'Código de Segurança': 64 caracteres",
        new_name: "Tamanho máximo do campo 'Nome': 40 caracteres"
      },
      required: {
        name: 'Campo obrigatório: Nome',
        code: 'Campo obrigatório: Código',
        enable: 'Campo obrigatório: Ativo',
        isSender: 'Campo obrigatório: Emissão',
        isReceiver: 'Campo obrigatório: Recepção'
      },
      exist: 'O método de entrega escolhido já está inserido',
      validityexist: 'Já existem dados de vigência no serviço para esse tipo e essa função. Deve excluir a vigência existente se desejar adicionar outra.',
      validationexist: 'Os dados de validação já existem no serviço para aquele tipo, formato e função. Você precisará excluir a validação existente se quiser adicionar outra. ',
      statusexist: 'Já existe o estado para visualizar nas tarefas pendentes associadas ao serviço',
      statuschangeexist: 'Já existe o estado para a alteração de estado associado ao serviço',
      categoryexist: 'Já existe a categoria associada ao serviço',
      mimeexist: 'A configuração mime associada ao serviço já existe',
      mime: {
        invalidMimeFrom: 'O correio eletrónico a partir de inserido não é válido',
        invalidMimeSender: 'O correio eletrónico remetente inserido não é válido',
        invalidMimeReplyTo: 'O correio eletrónico para responder inserido não é válido'
      },
      wrongLogoSize: 'O tamanho da imagem excede o máximo permitido: 256 KBs',
      wrongLogoExtension: 'Só podem ser utilizadas imagens em formato JPG/JPEG/PNG',
      adminParties_name_exist: 'Ocorreu um erro. Já existe um serviço com esse nome o código',
      format_email: 'O formato do e-mail não está correto.',
      format_phone: 'O formato do telefone não está correto.',
      partyTypeAndProject: 'O tipo de empresa não corresponde à função do serviço',
      signDocument_fileNull: 'O ficheiro deve ser anexado',
      signDocument_wrongExtension: 'A extensão do anexo deve ser PDF',
      signDocument_invalidPdf: 'O conteúdo do documento não é um PDF válido.',
      roleOfParte_isEmpty: 'Deve haver pelo menos uma função para a empresa',
      commercialrelation_insert: 'Indique apenas o comprador ou o vendedor.',
      existRelation: 'Operação não concluída. A relação já existe.',
      partyCountryNotEqual: 'O campo "País" não corresponde à empresa com esse identificador',
      partydisabled: 'Não pode adicionar a empresa,existe mas está desativada',
      partyAlreadyAdded: 'A empresa já foi atribuída,por favor verifique os dados',
      noMediaCorrect: 'Os dados de contacto não são corretos,verifique o tipo de empresa dos dados.',
      email_empty: 'Deve inserir um dado de contacto',
      contact_duplicado: 'Já existe o "correio eletrónico" para esse serviço',
      contact_noMore: 'Não é possível adicionar mais contactos a este tipo',
      adminparties: {
        required: {
          userType: 'O campo "Tipo persona" é obrigatório',
          name: 'O campo "Nome" é obrigatório',
          firstSurname: 'O campo "Sobrenome" é obrigatório',
          corporateName: 'O campo "Razão social" é obrigatório',
          country: 'O campo "País" é obrigatório',
          postcode: 'O campo "Código postal" é obrigatório',
          address: 'O campo "Endereço" é obrigatório',
          town: 'O campo "Localidade" é obrigatório',
          province: 'O campo "Província" é obrigatório',
          nif: 'O campo "ID fiscal" é obrigatório'
        },
        invalid: {
          name: 'O campo "Nome" não é válido',
          firstSurname: 'O campo "Sobrenome" não é válido',
          secondSurname: 'O campo "Segundo sobrenome" não é válido',
          postcode: 'O campo "Código postal" não é válido',
          postcode_max: 'O comprimento do campo "Código postal" não está correto',
          nif: 'O campo "ID fiscal" não tem um formato válido',
          nif_max: 'O comprimento do campo "ID fiscal" não está correto',
          email: 'O correio eletrónico inserido não é válido',
          phoneNumber: 'O número de telefone do contacto não é válido'
        }
      }
    },
    validations: {
      name: 'Validação',
      value: 'Valor',
      role: 'Significado do documento',
      document_type: 'Tipo de documento',
      comm_method: 'Método de comunicação',
      emission: 'Emissão',
      reception: 'Recepção',
      country: 'Pais',
      document_format: 'Formato documento'
    },
    validities: {
      validity: 'Vigência (dias)',
      country: 'País',
      role: 'Significado do documento',
      document_type: 'Tipo de documento',
      emission: 'Emissão',
      reception: 'Recepção'
    },
    pendingtasks: {
      status: 'Estado',
      module: 'Módulo'
    },
    rejectionCategories: {
      name: 'Nome',
      visible: 'Visível'
    },
    emailType: {
      type: 'Tipología email',
      value: 'Email'
    },
    visualization: {
      name: 'Visualização'
    }
  },

  new_project: {
    title: 'Criação de serviço',
    new_project_form: {
      name: {
        label: 'Nome',
        placeholder: ''
      },
      code: {
        label: 'Código',
        placeholder: ''
      },
      issuing: {
        label: 'Emissão',
        placeholder: 'Escolha...'
      },
      enable: {
        label: 'Ativo',
        placeholder: 'Escolha...'
      },
      reception: {
        label: 'Recepção',
        placeholder: 'Escolha...'
      },
      indra_project: {
        label: 'Contratado',
        placeholder: 'Escolha...'
      }
    },
    load: {
      upload_logo: 'Upload do Logo',
      save_changes: 'Salvando os dados do projeto'
    },
    notify: {
      upload_logo: 'O logo foi carregado com sucesso. Lembre-se de clicar em "Salvar alterações"',
      save_changes: 'Projeto criado com sucesso'
    }
  },

  project_detail: {
    info_message: 'Alguns dos campos dos dados de serviço são editáveis. Lembre-se de clicar no botão \'Salvar\' para aplicar as alterações',
    title_delete_communication: 'Alguma empresa de serviços possui credenciais para esse método, verifique se você deve excluí-las antes de continuar, deseja continuar mesmo assim?',
    expand_all_accordion: 'Expandir todos os acordes',
    collapse_all_accordion: 'Recolher todos os acordes',
    buttons: {
      management_services_parties: 'Ver empresas associadas',
      add_logo: 'Carregar',
      add_configuration_data: 'Carregar',
      add_delivery_methods: 'Carregar',
      add_logo_tooltip: 'Carregar logo',
      add_configuration_data_tooltip: 'Carregar dado de configuração',
      add_mime_configuration: 'Carregar',
      add_mime_configuration_tooltip: 'Carregar dado de configuração mime',
      add_delivery_methods_tooltip: 'Carregar método de entrega',
      add_validation_tooltip: 'Carregar validação',
      add_validity_document: 'Carregar',
      add_validity_document_tooltip: 'Carregar vigência',
      add_visualization_tooltip: 'Carregar visualização',
      add_pendingtask: 'Carregar',
      add_pendingtask_tooltip: 'Carregar estado tarefa pendente',
      add_rejectionCategory: 'Carregar',
      add_rejectionCategory_tooltip: 'Carregar categoria',
      add_emailype_tooltip: 'Carregar tipologia de correio',
      add_documentFormat_data_tooltip: 'Carregar um formato de documento'
    },
    project_detail_edit_form: {
      name: 'Nome de serviço',
      code: 'Código de serviço',
      enable: 'Ativo/Inativo',
      security_code: 'Código de segurança',
      issuing: 'Emissão',
      reception: 'Recepção',
      is_indra_project: 'Contratado'
    },
    validation: {
      error_code: 'El código no cumple con el formato requerido {0}'
    },
    facturar: 'Fatura',
    configuration_data: 'Dados de configuração',
    no_configuration_data: 'Este serviço não tem dados de configuração',
    configuration_data_table: {
      code: 'configuração',
      project_type: 'Tipo projeto'
    },
    mime_required: 'Você deve inserir pelo menos um dos valores',
    mime_configuration_data: 'Dados de configuração mime',
    mime_configuration: 'Dados de configuração mime',
    no_mime_configuration_data: 'Este serviço não tem dados de configuração mime',
    mime_configuration_table: {
      mime_from: 'De',
      mime_sender: 'Remitente',
      mime_reply_to: 'Responder a'
    },

    delivery_methods: 'Métodos de entrega',
    delivery_methods_credentials: 'Métodos de entrega de credenciais',
    no_delivery_methods: 'Este serviço não tem métodos de entrega',
    validations: 'Validações',
    addCharge_or_discount: 'Encargos e descontos',
    no_chargeDiscount: 'O serviço não tem encargos nem descontos',
    visualize_pdf: 'Visualização PDF',
    no_active_validations: 'O serviço não tem validações ativas',
    no_active_PDF: 'O serviço não tem visualizações de PDF ativas',
    validity_document: 'Vigência de documentos',
    no_validity_document: 'Este serviço não tem dados de vigência',
    rejectionCategories: 'Categoria de rejeiçãos',
    no_rejectionCategories: 'Este serviço não tem categorias de rejeição',
    rejectionCategory_table: {
      category: 'Categoria',
      visible: 'Visível'
    },
    emailType: 'Tipologia correos',
    no_emailType: 'Este serviço não tem tipologias de correio configuradas',
    pendingtasks: 'Configurações de status',
    no_pendingtasks: 'Este serviço não tem status configurado',
    pendingtask_table: {
      status: 'Estado a ser visualizado nas tarefas pendentes',
      statuschange: 'Redefinição de estado',
      statusplaceholder: 'Estado'
    },
    emailTypePlaceholder: 'Tipo email',
    validity_document_table: {
      days: 'Vigência (días)',
      country: 'País',
      document_type: 'Tipo documento',
      role: 'Função'
    },

    dialog_add_logo: {
      title: 'Carga un logo'
    },
    dialog_add_configuration_data: {
      title: 'Adicione os dados de configuração',
      configuration: {
        label: 'Configuração',
        placeholder: 'Escolha uma configuração'
      },
      type: {
        label: 'Tipo',
        placeholder: 'Escolha um tipo'
      }
    },
    dialog_add_mime_configuration: {
      title: 'Adicione os dados de configuração mime',
      mime_from: {
        label: 'A partir de',
        placeholder: 'Do correio'
      },
      mime_sender: {
        label: 'Remetente',
        placeholder: 'Remetente de e-mail'
      },
      mime_reply_to: {
        label: 'Responder a',
        placeholder: 'Responder ao e-mail'
      }
    },

    // Documentos y formatos
    document_format: 'Documentos e formatos',
    no_document_format: 'Este serviço não possui documentos e formatos',
    dialog_add_document_format: {
      title: 'Escolha um novo documento e formato',
      format: {
        labelType: 'Tipo de documento',
        labelFormat: 'Formato do documento',
        placeholder: 'Escolha...'
      }
    },
    document_format_table: {
      name: 'Nome',
      sender: 'Emitir/Receber',
      priority: 'Prioridade',
      user: 'Usuário',
      password: 'Senha',
      party: 'Entidade',
      format: 'Formato',
      documentType: 'Tipo documento'
    },

    dialog_add_delivery_method: {
      title: 'Escolha um novo método de entrega',
      method: {
        label: 'Método',
        placeholder: 'Escolha um método'
      }
    },
    dialog_add_validations: {
      title: 'Escolha uma nova validação',
      validation: {
        title: 'Validação',
        placeholder: 'Escolha uma validação'
      }
    },
    dialog_add_visualization: {
      title: 'Escolha uma nova visualização PDF',
      visualization: {
        title: 'Visualização PDF',
        placeholder: 'Escolha uma visualização'
      }
    },
    dialog_add_validities: {
      title: 'Escolha uma nova vigência',
      validity: {
        title: 'Vigência',
        placeholder: 'Escolha uma vigência'
      }
    },
    dialog_add_pendingtask: {
      title: 'Configuração de status',
      pendingtask: {
        title: 'Tarefa pendente',
        placeholder: 'Escolha tarefa pendente'
      }
    },
    dialog_add_emailType: {
      title: 'Escolha um tipo de email',
      emailType: {
        title: 'Tipo de email',
        placeholder: 'Escolha tipo de email'
      }
    },
    dialog_add_rejectionCategory: {
      title: 'Escolha uma categoria',
      rejectionCategory: {
        title: 'Categoria de rejeição',
        placeholder: 'Escolha categoria'
      }
    },
    dialog_add_charge_or_discount: {
      title: 'Adicionar encargo ou desconto',
      type: 'Tipo',
      description: 'Descrição'
    },
    load: {
      upload_logo: 'Upload do Logo',
      delete_logo: 'Eliminando logo da empresa',
      download_logo: 'Baixando logo do projeto',
      save_changes: 'Salvando os dados do serviço',
      cancel: 'Cancelando',
      add_configuration: 'Adicionando configuração',
      delete_configuration: 'Eliminando configuração',
      add_delivery_method: 'Adicionando método de entrega',
      delete_delivery_method: 'Eliminando método de entrega',
      delete_validation: 'Eliminando validação',
      add_validation: 'Adicionando validação',
      delete_validity: 'Eliminando vigência',
      add_validity: 'Adicionando vigência',
      delete_PDFVisualization: 'Eliminando visualização PDF',
      add_visualization: 'Adicionando visualização PDF',
      delete_pendingtask: 'Eliminando estado de tarefa pendente',
      add_pendingtask: 'Adicionando estado de tarefa pendente',
      delete_rejectionCategory: 'Eliminando categoria de rejeição',
      add_rejectionCategory: 'Adicionando categoria de rejeição',
      delete_emailType: 'Eliminando tipologia de correio',
      add_emailType: 'Adicionando tipologia de correio',
      delete_project_document_format: 'Excluindo documento e formato',
      add_document_format: 'Adicionando formato de documento',
      add_delivery_note_config: 'Adicionar matrícula para notas de entrega emitidas',
      add_project_delivery_note_type: 'Adicionando tipo de guia de remessa',
      delete_project_delivery_note_type: 'Eliminando o tipo de guia de remessa'
    },
    notify: {
      delete_logo: 'O logo foi eliminado com sucesso',
      save_changes: 'O serviço foi atualizado com sucesso',
      add_configuration: 'Os dados de configuração foram adicionados com sucesso',
      delete_configuration: 'A configuração foi eliminada com sucesso',
      add_delivery_method: 'O método de entrega foi adicionado com sucesso',
      delete_delivery_method: 'O método de entrega foi eliminado com sucesso',
      delete_validation: 'A validação foi eliminada com sucesso',
      add_validation: 'A validação foi adicionada com sucesso',
      delete_validity: 'A vigência foi adicionada com sucesso',
      add_validity: 'A vigência foi adicionada com sucesso',
      delete_PDFVisualization: 'A visualização foi eliminada com sucesso',
      add_PDFVisualization: 'A visualização foi adicionada com sucesso',
      noDisplayDocuments: 'Não existem visualizações para esse tipo de documento',
      delete_pendingtask: 'O estado foi eliminado com sucesso',
      add_pendingtask: 'O estado foi adicionado com sucesso',
      delete_rejectionCategory: 'A categoria de rejeição foi eliminada com sucesso',
      add_rejectionCategory: 'A categoria de rejeição foi adicionada com sucesso',
      delete_emailType: 'A tipologia de correio foi eliminada com sucesso',
      add_emailType: 'A tipologia de correio foi adicionada com sucesso',
      delete_project_document_format: 'O documento foi excluído e formatado corretamente',
      add_document_format: 'O formato do documento foi adicionado com sucesso',
      add_delivery_note_config: 'A matrícula foi adicionada corretamente',
      document_format_duplicate: 'Falha ao inserir documento e formato, documento e formato repetidos.',
      add_project_delivery_note_exist: 'A relação entre o projeto e o tipo de guia de remessa já existe',
      add_project_delivery_note_type: 'O tipo de guia de remessa foi adicionada corretamente',
      delete_project_delivery_note_type: 'O tipo de guia de remessa foi eliminada corretamente'
    },
    error: {
      duplicated: 'A validação escolhida já se encontra inserida',
      document_type: {
        required: 'Um tipo de documento não foi indicado'
      },
      validation_id: {
        required: 'Uma validação não foi indicada',
        duplicated: 'Validação duplicada'
      },
      validity: {
        required: 'Os dias de vigencia não foram indicados'
      },
      sender: {
        required: 'A função não foi indicada'
      },
      visualization_id: {
        required: 'Uma visualização não foi indicada',
        duplicated: 'Visualização duplicada'
      },
      statusconfig: {
        required: 'Nenhum estado foi indicado'
      },
      emailType: {
        required: 'Tipo de email não foi indicado'
      },
      emailValue: {
        required: 'Pelo menos um email deve ser indicado',
        duplicated: 'Já existe o email para esse projeto e tipologia',
        invalid: 'Email não tem um formato válido'
      },
      category: {
        required: 'A categoria não foi indicada'
      },
      visible: {
        required: 'Nenhuma visualização indicada'
      }
    }
  },

  parties: {
    filters: {
      party_name: {
        value: 'Nome de empresa',
        placeholder: 'Nome'
      },
      identification_tax_number: {
        value: 'ID fiscal',
        placeholder: 'ID fiscal'
      },
      gln: {
        value: 'GLN',
        placeholder: 'GLN'
      },
      registerDate: {
        value: 'Data de registro',
        placeholder: 'Data de registro'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Comprador'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Vendedor'
      },
      propietary: {
        value: 'Proprietário',
        placeholder: 'Proprietário'
      },
      active: {
        value: 'Ativo',
        placeholder: 'Ativo'
      },
      country: {
        value: 'País',
        placeholder: 'País'
      }
    },
    notify: {
      not_buyer_sponsor: 'Todas as empresas devem ser compradoras e patrocinadoras / não patrocinadoras',
      modify_all: 'Todas as empresas selecionadas serão modificadas. Quer continuar?',
      parties_updated: 'Empresas atualizadas',
      loadmassive_timeout: 'O upload da empresa está sendo processado, uma vez terminado você pode ver o resultado na auditoria de documentos',
      loadmassive_numlinesOK: 'Número de linhas processadas com sucesso:'
    },
    entity_table: {
      name: 'Nome',
      identification_tax_number: 'ID fiscal',
      country: 'País',
      province: 'Província',
      creation_date: 'D.atribuição',
      seller: 'Vendedor',
      buyer: 'Comprador',
      third: 'Terceiro',
      sponsor: 'Proprietário',
      register_location_company: 'R. Comercial',
      enable: 'Ativo',
      permanentEstablishment: 'Estabelecimento permanente'
    },
    buttons: {
      add_party: 'Carregar',
      add_party_tooltip: 'Carregar empresa',
      mass_partycharge_tooltip: 'Carregamento em massa de empresas',
      mass_partycharge: 'Carregamento empresas',
      mass_partyupdate_tooltip: 'Atualização em massa de razões sociais corporativas',
      mass_upload: 'Carga massiva',
      mass_partyupdate: 'Atualização em massa'

    },
    mass_party_chargemsg: 'Carregamento em massa de empresas. O ficheiro deve conter a extensão CSV.'
  },

  new_party: {
    country_nif: {
      title: 'Adicionar empresa',
      info: 'Adiciona o ID Fiscal e o país da empresa para continuar preenchendo o formulário de criação da empresa',
      form: {
        country: {
          label: 'País',
          placeholder: 'Escolha...'
        },
        identification_number: {
          label: 'ID fiscal'
        }
      }
    }
  },

  party_detail: {
    confirm_clean: 'Lembre-se: se você modificar os dados,precisará gerar novamente o modelo de solicitação de alteração de dados',
    title: 'Informação da empresa',
    info_message: 'Alguns dos campos dos dados da empresa são editáveis. Lembre-se de clicar no botão \'Salvar\' para aplicar as alterações',
    info_address: 'Para salvar as informações de endereço fiscal, é necessário preencher todos os campos na seção',
    buttons: {
      admin_channels: 'Gerenciar relações comerciais',
      admin_centres: 'Gerenciar centros',
      upload_centre: 'Centro de atualização',
      upload_centre_ok: 'Centro atualizado com sucesso',
      add_contact_data: 'Carregar',
      add_contact_data_tooltip: 'Carregar dados de contacto',
      add_gln_data: 'Carregar',
      add_gln_data_tooltip: 'Carregar GLN',
      add_delivery_method: 'Carregar',
      add_sign_document: 'Carregar',
      add_delivery_method_tooltip: 'Carregar método de entrega',
      add_document_format_tooltip: 'Carregar formato de documento',
      add_delivery_note_type_tooltip: 'Tipo de guia de embalagem de carga',
      add_label_tooltip: 'Carregar rótulo',
      add_registration_tooltip: 'Carregar Matrícula',
      add_sign_document_tooltip: 'Carregar documento de assinatura delegada',
      add_validations_tooltip: 'Carregar validação',
      mass_partyupdate: 'Atualizar nome da empresa',
      add_shipping_configuration: 'Carregar',
      add_shipping_configuration_tooltip: 'Carregar configurações de frete',
      add_paymentMeans_tooltip: 'Carregar detalhes de pagamento',
      add_document_cycle_tooltip: 'Carregar ciclo de documentos'
    },
    dialog_add_payments: {
      title: 'Adicione detalhes de pagamento'
    },

    party_detail_edit_form: {
      person_type: {
        label: 'Tipo de pessoa',
        placeholder: 'Escolha um tipo'
      },
      corporate_name: 'Razão social',
      name: 'Nome',
      gln: 'GLN',
      identification_tax_number: 'ID fiscal',
      enable: 'Ativo/Inativo',
      first_surname: 'Sobrenome',
      second_surname: 'Segundo sobrenome',

      // Registro mercantil
      book: 'Livro',
      folio: 'Fólio',
      volume: 'Volume',
      sheet: 'Folha',
      section: 'Secção',
      additional_data: 'Dados adicionais',
      registerOrCompaniesLocation: 'Registo comercial',
      taxDataCertificate: 'Carregar certificado de dados fiscais da agência fiscal',

      // Direccion
      address: 'Endereço',
      province: 'Província',
      postcode: 'Código postal',
      town: 'Localidade',
      country: {
        label: 'País',
        placeholder: 'País'
      },

      // Datos Bancarios
      iban: 'IBAN',
      bic: 'BIC Swift',
      accountTitular: 'Titular da conta',
      email: 'E-mail de comunicação de pagamento',
      ficheroCertificado: 'Carregando certificado de propriedade da conta bancária',
      donwloadModelo: 'Fazer o download da solicitação de dados de alteração do modelo',
      ficheroDatos: 'Solicitação de upload para alteração de dados (deve ser assinado digitalmente)',
      sendProject: {
        label: 'Projetos para enviar documentação',
        placeholder: 'Escolha Projeto (s)'
      },
      legalNif: 'Nif do representante legal/advogado',
      legalName: 'Sobrenome e nome do representante legal/advogado',
      legalCountry: {
        label: 'País',
        placeholder: 'País'
      },
      contactName: 'Sobrenome e nome da pessoa de contato',
      contactRole: 'Cargo ocupado pela pessoa de contato na entidade',
      contactEmail: 'E-mail da pessoa de contato',
      contactEmailEmi: 'E-mail para emitir comunicações relacionadas à fatura eletrônica',
      contactPhones: 'Telefone/s da pessoa de contato',

      // Rol por servicio
      buyer: 'Comprador',
      seller: 'Vendedor',
      sponsor: 'Proprietário'
    },
    subtitle: {
      commercial_register: 'Registo comercial',
      address: 'Direção fiscal',
      project_role: 'Função por serviço',
      bank: 'Dados bancários',
      bank_legal_data: 'Dados do representante legal/advogado',
      bank_contact_data: 'Dados da pessoa de contato em relação a este formulário'
    },

    // Carga de logo
    dialog_add_logo: {
      title: 'Carrega um logo'
    },

    dialog_add_party_label: {
      title: 'Escolha um novo rótulo'
    },

    no_active_validations: 'Esta empresa não tem validações ativas',
    // Proyectos relacionados
    project_related: 'Servicios relacionados',
    no_project_data: 'Esta empresa no está asociada a ningún servicio',

    // Datos de contacto
    contact_data: 'Dados de contacto',
    no_contact_data: 'Esta empresa não tem dados de contacto',
    party_media_table: {
      project: 'Serviço',
      media_type: 'Tipo de contacto',
      contact_data: 'Dado de contacto',
      party_type: 'Tipo de empresa',
      profile_info: '>>  Se você deseja modificar as informações de contato,entre em contato com seu cliente.'
    },
    dialog_add_contact_data: {
      title: 'Adicionar dados de contacto',
      media_type: {
        label: 'Medio de contacto',
        placeholder: 'Tipo de contacto'
      },
      party_type: {
        label: 'Tipo de empresa',
        placeholder: 'Tipo de empresa'
      },
      contact_data: {
        label: 'Dado de contacto'
      }
    },
    // Buzones
    gln_data: 'Identificadores',
    no_gln_data: 'Esta empresa não identificadores de correio',
    party_gln_table: {
      physical_gln: 'Identificatori',
	  physical_gln_type: 'Tipo'
    },
    dialog_add_gln_data: {
      title: 'Identificador',
      physical_gln: {
        label: 'Identificador',
		type: 'Tipo'
      }
    },

    // Metodos de entrega
    delivery_methods: 'Métodos de entrega',
    no_delivery_methods: 'Esta empresa não tem métodos de entrega',
    delivery_methods_table: {
      name: 'Nome',
      sender: 'Emissão/Recepção',
      priority: 'Prioridade',
      user: 'Utilizador',
      password: 'Senha',
      party: 'Empresa',
      countryEmission: 'País emisor',
      countryReception: 'País receptor',
    },
    dialog_add_delivery_methods: {
      title: 'Escolha um novo método de entrega',
      method: {
        label: 'Método de entrega',
        placeholder: 'Escolha...'
      }
    },
    dialog_add_delivery_methods_credentials: {
      title: 'Credenciais do método de envio'
    },

    // Formato de documento
    document_format: 'Formatos de documentos',
    no_document_format: 'Este serviço não possui formatos de documento',
    dialog_add_document_format: {
      title: 'Escolha um novo formato de documento',
      method: {
        labelType: 'Tipo de documento',
        labelFormat: 'Formato do documento',
        placeholder: 'Escolha...'
      }
    },
    document_format_table: {
      name: 'Nome',
      sender: 'Emitir/Receber',
      priority: 'Prioridade',
      user: 'Usuário',
      password: 'Senha',
      party: 'Entidade',
      format: 'Formato',
      documentType: 'Tipo de documento'
    },

    // Documento de firma delegada
    sign_document: 'Documento de assinatura delegada',
    no_sign_document: 'Esta empresa não tem documentos de assinatura delegada',
    sign_document_table: {
      project: 'Tipo/Serviço',
      filename: 'Nome ficheiro',
      creation_date: 'Data criação'
    },
    // Documento de datos fiscales
    aeat_document: 'Documento de dados fiscais',
    no_aeat_document: 'Esta empresa não tem documentos de dados fiscais',
    aeat_document_table: {
      user: 'Utilizador',
      documentname: 'Ficheiro',
      creation_date: 'Data criação'
    },
    dialog_add_sign_document: {
      title: 'Carregar ficheiro de delegação de assinatura'
    },
    // Datos de pago
    paymentMeans: 'Detalhes do pagamento',
    no_payment_data: 'Esta empresa não possui informações de pagamento',
    payments_table: {
      paymentMeans: 'Forma de pagamento',
      iban: 'IBAN',
      swift: 'SWIFT'
    },
    // Ciclos de documentos
    no_party_document_cycle: 'Não há ciclos de documentos',
    document_cycle_table: {
      title: 'Ciclos de documentos',
      sourceDocumentType: 'Tipo de documento de origem',
      destinationDocumentType: 'Tipo de documento de destino',
      buyer_centre: 'Centro da empresa compradora',
      seller: 'Empresa vendedora',
      class: 'Classe de documento de origem',
      additional: 'Parâmetro adicional da classe de documento de origem'
    },
    document_cycle_class_source_options: {
      source: 'Documento de origem',
      destination: 'Documento de destino'
    },
    dialog_add_document_cycle: {
      title: 'Adicionar um novo ciclo de documentos',
      source_document_type: {
        label: 'Tipo de documento de origem',
        placeholder: 'Escolha...'
      },
      destination_document_type: {
        label: 'Tipo de documento de destino',
        placeholder: 'Escolha...'
      },
      seller: {
        label: 'Empresa vendedora',
        placeholder: 'Digite 3 caracteres'
      },
      centre_buyer: {
        label: 'Centro da empresa compradora',
        placeholder: 'Escolha...'
      },
      document_cycle: {
        label: 'Classe de documento de origem',
        placeholder: 'Escolha...'
      },
      document_cycle_class_source: {
        label: 'Sentido do documento',
        placeholder: 'Escolha o documento ao qual adicionar a classe...'
      },
      additional_class_value: {
        title: 'Parâmetro adicional da classe de documento de origem'
      }
    },

    load: {
      add_document_format: 'Adicionando formato de documento',
      delete_party_document_format: 'Excluindo formato de documento',
      delete_party_emission_deliverynote_config: 'Eliminação da Matrícula para Notas de Entrega Emitidas',
      upload_logo: 'Upload do Logo',
      delete_logo: 'Eliminando logo da empresa',
      download_logo: 'Baixando Logo da empresa',
      save_changes: 'Salvando os dados da empresa',
      cancel: 'Cancelando',
      add_contact_data: 'Adicionando dados de contacto',
      delete_contact_data: 'Eliminando dados de contacto',
      add_approval_amount: 'Criando fluxo de aprovação',
      modify_approval_amount: 'Atualizando fluxo de aprovação',
      delete_approval_amount: 'Removendo fluxo de aprovação',
      add_approval_level: 'Criando nível de aprovação',
      delete_approval_level: 'Removendo nível de aprovação',
      add_party_label: 'Adicionando tag',
      delete_party_label: 'Removendo tag',
      add_gln_data: 'Adicionando identificador',
      delete_gln_data: 'Eliminando identificador',
      add_delivery_method: 'Adicionando método de entrega',
      add_party_delivery_note_type: 'Adicionando tipo de guia de remessa',
      delete_party_delivery_note_type: 'Eliminando tipo de guia de remessa',
      delete_delivery_method: 'Eliminando método de entrega',
      upload_sign_document: 'Upload do documento de assinatura delegada',
      download_sign_document: 'Baixando documento de assinatura delegada',
      delete_sign_document: 'Eliminando documento de assinatura delegada',
      download_aeat_document: 'Baixando documento de dados fiscais',
      add_shipping_configuration: 'Adicionando configurações de envio',
      delete_shipping_configuration: 'Eliminando configurações de envio',
      delete_paymentMeans: 'Eliminando dados de pagamento',
      add_paymentMeans: 'Adicionando detalhes de pagamento',
      delete_document_cycle: 'Excluindo ciclo de documentos',
      add_party_document_cycle: 'Adicionando ciclo de documentos'
    },
    notify: {
      add_document_format: 'O formato do documento foi adicionado com sucesso',
      delete_party_document_format: 'Formato de documento excluído com sucesso',
      delete_party_emission_deliverynote_config: 'A matrícula foi removida com sucesso',
      upload_logo: 'O logo foi carregado com sucesso. Lembre-se de clicar em "Salvar alterações"',
      delete_logo: 'O logo foi eliminado com sucesso',
      save_changes: 'A empresa foi atualizada com sucesso',
      created: 'A empresa foi criada com sucesso',
      save_changes_to_service: 'Os dados foram relatados ao serviço ',
      add_contact_data: 'Os dados de contacto foram adicionados com sucesso',
      delete_contact_data: 'Os dados de contacto foram eliminados com sucesso',
      add_approval_amount_data: 'Dados do fluxo de aprovação adicionados com sucesso',
      modify_approval_amount_data: 'Dados do fluxo de aprovação modificados com sucesso',
      delete_approval_amount_data: 'Fluxo de aprovação do centre removido',
      add_approval_level_data: 'Nível de aprovação adicionado com sucesso',
      delete_approval_level_data: 'Nível de aprovação removido',
      add_gln_data: 'O GLN foi adicionado com sucesso',
      delete_gln_data: 'O GLN foi eliminado com sucesso',
      noLabels: 'Não existem etiquetas para esse tipo de documento',
      existLabels: 'A tag já está associada à empresa',
      add_party_label: 'A tag foi adicionada com êxito',
      delete_party_label: 'A tag foi removida com êxito',
      add_party_delivery_note_type: 'O tipo de guia de remessa adicionado com sucesso',
      add_party_delivery_note_exist: 'A relação entre a empresa e o tipo de nota de entrega já existe',
      add_delivery_method: 'O método de entrega foi adicionado com sucesso',
      delete_delivery_method: 'O método de entrega foi eliminado com sucesso',
      delete_party_delivery_note_type: 'O tipo de guia de remessa eliminado com sucesso',
      delete_sign_document: 'O documento de assinatura foi eliminado com sucesso',
      typePersonTaxIden: 'O tipo de pessoa deve corresponder a um ID de imposto correto na Espanha',
      document_format_duplicate: 'Falha ao inserir o formato do documento, formato repetido.',
      add_shipping_configuration: 'A configuração de envio foi adicionado com sucesso',
      delete_shipping_configuration: 'A configuração de envio foi eliminado com sucesso',
      add_shipping_configuration_duplicate: 'Falha ao inserir a configuração de envio, formato para esse GLN repetido',
      add_paymentMeans: 'Detalhes de pagamento adicionados com sucesso',
      delete_paymentMeans: 'Os dados de pagamento foram excluídos com sucesso',
      payment_means_duplicate: 'Já existem dados de pagamento para o mesmo método. Exclua primeiro os dados de pagamento existentes',
      document_cycle_duplicate: 'O ciclo do documento para a empresa já existe, remova primeiro o ciclo do documento existente',
      delete_document_cycle: 'O ciclo do documento foi excluído com sucesso',
      add_document_cycle: 'O ciclo do documento foi adicionado com sucesso'
    },

    // Administrar canales
    channels: {
      filters: {
        name: {
          value: 'Nome da empresa',
          placeholder: 'Nome'
        },
        buyer: {
          value: 'Comprador',
          placeholder: 'Escolha...'
        },
        seller: {
          value: 'Vendedor',
          placeholder: 'Escolha...'
        }
      },
      entity_table: {
        sellers: 'Empresas vendedoras',
        buyers: 'Empresas compradoras',
        channels: 'Canais',
        seller: 'Empresa vendedora',
        buyer: 'Empresa compradora',
        communicationsMethod: 'Métodos de comunicação'
      },
      buttons: {
        add_commercial_relation: 'Adicionar relação comercial'
      },
      dialog_add_commercial_relation: {
        title: 'Nova relação comercial',
        party: 'Empresa',
        buyer: {
          label: 'Comprador',
          placeholder: 'Escolha...',
          write_placeholder: 'Insire 3 caracteres'
        },
        seller: {
          label: 'Vendedor',
          placeholder: 'Escolha...',
          write_placeholder: 'Insire 3 caracteres'
        }
      },
      dialog_users: {
        title: 'Utilizadores',
        userName: 'Nome do utilizador'
      },
      notify: {
        add_commercial_relation: 'A relação comercial foi adicionada com sucesso',
        delete_commercial_relation: 'A relação comercial foi eliminada com sucesso.'
      },
      confirm: {
        delete_commercial_relation: 'Tem certeza de que deseja eliminar a relação comercial?'
      },
      load: {
        add_commercial_relation: 'Adicionando relação comercial ...',
        delete_commercial_relation: 'Eliminando relação comercial ...'
      },
      channels_data: 'Canais da empresa',
      no_channels_data: 'A empresa não tem canais'
    },

    commercial_relation: {
      filters: {
        party_name: {
          value: 'Nome da empresa',
          placeholder: 'Empresa'
        },
        buyer: {
          value: 'Comprador',
          placeholder: 'Escolha...'
        },
        seller: {
          value: 'Vendedor',
          placeholder: 'Escolha...'
        }
      }
    },

    // Configuración de emisión de albaranes
    emission_delivery_note_config: 'Configuração de matrículas para emissão de guias de remessa',
    no_emission_delivery_note_config: 'Esta empresa não possui configuração de placas para emissão de guias de remessa',
    emission_delivery_note_config_table: {
      platformCode: 'Código da plataforma',
      partyPrefix: 'Código da Empresa',
      packSequenceNumber: 'Número sequencial'
    },

    // Configuración de tipos de albaranes recibidos
    reception_delivery_note_config: 'Configuração de tipos de guias de remessa recebidas',
    no_party_reception_delivery_note_config: 'Esta empresa não tem configuração de tipos de guias de remessa recebidas',
    no_project_reception_delivery_note_config: 'Este serviço não tem configuração de tipos de guias de remessa recebidas',
    reception_delivery_note_config_table: {
      delivery_note_type: 'Tipo de nota de entrega'
    },

    dialog_add_party_delivery_note_config: {
      title: 'Novo registo',
      method: {
        platformCode: 'Código da plataforma',
        partyPrefix: {
          title: 'Código da Empresa',
          tooltip: 'Insira o código do país (2 dígitos) + o código oficial do organismo (5 a 9 dígitos)'
        },
        packSequenceNumber: {
          title: 'Número sequencial',
          tooltip: 'Insira o número de sequência inicial para os pacotes numéricos'
        },
        rules: {
          partyPrefix_pattern: 'O código da empresa suporta apenas entre 7 e 11 dígitos',
          packSequenceNumber_pattern: 'O número de sequência suporta apenas dígitos'
        }
      }
    },
    dialog_add_party_delivery_note_type: {
      title: 'Escolha um novo tipo de guia de remessa',
      method: {
        deliveyNoteType: 'Tipo de nota de entrega'
      }
    },

    // Configuración de etiquetas para empresa compradora
    party_label_config: 'Configuração de etiquetas para notas de entrega recebidas',
    no_party_label_config: 'Esta empresa não tem etiquetas configuradas para as guias de remessa recebidas',
    party_label_config_table: {
      name: 'Nome',
      description: 'Descrição',
      document_type: 'Tipo de documento',
      class: 'Classe de implementação'
    },

    dialog_add_party_label_config: {
      title: 'Novo rótulo',
      method: {
        label: {
          title: 'Rótulo',
          placeholder: 'Escolha um rótulo'
        },
        description: 'Descrição',
        document_type: 'Tipo de documento',
        class: 'Classe de implementação'
      }
    },

    // CONFIGURACIÓN DE ENVÍO DE LA EMPRESA
    shipping_configuration: 'Configurações de envio',
    no_shipping_configuration: 'Esta empresa não tem configurações de envio',
    shipping_configuration_table: {
      documentType: 'Tipo documento',
      documentFormat: 'Formato',
      partySeller: 'Vendedor',
      deliveryPoint: 'Lugar de entrega',
      sellerGLN: 'Caixa de correio vendedor',
      buyerGLN: 'Caixa de correio comprador'
    },

    dialog_add_shipping_configuration: {
      title: 'Nova configurações de envio',
      document_type: {
        label: 'Tipo documento',
        placeholder: 'Escolha...'
      },
      document_format: {
        label: 'Formato do documento',
        placeholder: 'Escolha...'
      },
      gln_buyer: {
        label: 'Caixa de correio física do comprador',
        placeholder: 'Insire 3 caracteres'
      },
      gln_seller: {
        label: 'Caixa de correio física do vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        label: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      delivery_centre: {
        label: 'Lugar de entrega',
        placeholder: 'Insire 3 caracteres'
      }
    }
  },

  centres: {
    filters: {
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      gln: {
        value: 'Gln',
        placeholder: 'Gln'
      },
      province: {
        value: 'Província',
        placeholder: 'Província'
      },
      code: {
        value: 'Código',
        placeholder: 'Código'
      },
      mailbox: {
        value: 'Caixa de correio',
        placeholder: 'Caixa de correio'
      },
      centre_type: {
        value: 'Tipo de centro',
        placeholder: 'Tipo',
        buyer: 'Comprador',
        seller: 'Vendedor',
        both: 'Ambos'
      }
    },
    entity_table: {
      name: 'Nome',
      dateCreationTime: 'Data de criação',
      code: 'Código',
      gln: 'GLN',
      town: 'Localidade',
      province: 'Província',
      country: 'País',
      nameCentre: 'Nome do centro',
      mailbox: 'Caixa de correio',
      siret: 'Identificador internacional',
      siret_tooltip: 'Para França é necessário inserir o SIRET (14 caracteres)',
      address: 'Endereço',
      postcode: 'C.P',
      centreType: 'Tipo Centro'
    },
    save_changes_notify: 'O centro foi atualizado com sucesso',
    save_changes_load: 'Salvando os dados do centro',
    no_contact_data: 'Este centro não tem dados de contacto',
    no_aproval_flow_data: 'Este centro não possui usuários atribuídos para o fluxo de aprovação',
    save_changes_insert_notify: 'O centro foi adicionado com sucesso',
    data_contact_ko: 'Não é possível adicionar mais contactos desse tipo',
    data_contact_repeat: 'O dado de contacto inserido não é válido,está repetido',
    delete_centre: 'Eliminar centro',
    title_delete_user: 'Deseja eliminar o centro?',
    delete_user_ok: 'O centro foi eliminado com sucesso',
    approval_flow: 'Níveis de aprovação',
    title_admin_approval_flow: 'Fluxo de aprovação',
    title_admin_approval_flows: 'Fluxos de aprovação',
    delete_approval_flow: 'Excluir fluxo',
    confirm_delete_approval_flow: 'Tem certeza de que deseja excluir o fluxo de aprovação?',
    cannot_delete_flow_has_levels: 'Não é possível excluir o fluxo. Você deve primeiro excluir os níveis associados',
    confirm_delete_approval_level: 'Tem certeza de que deseja excluir este nível de aprovação?',
    centre_approval_level_table: {
      level: 'Nível',
      user: 'Usuário aprovador',
      notification: 'Notificação do usuário aprovador'
    },
    data_approval_level_repeat: 'O nível de aprovação inserido já existe para o usuário',
    data_approval_level_not_valid: 'Existe um nível de aprovação inferior não atribuído',
    data_approval_level_empty: 'Revise os campos obrigatórios do formulário',
    approval_level_delete_not_allowed: 'Existem níveis mais elevados. Caso queira excluir o item, cadastre previamente um novo para este nível.',
    approval_amount_empty: 'O valor mínimo é obrigatório e deve ser maior ou igual a 0',

    // Role Centro
    centre_roles: 'Função de centro',
    no_centre_role: 'Este centro no tiene ningún rol',
    centre_roles_table: {
      name: 'Rol'
    },

    buttons: {
      mass_upload: 'Carga massiva',
      centre_massive_charge: 'Carga massiva',
      centre_massive_tooltip: 'Carga massiva de centros',
      add_centre_role: {
        label: 'Carregar',
        content: 'Adicionar função de centro'
      },
      download_csv_approval_flow_tooltip: 'Exportação CSV de flujos e níveis de aprovação',
      download_csv_approval_flow: 'CSV flows'
    },

    dialog_add_centre_role: {
      title: 'Adicionar função de centro',
      role_type: {
        label: 'Função de centro',
        placeholder: 'Tipo de função'
      }
    },

    approval_flow_data: {
      amount: 'Preço mínimo',
      code: 'Código do centro',
      description: 'Descrição do fluxo de aprovação',
      purchase_order: 'Tenha em consideração a ordem',
      amountTo: 'Quantidade máxima'
    },
    centre_massive_charge: {
      title: 'Carga massiva de centros',
      message: 'O ficheiro deve conter a extensão CSV.'
    },
    dialog_add_approval_level: {
      title: 'Adicionar nível de aprovação',
      level: {
        label: 'Nível de aprovação',
        placeholder: 'Nível de aprovação'
      },
      user: {
        label: 'Usuário aprovador',
        placeholder: 'Usuário'
      },
      notification: {
        label: 'Enviar notificação com aprovação pendente?',
        placeholder: 'Sim / Não'
      }
    },

    load: {
      add_centre_role: 'Adicionando função de centro ...',
      delete_centre_role: 'Excluindo função de centro ...',
      text_load_data: 'Carregando dados ...',
      text_load_init_data: 'Carregando dados iniciais ...'
    },

    notify: {
      loadmassive_numlinesOK: 'Número de linhas processadas corretamente:',
      add_centre_role: 'Função de centro criado com sucesso.',
      delete_centre_role: 'Função de centro excluído com sucesso.',
      error_duplicate_role: 'Essa função já existe atribuída a esse centro'
    }
  },

  users: {
    filters: {
      registration_date: {
        value: 'D-h.registo'
      },
      username: {
        value: 'Utilizador',
        placeholder: 'Nome de utilizador'
      },
      complete_name: {
        value: 'Nome/Sobrenomes',
        placeholder: 'Nome',
        placeholder_first_surname: 'Sobrenome 1',
        placeholder_second_surname: 'Sobrenome 2'
      },
      trial: {
        value: 'Tentativas',
        placeholder: 'N. tentativas'
      },
      active: {
        value: 'Ativo',
        placeholder: 'Escolha...'
      },
      last_connection_date: {
        value: 'Data última conexão',
        placeholder: ''
      },
      identification_number: {
        value: 'N. identificação',
        placeholder: 'N. identificação'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      party: {
        value: 'Empresa',
        placeholder: 'Empresa'
      },
      party_type: {
        value: 'Tipo de empresa',
        placeholder: 'Tipo'
      },
      is_party_sponsor: {
        value: 'Proprietário de empresa',
        placeholder: 'Escolha...'
      },
      email: {
        value: 'Email',
        placeholder: 'Email'
      }
    },
    error: {
      usuarioKo: 'O utilizador {argumento} não existe'
    },
    // - CREATE USER
    createuser: {
      steps: {
        user: 'Usuário',
        data: 'Dados',
        entity: 'Entidades',
        profile: 'Perfis'
      },
      newuser: {
        title: 'Novo Utilizador',
        username: 'Utilizador',
        email: 'Email',
        success: 'Usuário criado com sucesso'
      },
      datauser: {
        title: 'Dados gerais do utilizador {username}',
        name: 'Nome',
        firstSurname: 'Sobrenome',
        secondSurname: 'Segundo sobrenome',
        taxIdentificationNumber: 'Núm.identificação fiscal'
      },
      party: {
        partyTaxIdentificationNumber: 'Núm.identificação fiscal empresa '
      },
      entitiesuser: {
        title: 'Atribuição de entidades ao utilizador {username}'
      },
      profilesuser: {
        title: 'Perfis do utilizador {username}'
      },
      error: {
        userExistsWithDifferentMail: 'O utilizador já existe e está associado a outro endereço de correio eletrónico. Verifique o endereço de correio eletrónico ou solicite outro utilizador.',
        usernameExists: 'O nome de utilizador já existe no sistema.',
        validation: {
          required: {
            username: "O campo 'Utilizador' é obrigatório",
            mail: "O campo 'Email' é obrigatório",
            name: "O campo 'Nome' é obrigatório",
            first_surname: "O campo 'Sobrenome' é obrigatório",
            partyId: 'O parâmetro partyId é obrigatório',
            projectId: 'O parâmetro projectId é obrigatório',
            userId: 'O parâmetro userId é obrigatório',
            userMediaId: 'O parâmetro userMediaId é obrigatório',
            userentities: 'É obrigatório alocar alguma entidade',
            rolesAuthorities: 'É obrigatório alocar algum perfil/autorização'
          },
          maxLength_username: 'Comprimento máximo do campo "Utilizador": 64 caracteres',
          minLength_username: 'Comprimento mínimo do campo "Utilizador": 3 caracteres',
          forbidden_word: "Altere o 'Utilizador'. Não pode usar esse valor como utilizador",
          format_mail: "'Email' não tem um formato válido",
          maxLength_mail: 'Comprimento máximo do campo "Email": 255 caracteres',
          maxLength_name: 'Comprimento máximo do campo "Nome": 50 caracteres',
          invalid_name: 'O campo "Nome" não é válido',
          maxLength_first_surname: 'Comprimento máximo do campo "Sobrenome": 50 caracteres',
          invalid_first_surname: 'O campo "Sobrenome" não é válido',
          maxLength_TaxID: 'Comprimento máximo do campo "Número de identificação fiscal": 20 caracteres',
          exist_TaxID: 'Já existe um utilizador com esse NIF',
          maxLength_second_surname: 'Comprimento máximo do campo "Segundo sobrenome": 50 caracteres',
          invalid_second_surname: 'O campo "Segundo sobrenome" não é válido',
          not_asociated_project: 'O Projeto não existe ou não está associado ao utilizador.',
          not_asociated_user: 'O Utilizador não existe ou não está associado ao utilizador',
          not_asociated_rol: 'A função não existe ou não está associada ao utilizador',
          not_asociated_permission: 'A Autorização não existe ou não está associada ao utilizador.',
          not_asociated_party: 'A Empresa não existe ou não está associada ao utilizador.',
          not_exist: 'Não existe relação entre o projeto e a empresa',
          userEntity_notfound: 'Não existe o utilizador ou não tem privilégios para visualizar suas entidades.'
        }
      },
      created: 'O utilizador foi criado com sucesso'
    },

    users_entity_table: {
      username: 'Utilizador',
      complete_name: 'Nome/Sobrenomes',
      creation_datetime: 'Data de registo',
      trail: 'Intentos',
      last_connection_date: 'Último login',
      password_expiration_date: 'Expiração da senha',
      id_number: 'Núm. identificação',
      enable: 'Ativo',
      email: 'Email',
      what_show: 'O que deseja visualizar na tabela?',
	  service_account_tooltip: 'Marcado: Este usuário é para integração.<br>Não marcado: Este usuário é para o portal',
      enable_tooltip: 'Marcado: Este usuário está ativo.<br>Não marcado: Este usuário está inativo'
    },
    users_pagination: {
      csv: 'CSV',
      showing: 'Mostrando'
    },
    users_multiple_selection: {
      csv: 'CSV',
      massive_reset: 'Reset massivo',
      confirm_massive_reset_title: 'Reset massivo de usuários',
      confirm_massive_reset_message: 'Todos os usuários selecionados serão redefinidos, tem certeza?'
    },
    users_filters: {
      button_new_user: 'Novo utilizador',
      button_reset_users: 'Reset massivo',
      button_reset_users_tt: 'Reset',
      button_mass_usercharge: 'Carregamento em massa',
      username_placeholder: 'Nome de utilizador',
      filter_form: {
        no_match: 'Não há resultados',
        placeholder_first_value: 'Escolha um filtro',
        button_add_filter: 'Carregar'
      }
    },
    user_reset_tooltip: 'Separe os nomes de utilizador com ponto e vírgola (;)',
    user_mass_userchargemsg: 'Carregamento em massa de utilizadores. O ficheiro deve conter a extensão CSV.',
    user_upload: 'Selecione arquivo',
    no_date: 'Não há fecha',
    load: {
      reset_password: 'Reseteio das senhas ...'
    },
    notify: {
      reset_ok: 'O reset aconteceu com sucesso.'
    },
    massive_upload: {
      username: {
        required: 'O campo utilizador é obrigatório',
        maxLength: 'O nome do utilizador excede o comprimento máximo permitido',
        forbidden_word: 'Esse valor não pode ser usado para utilizador'
      },
      mail: {
        required: 'O campo email é obrigatório',
        novalid: 'Formato de correio eletrónico inválido',
        maxLength: 'O email excede o comprimento máximo permitido',
        emailKO: 'Não é possível alterar o email do utilizador. O utilizador existe em outros projetos'
      },
      firstSurname: {
        maxLength: 'O sobrenome excede o comprimento máximo permitido',
        invalid: 'O campo Sobrenome não é válido',
        required: 'O campo Sobrenome é obrigatório'
      },
      name: {
        maxLength: 'O nome excede o comprimento máximo permitido',
        invalid: 'O campo Nome não é válido',
        required: 'O campo Nome é obrigatório'
      },
      nif: {
        maxLength: 'O NIF excede o comprimento máximo permitido',
        exist: 'Já existe um utilizador com o mesmo NIF'
      },
      entities: {
        invalid: 'O formato do campo entidades é incorreto'
      },
      enabled: {
        invalid: 'O campo Ativo não é válido'
      },
      parties: {
        required: 'O campo Empresas é obrigatório',
        noexist: 'A empresa não existe'
      },
      error: {
        projectParty: 'A empresa não pertence ao serviço',
        centreParty: 'O centro não pertence à empresa'
      },
      centre: {
        noexist: 'O centro não existe'
      },
      rol: {
        required: 'O campo Perfis é obrigatório',
        noexist: 'A função não existe'
      }
    }
  },
  plannedProcesses: {
    filters: {
      group: {
        value: 'Grupo',
        placeholder: 'Grupo'
      },
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      description: {
        value: 'Descrição',
        placeholder: 'Descrição'
      },
      status: {
        value: 'Status',
        placeholder: 'Status'
      },
      jobclass: {
        value: 'Classe de execução',
        placeholder: 'Classe de execução'
      }
    },
    plannedProcesses_table: {
      group: 'Group',
      name: 'Nome',
      description: 'Descrição',
      status: 'Status',
      jobclass: 'Classe de execução',
      triggerCron: 'Planejamento'
    },
    plannedProcesses_button: {
      pause: 'Pausa',
      resume: 'Resume',
      interrupt: 'Interromper',
      pauseAll: 'Pausa',
      resumeAll: 'Resume',
      standby: 'Em espera',
      shutdown: 'Parar',
      start: 'Iniciar',
      pauseAll_tooltip: 'Parar todas as tarefas',
      resumeAll_tooltip: 'Iniciar todas as tarefas',
      standby_tooltip: 'Pare todo o quartzo',
      shutdown_tooltip: 'Desligue o quartzo, não pode ser iniciado mais tarde, apenas reiniciando',
      start_tooltip: 'Comece o quarto, após um STANDBY'
    },
    text1: 'Significado de cada campo: [Segundos] [Minutos] [Horas] [Dia do mês Mês] [Dia da semana] [Ano (campo opcional)]',
    text2: 'Subexpressões individuais podem conter intervalos (-) e / ou listas (,).',
    text3: 'O caractere "*": "todos" os valores possíveis deste campo.',
    text4: 'O caractere "/": especifica incrementos em valores. Por exemplo, se você colocar "0/15" no campo Minutos, significa "a cada 15 minutos da hora".',
    text5: 'O "?": para os campos de dia do mês e dia da semana, indica "nenhum valor específico".'
  },
  mailTemplates: {
    editor: {
      toolbar: {
        bold_tooltip: 'Negrito',
        italic_tooltip: 'Itálico',
        underline_tooltip: 'Sublinhado',
        orderedList_tooltip: 'Lista numerada',
        bulletList_tooltip: 'Lista com marcadores',
        link_tooltip: 'Inserir link',
        image_tooltip: 'Inserir imagem',
        showHtml_tooltip: 'Ver/editar HTML',
        undo_tooltip: 'Desfazer',
        redo_tooltip: 'Refazer',
        alignLeft_tooltip: 'Alinhar à esquerda',
        alignCenter_tooltip: 'Centralizar',
        alignRight_tooltip: 'Alinhar à direita',
        justify_tooltip: 'Justificar',
        outdent_tooltip: 'Diminuir recuo',
        indent_tooltip: 'Aumentar recuo',
        sourceCode_tooltip: 'Código fonte',
        preview_tooltip: 'Pré-visualização',
        table_tooltip: 'Tabela',
        removeFormat_tooltip: 'Limpar formatação',
        fontFamily_tooltip: 'Tipo de letra',
        fontSize_tooltip: 'Tamanho da letra'
      },
      source: {
        code: 'Código',
        preview: 'Pré-visualização'
      }
    },
    filters: {
      mailType: {
        value: 'Tipo de correio',
        placeholder: 'Tipo de correio'
      },
      language: {
        value: 'Língua',
        placeholder: 'Língua'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      userHostServer: {
        value: 'Servidor de e-mail (usuário/from/host)',
        placeholder: 'Servidor de e-mail (usuário/from/host)'
      }
    },
    mailTemplates_table: {
      userHostServer: 'Servidor de e-mail (usuário/from/host)',
      mailType: 'Tipo de correio',
      language: 'Língua',
      project: 'Serviço'
    },
    detail: {
      subject: 'Cabeçãlho',
      body: 'Corpo da mensagem',
      delete_template: 'Eliminar padrão de referência',
      delete_template_ok: 'Padrão de referência eliminado com sucesso',
      save_changes: 'Padrão de referência atualizado com sucesso',
      create_template_ok: 'Padrão de referência criado com sucesso',
      confirm: {
        title_delete_template: 'Tem certeza de que deseja eliminar esse padrão de referência?'
      }
    },
    new_template: 'Novo padrão de referência',
    create_template: 'Criar padrão de referência ',
    add_template: 'Salvando padrão de referência',
    clone: {
      title: 'Clonar padrão de referência',
      label: 'Clonar'
    },
    error: {
      duplicated: 'Já existe um padrão de referência para esse tipo de correio,projeto e idioma',
      notFound: 'Falta preencher algum campo necessário para realizar a atualização'
    }
  },
  communicationm: {
    filters: {
      id: {
        value: 'Id',
        placeholder: 'Id'
      },
      name: {
        value: 'Nome',
        placeholder: 'Nome'
      },
      docTypeName: {
        value: 'Tipo de documento',
        placeholder: 'Tipo de documento'
      },
      enabled: {
        value: 'Ativo',
        placeholder: 'Escolha...',
        enabled: 'Habilitado',
        disabled: 'Desabilitado'
      },
      description: {
        value: 'Descrição',
        placeholder: 'Descrição'
      },
      creationDateTimeFrom: {
        value: 'Data de criação desde',
        placeholder: 'Data de criação desde'
      },
      creationDateTimeTo: {
        value: 'Data de criação até',
        placeholder: 'Data de criação até'
      }
    },
    communicationm_table: {
      id: 'Id',
      name: 'Nome',
      countryReception: 'País de receção',
      docTypeName: 'Tipo de documento',
      description: 'Descrição',
      creationDateTime: 'Data de criação',
      enable: 'Ativo',
      disabled: 'Inativo',
      byCountryEmission: 'Por país de emissão',
    },
    msg_generics: {
      saving: 'Guardar os dados de comunicação',
      enable: 'Habilitado',
      disable: 'Desabilitado',
      no_match: 'Nenhuma correspondência encontrada',
      advanced_search: 'Busca avançada',
      search: 'Buscar',
      popover_clean_filters: 'Limpar filtros'
    },
    notify: {
      save_changes: 'O estado foi atualizado',
      error_save_changes: 'O estado não foi atualizado'
    }
  },
  articles: {
    filters: {
      id: { value: 'ID do artigo', placeholder: 'Introduza o ID do artigo' },
      seller: { value: 'Vendedor', placeholder: 'Selecione vendedores' },
      buyer: { value: 'Comprador', placeholder: 'Selecione compradores' },
      itemCode: { value: 'Código do artigo (exato)', placeholder: 'Introduza o código exato' },
      itemCodeLike: { value: 'Código do artigo (like)', placeholder: 'Introduza o código (caracteres curinga permitidos)' },
      startIndexOfLikeCharacters: { value: 'Índice mínimo do like', placeholder: 'Introduza o índice mínimo' },
      description: { value: 'Descrição (like)', placeholder: 'Introduza a descrição' },
      creationDateTimeFrom: { value: 'Data de criação desde', placeholder: 'Selecione a data inicial' },
      creationDateTimeTo: { value: 'Data de criação até', placeholder: 'Selecione a data final' },
      futureGrossPriceDateFrom: { value: 'Atualização de preço futuro desde', placeholder: 'Selecione a data inicial' },
      futureGrossPriceDateTo: { value: 'Atualização de preço futuro até', placeholder: 'Selecione a data final' },
      pendingUpdate: { value: 'Pendentes de atualização', placeholder: 'Selecione uma opção' },
      enabled: { value: 'Ativo', placeholder: 'Selecione o estado' }
    },
    table: {
      seller: 'Vendedor',
      buyer: 'Comprador',
      itemCode: 'Código do artigo',
      itemDescription: 'Descrição',
      grossPrice: 'Preço bruto',
      futureGrossPriceDate: 'Próxima alteração de preço',
      futureGrossPrice: 'Novo preço',
      creationDateTime: 'Data de criação',
      enable: 'Ativo'
    },
    msg_generics: {
      enabled: 'Ativado',
      filter_table_menu: 'Menu de colunas',
      popover_clean_filters: 'Limpar filtros',
      load_init: 'A carregar resultados…',
      order_table: 'A ordenar a tabela…',
      size_table: 'A atualizar o tamanho da página…',
      pagination_table: 'A mudar de página…',
      saving: 'A guardar alterações…',
      filter_date: 'A filtrar por data…',
      filter_delete: 'A remover filtro…',
      filter_delete_all: 'A remover todos os filtros…',
      no_match: 'Sem correspondências',
      advanced_search: 'Pesquisa avançada',
      disabled: 'Desativado'
    },
    notify: {
      save_changes: 'Alterações guardadas com sucesso',
      error_save_changes: 'Erro ao guardar alterações',
      no_articles_found: 'Nenhum artigo encontrado com os filtros especificados',
      updating: 'Atualizando...',
      updated: 'Atualizado com sucesso',
      error_updating: 'Erro ao atualizar artigos'
    },
    buttons: {
      add_article: 'Adicionar',
      article_created: 'Artigo criado com sucesso',
      cancel_new_article: 'Cancelar'
    }
  },
  profiles: {
    new: 'Novo profile',
    filters: {
      name: {
        value: 'Profile',
        placeholder: 'Nome profile'
      },
      description: {
        value: 'Descrição',
        placeholder: 'Descrição'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      }
    },
    notify: {
      add_profile: 'Perfil criado com sucesso',
      delete_profile: 'Perfil eliminado com sucesso',
      save_changes: 'O perfil foi atualizado com sucesso'
    },
    confirm: {
      delete_profile: 'Você tem certeza de deletar o perfil?'
    },
    load: {
      add_profile: 'Adicionando o perfil ...',
      delete_profile: 'Rimozione del profilo ...'
    },
    profiles_table: {
      name: 'Profile',
      description: 'Descrição',
      project: 'Serviço'
    },
    profiles_auth: {
      name: 'Nome',
      description: 'Descrição',
      module: 'Módulo'
    }
  },
  form_new_role: {
    new_role: 'Criar novo perfil',
    service: 'Serviço',
    urole: 'Profile *',
    delete: 'Apagável',
    description: 'Descrição *',
    submit: 'Aceitar',
    permisos: 'Permissões',
    diálogo: {
      delete: 'É apagável?',
      service: 'Escolha o serviço',
      permisos: 'Escolha permissões'
    }
  },
  taxes: {
    new: 'Novo imposto',
    filters: {
      type: {
        value: 'Tipo de imposto',
        placeholder: 'Tipo imposto'
      },
      rate: {
        value: 'Taxa',
        placeholder: 'Taxa'
      },
      enabled: {
        value: 'Ativo',
        placeholder: 'Escolha...'
      },
      country: {
        value: 'País',
        placeholder: 'País'
      },
      validity_date_from: {
        value: 'Data válida de',
        placeholder: 'Data válida de'
      },
      validity_date_to: {
        value: 'Data válida até',
        placeholder: 'Data válida até'
      },
      legal_text: {
        value: 'Motivo',
        placeholder: 'Motivo'
      },
      taxable_event: {
        value: 'Evento tributável'
      }
    },
    notify: {
      add_tax: 'Imposto criado com sucesso.',
      delete_tax: 'O imposto foi excluído.',
      save_changes: 'O imposto foi atualizado.'
    },
    confirm: {
      delete_tax: 'Tem certeza que deseja deletar o imposto?'
    },
    load: {
      add_tax: 'Adicionando imposto ...',
      delete_tax: 'Excluindo imposto ...'
    },
    taxes_table: {
      type: 'Tipo imposto',
      rate: 'Taxa',
      country: 'País',
      validity_date_from: 'Data válida de',
      validity_date_to: 'Data válida até',
      enable: 'Ativo'
    },
    rules_form: {
      validity_date_msg: 'A data de validade de não pode ser posterior à data de validade até',
      duplicated_text: 'Valor duplicado. O texto legal associado ao imposto já existe.'
    },
    validity_date: 'Data válida',
    delete_tax: 'Eliminar',
    delete_tax_tooltip: 'Eliminar imposto',
    no_legalTex: 'Imposto sem textos legais',
    add_legalText_tooltip: 'Carregar texto legal'
  },
  userInformation: {
    title: 'Informação',
    validity_date: 'Período de validade',
    message: 'Mensagem',
    message_placeholder: 'Escreva a mensagem a apresentar',
    close: 'Fechar',
    dont_show_again: 'Não voltar a mostrar esta mensagem',
    rules: {
      message_required: 'Deve introduzir uma mensagem',
      date_range: 'A data de início não pode ser posterior à data de fim'
    },
    notify: {
      warning: 'Aviso',
      error: 'Erro',
      saved_title: 'Guardado',
      deleted_title: 'Eliminado',
      created: 'Mensagem criada com sucesso',
      updated: 'Mensagem atualizada com sucesso',
      deleted: 'Mensagem eliminada com sucesso',
      load_error: 'Não foi possível carregar a mensagem informativa',
      save_error: 'Não foi possível guardar a mensagem informativa',
      delete_error: 'Não foi possível eliminar a mensagem informativa'
    }
  },
  mailServer: {
    new: 'Novo servidor de e-mail',
    notify: {
      add_mailServer: 'Servidor de correio criado com sucesso',
      delete_mailServer: 'Servidor de email excluído com sucesso.',
      save_changes: 'Servidor de e-mail atualizado com sucesso'
    },
    confirm: {
      delete_mailServer: 'Tem certeza que deseja deletar o servidor de e-mail?'
    },
    load: {
      add_mailServer: 'Adicionando servidor de e-mail ...',
      delete_mailServer: 'Excluindo servidor de e-mail ...'
    },
    mailServer_table: {
      host: 'Host',
      user: 'Usuário',
      password: 'senha',
      mailfrom: 'Endereço de e-mail de origem',
      port: 'porta',
      auth: 'Auth',
      protocol: 'Protocolo',
      idClient: 'ID do Cliente',
      idTenant: 'ID da Organização',
      clientSecret: 'Segredo do Cliente',
      validityDateTo: 'Data de validade do acesso',
      saveToSentItems: 'Salvar Emails Enviados'
    },
    test_error: 'Não foi possível estabelecer conexão com o servidor de e-mail',
    test_ok: 'A conexão com o servidor de e-mail foi bem-sucedida',
    auth_error: 'Ocorreu um erro de autenticação',
    delete_mailServer: 'Delete',
    delete_mailServer_tooltip: 'Excluir servidor de e-mail',
    test_tooltip: 'Verificar conexão',
    test: 'Verificar',
    duplicate_error: 'Já existe um servidor de e-mail com esses dados'
  },
  user_detail: {
    info_user: 'Informação utilizador',
    new_role: 'Criar perfil',
    user_detail_edit_form: {
      name: 'Nome',
      first_surname: 'Sobrenome',
      second_surname: 'Segundo sobrenome',
      id_number: 'Identificador fiscal',
      department: 'Departamento',
      enable: 'Estado inativo/ativo'
    },
    delete_user: 'Eliminar',
    delete_user_tooltip: 'Eliminar utilizador',
    duplicate_user: 'Duplicar',
    duplicate_user_tooltip: 'Usuário duplicado',
    reset_pass_user: 'Reiniciar senha',
    user_media: 'Dados de contacto',
    no_user_media: 'Este utilizador não tem dados de contacto',
    add_user_media: 'Carregar',
    add_user_media_tooltip: 'Carregar dados de contacto',
    user_media_table: {
      media_type_name: 'Tipo de contacto',
      value: 'Contacto'
    },
    dialog_add_user_media: {
      title: 'Dados de contacto',
      media_type_name: 'Tipo de contacto',
      value: 'Contacto',
      button_add: 'Carregar'
    },
    dialog_change_user_email: {
      title: 'Novo correio eletrónico do usuário',
      old_email: 'Correio eletrónico atual',
      new_email: 'Novo correio eletrónico',
      button_add: 'Atualizar'
    },
    user_entity: 'Entidades de utilizador',
    no_user_entity: 'Este utilizador não tem nenhuma entidade de utilizador',
    add_user_entity: 'Carregar',
    add_user_entity_tooltip: 'Carregar entidade de utilizador',
    user_entity_table: {
      project_name: 'Nome de serviço',
      party_tax_identification_number: 'Empresa/Id fiscal',
      centre_code: 'Código/centro'
    },
    dialog_add_user_entity: {
      title: 'Entidades de utilizador',
      project_name: 'Nome de serviço',
      option_all_project: 'Todos',
      party_tax_identification_number: 'Empresa/Id fiscal',
      option_all_party: 'Todas',
      centre_code: 'Código/centro',
      option_all_centre: 'Todos',
      button_add: 'Carregar'
    },
    roles_authorities: 'Perfis/Autorizações',
    no_user_authorities: 'Este usuário não tem permissões',
	no_user_authorities_sign: 'Este usuário não possui permissões para esta empresa',
    option_all_project_roles_authorities: 'Todas',
    roles: 'Perfis',
    authorities: ' Autorizações',
    add_new_role: 'Criar',
    save_roles_authorities: 'Salvar',
    add_new_role_tooltip: 'Criar novo perfil',
    save_roles_authorities_tooltip: 'Salvar alterações',
    cancel_roles_authorities: 'Cancelar',
    cancel_roles_authorities_tooltip: 'Cancelar alterações',
    load: {
      delete_user_media: 'Eliminando Dados de contacto ...',
      add_user_media: 'Adicionando Dados de contacto ...',
      add_user_entity: 'Adicionando Entidade do Utilizador ...',
      delete_user_entity: 'Eliminando Entidade do Utilizador ...',
      change_roles_user: 'Alterando autorizações do Utilizador ...',
      init_user_data: 'Carregamento dos dados do utilizador ...',
      change_user_email: 'Atualizando correio eletrónico do usuário ...'
    },
    notify: {
      reset_password_ok: 'A nova senha foi enviada ao email',
      delete_user_media: 'Dado de contacto eliminado com sucesso.',
      add_user_media: 'Dado de contacto adicionado com sucesso.',
      add_role: 'El perfil se ha creado correctamente.',
      add_user_entity: 'Entidade de utilizador adicionada com sucesso.',
      add_user_entity_repeat: 'O utilizador já tem atribuída essa entidade',
      add_user_entity_validateko: 'A entidade a ser adicionada foi previamente contemplada',
      delete_user_entity: 'Entidade de utilizador eliminada com sucesso.',
      delete_user_entityko: 'Não é possível eliminar,o utilizador deve ter pelo menos uma entidade',
      delete_user_ok: 'Utilizador eliminado com sucesso',
      save_user_entityko: 'Não é possível actualizar,o utilizador deve ter pelo menos uma entidade',
      change_user_email: 'Correio eletrónico do usuário atualizado com sucesso.'
    },
    confirm: {
      title_delete_user: 'Tem certeza de que deseja eliminar este utilizador?',
      message_delete_user: 'Esta ação excluirá todas as informações relacionadas ao usuário. Recomenda-se desativar o usuário.',
      confirm_button_delete_user: 'Eliminar',
      title_reset_password: 'Tem certeza de que deseja alterar a senha deste utilizador?',
      confirm_button_reset_password: 'Alterar',
      title_delete_user_media: 'Tem certeza de que deseja eliminar estes dados de contacto?',
      confirm_button_delete_user_media: 'Eliminar',
      title_delete_user_entity: 'Tem certeza de que deseja eliminar esta entidade de utilizador?',
      confirm_button_delete_user_entity: 'Eliminar',
      change_user_email: 'O usuário deve ter um correio eletrónico como informação de contato. Para excluir o correio eletrónico atual, você deve inserir um novo correio eletrónico.',
	  service_account_title: 'Acesso via serviço',
	  service_account_ok_message: 'Este usuário só pode acessar por meio de canais de integração.',
	  service_account_ko_message: 'Este usuário só pode acessar pelo portal.',
	  service_account_ok: 'Acesso por serviço atualizado'
    }
  },

  // Recepciones emitidas y recibidas
  recadv: {
    number: {
      max: 'O número de recepções não pode ser superior a 100'
    },
    filters: {
      creation_date: {
        value: 'Data-hora do registo'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      delivery_date: {
        value: 'Intervalo datas de entrega',
        placeholder: 'Datas de entrega'
      },
      reception_date: {
        value: 'Intervalo datas de recepção',
        placeholder: 'Datas de recepção'
      },
      recadv_number: {
        value: 'Nº recepção',
        placeholder: 'Recepção'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      order_number: {
        value: 'Nº encomenda',
        placeholder: 'Encomenda'
      },
      delivery_number: {
        value: 'Nº nota de entrega',
        placeholder: 'Nota de entrega'
      },
      invoice_recadv: {
        value: 'Nº fatura',
        placeholder: 'Fatura'
      }
    },
    recadv_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      num_recadv: 'N.Recepção',
      date_receiving: 'D.Recepção',
      date_creation: 'D.Registo',
      status: 'Estado',
      services: 'Serviço',
      invoice_recadv: 'N.Fatura',
      buyer_centre: 'Centro comprador',
      delivery_centre: 'Lugar de entrega',
      seller_centre: 'Centro vendedor',
      csv_title: 'Exportar para CSV. Em formação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, por favor, restrinja sua pesquisa',
      csv_details_message: 'Você não pode exportar linhas de mais de 200 documentos, por favor, restrinja sua pesquisa',
	  total_amount: "Montante total",
    },
    recadv_entity_table_detail: {
      code: 'Código item',
      lineNumber: 'Nº lin',
      description: 'Descrição',
      itemCodeSeller: 'Code. item do vendedor',
      itemCodeBuyer: 'Cod. item do comprador',
      deliveryNoteNumber: 'Nota de entrega',
      deliveryNoteLine: 'Linha de nota de entrega',
      order: 'Encomenda',
      despatch_quantity: 'Quantidade anunciada',
      received_quantity: 'Quantidade recebida',
      accepted_quantity: 'Quantidade aceite',
      measure: 'Unidade de medida',
      price: 'Preço unitário',
      currency: 'Divisa',
      status: 'Estado',
      options: 'Opções',
      subtype: 'Subtipo'
    },
    recadv_related_documents_table: {
      date: 'Data de relacionamento',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo documento'
    },

    recadv_detail: {
      recadv_line_no_data: 'Este pedido não tem linhas',
      create_invoice_buttons: 'Criar',
      activate_recadv_buttons: 'Ativar',
      rejected_recadv_buttons: 'Rejeitar',
      recadv_line_no_date: 'Esta recepção não tem linhas',
      related_documents_no_data: 'Esta recepção não possui documentos relacionados',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF recepção',
      create_invoice_buttons_tooltip: 'Criar fatura',
      activate_recadv_buttons_tooltip: 'Ativar recepção',
      rejected_recadv_buttons_tooltip: 'Rejeitar recepção',
      rejected_recadv_lineErro: 'Linha de assimetria',
      download_pdfmultiple_buttons: 'Baixar',
      download_pdfmultiple_buttons_tooltip: 'Baixar recepção\\ões',
      create_line_buttons_tooltip: 'Criar linha de assimetria',
      edit_line_buttons_tooltip: 'Editar linha de assimetria',
      related_documents: 'Documentos relacionados',
      reception_lines: 'Linhas de recepção',
      edit: 'Editar',

      dialog_rejected_recadv: {
        title: 'Rejeição de recepção',
        value: 'Motivo',
        placeholder: 'Motivo de rejeição',
        motive_required: 'Motivo obrigatório'
      },

      change_state: {
        label: 'Mudança de status',
        placeholder: 'Escolha um estado de recebimento',
        load: 'Atualizando dados de recibo ...'
      },

      dialog_new_check_line_recadv: {
        title: 'Nova linea de recepção',
        title_edit: 'Editar linea de recepção',
        description: 'Descrição item',
        quantity: 'Quantidade',
        priceUnit: 'Preço Und.',
        date_required: 'Campo obrigatório',
        measure: 'Medida',
        measureUnit: {
          PCE: 'Peças',
          KGM: 'Quilogramas',
          MTR: 'Metro linear',
          TNE: 'Tonelada',
          LTR: 'Litro',
          MTQ: 'Metro cúbico',
          DMQ: 'Dcm. cúbico',
          CENT: 'Centenas',
          MILL: 'Milhares',
          MTK: 'M. quadrados',
          BOX: 'Caixa',
          BOTL: 'Garrafa',
          NTBK: 'Caderno',
          GRM: 'Grama',
          GRSA: 'Grossa',
          SHEE: 'Folha',
          GAME: 'Jogo',
          PAR: 'Par',
          OVLL: 'Novelo',
          CARR: 'Carreto',
          PACK: 'Pacote',
          DOCE: 'Dúzia',
          K: 'K',
          R: 'R',
          B: 'B',
          UN: 'Unidades'
        },
        search_measure: 'Escolha a unidade de medida'
      },

      notify: {
        submit_edit_recadv_ok: 'O status do recibo foi modificado com sucesso',
        recadv_rejected: 'A recepção foi rejeitada com sucesso',
        recadv_activate: 'A recepção foi ativada',
        download_pdf: 'O download do ficheiro {file} foi bem sucedido.',
        recadv_new_line: 'Uma nova linha de assimetria foi criada com sucesso',
        recadv_edit_line: 'A linha de assimetria foi alterada com sucesso'
      },
      load: {
        recadv_rejected: 'Rejeitando recepção',
        recadv_activate: 'Ativando recepção'
      },
      confirm: {
        title_recadv_activate: 'A recepção {recadvID} do fornecedor {sellerName} será ativada. Deseja continuar?',
        confirm_button_recadv_activate: 'Aceitar'
      }
    }
  },
  // Albaranes
  delivery: {
    number: {
      max: 'O número de entregas não pode ser superior a 30'
    }
  },
  // Pedidos emitidos y recibidos
  order: {
    number: {
      max: 'O número de pedidos não pode ser superior a 20'
    },
    filters: {
      creation_date: {
        value: 'Data-hora do registo'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Insire 3 caracteres'
      },
      delivery_date: {
        value: 'Intervalo datas de entrega',
        placeholder: 'Datas de entrega'
      },
      order_date: {
        value: 'Intervalo datas de pedido',
        placeholder: 'Datas de pedido'
      },
      issue_date: {
        value: 'Intervalo datas emissão',
        placeholder: 'Data incidências'
      },
      order_number: {
        value: 'Nº pedido',
        placeholder: 'Pedido'
      },
      deliveryNote_number: {
        value: 'Nº nota de entrega',
        placeholder: 'Nota de entrega'
      },
      invoice_number: {
        value: 'Nº fatura',
        placeholder: 'Fatura'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      invoice_order: {
        value: 'Nº fatura',
        placeholder: 'Fatura'
      },
      orderType: {
        value: 'Tipo',
        placeholder: 'Tipo de pedido'
      },
      orderSubType: {
        value: 'Subtipo',
        placeholder: 'Subtipo de pedido'
      },
      deliveryDateFrom: {
        value: 'Data entrega de',
        placeholder: 'Data entrega de'
      },
      deliveryDateTo: {
        value: 'Data entrega até',
        placeholder: 'Data entrega até'
      },
      no_error_status: {
        value: 'Estados excluidos',
        placeholder: 'Estados excluidos',
        rejected: 'Estados rejeitados'
      }
    },
    order_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      num_order: 'N. pedido',
      date_creation: 'D. registo',
      date_issue: 'F. emissão',
      status: 'Estado',
      services: 'Serviço',
      invoice_order: 'N. fatura',
      buyer_centre: 'Centro comprador',
      seller_centre: 'Centro vendedor',
      delivery_centre: 'Lugar de entrega',
      order_type: 'Tipo',
      delivery_date_from: 'D. entrega de',
      delivery_date_to: 'D. entrega até',
      csv_title: 'Exportar para CSV. Em formação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, restrinja sua pesquisa',
      csv_details_message: 'Você não pode exportar linhas de mais de 100 documentos, por favor, restrinja sua pesquisa'
    },
    order_entity_table_detail: {
      code: 'Código item',
      lineNumber: 'Nº lin',
      itemCode: 'Código do artigo',
      itemCodeSeller: 'Cód. artigo vendedor',
      itemCodeBuyer: 'Cód. artigo comprador',
      gtin14Code: 'Cód. GTIN14',
      delivery_centre: 'Lugar de entrega',
      quantity: 'quantidade',
      description: 'Descrição',
      order: 'Encomenda',
      despatch_quantity: 'Quantidade anunciada',
      received_quantity: 'Quantidade recebida',
      accepted_quantity: 'Quantidade aceite',
      measure: 'Unidade de medida',
      unitPrice: 'Preço unitário',
      totalAmount: 'Preço total da linha',
      deliveryDate: 'Data de entrega',
      documentStatus: 'Status da linha',
      currency: 'Divisa',
      status: 'Estado',
      options: 'Opções',
      notes: 'Notas',
      quantityTradeUnit: 'Quantidade embalagem',
      measureTradeUnit: 'Unidade de medida embalagem',
      netPrice: 'Preço liquido',
      grossPrice: 'Preço bruto',
      quantityRemaining: 'Quantidade restante',
      change_state: {
        title: 'Mudança de status de linea de pedido',
        label: 'Mudança de status de linea',
        placeholder: 'Escolha um status de linea',
        load: 'Atualizando dados de linea de pedido ...'
      }
    },
    order_related_documents_table: {
      date: 'Data de relacionamento',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo documento'
    },
    order_charges_discounts_table: {
      chargeDiscountTypeCode: 'Descrição',
      charge: 'Tipo',
      charge_code: {
        TD: 'Descontos comerciais',
        EAB: 'Descontos pagamento antecipado',
        ABH: 'Descontos por volume ou rapel',
        ACQ: 'Sociedade Canon de Autores',
        MC: 'Taxa de farinha de carne',
        VEJ: 'Ponto verde',
        AA: 'Taxa de publicidade'
      },
      rate: 'Taxa (em %)',
      baseAmount: 'Valor base',
      amount: 'Valor',
      currencyCode: 'Moeda',
      sequence: 'Seqüência'
    },
    order_detail: {
      create_invoice_buttons: 'Criar',
      activate_order_buttons: 'Ativar',
      rejected_order_buttons: 'Rejeitar',
      order_line_no_data: 'Esta pedido não tem linhas',
      related_documents_no_data: 'Este pedido não possui documentos relacionados',
      charge_discounts_no_data: 'Este pedido não tem cobranças e descontos',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF pedido',
      create_invoice_buttons_tooltip: 'Criar fatura',
      create_deliveryNote_buttons_tooltip: 'Criar note de entrega',
      activate_order_buttons_tooltip: 'Ativar pedido',
      rejected_order_buttons_tooltip: 'Rejeitar pedido',
      rejected_order_lineError: 'Linha de assimetria',
      download_pdfmultiple_buttons: 'Baixar',
      download_pdfmultiple_buttons_tooltip: 'Baixar pedido\\ões',
      create_line_buttons_tooltip: 'Criar linha de assimetria',
      edit_line_buttons_tooltip: 'Editar linha de assimetria',

      change_line_status_buttons_tooltip: 'Mudança de status de linea de pedido',
      change_line_status_buttons: 'Mudança status',

      order_lines: 'Linhas de pedido',
      related_documents: 'Documentos relacionados',
      charge_discount: 'Encargos e descontos',
      edit: 'Editar',
      order_reponse: 'Respostas do pedido',
      order_reponse_download_tooltip: 'Baixar resposta',
      order_reponse_number: 'Resposta No.',
      order_reponse_name: 'Nome',
      order_reponse_date: 'F. Registro',
      order_response_no_data: 'Esta pedido não tem repostas',

      dialog_rejected_order: {
        title: 'Rejeição de pedido',
        value: 'Motivo',
        placeholder: 'Motivo de rejeição',
        motive_required: 'Motivo obrigatório'
      },

      dialog_new_check_line_order: {
        title: 'Nova linea de pedido',
        title_edit: 'Editar linea de pedido',
        description: 'Descrição item*',
        quantity: 'Quantidade*',
        priceUnit: 'Preço Und.*',
        date_required: 'Campo obrigatório'
      },
      dialog_accept_order: {
        title: 'Aceite pedido e gere resposta',
        orderResponseNumberLabel: 'Numero para resposta da pedido'
      },
      change_state: {
        label: 'Mudança de status',
        placeholder: 'Escolha um status de pedido',
        load: 'Atualizando dados de pedido ...'
      },
      notify: {
        submit_edit_order_ok: 'O status de pedido foi modificado com sucesso',
        order_rejected: 'A pedido foi rejeitada com sucesso',
        order_activate: 'A pedido foi ativada',
        download_pdf: 'O download do ficheiro {file} foi bem sucedido.',
        order_new_line: 'Uma nova linha de assimetria foi criada com sucesso',
        order_edit_line: 'A linha de assimetria foi alterada com sucesso',
        line_error: 'Você não pode selecionar linhas inválidas para criar a fatura'
      },
      load: {
        order_rejected: 'Rejeitando pedido',
        order_activate: 'Ativando pedido'
      },
      confirm: {
        title_order_activate: 'A pedido {orderID} do fornecedor {sellerName} será rejeitada. Deseja continuar?',
        title_order_reject: 'A pedido {orderID} do fornecedor {sellerName} será ativada. Deseja continuar?',
        confirm_button_order_activate: 'Aceitar'
      }
    }
  },
  // reporte de ventas.
  sales_report: {
    number: {
      max: 'O número do relatório não pode exceder 35 caracteres'
    },
    filters: {
      service: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecione um vendedor'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecione um comprador'
      },
      store: {
        value: 'Ponto de venda',
        placeholder: 'Selecione um ponto de venda'
      },
      document_number: {
        value: 'Nº relatório',
        placeholder: 'Número do relatório'
      },
      sale_date: {
        value: 'Intervalo data de venda',
        placeholder: 'Selecione um intervalo de data de venda'
      },
      article_code: {
        value: 'Código do artigo',
        placeholder: 'Código do artigo'
      },
      creation_date: {
        value: 'Data-hora do registo'
      }
    },
    sales_report_entity_table: {
      slsrpt_number: 'Nº relatório',
      service: 'Serviço',
      seller: 'Vendedor',
      buyer: 'Comprador',
      centre_buyer: 'Ponto de venda',
      issue_date: 'Data de emissão',
      creation_date_time: 'Data de registro',
      status: 'Estado',
      expiration_date_time: 'Data de expiração',
      csv_title: 'Exportar para CSV. Informação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, por favor refine sua busca'
    },
    sales_report_entity_table_detail: {
      lineNumber: 'Nº linha',
      itemCode: 'Código do artigo',
      itemDescription: 'Descrição do artigo',
      quantitySales: 'Quantidade vendida',
      quantityReturn: 'Quantidade devolvida',
      salesDate: 'Data da venda',
      centre_buyer: 'Ponto de venda'
    },
    sales_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF do relatório de vendas',
      sales_report_lines: 'Linhas do relatório de vendas',
      edit: 'Editar',
      related_documents: 'Documentos relacionados',
      related_documents_no_data: 'Este relatório não possui documentos relacionados',
      sales_report_line_no_data: 'Este relatório não possui linhas',
      notify: {
        download_pdf: 'O arquivo {file} foi baixado com sucesso.'
      },
      load: {
        download_pdf: 'Baixando PDF do relatório de vendas ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Baixar CSV',
      download_original_tooltip: 'Baixar original'
    }
  },
  // reporte de inventario.
  inventory_report: {
    number: {
      max: 'O número do relatório não pode exceder 35 caracteres'
    },
    filters: {
      service: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecione um vendedor'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecione um comprador'
      },
      store: {
        value: 'Ponto de inventário',
        placeholder: 'Selecione um ponto de inventário'
      },
      document_number: {
        value: 'Nº relatório',
        placeholder: 'Número do relatório'
      },
      quantity_incoming_date: {
        value: 'Intervalo data de inventário',
        placeholder: 'Selecione um intervalo de data de inventário'
      },
      article_code: {
        value: 'Código do artigo',
        placeholder: 'Código do artigo'
      },
      creation_date: {
        value: 'Data-hora do registo'
      }
    },
    inventory_report_entity_table: {
      invrpt_number: 'Nº relatório',
      service: 'Serviço',
      seller: 'Vendedor',
      buyer: 'Comprador',
      centre_buyer: 'Ponto de inventário',
      issue_date: 'Data de emissão',
      creation_date_time: 'Data de registro',
      status: 'Estado',
      expiration_date_time: 'Data de expiração',
      csv_title: 'Exportar para CSV. Informação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, por favor refine sua busca'
    },
    inventory_report_entity_table_detail: {
      lineNumber: 'Nº linha',
      itemCode: 'Código do artigo',
      itemDescription: 'Descrição do artigo',
      quantityTarget: 'Quantidade em inventário',
      quantityIncoming: 'Quantidade em entrada',
      quantityStock: 'Quantidade em stock',
      quantityIncomingDate: 'Data do inventário',
      centre_buyer: 'Ponto de venda'
    },
    inventory_report_detail: {
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF do relatório de inventário',
      inventory_report_lines: 'Linhas do relatório de inventário ',
      edit: 'Editar',
      related_documents: 'Documentos relacionados',
      related_documents_no_data: 'Este relatório não possui documentos relacionados',
      inventory_report_line_no_data: 'Este relatório não possui linhas',
      notify: {
        download_pdf: 'O arquivo {file} foi baixado com sucesso.'
      },
      load: {
        download_pdf: 'Baixando PDF do relatório de inventário ...'
      }
    },
    buttons: {
      download_csv_tooltip: 'Baixar CSV',
      download_original_tooltip: 'Baixar original'
    }
  },
  // Traduções REMADV
  remadv: {
    buttons: {
      download_csv_tooltip: 'Baixar CSV remadv',
      download_original_tooltip: 'Baixar original'
    },
    remadv_entity_table: {
      service: 'Serviço',
      seller: 'Vendedor',
      buyer: 'Comprador',
      invoicee_centre: 'Centro faturado',
      remadv_number: 'Nº aviso de liquidação',
      invoice_number: 'Nº fatura',
      issue_date: 'Data emissão',
      document_date: 'Data documento',
      total_amount: 'Valor liquidação',
      currency: 'Divisa',
      creation_date_time: 'Data criação',
      status: 'Estado',
      payment_date: 'Data pagamento',
      notes: 'Notas'
    },
    lines_remadv_entity_table: {
      line_number: 'Nº linha',
      document_number: 'Nº documento',
      document_date: 'Data emissão',
      description: 'Descrição',
      centre_code: 'Faturador',
      document_amount: 'Total',
      currency: 'Divisa',
      payment_date: 'Data pagamento'
    },
    remadv_detail: {
      remadv_lines: 'Linhas do aviso de liquidação',
      remadv_line_no_data: 'Este aviso de liquidação não tem linhas'
    },
    csv_title: 'Exportar para CSV. Informação',
    csv_message: 'Não é possível exportar mais de {argumento} registros, por favor restrinja a pesquisa',
    csv_details_message: 'Não é possível exportar linhas de mais de 100 documentos, por favor restrinja a pesquisa',
    filters: {
      service: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Selecione um vendedor'
      },
      buyer: {
        value: 'Comprador',
        placeholder: 'Selecione um comprador'
      },
      centre_payer: {
        value: 'Centro faturado',
        placeholder: 'Selecione um centro faturado'
      },
      remadv_number: {
        value: 'Nº aviso de liquidação',
        placeholder: 'Nº aviso de liquidação'
      },
      invoice_number: {
        value: 'Número fatura',
        placeholder: 'Número fatura'
      },
      issue_date: {
        value: 'Intervalo data emissão',
        placeholder: 'Selecione um intervalo de data emissão'
      },
      document_date: {
        value: 'Intervalo data documento',
        placeholder: 'Selecione um intervalo de data documento'
      },
      total_amount_from: {
        value: 'Valor liquidação desde',
        placeholder: 'Valor liquidação desde'
      },
      total_amount_to: {
        value: 'Valor liquidação até',
        placeholder: 'Valor liquidação até'
      },
      validation: {
        amount_range: 'O valor inicial não pode ser maior que o valor final'
      },
      creation_date: {
        value: 'Data-hora de registro'
      }
    }
  },
  cmr: {
    cmr_entity_table_detail: {
      cargo_general_data: 'Mercadoria',
      cargo_general_data_tooltip: 'Dados gerais da mercadoria',
      sent: 'Enviado',
      general_data: 'Dados gerais',
      document_control: 'Documento de Controle',
      cmr: 'CMR',
      cmrNumber: 'Nº documento de transporte',
      group: 'Grupo',
      order: 'Pedido',
      loadparty: 'Cargador',
      load: 'Lugar de origen',
      shipper: 'Cargador',
      buyer: 'Destinatario',
      seller_centre: 'Lugar de origen',
      buyer_centre: 'Lugar de destino',
      loadcode: 'Código do lugar de origen',
      loaddirection: 'Endereço do lugar de origen',
      deliveryparty: 'Destinatario',
      delivery: 'Lugar de destino',
      deliverycode: 'Código do lugar de destino',
      deliverydirection: 'Endereço do lugar de destino',
      dateCreation: 'D. registro',
      status: 'Estado',
      service: 'Serviço',
      numpackages: 'Num paquetes',
      weight: 'Peso',
      cmrlines: 'Linhas de documento de transporte',
      cmrObservation: 'Observaciones/Incidencias de documento de transporte',
      addObservationTitle: 'Añadir observación/incidencia',
      addObservationOk: 'Añadida correctamente la observación/incidencia al documento de transporte',
      observation: 'Observación/incidencia',
      deleteObservation: 'Eliminar observación/incidencia',
      addLineTitle: 'Adicionar linha',
      deleteLineTitle: 'Eliminar linha',
      deleteLine: 'Eliminar linha',
      deleteLineOk: 'Eliminada linha corretamente',
      cannot_delete_last_line: 'Não é possível eliminar a última linha',
      must_keep_one_line: 'Deve existir pelo menos uma linha, se desejar eliminar esta linha deverá adicionar uma nova linha previamente',
      addLineOk: 'Linha adicionada corretamente',
      sendlink: 'Enviar',
      sendlink_tooltip: 'Aceitar/Enviar link',
      sendlink_ok: 'link enviado corretamente',
      sendlink_confirm: '¿Desea confirmar y enviar el enlace?',
      changeplates: 'Datos de transporte',
      changeplates_tooltip: 'Alteração de condutor, placas e dados da transportadora',
      changeplates_confirm: 'Deseja alterar as matrículas do veículo?',
      changeplates_ok: 'Dados atualizados corretamente',
      changeobservations: 'Observações/Incidências',
      changeobservations_tooltip: 'Adicionar observação/incidência',
      changegeneralobservations: 'Observações',
      changegeneralobservations_tooltip: 'Observações gerais',
      changeobservations_confirm: 'Deseja alterar as observações?',
      changeobservations_ok: 'Observaciones/incidencias actualizadas correctamente',
      updatestatus: 'Estado',
      updatestatus_tooltip: 'Alterar estado',
      updatestatus_ok: 'Estado atualizado corretamente',
      plate: 'Placa do veículo trator',
      trailerplate: 'Registro de semirreboque',
      secondTrailerplate: 'Registro de trailer',
	  id_cmr: 'Id interno',
      cmrnolines: 'Este documento de transporte no tiene líneas',
      cmrnoObservations: 'Este documento de transporte não contém observações/incidencias',
      events: 'Eventos',
      download_attach: 'Descargando adjunto',
      linecode: 'Código',
      linecodeseller: 'Código item de fornecedor',
      download_pdf: 'Descargar PDF',
      download_original: 'Original',
      download_metadata: 'Metadata',
      line: 'Linha',
      csv_title: 'Exportar para CSV. Em formação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, por favor, restrinja sua pesquisa',
      description: 'Descrição/Naturaleza',
      transportist_data: 'Datos del transportista',
      transportist_search: {
        title: 'Pesquisar transportador',
        col_name: 'Nome',
        col_nif: 'NIF',
        col_email: 'Email'
      },
      warn_required_fields: 'Datos opcionales en borradores que deben cumplimentarse obligatoriamente antes de enviar el documento al transportista',
      warn_required_fields_stop: 'Esta información es obligatoria si no se incluyen paradas por tratarse de una unica entrega',
      charger_observations: 'Observaciones del cargador',
      transportist_observations: 'Observaciones del transportista',
      observation_type: 'Tipo de observación/incidencia',
      transportist_name: 'Transportista',
      transportist_nif: 'NIF del transportista',
      transportist_email: 'Email del transportista/conductor',
      emailTransportist: 'Email do transportador/condutor',
      email_conductor: 'Email do condutor',
      conductor: 'Condutor',
      email_link_note: 'Este é o email para o qual será enviado o link do pdf',
      observation_type_values: {
        INCIDENCE: 'Incidência',
        UNPLANNEDSTOP: 'Paragem não planeada',
        DELIVERYNOTES: 'Notas de entrega',
        DELAY: 'Atraso',
        MERCHANDISESTATUS: 'Estado da mercadoria',
        OTHER: 'Outro'
      },
      transportist_default: 'Transportista',
      send_date: 'F. de envío',
      send_date_long: 'Fecha de envío',
      update_cmr: 'Atualização dos dados...',
      submit_edit_ok: 'Os dados foram atualizados com sucesso',
      confirm_update_status: 'Tem certeza de que deseja alterar o status de documento de transporte?',
      confirm_sign_pdf: 'Tem certeza de que deseja assinar o PDF?',
      confirm_sign_pdf_ok: 'PDF assinado com sucesso',
      confirm_draft: 'Tem certeza de que deseja enviar o documento de transporte como rascunho?',
      load_signing: 'Assinando PDF ...',
      biometric_signature: {
        title: 'Assinatura biométrica',
        no_pdf: 'ão há documento PDF para assinar',
        init_error: 'Erro ao inicializar o sistema de assinatura',
        error: 'Erro durante o processo de assinatura',
        saving: 'Salvando documento assinado...',
        success: 'Documento assinado e salvo corretamente'
      },
      send_tosign_tooltip: 'Enviar a firma',
      send_tosign: 'Enviar a firma',
      modify_tooltip: 'Modicicar documento de transporte',
      modify: 'Modificar',
      create_ecmr: 'Crear documento de transporte',
      change_state: {
        label: 'Mudança de estado',
        placeholder: 'Escolha um estado de documento de transporte',
        load: 'Atualizando dados de documento de transporte...'
      }
    },
    cmr_event_type: {
      CHANGE_STATUS: 'Mudança de estado',
      CHANGE_STATUS_INI: 'Estado inicial',
      CHANGE_STATUS_END: 'Estado final',
      CHANGE_STATUS_MOTIVE: 'Motivo de mudança',
      CHANGE_STATUS_USER: 'Usuário de mudança',
      SEND_MAIL: 'Enviado por correio',
      RECEIVED: 'Recebido',
      ISSUED: 'Emitido',
      ASSIGNED_ORDER: 'Ordem atribuída',
      DO_NOT_DOWNLOAD: 'Não descarregar',
      NO_LOAD: 'Não carregar',
      LOADED_PACKAGE: 'Pacote carregado',
      UNLOADED_PACKAGE: 'Pacote descarregado',
      CHANGE_DRIVER: 'Troca de motorista',
      SEND_PDF: 'Enviar PDF',
      COMMENTS: 'Observações',
      INTEGRATION: 'Integração',
      CHANGE_PLATE: 'Mudança de matrículas',
      CHANGE_CARGO: 'Modificação dos dados gerais da mercadoria',
      CHANGE_AUTHORIZATION: 'Alteração de autorização',
      CHANGE_SEND_DATE: 'Alteração da data de envio',
      CHANGE_OBSERVATIONS: 'Alteração das observações/incidências'
    },
    filters: {
      num_cmr: {
        value: 'Nº documento de transporte',
        placeholder: 'Nº documento de transporte'
      },
      order: {
        value: 'Pedido',
        placeholder: 'Pedido'
      },
      group: {
        value: 'Grupo',
        placeholder: 'Grupo'
      },
      date_creation: {
        value: 'D. registro',
        placeholder: 'D. registro'
      },
      vehicle_plate: {
        value: 'Placa veículo trator',
        placeholder: 'Placa veículo trator'
      },
      trailer_plate: {
        value: 'Placa semirreboque',
        placeholder: 'Placa semirreboque'
      },
      second_trailer_plate: {
        value: 'Placa do trailer',
        placeholder: 'Placa do trailer'
      },
	  id_cmr: {
        value: 'Id interno',
        placeholder: 'Id interno'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      },
      service: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      sender_party: {
        value: 'Cargador',
        placeholder: 'Insire 3 caracteres'
      },
      receiver_party: {
        value: 'Destinatario',
        placeholder: 'Insire 3 caracteres'
      },
      sender_centre: {
        value: 'Lugar de origen',
        placeholder: 'Lugar de origen'
      },
      receiver_centre: {
        value: 'Lugar de destino',
        placeholder: 'Lugar de destino'
      },
      transportist: {
        value: 'Transportista',
        placeholder: 'Transportista'
      },
      send_date: {
        value: 'D. envio',
        placeholder: 'D. envio'
      }
    }
  },
  coacsu: {
    coacsu_entity_table: {
      service: "Serviço",
      seller: "Vendedor",
      buyer: "Comprador",
      centre_buyer: "Centro",
      coacsu_number: "N.º Resumo de conta comercial",
      issue_date: "Data de emissão",
      creation_date_time: "Data de registo",
      total_amount: "Montante total",
      actions: "Ações"
    },
    filters: {
      service: { value: "Serviço", placeholder: "Serviço" },
      buyer: { value: "Comprador", placeholder: "Escreva 3 caracteres" },
      seller: { value: "Vendedor", placeholder: "Escreva 3 caracteres" },
      coacsu_number: { value: "N.º Resumo de conta comercial", placeholder: "Número" },
      invoice_number: { value: "N.º fatura", placeholder: "Número" },
      issue_date: { value: "Data de emissão", placeholder: "" },
      total_amount_from: { value: "Montante", placeholder: "Montante de liquidação desde" },
      total_amount_to: { value: "Montante até", placeholder: "Montante de liquidação até" },
      creation_date: { value: "Data-hora de registo", placeholder: "" }
    },
    buttons: {
      download_csv_tooltip: "Descarregar CSV",
      download_original_tooltip: "Descarregar original"
    },
    tooltip: {
      detail: "Ver detalhe"
    },
    breadcrumb: {
      coacsu_lines_view: "Resumo de conta comercial"
    },
    detail: {
      information: "Informação",
      seller: "Vendedor",
      buyer: "Comprador",
      code: "Código",
      name: "Nome",
      role: "Papel",
      address: "Endereço",
      summary: "Resumo",
      coacsuNumber: "N.º COACSU",
      status: "Estado",
      issueDate: "Emissão",
      paymentDate: "Vencimento",
      lineNumber: "N.º linha",
      invoiceNumber: "N.º documento",
      total: "Total",
      currency: "Moeda",
      no_lines: "Sem linhas",
      lines_title: "Linhas do resumo de conta comercial"
    }
  },
  deliverynote: {
    filters: {
      buyer: {
        value: 'Comprador',
        placeholder: 'Comprador'
      },
      seller: {
        value: 'Vendedor',
        placeholder: 'Vendedor'
      },
      num_deliverynote: {
        value: 'N. nota de entrega',
        placeholder: 'N. nota de entrega'
      },
      date_creation: {
        value: 'D. de registro',
        placeholder: 'D. de registro'
      },
      date_issue: {
        value: 'Período de emissão',
        placeholder: 'Período de emissão'
      },
      status: {
        value: 'Doença',
        placeholder: 'Doença'
      },
      services: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      buyer_centre: {
        value: 'Centro do comprador',
        placeholder: 'Centro do comprador'
      },
      seller_centre: {
        value: 'Centro do vendedor',
        placeholder: 'Centro do vendedor'
      },
      delivery_centre: {
        value: 'Lugar de entrega',
        placeholder: 'Lugar de entrega'
      },
      delivery_date: {
        value: 'D. de entrega',
        placeholder: 'D. de entrega'
      },
      invoice_number: {
        value: 'Nº fatura',
        placeholder: 'Fatura'
      }
    },
    delivery_entity_table: {
      buyer: 'Comprador',
      seller: 'Vendedor',
      num_deliverynote: 'N. nota de entrega',
      date_creation: 'D. de registro',
      date_issue: 'D. de emissão',
      status: 'Doença',
      delivery_type: 'Tipo de nota de entrega',
      services: 'Serviço',
      buyer_centre: 'Centro do comprador',
      seller_centre: 'Centro do vendedor',
      delivery_centre: 'Lugar de entrega',
      delivery_date: 'D. de entrega',
      order_number: 'N. de ordem',
      csv_title: 'Exportar para CSV. Em formação',
      csv_message: 'Não é possível exportar mais de {argumento} registros,restrinja sua pesquisa',
      csv_details_message: 'Você não pode exportar linhas de mais de 100 documentos, por favor, restrinja sua pesquisa'
    },
    delivery_entity_table_detail: {
      lineNumber: 'Número da linha',
      itemCode: 'Cód. do item',
      itemCodeSeller: 'Cód. do item do fornecedor',
      itemCodeBuyer: 'Cód. do item do comprador',
      codeCentreDeliveryPoint: 'Lugar de entrega',
      quantity: 'Quantidade pendente',
      description: 'Descrição',
      order: 'Número de ordem',
      despatch_quantity: 'Valor anunciado',
      received_quantity: 'Valor recebido',
      accepted_quantity: 'Quantidade aceita',
      measure: 'Unidade de medida',
      unitPrice: 'Preço unitário',
      totalAmount: 'Preço total da linha',
      documentStatus: 'Estado da linha',
      serialNumber: 'Número de série',
      batch: 'Número do lote',
      expirationDate: 'Data de validade',
      currency: 'Distintivo',
      status: 'Doença',
      options: 'Opções',
      notes: 'Notas',
      quantityTradeUnit: 'Quantidade embalagem',
      measureTradeUnit: 'Unidade de medida de embalagem',
      assignedQuantity: 'Quantidade atribuída',
      assignedMeasureUnit: 'Unidade de medida atribuída',
      netPrice: 'Preço líquido',
      grossPrice: 'Preço bruto',
      gtin14Code: 'Cód. GTIN14'
    },
    delivery_related_documents_table: {
      date: 'Data de relacionamento',
      destinationDocument: 'Nº documento',
      destinationDocumentType: 'Tipo documento'
    },
    deliverynote_detail: {
      activate_deliverynote_buttons: 'Ativar',
      rejected_deliverynote_buttons: 'Rejeitar',
      deliverynote_line_no_date: 'Esta nota de entrega não possui linhas',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF nota de entrega',
      activate_deliverynote_buttons_tooltip: 'Aceitar nota de entrega',
      rejected_deliverynote_buttons_tooltip: 'Rejeitar nota de entrega',
      rejected_deliverynote_lineError: 'Linha de desequilíbrio',
      related_documents_no_data: 'Esta nota de entrega não possui documentos relacionados',
      source_related_documents: 'Documentos relacionados de origem',
      destination_related_documents: 'Documentos relacionados no destino',
      deliverynote_lines: 'Linhas da nota de entrega',
      edit: 'Editar',
      send_to_draft: 'Rascunho',
      send_to_draft_tooltip: 'Enviar para rascunho',

      change_state: {
        label: 'Mudança de status',
        placeholder: 'Escolha um status de guia de remessa',
        load: 'Atualizando dados da nota de entrega ...'
      },

      dialog_rejected_deliverynote: {
        title: 'Rejeição da nota de entrega',
        value: 'Motivo',
        placeholder: 'Motivo da rejeição',
        motive_required: 'Razão obrigatória'
      },

      dialog_new_check_line_deliverynote: {
        title: 'Nova linha da nota de entrega',
        title_edit: 'Editar linha da nota de entrega',
        description: 'Descrição do artigo *',
        quantity: 'Quantidade *',
        priceUnit: 'Preço unitário *',
        date_required: 'Campo obrigatório'
      },

      notify: {
        submit_edit_deliverynote_ok: 'O status da nota de entrega foi modificado com sucesso',
        deliverynote_rejected: 'A nota de entrega foi rejeitada com sucesso',
        deliverynote_activate: 'A nota de entrega foi ativada',
        deliverynote_new_line: 'Uma nova linha de desbalanceamento foi registrada com sucesso',
        deliverynote_edit_line: 'A linha de desequilíbrio foi modificada com sucesso',
        delivery_point_centre_not_found: 'Não foi encontrado o centro do local de entrega indicado'
      },
      load: {
        deliverynote_rejected: 'Rejeitando nota de entrega',
        deliverynote_activate: 'Ativando nota de entrega'
      },
      confirm: {
        title_deliverynote_activate: 'A nota de entrega {deliveryId},do fornecedor {sellerName},será ativada. Você deseja continuar?',
        title_deliverynote_reject: 'A nota de entrega {deliveryId},do provedor {sellerName},será rejeitada. Você deseja continuar?',
        confirm_button_deliverynote_activate: 'OK'
      }
    },
    package_type: {
      TRANSPORT: 'Transporte',
      PALLET: 'Palete',
      HALF_PALLET: 'Meia palete',
      BOX: 'Caixa'
    },
    package: {
      invalid: {
        sscc: 'O código SSCC indicado para a embalagem não é válido. Deve ser composto por 18 dígitos',
        ssccExist: 'O código SSCC indicado para a embalagem é inválido. Já existe uma guia de remessa com esse código SSCC',
        delete: 'Não é possível excluir a embalagem da guia de remessa, pois ela possui embalagens ou linhas associadas',
        noLogistic: 'A embalagem não pode ser adicionada a uma nota de entrega não logística',
        lineCentreDeliveryPoint: 'Linhas com locais de entrega diferentes não podem ser associadas à mesma embalagem',
        typeLevel: 'Não é possível adicionar uma embalagem do tipo {argumento} dentro de uma embalagem do tipo {argumento1}'
      },
      max: {
        levels: 'A embalagem que você deseja adicionar excede o número máximo de níveis da guia de remessa'
      },
      all: {
        hasLines: 'Todas as embalagens de último nível da guia de remessa deverão ter pelo menos uma linha associada',
        linesHasPackage: 'Todas as linhas da nota de entrega deverão ter embalagem marcada'
      },
      line: {
        notFound: {
          package: 'A embalagem indicada para a linha da guia de remessa não foi encontrada',
          parent: 'A embalagem pai indicada para a embalagem da linha de guia de remessa não foi encontrada'
        }
      }
    }
  },
  // Genrals emitidos y recibidos
  genral: {
    filters: {
      creation_date: {
        value: 'Data-hora do registo'
      },
      buyer: {
        value: 'Transmissor',
        placeholder: 'Insire 3 caracteres'
      },
      seller: {
        value: 'Receptor',
        placeholder: 'Insire 3 caracteres'
      },
      delivery_date: {
        value: 'Intervalo datas de entrega',
        placeholder: 'Datas de entrega'
      },
      genral_date: {
        value: 'Intervalo datas de genral',
        placeholder: 'Datas de genral'
      },
      issue_date: {
        value: 'Intervalo datas emissão',
        placeholder: 'Data incidências'
      },
      genral_number: {
        value: 'Nº genral',
        placeholder: 'genral'
      },
      description: {
        value: 'Texto',
        placeholder: 'Texto'
      },
      project: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      status: {
        value: 'Estado',
        placeholder: 'Estado'
      }
    },
    genral_entity_table: {
      seller: 'Recetor',
      buyer: 'Emissor',
      num_genral: 'N. genral',
      description: 'Texto',
      date_creation: 'D. registo',
      date_issue: 'F. emissão',
      status: 'Estado',
      csv_title: 'Exportar para CSV. Em formação',
      csv_message: 'Não é possível exportar mais de {argumento} registros, por favor, restrinja sua pesquisa',
      services: 'Serviço'
    },
    genral_detail: {
      activate_genral_buttons: 'Ativar',
      rejected_genral_buttons: 'Rejeitar',
      download_pdf_buttons: 'PDF',
      download_pdf_buttons_tooltip: 'Baixar PDF genral',
      activate_genral_buttons_tooltip: 'Ativar genral',
      rejected_genral_buttons_tooltip: 'Rejeitar genral',
      download_pdfmultiple_buttons: 'Baixar',
      download_pdfmultiple_buttons_tooltip: 'Baixar genral/s',
      edit: 'Editar',
      dialog_rejected_genral: {
        title: 'Rejeição de genral',
        value: 'Motivo',
        placeholder: 'Motivo de rejeição',
        motive_required: 'Motivo obrigatório'
      },
      notify: {
        genral_rejected: 'A genral foi rejeitada com sucesso',
        genral_activate: 'A genral foi ativada',
        download_pdf: 'O download do ficheiro {file} foi bem sucedido.'
      },
      load: {
        genral_rejected: 'Rejeitando genral',
        genral_activate: 'Ativando genral'
      },
      confirm: {
        title_genral_activate: 'A genral {genralID} do fornecedor {sellerName} será rejeitada. Deseja continuar?',
        title_genral_reject: 'A genral {genralID} do fornecedor {sellerName} será ativada. Deseja continuar?',
        confirm_button_genral_activate: 'Aceitar'
      }
    }
  },
  // Coacsu
  coacsu: {
    filters: {
      service: {
        value: 'Serviço',
        placeholder: 'Serviço'
      },
      document_number: {
        value: 'Número documento',
        placeholder: 'Número documento'
      },
      article_code: {
        value: 'Código artigo',
        placeholder: 'Código artigo'
      },
      sale_date: {
        value: 'Data venda',
        placeholder: 'Data venda'
      }
    }
  },
  document_type: {
    INVOICE: 'Fatura',
    PURCHASEORDER: 'Ordem',
    DELIVERYNOTE: 'Nota de entrega',
    RECEIVEADVICE: 'Recepção',
    SALES_REPORT: 'Relatório de vendas',
    INVENTORY_REPORT: 'Relatório de inventário'
  },
  charge_type: {
    CHARGE: 'Cobrança',
    DISCOUNT: 'Desconto'
  },
  // Validaciones genericas
  validations: {
    maxlenght: 'Máximo "{maxlenght}" caracteres',
    minlenght: 'Mínimo "{minlenght}" caracteres',
    required: 'O campo "{field}" é obrigatório',
    data: {
      VALIDATION_ATTACHMENT_RENFE: 'Anexos de Renfe',
      VALIDATION_B2BINVOICEVALIDATION_WS: 'Serviço SOAP do cliente',
      VALIDATION_BUYER: 'Empresa cliente no projeto e ativada',
      VALIDATION_BUYER_CENTRES: 'Centro cliente na empresa e ativado',
      VALIDATION_COMMERCIAL_RELATION_CHANNEL: 'Relação comercial com canal',
      VALIDATION_COMMERCIAL_RELATION: 'Existência de relação comercial',
      VALIDATION_DOCUMENT_SIGN: 'Assinatura delegada',
      VALIDATION_DUPLICATION: 'Duplicações',
      VALIDATION_DUPLICATION_ISSUEYEAR: ' Duplicações com ano de emissão',
      VALIDATION_EIFFAGEINVOICEVALIDATION_WS: 'Utilizar WS de Eiffage',
      VALIDATION_INTRASTAT_REQUIRED: 'Intracomunidade obrigatória',
      VALIDATION_INVOICE_ACCOUNTING: 'Todas as validações contábeis da fatura',
      VALIDATION_INVOICE_CORRECTIVE: 'Existência de dados obrigatórios de fatura corrigida',
      VALIDATION_INVOICE_CORRECTIVE_MANDATORY: 'O número de fatura que vai ser retificada é obrigatório',
      VALIDATION_INVOICE_TOTAL: 'Total da fatura sem descontos e sem taxas gerais',
      VALIDATION_INVOICE_TOTAL_TAXES: 'Total de impostos igual à soma dos impostos',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES: 'Total da fatura com descontos e taxas gerais',
      VALIDATION_INVOICE_TOTAL_DISCOUNTS_CHARGES_TAXES: 'Total da fatura',
      VALIDATION_INVOICE_TOTALEXECUTABLE: 'Total executável da fatura',
      VALIDATION_INVOICENUMBER_FORMAT: 'Formato de número de fatura',
      VALIDATION_ISSUEDATE_FUTURE: 'Data de emissão não maior',
      VALIDATION_ISSUEDATE_PAST: 'Data de emissão não anterior',
      VALIDATION_ISSUER_TYPE: 'Tipo emissor Fatura',
      VALIDATION_ISSUER_TYPE_RENFE: 'Tipo emissor Fatura para projeto Renfe',
      VALIDATION_LINE_DESCRIPTION: 'Descrição obrigatória de linhas de fatura',
      VALIDATION_LINES_TOTAL: 'Total linha sem impostos',
      VALIDATION_LINES_TOTAL_DISCOUNTS_CHARGES: 'Total de linha com descontos e custos de linha',
      VALIDATION_MODALITY: 'Tipo de fatura individual',
      VALIDATION_OPERATION_AND_ISSUE_DATE: 'Data de vencimento',
      VALIDATION_RECEIVER_CONTRACT: 'ReceiverContractReference obrigatório',
      VALIDATION_RECEIVER_CONTRACT_FIRSTLINE: 'ReceiverContractReference obrigatório somente na primeira linha o cabeçalho',
      VALIDATION_RECEIVER_TRANSACTION_FIRSTLINE: 'Destinatário do pedido obrigatório somente na primeira linha o cabeçalho',
      VALIDATION_RECEIVER_CONTRACT_FORMAT: 'Formato ReceiverContractReference',
      VALIDATION_RECEIVER_CONTRACT_UNIQUE: 'ReceiverContractReference único',
      VALIDATION_RECEIVER_EXP: 'FileReference obrigatório',
      VALIDATION_RECEIVER_EXP_FIRSTLINE: 'FileReference obrigatório somente na primeira linha o cabeçalho',
      VALIDATION_RECEIVER_EXP_FORMAT: 'Formato FileReference',
      VALIDATION_RECEIVER_EXP_UNIQUE: 'FileReference único',
      VALIDATION_RECEIVER_ORDER: 'Destinatário do pedido obrigatório',
      VALIDATION_RECEIVER_ORDER_FORMAT: 'Formato do destinatário do pedido',
      VALIDATION_RECEIVER_ORDER_UNIQUE: 'Destinatário do pedido único',
      VALIDATION_ISSUER_ORDER: 'Emissor de pedido obrigatório',
      VALIDATION_ISSUER_ORDER_FORMAT: 'Formato de emissor de pedido',
      VALIDATION_ISSUER_ORDER_UNIQUE: 'Emissor de pedido único',
      VALIDATION_RENFE_WS: 'Utilizar WS de Renfe',
      VALIDATION_SELLER: 'Existência empresa fornecedora,como fornecedora no projeto e ativada',
      VALIDATION_SELLER_BUYER_NOSPONSOR: 'Existência dum sponsor no cliente ou no fornecedor',
      VALIDATION_SELLER_CENTRES: 'Existência centro fornecedor na empresa,com função fornecedor e ativado',
      VALIDATION_UNIQUE_CENTRES_BUYER: 'Centros iguais para o comprador. Centro único',
      VALIDATION_UNIQUE_CENTRES_SELLER: 'Centros iguais para o vendedor. Centro único.',
      VALIDATION_INVOICE_PUBLICORGANISM: 'Órgão Público Proponente – DIR3',
      VALIDATION_LINE_CODE: 'Existência de código para cada linha',
      VALIDATION_LINE_ORDER_EXIST: 'Existência no BBDD do pedido registrado',
      VALIDATION_LINE_TRANSACTIONREFERENCE: 'Issuer ou Receiver TransactionReference obrigatório',
      VALIDATION_LINE_EXIST: 'Existência de linhas',
      VALIDATION_CURRENCY_EXCHANGE: 'Taxa de câmbio e data da taxa de câmbio obrigatória se moeda diferente do parâmetro',
      VALIDATION_IBAN: 'IBAN obrigatório para transferências e débitos diretos',
      VALIDATION_REGISTRATION_DATA: 'Comparação dos dados do registro comercial do vendedor com os registrados no B2B',
      VALIDATION_SEQUENCE_NUMBER_BY_ORDER_FORMAT: 'Posição do pedido obrigatório se o pedido encontrar a máscara',
      VALIDATION_CORRECTIVE_SIGN: 'Sinal positivo em faturas com CorrectionMethod igual ao parâmetro',
      VALIDATION_INVOICE_BUYER_CENTRE: 'Centro cliente obrigatório',
      VALIDATION_INVOICE_CENTRE_MASK: 'Formato máscara de centro',
      VALIDATION_INVOICE_CENTRE_ROL: 'Tipo de função de centro',
      VALIDATION_NO_INTEGRATE_REJECTED_INVOICE: 'Validação de fatura rejeitada não integrada',
      VALIDATION_REGISTRATION_DATA_INDRAFE: 'Comparação dos dados do registro comercial do vendedor com os registrados no B2B Indrafe',
      VALIDATION_BUYER_CENTRES_ROL: 'Tipo de função obrigatória no centro comprador',
      VALIDATION_SELLER_CENTRES_ROL: 'Tipo de função obrigatória no centro vendedor',
      VALIDATION_BUYER_CENTRES_ROL_BYVALUES: 'Validación centro comprador contiene el rol',
      VALIDATION_SELLER_CENTRES_ROL_BYVALUES: 'Validación centro vendedor contiene el rol',
      VALIDATION_CENTRE_VOCENTO_WS: 'Custom Vocento: validação de centro via Vocento WS',
      VALIDATION_LINE_DELIVERY_BATCH: 'Existência de número do lote para cada linha da nota de entrega',
      VALIDATION_LINE_DELIVERY_SERIAL: 'Existência de número de série para cada linha da nota de entrega',
      VALIDATION_LINE_DELIVERY_EXPIRATION: 'Existência de data de validade para cada linha da nota de entrega',
      VALIDATION_LINE_DELIVERY_DATES: 'Data de validade após a data de entrega para cada linha da nota de entrega',
      VALIDATION_SENDATE_FUTURE: 'Data de envio deve ser atual ou futura',
      VALIDATION_LINE_DELIVERY_QUANTITY: 'A soma dos valores das sublinhas deve ser igual ao valor da linha pai',
      VALIDATION_LINE_DELIVERY_SUBLINE_REQUIRED: 'Existência de sublinha por linha da guia de remessa',
      VALIDATION_LINE_DOCUMENT_CANAL: 'Validação de documentos de fatura CYII',
      VALIDATION_VALID_IBAN: 'Validação do IBAN da fatura',
      VALIDATION_PAYMENT_MEAN: 'Validação de métodos de pagamento',
      VALIDATION_FILE_SIZE: 'Validação do tamanho máximo do arquivo',
      VALIDATION_INVOICE_CORRECTIVE_METHOD: 'Validação de métodos de correção em faturas corretivas',
      VALIDATION_NIF_CODPAIS: 'Validação do código do país em NIF',
      VALIDATION_LINE_SEQUENCE_NUMBER: 'Validação do sequence number exclusivo',
      VALIDATION_PARTY_NAME: 'Nome da empresa na fatura',
      VALIDATION_INVOICE_OPERATIONDATE: 'Validar a data da operação em relação à data de emissão',
      VALIDATION_INVOICE_INVOICINGPERIOD: 'Validar a data final do período de faturamento em relação à data de emissão',
      VALIDATION_INVOICE_WITHHOLDINGAMOUNT: 'Validação de retenção de garantia',
      VALIDATION_INVOICE_TRANSACTIONXORCONTRACT: 'Contrato e pedido não podem ser indicados ao mesmo tempo',
      VALIDATION_INVOICE_CORRECTCONTRACTANDTRANSACTION: 'O contrato e o pedido do arquivo devem corresponder ao registrado',
      VALIDATION_INVOICE_EURCURRENCY: 'Moeda em euros',
      VALIDATION_INVOICE_IGICINCANARY: 'Imposto IGIC e endereço nas Ilhas Canárias obrigatórios',
      VALIDATION_INVOICE_IPSIINCEUTA: 'Imposto IPSI e domicílio obrigatório em Ceuta',
      VALIDATION_LINE_DELIVERY_PACKAGE_GTIN14: 'Mesmo código GTIN14 para todas as linhas associadas a uma embalagem de entrega',
      VALIDATION_INVOICE_ATTACHEDFILESNUMBER: 'Validar número de anexos',
      VALIDATION_INVOICE_ATTACHEDFILESEXTENSION: 'Validar a extensão do arquivo anexo',
      VALIDATION_INVOICE_TAXESINPROJECT: 'Validar imposto e alíquota ativos no serviço',
      VALIDATION_INVOICE_FILEFORMAT: 'Validação do formato do arquivo de entrada',
      VALIDATION_LINE_TAX0_LEGALTEXT: 'Para o imposto 0 deverá informar um texto legal',
      VALIDATION_CORRECTIVE_ORDERORCONTRACT: 'Validação de pedido ou contrato necessária em fatura retificativa',
      VALIDATION_CORRECTIVE_REQUIRED: 'O bloco corretivo é obrigatório para uma fatura retificativa',
      VALIDATION_PARTY_BUYER_ADDRESS_VALUE: 'Validação para que o endereço do comprador seja o mesmo configurado',
      VALIDATION_SPECIFIC_CANARY: 'Validações específicas para faturas de fornecedores puros das Canárias (100% Canárias)',
      VALIDATION_SPECIFIC_CEUTA: 'Validações específicas para faturas de fornecedores puros das Ceuta (100% Ceuta)',
      VALIDATION_PHYSICAL_GLN_REQUIRED: 'Validação obrigatória de caixa postal para envio de formatos edi',
      VALIDATION_INVOICE_NOIGICIVA: 'Valida que uma fatura não pode ter IGIC e IVA ao mesmo tempo',
      VALIDATION_INVOICE_EXITSPAYMENTDETAILS: 'Valida que uma fatura contém uma forma de pagamento',
      VALIDATION_LINE_RECADVPRICEQUANTITYPOSITIVE: 'Valida que todas as linhas de um saque de uma recepção possuem valor e quantidade positivos',
      VALIDATION_LINE_CORRECTIVEPRICENEGATIVE: 'Valida que todas as linhas de um rascunho corretivo têm preço negativo',
      VALIDATION_INVOICELINES_SAMETAX: 'Valida que uma fatura não contém o mesmo imposto na mesma linha',
      VALIDATION_INVOICELINES_NONEGATIVE: 'Valida que todas as linhas possuem valor e quantidade positivos',
      VALIDATION_INVOICE_RECEIVERTRANSACTIONREFERENCE: 'Validação da ordem de recebimento, se existir e for informada em todas as linhas ou no cabeçalho',
      VALIDATION_INVOICE_FROMRECADV: 'Confirmar a existência da receção indicada na fatura',
      VALIDATION_INVOICE_DOCUMENTVALUESFROMRECADV: 'Confirmar que os documentos da fatura correspondem aos da receção',
      VALIDATION_INVOICE_ADDITIONALINFOFROMRECADV: 'Personalizada red.es: validar que as informações adicionais da fatura contêm propriedades da receção',
      VALIDATION_INVOICE_LINEDATAFROMRECADV: 'Validar as informações da linha da fatura na receção',
      VALIDATION_CENTRE_PERMANET_ESTABLISHMENT: 'Estabelecimento permanente de acordo com o comprador e o vendedor para rascunhos',
      VALIDATION_INVOICE_ISSUEDATE_REJECTED: 'Verifique se a data de emissão coincide com a de outra fatura negativa existente.',
      VALIDATION_RULES_KOSIT: 'Validação das regras KoSIT',
      VALIDATION_RULES_SCHEMATRON: 'Validação das regras Schematron'
    }
  },

  error: {
    e400: 'Têm havido erros de validação no pedido.',
    e400_create_invoice: 'Ocorreu um erro durante a criaçao da fatura,contacte o administrador.',
    e401_login: 'Utilizador ou senha incorretos.',
    e401: 'A sessão expirou ou usuário não autorizado.',
    e403: 'O utilizador não tem a autorização necessária para realizar esta ação',
    e403_service: 'O usuário não tem permissão para acessar o serviço',
    e404: 'Arquivo não encontrado.',
    e409: 'O meio selecionado já existe para o utilizador',
    e409_create_invoice: 'Já existe uma fatura com este número de fatura para o mesmo fornecedor',
    e428_login: 'O usuário tem autenticação de dois fatores ativa, insira o código',
    e401_two_factor_auth: 'O código expirou ou está incorreto',
    e500: 'Ocorreu um erro. Contacte o seu administrador.',
    e500_user: 'Erro criando utilizador. Consulte o seu administrador.',
    default: 'Erro de conexão com o servidor. Por favor,tente novamente mais tarde',
    recadv_rejected: 'Não é possível faturar,alguma recepção foi rejeitada',
    validation_intrastat_required: 'O campo "Código de mercadoria" e "Peso" são obrigatórios',
    password_expired: 'Sua senha expirou, você deve alterar sua senha.',
    file_size: {
      exceeded: 'Tamanho não permitido. O tamanho máximo é {argumento}'
    },
    invalid_image: 'O arquivo não é uma imagem válida',
    retry: 'Ocorreu um erro. Por favor, tente novamente mais tarde',
    user: 'Você não pode excluir o usuário porque ele está associado a processos do sistema relacionados a faturas, você deve desabilitar o usuário'
  },

  global_error: 'Ocorreu um erro. Contacte o seu administrador.',
  user_not_found: 'Utilizador não encontrado',

  // Paises
  countries: {
    country_AFG: 'Afeganistão',
    country_ALA: 'Åland',
    country_ALB: 'Albânia',
    country_DEU: 'Alemanha',
    country_AND: 'Andorra',
    country_AGO: 'Angola',
    country_AIA: 'Anguilla',
    country_ATA: 'Antártica',
    country_ATG: 'Antígua e Barbuda',
    country_SAU: 'Arábia Saudita',
    country_DZA: 'Argélia',
    country_ARG: 'Argentina',
    country_ARM: 'Armênia',
    country_ABW: 'Aruba',
    country_AUS: 'Austrália',
    country_AUT: 'Áustria',
    country_AZE: 'Azerbaijão',
    country_BHS: 'Bahamas',
    country_BGD: 'Bangladesh',
    country_BRB: 'Barbados',
    country_BHR: 'Bahrain',
    country_BEL: 'Bélgica',
    country_BLZ: 'Belize',
    country_BEN: 'Benim',
    country_BMU: 'Bermuda',
    country_BLR: 'Bielorrússia',
    country_MMR: 'Myanmar',
    country_BOL: 'Bolívia',
    country_BIH: 'Bósnia e Herzegovina',
    country_BWA: ' Botswuana',
    country_BRA: 'Brasil',
    country_BRN: 'Brunei Darussalam',
    country_BGR: 'Bulgária',
    country_BFA: 'Burkina Faso',
    country_BDI: 'Burundi',
    country_BTN: ' Butão ',
    country_CPV: 'Cabo Verde',
    country_KHM: 'Camboja',
    country_CMR: 'Camarões',
    country_CAN: 'Canadá',
    country_QAT: 'Catar',
    country_BES: 'Bonaire,Santo Eustaquio e Saba',
    country_TCD: 'Chade',
    country_CHL: 'Chile',
    country_CHN: 'China',
    country_CYP: 'Chipre',
    country_COL: 'Colômbia',
    country_COM: 'Comores',
    country_PRK: ' Coreia do Norte',
    country_KOR: ' Coreia do Sul',
    country_CIV: 'Costa do Marfim',
    country_CRI: 'Costa Rica',
    country_HRV: 'Croácia',
    country_CUB: 'Cuba',
    country_CUW: 'Curaçao',
    country_DNK: 'Dinamarca',
    country_DMA: 'Dominica',
    country_ECU: 'Equador',
    country_EGY: 'Egito',
    country_SLV: 'El Salvador',
    country_ARE: 'Emirados Árabes Unidos',
    country_ERI: 'Eritreia',
    country_SVK: 'Eslováquia',
    country_SVN: 'Eslovênia',
    country_ESP: 'Espanha',
    country_USA: 'Estados Unidos',
    country_EST: ' Estónia',
    country_ETH: 'Etiópia',
    country_PHL: 'Filipinas',
    country_FIN: ' Finlândia',
    country_FJI: 'Fiji',
    country_FRA: 'França',
    country_GAB: 'Gabão',
    country_GMB: ' Gâmbia',
    country_GEO: 'Geórgia',
    country_GHA: 'Gana',
    country_GIB: 'Gibraltar',
    country_GRD: 'Granada',
    country_GRC: 'Grécia',
    country_GRL: 'Gronelândia',
    country_GLP: 'Guadalupe',
    country_GUM: 'Guam',
    country_GTM: 'Guatemala',
    country_GUF: 'Guiana Francesa',
    country_GGY: 'Guernsey',
    country_GIN: 'Guiné',
    country_GNB: 'Guiné-Bissau',
    country_GNQ: 'Guiné Equatorial ',
    country_GUY: 'Guiana',
    country_HTI: 'Haiti',
    country_HND: 'Honduras',
    country_HKG: 'Hong Kong',
    country_HUN: 'Hungria',
    country_IND: 'Índia',
    country_IDN: 'Indonésia',
    country_IRQ: 'Iraque',
    country_IRN: ' Irão',
    country_IRL: 'Irlanda',
    country_BVT: 'Ilha Bouvet',
    country_IMN: 'Ilha de Man',
    country_CXR: 'Ilha do Natal',
    country_NFK: 'Ilha Norfolk',
    country_ISL: 'Islândia',
    country_CYM: 'Ilhas Cayman',
    country_CCK: 'Ilhas Cocos (Keeling)',
    country_COK: 'Ilhas Cook',
    country_FRO: 'Ilhas Feroé',
    country_SGS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
    country_HMD: 'Ilha Heard e Ilhas McDonald',
    country_FLK: 'Ilhas Malvinas',
    country_MNP: 'Marianas Setentrionais',
    country_MHL: 'Ilhas Marshall',
    country_PCN: 'Pitcairn',
    country_SLB: 'Ilhas Salomão',
    country_TCA: 'Turks e Caicos',
    country_UMI: 'Ilhas Menores Afastadas dos Estados Unidos',
    country_VGB: 'Ilhas Virgens Britânicas',
    country_VIR: 'Ilhas Virgens Americanas',
    country_ISR: 'Israel',
    country_ITA: 'Itália',
    country_JAM: 'Jamaica',
    country_JPN: 'Japão',
    country_JEY: 'Jersey',
    country_JOR: 'Jordânia',
    country_KAZ: 'Cazaquistão',
    country_KEN: 'Quênia',
    country_KGZ: 'Quirguistão',
    country_KIR: 'Kiribati',
    country_KWT: 'Kuwait',
    country_LAO: 'Laos',
    country_LSO: 'Lesoto',
    country_LVA: 'Letônia',
    country_LBN: 'Líbano',
    country_LBR: 'Libéria',
    country_LBY: 'Líbia',
    country_LIE: 'Liechtenstein',
    country_LTU: 'Lituânia',
    country_LUX: 'Luxemburgo',
    country_MAC: 'Macau',
    country_MDG: 'Madagáscar',
    country_MYS: 'Malásia',
    country_MWI: 'Malawi',
    country_MDV: 'Maldivas',
    country_MLI: 'Mali',
    country_MLT: 'Malta',
    country_MAR: 'Marrocos',
    country_MTQ: 'Martinica',
    country_MUS: 'Maurícia',
    country_MRT: 'Mauritânia',
    country_MYT: 'Mayotte',
    country_MEX: 'México',
    country_FSM: 'Estados Federados da Micronésia',
    country_MDA: 'Moldávia',
    country_MCO: 'Mónaco',
    country_MNG: 'Mongólia',
    country_MNE: 'Montenegro',
    country_MSR: 'Montserrat',
    country_MOZ: 'Moçambique',
    country_NAM: 'Namíbia',
    country_NRU: 'Nauru',
    country_NPL: 'Nepal',
    country_NIC: 'Nicarágua',
    country_NER: 'Níger',
    country_NGA: 'Nigéria',
    country_NIU: 'Niue',
    country_NOR: 'Noruega',
    country_NCL: 'Nova Caledônia',
    country_NZL: 'Nova Zelândia ',
    country_OMN: 'Omã',
    country_NLD: 'Países Baixos',
    country_PAK: 'Paquistão',
    country_PLW: 'Palau',
    country_PSE: 'Palestina',
    country_PAN: 'Panamá',
    country_PNG: 'Papua-Nova Guiné',
    country_PRY: 'Paraguai',
    country_PER: 'Peru',
    country_PYF: 'Polinésia Francesa',
    country_POL: 'Polónia',
    country_PRT: 'Portugal',
    country_PRI: 'Porto Rico',
    country_GBR: 'Reino Unido',
    country_CAF: 'República Centro-Africana',
    country_CZE: 'República Checa',
    country_MKD: 'Macedônia do Norte',
    country_COG: 'República do Congo',
    country_COD: 'República Democrática do Congo',
    country_DOM: 'República Dominicana',
    country_REU: 'Reunião',
    country_RWA: 'Ruanda',
    country_ROU: 'Roménia',
    country_RUS: ' Rússia',
    country_ESH: 'Saara Ocidental',
    country_WSM: 'Samoa',
    country_ASM: 'Samoa Americana',
    country_BLM: 'São Bartolomeu',
    country_KNA: 'São Cristóvão e Névis',
    country_SMR: 'San Marino',
    country_MAF: 'São Martinho',
    country_SPM: 'Saint-Pierre e Miquelon',
    country_VCT: ' São Vicente e Granadinas',
    country_SHN: 'Santa Helena,Ascensão e Tristão da Cunha',
    country_LCA: 'Santa Lúcia',
    country_STP: ' São Tomé e Príncipe',
    country_SEN: 'Senegal',
    country_SRB: 'Sérvia',
    country_SYC: 'Seicheles',
    country_SLE: ' Serra Leoa',
    country_SGP: 'Singapura',
    country_SXM: 'São Martinho',
    country_SYR: 'Síria',
    country_SOM: 'Somália',
    country_LKA: 'Sri Lanka',
    country_SWZ: 'Suazilândia',
    country_ZAF: ' África do Sul',
    country_SDN: ' Sudão',
    country_SSD: 'Sudão do Sul',
    country_SWE: 'Suécia',
    country_CHE: 'Suíça',
    country_SUR: ' Suriname ',
    country_SJM: 'Svalbard e Jan Mayen',
    country_THA: 'Tailândia',
    country_TWN: 'Taiwan',
    country_TZA: 'Tanzânia',
    country_TJK: 'Tajiquistão',
    country_IOT: 'Território Britânico do Oceano Índico',
    country_ATF: 'Terras Austrais e Antárticas Francesas',
    country_TLS: 'Timor-Leste',
    country_TGO: 'Togo',
    country_TKL: 'Toquelau',
    country_TON: 'Tonga',
    country_TTO: 'Trinidad e Tobago',
    country_TUN: 'Tunísia',
    country_TKM: 'Turquemenistão',
    country_TUR: 'Turquia',
    country_TUV: 'Tuvalu',
    country_UKR: 'Ucrânia',
    country_UGA: 'Uganda',
    country_URY: 'Uruguai',
    country_UZB: 'Uzbequistão',
    country_VUT: 'Vanuatu',
    country_VAT: 'Vaticano',
    country_VEN: 'Venezuela',
    country_VNM: 'Vietnã',
    country_WLF: 'Wallis e Futuna',
    country_YEM: 'Iêmen',
    country_DJI: 'Djibouti',
    country_ZMB: 'Zâmbia',
    country_ZWE: 'Zimbabwe'
  },

  // Permisos
  authorities: {
    ADMIN_GROUP: 'Administração de grupos de centros',
    ADMIN_PROFILE: 'Administração do perfil',
    ADVANCED_ADMIN_USER: 'Administração avançada de utilizadores',
    ADVANCED_ADMIN_PARTY: 'Administração avançada de empresas',
    ADMIN_USER: 'Administração de utilizadores',
    ADMIN_CERTIFICATE: 'Administração de certificados',
    ADMIN_TAX: 'Administração de impostos',
    ADMIN_ARTICLE: 'Administração de artigos',
	ADMIN_METHODS: 'Administração de métodos de comunicação',
    ADMIN_DOCUMENTATION: 'Administração de documentação',
    ADMIN_QUARTZ: 'Administração de processos planejados',
    ADMIN_MAP: 'Administração de mapas',
    ADMIN_GROUP_PARTY: 'Administração de grupos de empresas',
    ADMIN_CENTRE: 'Administração de centros',
    ADMIN_PARTY: 'Administração de empresas',
    ADMIN_PROJECT: 'Administração de serviço',
    AUDITORY_ACTION: 'Auditoria das ações do utilizador ou do sistema',
    AUDITORY_DOCUMENT: 'Auditoria de documentos',
    BILLING_MANAGEMENT: 'Faturação',
    DELETE_INVOICE_ATTACHMENTS: 'Eliminar anexos de fatura',
    UPLOAD_INVOICE: 'Carregamento de fatura através de ficheiro',
    SEARCH_INVOICE_SALES: 'Pesquisa de faturas assinadas de vendas',
    SEARCH_INVOICE_PURCHASES: 'Pesquisa de faturas assinadas de compras',
    SEARCH_REPORT_EMITTED: 'Pesquisa de relat\u00F3rios emitidos',
    SEARCH_REPORT_RECEIVED: 'Pesquisa de relat\u00F3rios recebidos',
    SEARCH_INVOICE_THIRD: 'Pesquisa de faturas de terceiros',
    SEARCH_INVOICE_DRAFT: 'Pesquisa de rascunhos de fatura',
    SEARCH_ACCOUNTING_CLOSE: 'Consulta de encerramento contábil',
    SEARCH_INVOICE_SENDER: 'Pesquisa de faturas assinadas enviadas',
    ADD_INVOICE_ATTACHMENTS: 'Adicionar anexos à fatura',
    SEARCH_INVOICE_RECEIVER: 'Pesquisa de faturas assinadas recebidas',
    VIEW_INVOICE_PDF: 'Ver PDF de fatura',
    VIEW_INVOICE_ATTACHMENT: 'Ver anexos de fatura',
    VIEW_INVOICE_EVENTS: 'Ver eventos de fatura',
    VIEW_INVOICE_DOCUMENTS: 'Ver documentos de cabeçalho em rascunhos',
    GET_PAYMENT_DATA: 'Consultar dados de pagamento/cobrança de faturas',
    CHANGE_INVOICE_STATUS: 'Redefinição de estado de fatura',
    SEARCH_ISSUE: 'Pesquisa de incidências',
    CREATE_ISSUE: 'Criação de incidência',
    STATISTICS_MANAGEMENT: 'Estatísticas',
    UPDATE_ISSUE: 'Atualizar estado de incidência',
    ADD_ISSUE: 'Criação de incidências',
    DELETE_ISSUE: 'Eliminar incidências',
    DOWNLOAD_INVOICE_WS: 'Download de faturas no Web Service',
    INTEGRATION_INVOICE_WS: 'Integração de faturas no Web Service',
    SEARCH_STATUS_INVOICE_WS: 'Consulta de estados de faturas no Web Service',
    ADMIN_DELIVERY_METHODS: 'Administração de parâmetros de entrega',
    CANCEL_INVOICE: 'Solicitar cancelamento de fatura',
    COPY_INVOICE: 'Copiar fatura',
    CREATE_PROJECT: 'Criação de serviço',
    CREATE_PARTY: 'Criação de empresas',
    MODIFY_PROJECT: 'Modificar serviço',
    PROJEC_DELIVERY_METHOD: 'Gestão de métodos de entrega de serviço',
    PARTY_DELIVERY_METHOD: 'Gestão de métodos de entrega de empresa',
    PARAMS_DELIVERY_METHOD: 'Gestão de parâmetros de entrega',
    CREATE_CENTRE: 'Criação de centros',
    FORWARD_INVOICE_EMITTED: 'Reenvio de faturas',
    FORWARD_INVOICE_RECEIVED: 'Reenvio de faturas',
    CREATION_PARTY_WS: 'Criação de empresas',
    UPDATE_PARTY_WS: 'Atualização de empresas',
    ADMIN_USER_WS: 'Administração de utilizadores',
    CREATION_USER_WS: 'Criação de utilizadores',
    UPDATE_USER_WS: 'Alteração de utilizadores',
    REMOVE_USER_WS: 'Eliminação de utilizadores',
    UNLOCK_USER_WS: 'Desbloqueio de utilizadores',
    RESET_USER_WS: 'Reset de utilizadores',
    DRAFT_ACCOUNTING_CLOSE: 'Rascunhos de encerramento contábil',
    CREATE_GROUP: 'Criação de grupos de centros',
    ADMIN_INDRA: 'Administração de Indra',
    SEARCH_ACCOUNTING_CLOSE_DRAFT: 'Pesquisa de rascunhos encerramento ',
    CHECK_STATUS: 'Consulta de estados online',
    SEARCH_PENDING_TASKS: 'Consulta de tarefas pendentes',
    CONSULT_DOCUMENTATION: 'Consultar documentação',
    CONSULT_SIGNDOCUMENT: 'Consultar documentos de assinatura delegada',
    UPLOAD_SIGNDOCUMENT: 'Carregar documentos de assinatura delegada',
    DELETE_SIGNDOCUMENT: 'Eliminar documentos de assinatura delegada',
    CREATE_COVER: 'Criar reiniciar capa',
    SEARCH_RECADV_SENDER: 'Consultar recepções emitidas',
    SEARCH_RECADV_RECEIVER: 'Consultar recepções recebidas',
    INVOICE_VALIDATION_WS: 'WS Validação de faturas',
    CHANGE_INVOICE_STATUS_WS: 'WS Modificar estado da fatura',
    VIEW_INVOICE_BY_LINK: 'Visualização de fatura mediante ligação externa',
    REJECT_RECADV: 'Rejeitar recepções',
    MODIFY_RECADV: 'Modificar recepções',
    RECADV_CREATE_INVOICE: 'Criar fatura a partir de recepções',
    RECADV_CREATE_INVOICE_PARCIAL: 'Criar fatura a partir de recepções parciais',
    SEARCH_ORDER_SENDER: 'Consultar pedidos emitidos',
    SEARCH_ORDER_RECEIVER: 'Consultar pedidos recebidos',
    SEARCH_GENRAL_SENDER: 'Consultar genrals emitidos',
    SEARCH_GENRAL_RECEIVER: 'Consultar genrals recebidos',
    SEARCH_SALES_REPORT_VIEW: 'pesquisa de relatório de venda',
    SEARCH_INVENTORY_REPORT_VIEW: 'Consultar relatório de inventário',
    MULTIPLE_CHANGE_STATUS: 'Múltiplas alterações de estado em tarefas pendentes',
    SEARCH_DELIVERY_SENDER: 'Consultar notas de entrega emitidas',
    SEARCH_DELIVERY_RECEIVER: 'Consultar notas de entrega recebidas',
    EDIT_INVOICE_DATA: 'Editar metadados da fatura',
    EDIT_INVOICE_NOTE: 'Editar notas de fatura',
    EDIT_CARRIER_CMR: 'Editar transportador de CMR',
    EDIT_CHARGER_CMR: 'Editar carregador de CMR',
    EDIT_CENTRE_PERMANENT_ESTABLISHMENT: 'Modificar e eliminar centros com estabelecimento permanente',
    ADMIN_APPROVAL_FLOW_BY_LEVELS: 'Administração de fluxos de aprovação por níveis e usuários',
    USER_APPROVAL_FLOW_BY_LEVELS: 'Aprovar, rejeitar e enviar faturas no fluxo de aprovação por níveis e usuários',
    SEARCH_OCR_DOCUMENTS: 'Consultar documentos OCR pendentes de validação',
    VIEW_INVOICE_NOTE: 'Ver notas de fatura',
    VIEW_ADMINISTRATIVE_CENTRES: 'Ver colunas de centros administrativos',
    VIEW_DISTRIBUTION_CENTRES: 'Visualização de distribuição na seleção do centro',
    DOWNLOAD_DOCUMENT_WS: 'Download de documentos',
    UPDATE_DOCUMENT_WS: 'Atualizar documento',
    CREATE_INVOICE_DRAFT: 'Criar rascunho de fatura',
    ATTACHMENT_HIDDEN: 'Anexo não visível',
    VIEW_REQUEST_REDIGITALIZATION: 'Pedido redigitalização',
    VIEW_INVALID_INVOICE_COLOR: 'Ver estado da fatura inválida a vermelho',
    SEARCH_CHANNEL: 'Consultar através de Canais',
    VIEW_COMERCIAL_RELATION: 'Ver relações comerciais',
    VIEW_RELATION_CHANNEL: 'Ver relações comerciais com canal',
    CREATE_COMERCIAL_RELATION: 'Criar relações comerciais',
    CHANGE_MASTER_DATA: 'Alterar dados principais',
    CHANGE_ROLE: 'Alterar rol',
    NO_EDIT_DATA_USER: 'Utilizador de dados sem edição',
    SIGNATURE_DELEGATION: 'Delegação de assinatura',
    CHANGE_STATUS_PENDINGTASKS: 'Redefinição de estados pendentes',
    CHANGE_STATUS_ORDER: 'Redefinição de estado de pedidos',
    CHANGE_STATUS_DELIVERYNOTE: 'Alteração de status de uma nota de entrega',
    CHANGE_STATUS_RECADV: 'Mudança de status de um recibo',
    VIEW_INVOICE_BPM_EVENTS: 'Ver eventos de BPM de fatura',
    CHANGE_STATUS_RECADV_WS: 'Redefinição de recepções WS',
    CHECK_STATUS_RECADV_WS: 'Verificar estado de recepções WS',
    INTEGRATION_RECADV_WS: 'Integração de recepções WS',
    INTEGRATION_ORDER_WS: 'Integração de pedidos WS',
    VIEW_METADATA: 'Ver metadatos',
    VIEW_ORDER_METADATA: 'Ver metadados do pedido',
    VIEW_RECADV_METADATA: 'Visualizar metadados de recepção',
    VIEW_ORDER_ORIGINAL: 'Visualizar pedidos originais',
    VIEW_RECADV_ORIGINAL: 'Ver recibos originais',
    VIEW_DESADV_METADATA: 'Ver metadados da nota de entrega',
    VIEW_DESADV_ORIGINAL: 'Ver original da nota de entrega',
    ORDER_CREATE_INVOICE: 'Criar fatura a partir de pedidos',
    ORDER_CREATE_DELIVERY_NOTE: 'Criar uma guia de remessa a partir de um pedido',
    CREATE_INVOICE_FROM_DELIVERY_NOTE: 'Criar fatura a partir de uma nota de entrega',
    VIEW_BANK_DATA: 'Ver detalhes bancários',
    DOWNLOAD_DELIVERY_NOTE_WS: 'Download de notas de entrega no Web Service',
    DOWNLOAD_INVOIC_FORMATTED: 'Download do guardado formatado',
    RECADV_ATTACH: 'Permitir anexos em recepções',
    CHANGE_PARTY_MEDIA: 'Modificar detalhes de contato da empresa',
    VIEW_CMR: 'ver CMR documento de transporte',
    CREATE_CMR_DRAFT: 'Criar documento de transporte',
    VIEW_CMR_DRAFT_SELLER_CENTRES: 'Visualizar centros vendedores para rascunho de documento de transporte',
    VIEW_CMR_DRAFT_BUYER_CENTRES: 'Visualizar centros compradores para rascunho de documento de transporte',
    CREATE_INVOICE_FROM_RECADV: 'Permite preencher determinados campos ao criar a fatura a partir da recepção',
    CHANGE_CENTRE_ROLE: 'Alterar função de centros',
    MODIFY_PAYMENT_METHODS: 'Modificar métodos de pagamento da empresa',
    CREATE_CORRECTIVE_INVOICE: 'Criação de nota fiscal corretiva a partir da nota fiscal emitida',
    NO_VIEW_INVOICE_SERIES_CODE: 'Sem acesso ao número de série',
    TOTAL_IRPF: 'IRPF nos totais das faturas',
    NO_VIEW_RECADV_PDF: 'Sem acesso ao pdf na recepção',
    ADD_BUYER_CENTRE: 'Adicionar centro de compradores',
    VIEW_MENU: 'Ver menu',
    VIEW_SALES_REPORT_ORIGINAL: 'Ver relatório de vendas original',
    VIEW_SALES_REPORT_METADATA: 'Ver metadados do relatório de vendas',
    VIEW_INVENTORY_REPORT_ORIGINAL: 'Ver relatório de inventário original',
    VIEW_INVENTORY_REPORT_METADATA: 'Ver metadados do relatório de inventário',
    SEARCH_REMADV_VIEW: 'Consultar aviso de liquidação',
    VIEW_REMADV_ORIGINAL: 'Ver aviso de liquidação original',
    VIEW_REMADV_METADATA: 'Ver metadados do aviso de liquidação',
    SEARCH_COACSU_VIEW: 'Consultar resumo de entregas',
    VIEW_COACSU_ORIGINAL: 'Ver resumo de entregas original',
    VIEW_COACSU_METADATA: 'Ver metadados do resumo de entregas',
    CREATE_COACSU: 'Criar resumo de conta comercial'
  },
  authorities_module: {
    INVOICE: 'Faturas',
    ADMIN: 'Administração',
    AUDITORY: 'Auditoria',
    BILLING: 'Faturamento',
    ISSUE: 'Incidentes',
    STATISTICS: 'Estatisticas',
    WEBSERVICE: 'Serviço da Web',
    GROUP: 'Grupo central',
    DOCUMENTATION: 'Documentação',
    RECADV: 'Recepção',
    PURCHASEORDER: 'Encomenda',
    ORDERRSP: 'Resposta do encomenda',
    DELIVERY: 'Nota de entrega',
    GENRAL: 'Genral',
    GENERAL: 'Genral note',
    CMR: 'DeCA',
    SALESREPORT: 'Relatório de vendas',
    INVENTORYREPORT: 'Relatório de inventário',
    COACSU: 'Resumo da conta comercial',
    REMADV: 'Aviso de pagamento'
  },
  auditaction: {
    create: 'Criação',
    update: 'Atualizar',
    delete: 'Deletado',
    resend: 'Reenviar',
    reprocess: 'Reprocessar',
    updateStatus: 'Atualização de status',
    sendInvoice: 'Send invoice',
    cancel: 'Cancelamento',
    demand: 'Solicitar',
    checkStatus: 'Verificar status',
    sendData: 'Enviar dados',
    reject: 'Rejeitar',
    send: 'Envio'
  },
  functionalGroup: {
    ROLE: 'Perfis',
    PROJECT: 'Projeto',
    PARTY: 'Empresa',
    CENTRE: 'Centro',
    USER: 'Usuário',
    TAXES: 'Impostos',
    ISSUE: 'Incidentes',
    CERTIFICATE: 'Certificados',
    EMAIL: 'Personalizar e-mail',
    DOCUMENTATION: 'Documentação',
    INVOICE: 'Fatura',
    ORDER: 'Pedido',
    GENRAL: 'Genral',
    DELIVERYNOTE: 'Nota de entrega',
    RECADV: 'Recepção',
    ORDERRSP: 'Resposta do Pedido',
    CMR: 'DeCA',
    COMMUNICATION_METHOD: 'Método de entrega'
  },

  // Tipos de medio de contacto
  mediaType: {
    email: 'Correio eletrónico',
    telefono_fijo: 'Telefone fixo',
    telefono_movil: 'Celular',
    telefono_trabajo: 'Telefone da empresa',
    fax: 'Fax',
    email_to_report_issued: 'Enviando relatórios',
    contact_person: 'Pessoa de contato'
  },

  // Impuestos
  adminTaxes: {
    tax: {
      VAT: 'IVA',
      IGIC: 'IGIC',
      IGI: 'IGIC',
      EXT: 'EXT',
      ENV: 'ENV',
      IRPF: 'IRS',
      IPSI: 'IPSI',
      ITPAJD: 'ITPAJD',
      IE: 'IE',
      ICIO: 'ICIO',
      IPS: 'IPS',
      RLEA: 'RLEA',
      IGFEI: 'IGFEI',
      Otros: 'Outros',
      Ra: 'Renda aduanas',
      IGTECM: 'IGTECM',
      IECDPCAC: 'IECDPCAC',
      IMVDN: 'IMVDN',
      IMSN: 'IMSN',
      IMGSN: 'IMGSN',
      IMPN: 'IMPN',
      REIVA: 'REIVA',
      REIGIC: 'REIGIC',
      REIPSI: 'REIPSI',
      IVPEE: 'IVPEE',
      IPCNG: 'IPCNG',
      IACNG: 'IACNG',
      IDEC: 'IDEC',
      ILTCC: 'ILTCC',
      IRNR: 'IRNR',
      ISS: 'ISS',
      IIIMAB: 'IIIMAB',
      OTH: 'OTH',
      ITRT01: 'RT01',
      ITRT02: 'RT02',
      ACT: 'ACT'
    }
  },

  tax_type: {
    VAT: 'Imposto sobre o Valor Acrescentado',
    IGIC: 'Imposto Geral Indirecto Canário',
    EXT: 'Isento',
    ENV: 'Imposto ambiental',
    IRPF: 'Imposto sobre o rendimento das pessoas singulares',
    IPSI: 'Imposto sobre a produção,os serviços e a importação',
    IGI: '@:tax_type.IGIC',
    ITPAJD: 'Imposto sobre Transmissões Patrimoniais e Actos Jurídicos Documentados',
    IE: 'Impostos especiais',
    ICIO: 'Imposto sobre construções,instalações e obras',
    IPS: 'Imposto sobre a produção,serviços e importações',
    RLEA: 'Sobretaxa destinada a financiar as funções de liquidação das companhias seguradoras',
    IGFEI: 'Imposto sobre Gases Fluorados com Efeito de Estufa',
    Otros: 'Outros',
    Ra: 'Renda Aduanas',
    IGTECM: 'Imposto geral sobre o volume de negócios aplicável a Ceuta e Melilha',
    IECDPCAC: 'Imposto especial sobre os combustíveis derivados do petróleo na Comunidade Autonoma das Canárias',
    IIIMAB: 'Imposto sobre as instalações que incidem sobre o meio ambiente nas Ilhas Baleares',
    IMVDN: 'Imposto municipal sobre os imóveis desocupados em Navarra',
    IMSN: 'Imposto municipal sobre terrenos em Navarra',
    IMGSN: 'Imposto municipal sobre gastos sumptuários em Navarra',
    IMPN: 'Imposto municipal de publicidade em Navarra',
    REIVA: 'Regime especial de IVA para agências de viagens',
    REIGIC: 'Regime especial de IGIC: para agências de viagens',
    REIPSI: 'Regime especial IPSI para agências de viagens',
    IVPEE: 'Imposto sobre o valor da produção da energía eléctrica',
    IPCNG: 'Imposto sobre a produção de combustível nuclear irradiado e resíduos radioativos provenientes da geração de energia nuclear',
    IACNG: 'Imposto sobre a armazenagem de combustível nuclear irradiado e resíduos radioativos em instalações centralizadas',
    IDEC: 'Imposto sobre Depósitos em Instituições de Crédito',
    ILTCC: 'Imposto sobre o tabaco na Comunidade Autónoma das Canárias',
    IRNR: 'Imposto sobre o Rendimento de Não Residentes',
    ISS: 'Imposto sobre as Sociedades',
    ITRT01: 'Imposto fatturapa RT01',
    ITRT02: 'Imposto fatturapa RT02',
    OTH: 'OTH',
    ACT: 'Imposto sobre o álcool'
  },

  // Recepciones estados
  recadv_status: {
    RECEIVED: 'Recebida',
    REJECTED: 'Rejeitada',
    REJECTED_SELLER: 'Rejeitada Fornecedor',
    ERROR: 'Erro',
    FULLY_INVOICED: 'Totalmente faturado',
    PARTIALLY_INVOICED: 'Parcialmente faturado',
    ORIGINAL: 'Original',
    MODIFIED: 'Modificada'
  },
  // Recepciones subtype
  recadv_subtype: {
    GOODS: 'Goods',
    SERVICES: 'Services'
  },
  // Pedidos estados
  order_status: {
    RECEIVED: 'Recebida',
    REJECTED: 'Rejeitada',
    ACCEPTED: 'Aceito',
    REJECTED_SELLER: 'Rejeitada Fornecedor',
    ERROR: 'Erro',
    FULLY_INVOICED: 'Totalmente faturado',
    PARTIALLY_INVOICED: 'Parcialmente faturado',
    ORIGINAL: 'Original',
    MODIFIED: 'Modificada',
    DISPATCHED: 'Publicado',
    PARTIALLY_SENT: 'Expedido parcialmente',
    FULLY_SENT: 'Expedido totalmente'
  },

  order_type: {
    ORDER: 'Normal',
    BLANKET_ORDER: 'Comercial',
    RUSH_ORDER: 'Urgente',
    CONSIGNMENT_ORDER: 'Em consignação',
    CROSS_DOCKING_ORDER: 'Cross-docking',
    INFO: 'Informativo'
  },
  // Subtipos de pedido
  order_subtype: {
    INVOICED_NOT_REPLENISHED: 'Faturar não reabastecer',
    FULL_DELIVERY: 'Entrega completa',
    REPLENISHED_NOT_INVOICED: 'Reabastecer não faturar',
    REPLENISHED_INVOICED: 'Reabastecer e faturar'
  },
  // genrals estados
  genral_status: {
    RECEIVED: 'Recebida',
    REJECTED: 'Rejeitada',
    ACCEPTED: 'Aceito',
    REJECTED_SELLER: 'Rejeitada Fornecedor',
    ERROR: 'Erro',
    FULLY_INVOICED: 'Totalmente faturado',
    PARTIALLY_INVOICED: 'Parcialmente faturado',
    ORIGINAL: 'Original',
    MODIFIED: 'Modificada'
  },
  party_gln_type: {
      GLN: 'GLN',
      EAS: 'EAS',
      SIREN: 'SIREN',
      SIRET: 'SIRET',
	  ENDPOINTID: 'ENDPOINTID'
    },
  // Metodos de entrega y recepcion
  communication_method: {
    INDRAFIN: 'Indra financeira',
    ALAVA: 'Deputação Alava',
    ANDALUCIA: 'Governo regional de Andalucia',
    AOC: 'AOC',
    CANARIAS: 'Canárias',
    DIPUTACION_VIZCAYA: 'Deputação Biscaia',
    EMAIL: 'Email',
    EMAIL_PDF: 'Email PDF',
    FACE: 'FACe',
    GUIPUZCOA: 'Deputação Guipuzcoa',
    G_VALENCIA: 'Governo regional de Valência',
    G_VASCO_EUROBITS: 'Governo Basco',
    NO_ENTREGA: 'Não entrega',
	NO_ENTREGA_RECEPCION: 'Não entrega',
    XUNTA_GALICIA: 'Governo regional de Galiza',
    OSAKIDETZA: 'Osakidetza',
    EMAIL_SIGNED: 'Email guardado',
    EMAIL_SIGNED_ATTACH: 'Email guardado e anexo',
    EMAIL_PDF_SIGNED: 'Email PDF guardado',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF,anexos e guardado',
    EMAIL_PDF_ATTACH: 'Email PDF e anexos',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF e anexos unificados',
    EMAIL_LINK: 'Email com link',
    PAPER: 'Papel',
    BANKIA: 'Bankia',
    CONSORCIO_AGUAS_BILBAO: 'Aguas Bilbao',
    ESPUBLICO: 'Espublico',
    AOC_WS: 'AOC webService',
    AYUNTAMIENTO_VITORIA: 'Prefeitura Vitoria',
    AYUNTAMIENTO_BOADILLA: 'Prefeitura Boadilla',
    VOCENTO: 'Vocento',
    MMA: 'Mutua',
    REE: 'Rede elétrica',
    AYUNTAMIENTO_AMOREBIETA: 'Prefeitura Amorebieta',
    SENADO: 'Senado',
    WS: 'Serviço web',
    UPLOAD: 'Carregamento',
    MANUAL: 'Manual',
    AYUNTAMIENTO_TORRELODONES: 'Prefeitura Torrelodones',
    ADIF: 'Adif',
    RENFE: 'Renfe',
    AYUNTAMIENTO_SANTURCE: 'Prefeitura Santurce',
    VAN: 'RVA',
    FACEB2B: 'FaceB2B',
    SFACTURA: 'sFactura',
    DOWNLOAD: 'DOWNLOAD',
    OHLSAP: 'OHLSap',
    OHLGCONS: 'OHLGcons',
    METADATA: 'Entrega dados',
    METADATA_ATTACH: 'Entregar dados e anexos',
    METADATA_ATTACH_PDF: 'Entregar dados,anexos e PDF',
    ZIPALL: 'Entrega completa',
    ZIPALL_FILES_NAMES_COUNT: 'Redeia',
    ERPEIFFAGE: 'Eiffage',
    ERPPACSA: 'Pacsa',
    ERPSARRION: 'Sarrion',
    ITALIA: 'Italia',
    INDRA: 'SAP Indra',
    AYUNTAMIENTO_COLMENAR_VIEJO: 'Prefeitura Colmenar Viejo',
    AYUNTAMIENTO_GALDAKAO: 'Prefeitura Galdakao',
    AYUNTAMIENTO_GORLIZ: 'Prefeitura Gorliz',
    ECOSYSTEM: 'Ecosystems',
    CECABANK: 'Cecabank',
    REDES: 'Redes',
    ADQUIRA: 'Adquira',
    VAN_EDICOM: 'Rva EDICOM',
    VAN_ARIBA: 'Rva ARIBA',
    VAN_SERES: 'Rva SERES',
    VAN_INDRA: 'Rva INDRA',
    PAVENTURA: 'Port Aventura',
    CANAL_ISABEL_II: 'Canal Isabel II',
    SEDEB2B: 'Sede B2B',
    VWGROUP: 'Grupo Volkswagen',
	PEPPOL: 'Peppol',
    ELECTRONET: 'Electronet',
    BSFACTURA: 'BS Fatura',
    MAPFRE: 'Mapfre',
    PGN: 'PGN',
    RSI: 'RSI',
    INDRAFE: 'Indra',
    INDITEX: 'Inditex',
    INDRAFEREC: 'Indra recepção',
    B2BCONNECT: 'B2BConnect',
    TSHIFT: 'TShift',
    INDRATOVODAFONE: 'IndraToVodafone',
    COMEX: 'Comex',
    RECKITT: 'Reckitt',
    RECKITT_DELIVERYNOTE: 'Reckitt',
    LEKEITIO: 'Lekeitio',
    AYUNTAMIENTO_ORDUNA: 'Prefeitura Orduna',
    LEA_ARTIBAI: 'Lea Artibai',
    AYUNTAMIENTO_OROZKO: 'Prefeitura Orozko',
    AYUNTAMIENTO_GUENES: 'Prefeitura Guenes',
    AYUNTAMIENTO_SESTAO: 'Prefeitura Sestao',
    AYUNTAMIENTO_ESCORIAL: 'Prefeitura Escorial',
    AYUNTAMIENTO_MUSKIZ: 'Prefeitura Muskiz',
    AYUNTAMIENTO_LEMOA: 'Prefeitura Lemoa',
    JCM: 'Junta de Castilla La Mancha',
    FCC: 'Fcc',
    AYUNTAMIENTO_BILBAO: 'Prefeitura Bilbao',
    CAIXAF: 'Caixa Factura',
    CAIXA: 'Caixa WS',
    JUNTA_ANDALUCIA: 'JDA',
    DEFAULT: 'Metodo già assegnato',
    LA_RIOJA: 'La Rioja',
    ARGENTINA: 'AFIP Argentina',
    DISANET: 'Disanet',
    FIRMAE: 'Firma-e',
    LYNTIAEMISSION: 'Lyntia',
    LYNTIARECEPTION: 'Lyntia',
    CANALRECEPTION: 'Canal',
    LYNTIA_ACCESS_EMISSION: 'Elanta',
    LYNTIA_ACCESS_RECEPTION: 'Elanta',
    RUMANIA: 'Rumania',
    FRANCE: 'França',
    INDRAFEHANA: 'IndraFE',
    INDRAFINHANA: 'IndraFin',
    COMEXHANA: 'IndraComex',
    AYUNTAMIENTO_ABADINO: 'Prefeitura de Abadiño',
    AYUNTAMIENTO_BALMASEDA: 'Prefeitura de Balmaseda',
    AYUNTAMIENTO_BERRIZ: 'Prefeitura de Berriz',
    AYUNTAMIENTO_BUSTURIA: 'Prefeitura de Busturia',
    AYUNTAMIENTO_DERIO: 'Prefeitura de Derio',
    AYUNTAMIENTO_ERANDIO: 'Prefeitura de Erandio',
    AYUNTAMIENTO_FORUA: 'Prefeitura de Forua',
    AYTO_GERNIKA_LUMO: 'Prefeitura de Gernika Lumo',
    AYUNTAMIENTO_LOIU: 'Prefeitura de Loiu',
    AYUNTAMIENTO_SANTURTZI: 'Prefeitura de Santurtzi',
    AYTO_GAUTEGIZ_ARTEAGA: 'Prefeitura de Gautegiz Arteaga',
    AYUNTAMIENTO_BERRIATUA: 'Prefeitura de Berriatua',
    AYUNTAMIENTO_TRAPAGARAN: 'Prefeitura de Trapagaran',
    AYUNTAMIENTO_ARTEA: 'Prefeitura de Artea',
    AYUNTAMIENTO_ABANTO: 'Prefeitura de Abanto',
    AYUNTAMIENTO_BARRIKA: 'Prefeitura de Barrika',
    AYUNTAMIENTO_ELORRIO: 'Prefeitura de Elorrio',
    AYUNTAMIENTO_ERENO: 'Prefeitura de Ereño',
    AYUNTAMIENTO_IURRETA: 'Prefeitura de Iurreta',
    AYUNTAMIENTO_LEMOIZ: 'Prefeitura de Lemoiz',
    AYUNTAMIENTO_LEZAMA: 'Prefeitura de Lezama',
    AYTO_MARURI_JATABE: 'Prefeitura de Maruri Jatabe',
    AYUNTAMIENTO_PLENTZIA: 'Prefeitura de Plentzia',
    AYUNTAMIENTO_SOPUERTA: 'Prefeitura de Sopuerta',
    AYUNTAMIENTO_ZALDIBAR: 'Prefeitura de Zaldibar',
    AYUNTAMIENTO_ZAMUDIO: 'Prefeitura de Zamudio',
    AYUNTAMIENTO_ZARATAMO: 'Prefeitura de Zaratamo',
    AYUNTAMIENTO_ZIERBENA: 'Prefeitura de Zierbena',
    AYUNTAMIENTO_ETXEBARRI: 'Prefeitura de Etxebarri',
    CONSOR_TRANSPOR_BIZKAIA: 'Consórcio de Transportes de Bizkaia',
    MDAD_MERINDAD_DURANGO: 'Comunidade da Merindade de Durango',
    AYUNTAMIENTO_GORDEXOLA: 'Prefeitura de Gordexola',
    AYUNTAMIENTO_MENDATA: 'Prefeitura de Mendata',
    AYUNTAMIENTO_BERMEO: 'Prefeitura de Bermeo',
    AYUNTAMIENTO_GETXO: 'Prefeitura de Getxo',
    AULA_CULTURA_GETXO: 'Sala de Cultura de Getxo',
    RESIDENCIA_MPAL_GETXO: 'Residência Municipal de Getxo',
    AYUNTAMIENTO_LEIOA: 'Prefeitura de Leioa',
    AYUNTAMIENTO_LEGAZPI: 'Prefeitura de Legazpi',
    AYUNTAMIENTO_ZUIA: 'Prefeitura de Zuia',
    AYUNTAMIENTO_ORTUELLA: 'Prefeitura de Ortuella',
    PARLAMENTO_VASCO: 'Parlamento Basco',
    AYUNTAMIENTO_ARANTZAZU: 'Prefeitura de Arantzazu',
    AYUNTAMIENTO_BAKIO: 'Prefeitura de Bakio',
    AYUNTAMIENTO_GARAI: 'Prefeitura de Garai',
    AYUNTAMIENTO_SONDIKA: 'Prefeitura de Sondika',
    AYUNTAMIENTO_URDULIZ: 'Prefeitura de Urduliz',
    AYUNTAMIENTO_BEDIA: 'Prefeitura de Bedia',
    AYUNTAMIENTO_ALONSOTEGI: 'Prefeitura de Alonsotegi',
    AYUNTAMIENTO_ARAKALDO: 'Prefeitura de Arakaldo',
    AYUNTAMIENTO_AREATZA: 'Prefeitura de Areatza',
    AYTO_ARRIGORRIAGA: 'Prefeitura de Arrigorriaga',
    AYUNTAMIENTO_BERANGO: 'Prefeitura de Berango',
    AYUNTAMIENTO_DURANGO: 'Prefeitura de Durango',
    AYUNTAMIENTO_GALDAMES: 'Prefeitura de Galdames',
    AYUNTAMIENTO_GAMIZ_FIKA: 'Prefeitura de Gamiz-Fika',
    AYUNTAMIENTO_ISPASTER: 'Prefeitura de Ispaster',
    AYUNTAMIENTO_IZURTZA: 'Prefeitura de Izurtza',
    AYUNTAMIENTO_MANARIA: 'Prefeitura de Manaria',
    AYUNTAMIENTO_MORGA: 'Prefeitura de Morga',
    AYUNTAMIENTO_MUXIKA: 'Prefeitura de Muxika',
    AYTO_TRUCIOS_TURTZIOZ: 'Prefeitura de Trucios-Turtzioz',
    AYUNTAMIENTO_UBIDE: 'Prefeitura de Ubide',
    AYTO_UGAO_MIRABALLES: 'Prefeitura de Ugao-Miraballes',
    MDAD_URIBE_KOSTA: 'Mancomunidad Uribe Kosta',
    AYUNTAMIENTO_ZEANURI: 'Prefeitura de Zeanuri',
    AYUNTAMIENTO_ZEBERIO: 'Prefeitura de Zeberio',
    AYTO_ZIORTZA_BOLIBAR: 'Prefeitura de Ziortza-Bolibar',
    ARARTEKO: 'Ararteko',
    AYUNTAMIENTO_BASAURI: 'Prefeitura de Basauri',
    AYUNTAMIENTO_AJANGIZ: 'Prefeitura de Ajangiz',
    AYUNTAMIENTO_AMOROTO: 'Prefeitura de Amoroto',
    AYTO_ARRANKUDIAGA: 'Prefeitura de Arrankudiaga',
    ARRATIAKO_UDALEN: 'Arratiako Udalen Mankomunitatea',
    AYUNTAMIENTO_ARRATZU: 'Prefeitura de Arratzu',
    AYUNTAMIENTO_ARRIETA: 'Prefeitura de Arrieta',
    AYTO_ARTZENTALES: 'Prefeitura de Artzentales',
    AYUNTAMIENTO_ATXONDO: 'Prefeitura de Atxondo',
    AYUNTAMIENTO_AULESTI: 'Prefeitura de Aulesti',
    AYTO_IBARRANGELU: 'Prefeitura de Ibarrangelu',
    AYUNTAMIENTO_DIMA: 'Prefeitura de Dima',
    AYUNTAMIENTO_EA: 'Prefeitura de Ea',
    MDAD_ENCARTACIONES: 'Mancomunidad de las Encartaciones',
    AYUNTAMIENTO_ERRIGOITI: 'Prefeitura de Errigoiti',
    AYUNTAMIENTO_ETXEBARRIA: 'Prefeitura de Etxebarria',
    AYUNTAMIENTO_FRUIZ: 'Prefeitura de Fruiz',
    AYUNTAMIENTO_GATIKA: 'Prefeitura de Gatika',
    AYUNTAMIENTO_IGORRE: 'Prefeitura de Igorre',
    AYTO_VALLE_CARRANZA: 'Prefeitura de Valle de Carranza',
    AYUNTAMIENTO_KORTEZUBI: 'Prefeitura de Kortezubi',
    AYUNTAMIENTO_LARRABETZU: 'Prefeitura de Larrabetzu',
    AYUNTAMIENTO_LAUKIZ: 'Prefeitura de Laukiz',
    AYUNTAMIENTO_MALLABIA: 'Prefeitura de Mallabia',
    AYTO_MARKINA_XEMEIN: 'Prefeitura de Markina-Xemein',
    AYUNTAMIENTO_MENDEXA: 'Prefeitura de Mendexa',
    AYUNTAMIENTO_MENAKA: 'Prefeitura de Menaka',
    AYUNTAMIENTO_MUNDAKA: 'Prefeitura de Mundaka',
    AYUNTAMIENTO_MUNITIBAR: 'Prefeitura de Munitibar',
    AYUNTAMIENTO_MURUETA: 'Prefeitura de Murueta',
    AYUNTAMIENTO_NABARNIZ: 'Prefeitura de Nabarniz',
    AYUNTAMIENTO_OTXANDIO: 'Prefeitura de Otxandio',
    AYTO_SUKARRIETA_PEDERNALES: 'Prefeitura de Sukarrieta-Pedernales',
    MDAD_TXORIERRI: 'Mancomunidad de Txorierri',
    MDAD_BUSTURIALDE: 'Mancomunidad de Busturialde',
    AYUNTAMIENTO_LANESTOSA: 'Prefeitura de Lanestosa',
    UDAL_SAREAK: 'Udal Sareak',
    REDE_ES: 'Red.es'
  },

  // modulos estados de tareas pendientes
  module: {
    ACCOUNTING_CLOSE: 'Encerramentos contábeis',
    PENDING_TASKS_CHANGE_STATUS: 'Redefinição de estado em tarefas pendentes',
    PENDING_TASKS: 'Tarefas pendentes',
    CMR: 'DeCA',
    CONTROLDOCUMENT: 'Controle de documentos',
    CONTROLDOCUMENTLINK: 'Controle de documentos link'
  },
  job_status: {
    RUNNING: 'Em execução',
    NORMAL: 'Em espera',
    PAUSED: 'Lento',
    NONE: 'Nenhum',
    COMPLETE: 'Concluído',
    ERROR: 'Erro',
    BLOCKED: 'Bloqueado'
  },
  // Estado de factura
  invoice_status: {
    ANNULLED: 'Anulada',
    ERROR: 'Erro',
    REJECTED: 'Rejeitada',
    RECEIVED: 'Recebida',
    CANCELLED: 'Cancelada',
    DISAGREEMENT: 'Não compatível',
    PENDING_OF_SIGNING: 'Pendente de assinatura',
    PENDING_OF_SEND: 'Pendende de envio',
    PENDING_OF_VERIFYING: 'Pendente de verificação',
    PENDING_OF_GENERATE: 'Geração pendente',
    PENDING_OF_REPORTING: 'Pendente de reporte',
    REPORTED: 'Reportada',
    YIELDED: 'Cedido',
    COMPENSATED: 'Compensado',
    PENDING_OF_COMPENSATION: 'Compensação pendente',
    PENDING_OF_CONFIRM: 'A ser confirmado',
    COLLECTED: 'Carregada',
    PENDING: 'Pendente',
    PENDING_OF_ACCEPTING: 'Pendente de aceptação',
    PENDING_OF_VALIDATION: 'Pendente de validação',
    IN_PROCESS: 'Em tramitação',
    OPENED: 'Aberta',
    SIGNED: 'Assinada',
    SENDED: 'Enviada',
    REGISTERED: 'Registada por cliente',
    ACCEPTED: 'Aceite',
    ACCOUNTED: 'Lançada',
    PENDING_OF_PAYMENT: 'Pagamento em atraso',
    PARTIALLY_PAID: 'Parcialmente pagada',
    PARTIALLY_ACCEPTED: 'Parcialmente aceite',
    PAID: 'Pagada',
    RETAINED: 'Retenida',
    AWAITING_PAYMENT: 'Pagamento em fila de espera',
    CONSOLIDATED: 'Consolidada',
    DELIVERED: 'Entregada',
    DELIVERYCONFIRMED: 'Entrega confirmada',
    SENT_TO_PAYMENT: 'Enviada para pagamento',
    INVOICE_RESPONSE: 'Pagamento em atraso',
    WITHOUT_INTERNAL_STATUS: 'Sem estado interno',
    REJECTED_REDIGITALIZATION: 'Redigitalizada',
    INVOICE_SIGNATURE: 'Fatura para assinatura',
    PROPOSALS_SIGNATURE: 'Proposta para assinatura',
    SEND_PROPOSED_STATE: 'Enviado estado proposta',
    SENT: 'Enviada',
    WAITING_CALLBACK: 'Nenhum estado interno',
    RETAINED_PAYMENT: 'Pagamento retido',
    VALIDATIONACCEPTED: 'Validação aceite',
    VALIDATIONERROR: 'Erro de validação',
    LOADING: 'Carregando',
    FINISH: 'Finalizado',
    CHANGE_DRIVER: 'Mudança de motorista',
    ON_RUTE: 'Em rota',
    DRAFT: 'Rascunho',
    ACCEPT: 'Aceito',
    VISUALIZED: 'Visualizado',
  },

  // Campo enviada
  invoice_sent_flag: {
    SENT: 'Enviada',
    PENDING_OF_SEND: 'Pendente de envio',
    NOT_SENT: 'Não enviado'
  },

  // Estado del albaran
  deliverynote_status: {
    SENT: 'Mandar',
    ACCEPTED: 'Aceitaram',
    REJECTED: 'Rejeitado',
    ERROR: 'Erro',
    RECEIVED: 'Recebido',
    FULLY_INVOICED: 'Totalmente faturado',
    PARTIALLY_INVOICED: 'Parcialmente faturado',
    PARTIALLY_RECEIVED: 'Recebido parcialmente',
    IN_PROCESS: 'Em tramitação',
    PENDING_OF_SEND: 'Pré-emitido',
    PARTIALLY_SENT: 'Expedido parcialmente',
    FULLY_SENT: 'Expedido totalmente'
  },

  // Estado de cmr
  cmr_status: {
    PENDING_OF_SEND: 'Pendiente de envío',
    LOADING: 'Cargando',
    IN_PROCESS: 'En curso',
    FINISH: 'Finalizado',
    CHANGE_DRIVER: 'Cambio de conductor',
    CANCELLED: 'Viaje cancelado',
    ANNULLED: 'Anulado',
    SENT: 'Enviado',
    ON_RUTE: 'Em rota',
    DRAFT: 'Borrador',
    REJECTED: 'Rechazado',
    ACCEPT: 'Aceito',
    VISUALIZED: 'Visualizado',
    ERROR: 'Error',
  },

  // Divisas
  currency: {
    AUD: 'Dólar australiano',
    ALL: 'Leque albanês',
    DZD: 'Dinar argelino',
    ARS: 'Peso argentino',
    AWG: 'Florim arubano',
    GBP: 'Libra esterlina',
    BSD: 'Dólar baamiano',
    BHD: 'Dinar barenita',
    BDT: 'Taca bangladexense',
    BBD: 'Dólar barbadense',
    BYR: 'Rublo bielorruso',
    BZD: 'Dólar de Belice',
    BMD: 'Dólar bermudense',
    BTN: 'Ngúltrume butanês',
    BOB: 'Boliviano',
    BWP: 'Pula do Botsuana',
    BRL: 'Real',
    BND: 'Dólar do Brunei',
    BGN: 'Leve búlgaro',
    BIF: 'Franco burundiano',
    CAD: 'Dólar canadiano',
    CNY: 'Iuane chinês',
    KHR: 'Riel cambojano',
    CVE: 'Escudo cabo-verdiano',
    KYD: 'Dólar das Ilhas Caimão',
    XOF: 'Franco CFA (BCEAO)',
    XAF: 'Franco CFA (BEAC)',
    CLP: 'Peso chileno',
    COP: 'Peso colombiano',
    KMF: 'Franco comorense',
    CRC: 'Colom costa-riquenho',
    HRK: 'Cuna croata',
    CUP: 'Peso cubano',
    CZK: 'Coroa checa',
    DKK: 'Coroa dinamarquesa',
    DJF: 'Franco jibutiano',
    DOP: 'Peso dominicano',
    EUR: 'Euro',
    XCD: 'Dólar das Caraíbas Orientais',
    EGP: 'Libra egípcia',
    SVC: 'Dólar dos Estados Unidos',
    EEK: 'Euro',
    ETB: 'Birre etíope',
    FKP: 'Livra das Ilhas Malvinas',
    FJD: 'Dólar fijiano',
    GMD: 'Dalasi gambiano',
    GTQ: 'Quetzal guatemalteco',
    GNF: 'Franco guineense',
    GYD: 'Dólar guianense',
    GHS: 'Cedi do Gana',
    HKD: 'Dólar de Honguecongue',
    HTG: 'Gurde haitiano',
    HNL: 'Lempira hondurenha',
    HUF: 'Florim húngaro',
    IDR: 'Rupia indonésia',
    INR: 'Rupia indiana',
    ISK: 'Coroa islandesa',
    IRR: 'Rial iraniano',
    IQD: 'Dinar iraquiano',
    ILS: 'Novo Shekel israelita',
    JPY: 'Iene japonês',
    JOD: 'Dinar jordano',
    KZT: 'Tenge cazaque',
    KES: 'Xelim queniano',
    KRW: 'Won sul-coreano',
    KWD: 'Dinar cuaitiano',
    KGS: 'Som quirguiz',
    MOP: 'Pataca macaense',
    MKD: 'Dinar macedonio',
    MWK: 'Kwacha malauiano',
    MYR: 'Ringuite malaio',
    MVR: 'Rupia maldiva',
    MRO: 'Uguia mauritana',
    MUR: 'Rupia maurícia',
    MXN: 'Peso mexicano',
    MDL: 'Leu moldávio',
    MNT: 'Tugrique mongol',
    MAD: 'Dirame marroquino',
    MMK: 'Kyat de Mianmar',
    NAD: 'Dólar namibiano',
    NPR: 'Rupia nepalesa',
    ANG: 'Florim antilhano',
    NZD: 'Dólar neozelandês',
    NIO: 'Córdoba nicaraguano',
    NGN: 'Naira nigeriano',
    KPW: 'Won norte-coreano',
    NOK: 'Coroa norueguesa',
    OMR: 'Rial omanense',
    XPF: 'Franco CFP',
    PKR: 'Rupia paquistanesa',
    PAB: 'Balboa panamense',
    PGK: 'Kina papuásia',
    PYG: 'Guarani paraguaio',
    PEN: 'Novo sol peruano',
    PHP: 'Peso filipino',
    PLN: 'Zlóti polaco',
    QAR: 'Rial catarense',
    RON: 'Leu romeno',
    RUB: 'Rublo russo',
    RWF: 'Franco ruandês',
    CHF: 'Franco suiço',
    WST: 'Tala samoana',
    STD: 'Dobra de São Tomé e Príncipe',
    SAR: 'Rial saudita',
    SCR: 'Rupia seichelense',
    SLL: 'Leone serra-leonnino',
    SGD: 'Dólar de Singapura',
    SKK: 'Koruna eslováquia ',
    SBD: 'Dólar das Ilhas Salomão',
    SOS: 'Xelim somaliano',
    ZAR: 'Rand sul-africano ',
    LKR: 'Rupia do Sri Lanka',
    SHP: 'Libra de Santa Helena',
    SDG: 'Libra sudanesa',
    SZL: 'Lilangeni suazilandês',
    SEK: 'Coroa sueca',
    SYP: 'Libra síria',
    THB: 'Baht tailandês',
    TRY: 'Lira turca',
    TWD: 'Novo dólar taiwanês',
    TZS: 'Xelim tanzaniano',
    TOP: 'Paanga tonganesa',
    TTD: 'Dólar de Trindade e Tobago',
    TND: 'Dinar tunisino',
    USD: 'Dólar estadunidense',
    AED: 'Dirame dos Emirados Árabes Unidos',
    UGX: 'Xelim ugandês',
    UAH: 'Grívnia ucraniana',
    UYU: 'Peso uruguaio',
    UZS: 'Som usbeque',
    VUV: 'Vatu do Vanuatu',
    VND: 'Dongue vietnamita',
    VES: 'Bolívar venezuelano',
    YER: 'Rial iemenita',
    ZMK: 'Kwacha zambiano',
    PES: 'Peso',
    JMD: 'Dolar do Jamaica'
  },

  // Estados de auditoría
  auditory_status: {
    DELIVERED: 'Entregado',
    DELIVERYCONFIRMED: 'Entrega confirmada',
    DIVIDED: 'Dividido',
    ERROR: 'Erro',
    DELETED: 'Eliminado',
    CREATED: 'Criado',
    UPDATED: 'Atualizado',
    EXTRACTED: 'Extraído',
    GENERATED: 'Gerado',
    INCOMINGERROR: 'Erro de entrada',
    INTEGRATED: 'Integrado',
    PENDINGOFDELIVERY: 'Pendente de envio',
    DISCARDED: 'Descartado',
    RECEIVED: 'Recebido',
    RECOGNIZED: 'Reconhecido',
    SIGNED: 'Assinado',
    DISAGREEMENT: 'Não compatível',
    PENDING_OF_SIGNING: 'Pendente de assinatura',
    PENDING_OF_SEND: 'Pendende de envio',
    TRANSFORMED: 'Transformado',
    ERROR_WS_DOCUMENT: 'Erro serviço de integração de documentos',
    ERROR_WS_NOTIFICATION: 'Erro serviço de integração de notificações',
    SENT_TO_PAYMENT: 'Enviada para pagamento',
    WAITING_CALLBACK: 'Nenhum estado interno',
    WARNING: 'Aviso',
    VALIDATIONACCEPTED: 'Validação aceite',
    VALIDATIONERROR: 'Erro de validação'
  },

  // Tipos de documentos auditoria
  auditory_doc_type: {
    INVOICE: 'Fatura',
    DIGITIZEDINVOICE: 'Fatura digitalizada',
    ATTACHMENT: 'Anexos',
    UPDATE_STATUS: 'Estados de fatura',
    UPDATE_INTERNAL_STATUS: 'Estados internos de fatura',
    INVOICE_RESPONSE: 'Ficheiro de resposta de fatura',
    BATCHFILE: 'Lote',
    RECADV: 'Recadv',
    OTHER: 'Outros',
    RECEIVEADVICE: 'Recepção',
    PURCHASEORDER: 'Encomenda',
    ORDER: 'Encomenda',
    ORDERRSP: 'Resposta do encomenda',
    DELIVERYNOTE: 'Nota de entrega',
    GENRAL: 'Genral',
    GENERAL: 'Genral note',
    CMR: 'DeCA',
    USER: 'Utilizadores',
    PARTY: 'Empresas',
    STATUS: 'Estados',
    SALESREPORT: 'Relatório de vendas',
    INVENTORYREPORT: 'Relatório de inventário',
    REMADV: "Aviso de liquidação",
    COACSU: "Resumo de conta comercial",
    CONTROLDOCUMENT: "Documento de controle",
  },

  // Tipos de formatos de documentos auditoria
  auditory_doc_format: {
    FACTURAE32: 'FACTURAE32',
    FACTURAE321: 'FACTURAE321',
    INVOIC_D96A: 'INVOIC_D96A',
    INVOIC_D97A: 'INVOIC_D97A',
    INVOIC_D93A: 'INVOIC_D93A',
    XML_AECOC: 'XML_AECOC',
    PDF: 'PDF',
    PDF_A: 'PDF-A',
    UBL20: 'UBL20',
    ZIP: 'ZIP',
    CSV: 'CSV',
    PLAIN_ALTCLI: 'PLANO REGISTO CLIENTES',
    XML_ENVEST: 'XML ENVIO ESTADOS',
    TXT: 'TXT',
    PLAIN_ENVRES: 'PLANO ENVIO RESPOSTA',
    XML_SANTILLANA: 'XML SANTILLANA',
    XML_B2B_RECADV: 'XML B2B RECEPÇÃO',
    INVOIC_D01B: 'INVOIC_D01B',
    PLAIN_ALTPRO: 'PLAIN_ALTPRO',
    FACTURAE322: 'FACTURAE322',
    FATTURAPA12: 'FATTURAPA12',
    FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
    FATTURAPA12_CADES: 'FATTURAPA12_CADES',
    FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
    XML_B2B_ORDER: 'XML B2B encomenda',
    XML_B2B_ORDERRSP: 'XML B2B resposta do encomenda',
    XML_B2B_DELIVERYNOTE: 'XML B2B nota de entrega',
    XML_B2B_INVOICE: 'XML B2B METADATOS',
    GENRAL_D96A: 'GENRAL D96A',
    CSV_B2B_PARTY: 'CSV Empresas',
    DIGITALIZED_DELIVERYNOTE: 'Nota de entrega digitalização',
    CXML_INVOICE: 'CXML',
    FEV1: 'FEV1',
    FATTURAPA11: 'FATTURAPA11',
    FATTURAPA10: 'FATTURAPA10',
    FISI: 'FISI',
    UBL21: 'UBL21',
    ORDERS_D96A: 'ORDERS_D96A',
    FACTURAE30: 'FACTURAE30',
    FACTURAE31: 'FACTURAE31',
    XCBL40: 'XCBL40',
    '3C3': 'RosettaNet',
    XML_B2B_CMR: 'XML_B2B_CMR',
    DESADV_D96A: 'DESADV_D96A',
    XML_B2B_GENRAL: 'XML_B2B_GENRAL',
    CSV_B2B_USER: 'CSV_B2B_USER',
    XML_B2B_INVOICE_STATUS: 'XML_B2B_INVOICE_STATUS',
    XML_B2B_RECADV_STATUS: 'XML_B2B_RECADV_STATUS',
    XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
    CII: 'CII',
    XML_CANONICAL_B2B_INVOICE: 'XML CANONICAL B2B INVOICE',
  },

  // Protocolos de comunicación en auditoría
  auditory_communication_protocol: {
    SSH_FTP: 'SFTP',
    WS: 'Webservice',
    AS2: 'AS2',
    EMAIL: 'Correio eletrónico',
    OTX: 'VAN',
    FILESYSTEM: 'Entrega interna',
    VALIDATION_WS: 'WS validação',
    REST: 'Serviço de descanso',
    WEB: 'Portal da Web'
  },

  // Modulos  auditoria
  auditory_module: {
    EXCHANGE_WS_SEND: 'Envio de faturas',
    EXCHANGE_WS_STATUS: 'Consulta de status',
    EXCHANGE_WS_CHANGE: 'Mudança de status',
    EXCHANGE_WS_DOWNLOAD: 'Baixe',
    MASSIVE_PARTY: 'Carregamento em massa de empresas',
    PARTY: 'Empresas',
    CENTRE: 'Centros',
    PAYMENT: 'Dados de pagamento',
    USER: 'Utilizadores',
    WS_VALIDATION: 'WS de validação',
    RECADV: 'Recepções',
    EDITRACK_DOCUMENT_INTEGRATION: 'Integração Editrack',
    EDITRACK_DOCUMENT_NOTIFICATION: 'Notificação Editrack',
    CMR: 'DeCA',
    ORDER: 'Encomendas',
    DELIVERY_NOTE: 'Notas de entrega',
    SIGNATURE_PLATFORM: 'Plataforma de assinatura'
  },

  // Categorias de documentos
  documentation_category: {
    EXAMPLE: 'Exemplo',
    FUNCTIONAL_ANALYSIS: 'Analise funcional',
    INTEGRATION_DOCUMENT: 'Documento de integração',
    OFFER: 'Oferta',
    USER_MANUAL: 'Manual de utilizador',
    INFORMATIVE_DOCUMENT: 'Documento informativo',
    USER_INFORMATION: 'Informações ao usuário'
  },

  // Idioma documentos
  documentation_language: {
    spanish: 'Espanhol',
    english: 'Inglês',
    italian: 'Italiano',
    portuguese: 'Português',
    french: 'Francês'
  },

  // Estados de cierres contables
  status_accounting_close: {
    Abierto: 'Aberto',
    Cerrado: 'Fechado'
  },

  // Clases de documento
  document_class: {
    COPY: 'Cópia',
    ORIGINAL: 'Original',
    DUPLICATE: 'Cópia',
    ADDITIONAL_TRANSMISSION: 'Adicional',
    REPLACE: 'Retificativa',
    ADDITION: 'Adição'
  },

  // Clases de ciclos de documentos
  document_cycle_class: {
    DELIVERY_VALIDATION_PACKAGE_GTIN14: 'Validação do GTIN14 das linhas da nota de entrega',
    INVOICE_LINES_EDITABLE_FIELDS: 'Valida de acordo com o subtipo das linhas de recepção se as linhas devem ser criadas e se são editáveis',
    INVOICE_FROM_ORDER_TYPE_SUBTYPE: 'Valide o tipo e/ou subtipo do pedido para criar uma fatura com alguns campos não editáveis',
    VALIDATION_ORDER_RESPONSE_REQUIRED: 'Validação da existência de resposta de pedido anterior'
  },

  // Tipos de factura
  invoice_type: {
    PROFORMA: 'Pro-forma',
    COMMERCIAL: 'Comercial',
    CREDIT_NOTE: 'Nota de crédito',
    DEBIT_NOTE: 'Nota de débito',
    CONSOLIDATED: 'Consolidada',
    SELF_BILLED: 'Autofatura'
  },

  // Tipo de documento de factura
  invoice_document_type: {
    FC: 'Fatura completa',
    FA: 'Fatura resumida',
    AF: 'Autofatura',
    AN: 'Fatura adiantamento',
    PF: 'Fatura pro-forma',
    NL: 'Não logístico'
  },

  delivery_note_type: {
    NO_LOGISTIC: 'Não logística',
    LOGISTIC_TWO_LEVELS: 'Logística de 2 níveis. Mercadorias em geral',
    LOGISTIC_THREE_LEVELS: 'Logística de 3 níveis. Consumo de massa'
  },

  // Tipos de servicios
  project_type: {
    seller: 'Emissão',
    buyer: 'Recepção',
    both: 'Ambos'
  },

  // Tipos de empresa
  party_type: {
    seller: 'Vendedor',
    buyer: 'Comprador',
    third: 'Terceiro',
    both: 'Ambos'
  },

  // Método de entrega
  party_type_meth: {
    emission: 'Emissão',
    reception: 'Recepção',
    both: 'Ambos'
  },

  // Método de entrega project
  project_type_meth: {
    emission: 'Emissão',
    reception: 'Recepção'
  },

  chart_legend: {
    from_others: 'Faturas',
    from_orders: 'Faturas de pedidos',
    from_recadvs: 'Faturas de recebimentos',
    from_deliverynotes: 'Faturas de notas de entrega',
    invoices_emitted: 'Faturas emitidas',
    invoices_received: 'Faturas recebidas',
    parties_registered: 'Empresas registradas',
    invoices_redigitized: 'Faturas redigitalizadas',
    invoices_rejected: 'Faturas rejeitadas'
  },
  // Tipos de tabla
  chart_type: {
    title: 'Tipo tabela',
    economic: 'Volume econômico',
    invoice: 'Número de faturas'
  },
  // Tipos de persona
  person_type: {
    physical: 'Física',
    legal: 'Jurídica'
  },
  // Forma de pago
  paymentmethod: {
    CASH: 'Dinheiro',
    CHECK: 'Verifique',
    CONFIRMING: 'Confirming',
    TRANSFER: 'Transferir'
  },
  // Formato de documento
  document: {
    format: {
      FACTURAE32: 'FACTURAE32',
      FACTURAE321: 'FACTURAE321',
      FACTURAE322: 'FACTURAE322',
      FATTURAPA12: 'FATTURAPA12',
      FATTURAPA_SEMPLIFICATA: 'FATTURAPA_SEMPLIFICATA',
      FATTURAPA12_CADES: 'FATTURAPA12_CADES',
      FATTURAPA_SEMPLIFICATA_CADES: 'FATTURAPA_SEMPLIFICATA_CADES',
      INVOIC_D96A: 'INVOIC_D96A',
      INVOIC_D97A: 'INVOIC_D97A',
      INVOIC_D93A: 'INVOIC_D93A',
      XML_AECOC: 'XML_AECOC',
      PDF: 'PDF',
      PDF_A: 'PDF-A',
      ZIP: 'ZIP',
      CSV: 'CSV',
      UBL20: 'UBL20',
      PLAIN_ALTCLI: 'Plano registo clientes',
      XML_ENVEST: 'XML envio estados',
      PLAIN_ENVRES: 'Plano envio resposta',
      XML_SANTILLANA: 'XML SANTILLANA',
      XML_B2B_RECADV: 'XML B2B RECEPÇÃO',
      INVOIC_D01B: 'INVOIC_D01B',
      PLAIN_ALTPRO: 'PLAIN_ALTPRO',
      XML_B2B_ORDER: 'XML B2B encomenda',
      XML_B2B_ORDERRSP: 'XML B2B resposta do encomenda',
      XML_B2B_DELIVERYNOTE: 'XML B2B nota de entrega',
      XML_B2B_INVOICE: 'XML B2B METADATOS',
      GENRAL_D96A: 'GENRAL D96A',
      CSV_B2B_PARTY: 'CSV Empresas',
      DIGITALIZED_DELIVERYNOTE: 'Nota de entrega digitalização',
      CXML_INVOICE: 'CXML',
      FEV1: 'FEV1',
      FATTURAPA11: 'FATTURAPA11',
      FATTURAPA10: 'FATTURAPA10',
      FISI: 'FISI',
      UBL21: 'UBL21',
      ORDERS_D96A: 'ORDERS_D96A',
      FACTURAE30: 'FACTURAE30',
      FACTURAE31: 'FACTURAE31',
      XCBL40: 'XCBL40',
      XML_B2B_SLSRPT: 'XML_B2B_SLSRPT',
      CII: 'CII',
      XML_CANONICAL_B2B_INVOICE: 'XML CANONICAL B2B INVOICE',
    }
  },
  categories: {
    OTHERS: 'Outros',
    AUTOMATIC: 'Automático',
    INCORRECT_ATTACHS: 'Anexos: Falta documentação ou está incorreta',
    INCORRECT_CENTER: 'Centro incorreto',
    INCORRECT_DETAIL: 'Concepto incorreto ou falta detalhe',
    PARTY_CONTRACTING: 'Contratação empresa',
    INCORRECT_FISCAL: 'Dados fiscais incorretos',
    INCORRECT_RELATION: 'Documentos associados incorretos',
    ACCOUNTING_NOT_EXIST: 'Fatura retificada não lançada ou não existe',
    DUPLICATED_INVOICE: 'Fatura duplicada',
    INCORRECT_DELIVERY_DATE: 'Data/periodo de prestação de serviços incorreto',
    INCORRECT_AMOUNTS: 'Montantes incorretos',
    REDIGITALIZATION: 'Redigitalização',
    INCORRECT_ENTRY: 'Requisitos de entrada incorretos',
    PAPER: 'Tratamento em papel',
    WRONG_CAPTURED: 'Campo mal capturado',
    NO_CAPTURED: 'Campo não capturado',
    WRONG_FIELD_CAPTURED: 'Campo capturado incorreto',
    NO_CATEGORY: 'Sem categoria',
    INCORRECT_OCR_DATA: 'Validação de OCR'
  },

  // Tipo de extensión de factura
  extension_type: {
    FACEB2B: 'Extensão FACe B2B'
  },

  // Roles para centros
  centre_role_type: {
    payer: 'Pagador/Ud.Processadora',
    payee: 'Recetor da alteração',
    invoicee: 'Faturado',
    finalclient: 'Cliente final',
    ship_to: 'Lugar de entrega',
    ship_from: 'Envio desde',
    receiver: 'Recetor/Org.Gestão',
    buyer: 'Comprador/Org.Proponente',
    collector: 'Cobrador',
    seller: 'Vendedor',
    payment_receiver: 'Recetor do pagamento',
    collection_receiver: 'Recetor da cobrança',
    issuer: 'Emissor',
    fiscal: 'Fiscal/Serv.Contabilístico'
  },
  centre_role_type_order: {
    payer: 'Pagador',
    payee: 'Recetor da alteração',
    invoicee: 'Faturado',
    finalclient: 'Cliente final',
    ship_to: 'Lugar de entrega',
    ship_from: 'Envio desde',
    receiver: 'Recetor',
    buyer: 'Comprador',
    collector: 'Cobrador',
    seller: 'Vendedor',
    payment_receiver: 'Recetor do pagamento',
    collection_receiver: 'Recetor da cobrança',
    issuer: 'Emissor',
    fiscal: 'Fiscal'
  },
  // Estadísticas
  statistic: {
    emitted_title: 'Volume de faturas emitidas',
    received_title: 'Volume de faturas recebidas',
    other_title: 'Faturas geradas a partir de outro documento, pedido, recebimento ou guia de remessa',
    topseller_title: 'Os 20 principais fornecedores por volume econômico e número de faturas',
    parties_title: 'Volume de empresas registradas',
    rejected_invoice_title: 'Faturas: Tipos de rejeições e motivos para redigitalização',
    symbol: 'Faturas',
    party_type: 'Tipo de empresas',
    party_sponsor: 'Propietário',
    invoice_status_title: 'Status da fatura',
    total_party: 'Total de empresas acumuladas'
  },
  // Documentacion
  documentation: {
    documentation_entity_table: {
      project: 'Serviço',
      name: 'Nome',
      category: 'Categoria',
      language: 'Língua'
    },
    buttons: {
      new_document: 'Carregar',
      download_multiple: 'Baixar',
      new_document_tooltip: 'Carregar documento',
      download_multiple_tooltip: 'Baixar documento/s'
    },
    dialog_add_documentation: {
      title: 'Carregar documentação',
      deletefile: 'Eliminar ficheiro de documentação',
      updatetitle: 'Actualizar documentação',
      project: {
        label: 'Serviço',
        placeholder: 'Escolha um serviço'
      },
      categoria: {
        label: 'Categoria',
        placeholder: 'Escolha uma categoria'
      },
      nombre: {
        label: 'Nome documento'
      },
      url: {
        label: 'URL'
      },
      idioma: {
        label: 'Língua',
        placeholder: 'Escolha uma língua'
      },
      urlorfile_required: 'O URL ou o ficheiro é obrigatório'
    },
    error: {
      validation: {
        parametro_obligatorio_idioma: 'O idioma é um parâmetro obrigatório',
        parametro_obligatorio_nombre: 'O nome é um parâmetro obrigatório',
        parametro_obligatorio_documentation: 'O ficheiro ou o url é obrigatório',
        duplicated: 'A documentação para o serviço já existe',
        size_exceeded: 'O tamanho do ficheiro excede o máximo permitido de 10 MB'
      },
      error_generico: 'Erro ao carregar a documentação'
    }
  },

  documentation_detail: {
    buttons: {
      document: 'Documento',
      eraseDocument: 'Eliminar'
    },
    documentation_detail_form: {
      project: 'Serviço',
      name: 'Nome',
      category: 'Categoria',
      language: 'Língua'
    },
    confirm: {
      title_delete_documentation: 'Tem certeza de que deseja eliminar este documento?',
      confirm_button_delete_documentation: 'Eliminar',
      title_upload_documentation: 'Tem certeza de que deseja substituir este documento?',
      confirm_button_upload_documentation: 'Substituir'
    },
    notify: {
      delete_document_ok: 'O documento foi eliminado com sucesso.',
      upload_document_ok: 'A documentação foi atualizado com sucesso.'
    },
    load: {
      download: 'Baixando documento ...',
      delete_document: 'Eliminando documento ...',
      upload_document: 'Carregando o documento ...'
    }
  },
  NO_PENDING_TASK_STATUS: 'Os estados configurados para o serviço selecionado não foram encontrados.',
  display_documents: {
    PDF_INDRA: 'PDF Indra',
    PDF_OHL_PERU: 'PDF para OHL Peru',
    PDF_RENFE: 'PDF para Renfe',
    PDF_INDRAFE: 'PDF para IndraFE',
    PDF_SARQUAVITAE: 'PDF para Sarquavitae',
    PDF_RENFE_RECADV: 'PDF para recepções Renfe',
    PDF_CATEGORY: 'PDF anexo categorizado',
    PDF_TOYOTA: 'PDF para Toyota Canárias',
    PDF_IDCSALUD: 'PDF para IDC Saúde',
    PDF_RECADV: 'PDF recepções por defeito',
    PDF_ENDESA: 'PDF para Endesa',
    PDF_QUIRON_RECADV: 'PDF para Quiron',
    PDF_ORDER: 'PDF para pedido',
    PDF_QUIRON_ORDER: 'PDF para pedido de Quiron',
    PDF_DELIVERYNOTE: 'PDF para nota de entrega',
    PDF_GENRAL: 'PDF per Genral',
    PDF_RENFE_SUPPLIER_DATA: 'PDF per dados do fornecedor',
    PDF_RENFE_SOCIETIES_RECADV: 'PDF per empresas de recepção',
    PDF_REDSYS: 'PDF para Redsys',
    PDF_GNUBILA: 'PDF para Gnubila',
    PDF_OHL: 'PDF para OHL',
    PDF_ORDER_INDRA: 'PDF para pedido Indra',
    PDF_NISSAN: 'PDF para Nissan',
    PDF_GONVARRI: 'PDF para Gonvarri',
    PDF_CONSUM: 'PDF para Consum',
    PDF_TELEFONICATECH: 'PDF para Telefónica Tech',
    PDF_DRAFT_INDRA: 'PDF temporário para rascunhos',
    PDF_OTIS: 'PDF para Otis',
    PDF_LYNTIA_GLOBAL: 'PDF Lyntia Global Fontibre',
    PDF_LYNTIA_CODINET: 'PDF Lyntia Codinet',
    PDF_LYNTIA_NETWORKS: 'PDF Lyntia Networks',
    PDF_LYNTIA_TOWERNET: 'PDF Lyntia Towernet',
    PDF_LYNTIA_ELANTA: 'PDF Lyntia Elanta',
    PDF_CANAL: 'PDF para Canal',
    PDF_REDEIA: 'REDEIA PDF',
    PDF_RENFE_AMERICA: 'PDF Renfe of America',
    PDF_CORREOS_EXPRESS: 'PDF Correos Express',
    PDF_CMR_MAHOU: 'PDF CMR Mahou',
    PDF_CMR_TKAS: 'PDF CMR TKAS',
    PDF_CMR_ECMR: 'PDF documento de transporte',
    PDF_ACCIONA_ENERGIA: 'PDF Acciona Energia',
    PDF_ABOGACIA: 'PDF Abogacia',
    PDF_DOCUMENTO_CONTROL_MAHOU: 'PDF para documento de controle de Mahou',
  },

  display_labels: {
    PDF_DELIVERYNOTE_LABEL: 'PDF para etiquetas genéricas de nota',
    PDF_ALCAMPO_DELIVERYNOTE_LABEL: 'PDF para etiquetas de nota de Alcampo',
    PDF_CARREFOUR_DELIVERYNOTE_LABEL: 'PDF para etiquetas de nota de Carrefour',
    PDF_BONPREU_DELIVERYNOTE_LABEL: 'PDF para etiquetas de nota de Bon Preu',
    PDF_ECI_DELIVERYNOTE_LABEL: 'PDF para etiquetas de nota de ECI'
  },

  email_type: {
    NEW_USER: 'Novo utilizador e senha',
    RESET_PASSWORD: 'Recuperar senha',
    NEW_INVOICE: 'Email informativo nova fatura',
    EMAIL_PDF_ATTACH: 'Email PDF e anexos',
    EMAIL_PDF_ATTACH_MERGED: 'Email PDF e anexos unificados',
    EMAIL_SIGNED: 'Email guardado',
    EMAIL_PDF_SIGNED: 'Email PDF e guardado',
    EMAIL_PDF_SIGNED_ATTACH: 'Email PDF, guardado e anexos',
    EMAIL_LINK: 'Email com link',
    INVOICE_ERROR_DELIVERY_METHOD: 'Método de entrega não contratado',
    BILLING_REPORT_SERVICE: 'Notificação de um serviço',
    ACK_EMAIL_ERROR: 'Erro envio ACK email',
    ERROR_CMR: 'Notificação de erro para documento de controle',
    ANNULLED_CMR: 'Notificação de anulação para documento de controle',
    INVALID_STATUS: 'Erro no envio',
    RESUMEN_BOLETAS_ERROR: 'CDR em resumo de cédulas',
    NEW_RECADV: 'Nova recepção',
    NEW_ORDER: 'Novo pedido',
    ERROR_RRVV: 'Email com notificação de erro para recepções valoradas',
    ERROR_ORDER: 'Email com notificação de erro para pedidos',
    BILLINGINACTIVE_REPORT: 'Relatório de faturas inativas',
    NEW_INVOICE_PENDING_ACCEPTANCE: 'Nova fatura pendente de aceptação',
    ANEXO_DOCUMENTATION: 'Nova proposta de pagamento',
    INVALID_INVOICE_NOTE_URL: 'Notificação de acesso erroneo mediante url consulta de fatura',
    REDIGITALIZATION_REQUEST: 'Pedido Redigitalização',
    BILLING_REPORT_SERVICES: ' Notificação de múltiples serviços',
    ERROR: 'Email de notificação de erro para suporte',
    VALIDATE_FORMAT_ERROR: 'Erro de integração com tipo de email',
    EMAIL_PDF: 'Email PDF',
    INTEGRATION_REJECTED: 'Email para fornecedores quando a fatura está integrada com estado rejeitada',
    INVOICE_TIME_EXCEED_NOTIFICATION_EMISSION: 'Email para fornecedores quando o SDI não possa entregar a fatura',
    INVOICE_TIME_EXCEED_NOTIFICATION_RECEPTION: 'Email para recetores quando o SDI não haja recebido notificações',
    CHANGE_STATUS_ERROR: 'Email para avisar que não é possível efetuar a alteração do estado',
    NEW_DELIVERY_NOTE: 'Nova nota de entrega',
    CHANGE_STATUS_DELIVERYNOTE: 'Alteração da nota de entrega',
    CHANGE_STATUS_RECADV: 'Mudança de status de um recibo',
    WS_DOCUMENT: 'Envio de documentos da empresa pelo WS',
    PARTY_DATA: 'Envio de documentos da empresa por email',
    EMAIL_TO_REPORT_ISSUED: 'Email para envio do relatório CSV das faturas emitidas',
    INTEGRATION_OCR_ERROR: 'Email de notificação de erros de integração em faturas de OCR',
    EMAIL_NOTIFICATION_CUSTOMER: 'Email que é enviado na chamada para o cliente para enviar a fatura',
    EMAIL: 'Email de notificação',
    EMAIL_SIGNED_ATTACH: 'Email guardado e anexos',
    EMAIL_INVOICE_NO_OCR: 'Envio centralizado de notificações de fatura eletrônica',
    EMAIL_THIRDPARTY: 'E-mail para envio de faturas a terceiros',
    ERROR_CENTRE: 'Email de notificação de erros de integração em centros',
    VERIFY_2FA: 'E-mail para notificar o código para autenticação de dois fatores',
    APPROVAL_FLOW: 'Email para aprovação de faturas',
    EMAIL_BILLING_REPORT: 'Email con il report di fatturazione di Indra e Telefónica',
    REDES_NOTIFICATION: 'Notificação de erro no site red.es recepções',
    SHIPMENT_NOTIFICATION: 'Notificação ao comprador do envio da fatura para o destino ws'
  },
  configuration_table: {
    GENERATE_ACK: 'Generação de ficheiro ack',
    GENERATE_ENVEST: 'Generação de ficheiro de envio de estados de fatura (ENVEST)',
    GENERATE_ENVRES: 'Generação de ficheiro de envio de resposta de lote de faturas',
    GENERATE_ACK_EMAIL: 'Envio de Email com ack',
    GENERATE_ACK_ERROR_EMAIL: 'Envio de Email com erros ack',
    GENERATE_ACK_ERROR_EMAIL_WITHOUT_ATTACH: 'Envio de Email com erros ack sem anexos',
    GENERATE_ACK_EMAIL_WITHOUT_ATTACH: 'Enviando o arquivo ack sem anexos',
    GENERATE_PDF417: 'Generação do código para as faturas assinadas',
    GET_CHANNEL: 'Obtenção do canal',
    MANUAL_SEND: 'Envio manual de tarefas pendentes',
    GENERATE_PARTY_REPORT: 'Envio ficheiros empresas para Digitalização',
    SEND_ALL_INVOICES: 'Envio de todas as faturas independentemente do estado',
    PENDING_INVOICES_XML_REPORT: 'Criação de Relatório XML com as faturas em estado não final',
    SEND_EMAIL_INVOICE_RECEIVED: 'Envio de email indicando que uma nova fatura foi recebida',
    STATUS_RECADV_FILE: 'Generação do ficheiro xml de estados de recepções',
    NO_INTEGRATE_REJECTED_INVOICE_EMISION: 'Faturas emitidas,não integrar recusadas',
    NO_INTEGRATE_DUPLICATED_INVOICE: 'Não integrar faturas duplicadas',
    SET_SPONSOR: 'Ao criar ou alterar una empresa do serviço,a função sponsor será atribuída a essa',
    NEW_PARTY_CREATE_CENTRE: 'Criar o centro da empresa mesmo que ela não se queira como patrocinador',
    GENERATE_ORDRSP: 'Geração do arquivo de resposta do pedido',
    GENERATE_B2B_STATUS: 'Geração do arquivo de status da fatura',
    DELIVERY_INVOICE_TO_ISSUER: 'Entrega da fatura ao emissor conforme configuração',
    STATUS_RETAINED_INVOICE: 'Não envie faturas até a data de emissão',
    CHANGE_SIGNED_TO_OPENED: 'Alteração de status para abrir ao consultar uma fatura assinada, PDF ou guardado',
    GENERATE_REPORT_ISSUED: 'Relatório CSV de faturas emitidas atualizado desde a última execução',
    NO_DELIVER_INVOICE: 'Não envie faturas registradas com método de entrega',
    STATUS_SIGNED_FROM_INVOICE_RECEIVED: 'As faturas assinadas e recebidas da Editrack (RVA) permanecem no estado assinado',
    SET_EMISSION_NULL_IF_SPONSOR: 'Integração da autofatura com o sinalizador de emissão definido como nulo se ambas as empresas forem patrocinadoras',
    PENDING_TASK_REJECT_VALIDATION: 'Validação para rejeição de tarefas pendentes',
    PENDING_TASK_SEND_VALIDATION: 'Validação para envio de fatura para sap de tarefas pendentes',
    CREATE_USER_NO_SPONSOR_PARTY: 'Criar um usuário empresa na contratação da empresa não patrocinadora a partir da integração da nota fiscal',
    CREATE_USER_THIRD_PARTY: 'Cria um terceiro usuário na contratação do terceiro a partir da integração da fatura',
    SEND_TO_THIRDPARTY: 'Processo envio de faturas por e-mail para terceiros',
    INVOICE_RECADV_MISSING_ORDER_VALIDATION: 'Validação dos dados do pedido para a criação de uma fatura a partir de uma recepção',
    HIDDEN_INVOICE_EXTENSION: 'Excluir extensão na visualização de rascunhos',
    NOT_SEND_INTEGRATION_NOTIFICATION: 'A notificação de integração e o status do documento (RECADV e/ou ORDER) não são enviados.',
    ADD_COUNTRY_PARTY_TO_MANUAL_INVOICE: 'Adicionar o país aos NIFs das empresas a partir da criação manual',
    SEND_EMAIL_WITH_COPY_TO_ORIGIN: 'Envie uma cópia do email do tipo de email configurado para a origem configurada',
    UPDATE_FLAG_OTP_AUTHENTICATION: 'Ativar autenticação OTP',
    APPROVAL_FLOW_BY_LEVELS_AND_USERS: 'Fluxo de aprovação por níveis e usuários',
    SEE_ONLY_GENERAL_SIGN_DOCUMENT: 'Ver apenas documentos gerais de assinatura delegada',
    GET_PERMANENT_ESTABLISHMENT: 'Veja os centros que são estabelecimentos permanentes',
    GET_TAXES_PROJECT: 'Ver os impostos associados ao projeto',
    GET_TAXES_BUSINESS_RULE_REE: 'Visualizar impostos com base nas regras de negócios para impostos REE',
    GENERATE_TEXT_COLLECTION_ADDITIONAL_INFO: 'Texto fixo em informações adicionais de método de pagamento em rascunhos',
    INVOICE_INTEGRATION_NO_CERTIFICATE_VALIDATION: 'As faturas de contrato para integração entram sem passar pela validação do pedido de certificação',
    GENERATE_TEXT_WITHHOLDING_REASON: 'Texto fixo por motivo de retenção em rascunhos',
    DRAFT_CORRECTIVE_INVOICE_ONLY: 'Somente faturas corretivas podem ser criadas a partir de rascunhos',
    DRAFT_INVOICE_DOCUMENT_FILTER: 'Tipos de documentos limitados em nível geral e em nível de linha em um projeto',
    INVOICE_REJECT_RELEASE_RECADV: 'Liberar certificação ao rejeitar uma fatura',
    CREATE_DOCUMENT_RELATION: 'Criar uma relação entre documentos',
    INVOICE_STATUS_RECADV_INVOICED: 'Fatura a partir do recebimento, status faturado dependendo do preço por quantidade',
    CALCULATE_NEGATIVE_RETENTION: 'As retenções sobre faturas negativas serão adicionadas ao valor total executável',
    RECADV_SUBTYPE_DEFAULT_GOODS: 'Nos recebimentos de mercadorias inadimplentes no caso de não ser informado de nada no tipo recebido',
    HIDDEN_COMMUNICATION_METHOD: 'Remover exibição de métodos de envio em rascunhos',
    DRAFT_DOCUMENTS_HEADER: 'Obter os documentos no nível do cabeçalho a partir das linhas',
    INVOICE_INSTALLMENTS_DATERANGE: 'Data de vencimento (em meses) para rascunhos de projeto',
    GENERATE_INVOICE_INSTALLMENTS: 'Carregar dados de expiração em totais de rascunho por padrão',
    ATTACHMENTS_REPOSITORY: 'Anexar os documentos do repositório cujo nome atende a um determinado padrão',
    ATTACHMENTS_REPOSITORY_SUBDIRECTORY_DATE: 'Anexar documentos do repositório cujo nome atenda a um determinado padrão contido no subdiretório date',
    CHANGE_OPERATION_PERIOD_DATES: 'Permite modificar as datas das operações e período de tributação em rascunhos',
    NOTIFY_ERROR_TO_PROJECT_PARTY_EMAIL_CONTACT: 'Além de avisar o emissor, caso conste na nota fiscal, para o e-mail configurado na administração da empresa no serviço',
    DRAFT_NO_CHANGE_CURRENCY: 'Não permitir alterar a moeda em rascunhos',
    ALLOWED_EMAIL_DOMAINS: 'Domínios de e-mail permitidos',
    WITHHOLDINGAMOUNT_ABSOLUTE_TO_ACCOUNTING: 'Valor absoluto da retenção para contabilidade',
    REQUIRED_FIELDS_FOR_FIRST_LEVEL_APPROVAL: 'Campos adicionais para aprovação de primeiro nível',
    VOCENTO_VALIDATION_WS: 'Personalizado Vocento : Validação dos dados adicionais do Vocento',
    VOCENTO_CENTRE_VALIDATION_WS: 'Validação de centre faturas Vocento pela WS',
    SHIPMENT_NOTIFICATION: 'Notificação ao comprador do envio da fatura para o destino ws',
    UPDATE_ALL_STATUS_INVOICENOTE: 'Atualização de estados negativos pelo VPL',
    NO_INTEGRATE_DOCUMENT_ERROR: 'Não integrar documento com estado de erro',
    CONFIGURATION_CONTROLDOCUMENT_SENDLINK: 'For automatic sending of control document',
    CONFIGURATION_BILLING_SPONSOR_REPORT: 'Adicionar empresas sponsor ao relatório de faturação',
    METADATA_FROM_PATH: 'Obter o arquivo de metadados a partir do caminho e não gerá-lo novamente',
    REPLACE_NIF: 'Substituir NIF de origem pelo NIF configurado',
	EXTERNAL_PDF: 'PDF externo não gerado pela Ecosystems B2B'
  },
  recaptcha: {
    error: 'Você deve marcar a caixa CAPTCHA',
    text: 'Você fez várias tentativas malsucedidas de login. Por favor, verifique o CAPTCHA para continuar'
  },
  mailServer: {
    new: 'Novo servidor de e-mail',
    notify: {
      add_mailServer: 'Servidor de correio criado com sucesso',
      delete_mailServer: 'Servidor de email excluído com sucesso.',
      save_changes: 'Servidor de e-mail atualizado com sucesso'
    },
    confirm: {
      delete_mailServer: 'Tem certeza que deseja deletar o servidor de e-mail?'
    },
    load: {
      add_mailServer: 'Adicionando servidor de e-mail ...',
      delete_mailServer: 'Excluindo servidor de e-mail ...'
    },
    mailServer_table: {
      host: 'Host',
      user: 'Usuário',
      password: 'Senha',
      mailfrom: 'Endereço de e-mail de origem',
      port: 'Porta',
      auth: 'Auth',
      protocol: 'Protocolo',
      idClient: 'ID do Cliente',
      idTenant: 'ID da Organização',
      clientSecret: 'Segredo do Cliente',
      validityDateTo: 'Data de validade do acesso',
      saveToSentItems: 'Salvar Emails Enviados'
    },
    test_error: 'Não foi possível estabelecer conexão com o servidor de e-mail',
    test_ok: 'A conexão com o servidor de e-mail foi bem-sucedida',
    auth_error: 'Ocorreu um erro de autenticação',
    delete_mailServer: 'Delete',
    delete_mailServer_tooltip: 'Excluir servidor de e-mail',
    test_tooltip: 'Verificar conexão',
    test: 'Verificar',
    duplicate_error: 'Já existe um servidor de e-mail com esses dados',
    password_too_long: 'A senha é muito longa. Por favor, use uma senha mais curta',
    data_integrity_error: 'Erro de integridade de dados ao salvar o servidor de correio'
  },
  unit_of_measure: {
    title: 'Unidade de medida',
    UND: 'Unidades',
    HUR: 'Horas',
    KGM: 'Quilogramas',
    LTR: 'Litros',
    OTR: 'Outras',
    BOX: 'Caixas',
    BDJ: 'Bandejas',
    BID: 'Bateria',
    BOL: 'Bolsas',
    BOM: 'Garrafões',
    BTL: 'Garrafas',
    BOT: 'Jarras',
    CLT: 'Centilitros',
    CMT: 'Centimetros',
    GAR: 'Tanque',
    GRM: 'Gramas',
    KMT: 'Quilômetros',
    MTR: 'Metros',
    MMT: 'Milimetros',
    PKG: 'Pacotes',
    ROL: 'Rolos',
    SOB: 'Envelopes',
    MT3: 'Metro cúbico',
    WAT: 'Watt',
    HOJ: 'Lençóis',
    JUG: 'Jogos',
    CEN: 'Centenas',
    PAR: 'Torque',
    CAR: 'Carretel',
    NTB: 'Caderno',
    MT2: 'Metros quadrados',
    PCE: 'Peças',
    XCA: 'Caixas',
    TNE: 'Toneladas',
  }

}
